function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __esm = function __esm(fn, res) {
  return function __init() {
    return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
  };
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/lib/locales/ar-AE/translations.json
var translations_exports = {};
__export(translations_exports, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required;
  },
  Answer: function Answer() {
    return _Answer;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_;
  },
  Answerssss: function Answerssss() {
    return _Answerssss;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed;
  },
  Clear: function Clear() {
    return _Clear;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection;
  },
  Close: function Close() {
    return _Close;
  },
  Continue: function Continue() {
    return _Continue;
  },
  Finish: function Finish() {
    return _Finish;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal;
  },
  Next: function Next() {
    return _Next;
  },
  "Next Page": function NextPage() {
    return Next_Page;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks;
  },
  OK: function OK() {
    return _OK;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_;
  },
  Prev: function Prev() {
    return _Prev;
  },
  Previous: function Previous() {
    return _Previous;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam;
  },
  Return: function Return() {
    return _Return;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_0;
  },
  "You passed!": function YouPassed() {
    return You_passed_;
  },
  "default": function _default() {
    return translations_default;
  }
});
var _Select_all_that_apply_, __000_character_limit, A_score_of_at_least___passingGrade____is_required, _Answer, Answer__Must_be_a_number_, _Answerssss, Assessment_Completed, _Clear, Clear_Selection, _Close, _Continue, _Finish, Let_s_Get_Started, Must_be_a_decimal, _Next, Next_Page, Number_of_Drinks, _OK, Page___currentPage___of___totalPages__, Please_click_OK_to_continue_to_the_next_page_, _Prev, _Previous, Previous_Page, Question___currentQuestion___of___totalQuestions__, Questions_you_missed_on_the_assessment_, Retake_Exam, _Return, Review_answer_feedback_to_learn_more_, Score____score___, Select_an_answer, Submit_Answer_s_, The_response_options_are__, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_, Value_must_be_greater_than_or_equal_to_0, You_passed_, translations_default;
var init_translations = __esm({
  "src/lib/locales/ar-AE/translations.json": function srcLibLocalesArAETranslationsJson() {
    _Select_all_that_apply_ = "(\u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062F \u0643\u0644 \u0645\u0627 \u064A\u0646\u0637\u0628\u0642)";
    __000_character_limit = "1000 \u062D\u0631\u0641 \u0628\u062D\u062F \u0623\u0642\u0635\u0649";
    A_score_of_at_least___passingGrade____is_required = "\u064A\u062C\u0628 \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0645\u062C\u0645\u0648\u0639 \u0646\u0642\u0627\u0637 {{passingGrade}}% \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644";
    _Answer = "\u0627\u0644\u0625\u062C\u0627\u0628\u0629";
    Answer__Must_be_a_number_ = "\u0627\u0644\u0625\u062C\u0627\u0628\u0629 (\u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0631\u0642\u0645\u064B\u0627)";
    _Answerssss = "\u0627\u0644\u0625\u062C\u0627\u0628\u0627\u062A";
    Assessment_Completed = "\u0627\u0643\u062A\u0645\u0644 \u0627\u0644\u062A\u0642\u064A\u064A\u0645";
    _Clear = "\u0645\u0633\u062D";
    Clear_Selection = "\u0645\u0633\u062D \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631";
    _Close = "\u0625\u063A\u0644\u0627\u0642";
    _Continue = "\u0645\u062A\u0627\u0628\u0639\u0629";
    _Finish = "\u0625\u0646\u0647\u0627\u0621";
    Let_s_Get_Started = "\u062F\u0639\u0646\u0627 \u0646\u0628\u062F\u0623";
    Must_be_a_decimal = "\u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0631\u0642\u0645\u064B\u0627 \u0639\u0634\u0631\u064A\u064E\u0627";
    _Next = "\u0627\u0644\u062A\u0627\u0644\u064A";
    Next_Page = "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629";
    Number_of_Drinks = "\u0639\u062F\u062F \u0627\u0644\u0645\u0634\u0631\u0648\u0628\u0627\u062A";
    _OK = "\u0645\u0648\u0627\u0641\u0642";
    Page___currentPage___of___totalPages__ = "\u0627\u0644\u0635\u0641\u062D\u0629 {{currentPage}} \u0645\u0646 {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_ = "\u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \"\u0645\u0648\u0627\u0641\u0642\" \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629.";
    _Prev = "\u0627\u0644\u0633\u0627\u0628\u0642";
    _Previous = "\u0627\u0644\u0633\u0627\u0628\u0642";
    Previous_Page = "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629";
    Question___currentQuestion___of___totalQuestions__ = "\u0627\u0644\u0633\u0624\u0627\u0644 {{currentQuestion}} \u0645\u0646 {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_ = "\u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u062A\u064A \u0641\u0627\u062A\u062A\u0643 \u0641\u064A \u0627\u0644\u062A\u0642\u064A\u064A\u0645:";
    Retake_Exam = "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631";
    _Return = "\u0631\u062C\u0648\u0639";
    Review_answer_feedback_to_learn_more_ = "\u0631\u0627\u062C\u0639 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u0625\u062C\u0627\u0628\u0627\u062A \u0644\u0644\u062A\u0639\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0645\u0632\u064A\u062F.";
    Score____score___ = "\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0646\u0642\u0627\u0637: {{score}}%";
    Select_an_answer = "\u062D\u062F\u062F \u0625\u062C\u0627\u0628\u0629";
    Submit_Answer_s_ = "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0625\u062C\u0627\u0628\u0629 (\u0627\u0644\u0625\u062C\u0627\u0628\u0627\u062A)";
    The_response_options_are__ = "\u0627\u062E\u062A\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0627\u062A \u0647\u064A: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question = "\u0644\u0625\u0644\u063A\u0627\u0621 \u0627\u062E\u062A\u064A\u0627\u0631 \u0625\u062C\u0627\u0628\u0629\u060C \u0627\u0633\u062A\u062E\u062F\u0645 \u062E\u064A\u0627\u0631 \"\u0645\u0633\u062D \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631\" \u0628\u0639\u062F \u0622\u062E\u0631 \u0627\u062E\u062A\u064A\u0627\u0631 \u0625\u062C\u0627\u0628\u0629 \u0639\u0644\u0649 \u0643\u0644 \u0633\u0624\u0627\u0644";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_ = "\u0644\u0644\u0623\u0633\u0641 \u0644\u0645 \u062A\u062C\u062A\u0632 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631 \u0648\u0639\u0644\u064A\u0643 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062E\u0636\u0648\u0639 \u0644\u0644\u062A\u0642\u064A\u064A\u0645.";
    Value_must_be_greater_than_or_equal_to_0 = "\u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u0642\u064A\u0645\u0629 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0623\u0648 \u062A\u0633\u0627\u0648\u064A 0";
    You_passed_ = "\u0644\u0642\u062F \u0646\u062C\u062D\u062A!";
    translations_default = {
      "(Select all that apply)": _Select_all_that_apply_,
      "1,000 character limit": __000_character_limit,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required,
      Answer: _Answer,
      "Answer (Must be a number)": Answer__Must_be_a_number_,
      Answerssss: _Answerssss,
      "Assessment Completed": Assessment_Completed,
      Clear: _Clear,
      "Clear Selection": Clear_Selection,
      Close: _Close,
      Continue: _Continue,
      Finish: _Finish,
      "Let's Get Started": Let_s_Get_Started,
      "Must be a decimal": Must_be_a_decimal,
      Next: _Next,
      "Next Page": Next_Page,
      "Number of Drinks": Number_of_Drinks,
      OK: _OK,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_,
      Prev: _Prev,
      Previous: _Previous,
      "Previous Page": Previous_Page,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_,
      "Retake Exam": Retake_Exam,
      Return: _Return,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_,
      "Score: {{score}}%": Score____score___,
      "Select an answer": Select_an_answer,
      "Submit Answer(s)": Submit_Answer_s_,
      "The response options are: ": The_response_options_are__,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_0,
      "You passed!": You_passed_
    };
  }
});

// src/lib/locales/bg-BG/translations.json
var translations_exports2 = {};
__export(translations_exports2, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_2;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit2;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required2;
  },
  Answer: function Answer() {
    return Answer2;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_2;
  },
  Answerssss: function Answerssss() {
    return Answerssss2;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed2;
  },
  Clear: function Clear() {
    return Clear2;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection2;
  },
  Close: function Close() {
    return Close2;
  },
  Continue: function Continue() {
    return Continue2;
  },
  Finish: function Finish() {
    return Finish2;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started2;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal2;
  },
  Next: function Next() {
    return Next2;
  },
  "Next Page": function NextPage() {
    return Next_Page2;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks2;
  },
  OK: function OK() {
    return OK2;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__2;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_2;
  },
  Prev: function Prev() {
    return Prev2;
  },
  Previous: function Previous() {
    return Previous2;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page2;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__2;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_2;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam2;
  },
  Return: function Return() {
    return Return2;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_2;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___2;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer2;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_2;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__2;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question2;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_2;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_02;
  },
  "You passed!": function YouPassed() {
    return You_passed_2;
  },
  "default": function _default() {
    return translations_default2;
  }
});
var _Select_all_that_apply_2, __000_character_limit2, A_score_of_at_least___passingGrade____is_required2, Answer2, Answer__Must_be_a_number_2, Answerssss2, Assessment_Completed2, Clear2, Clear_Selection2, Close2, Continue2, Finish2, Let_s_Get_Started2, Must_be_a_decimal2, Next2, Next_Page2, Number_of_Drinks2, OK2, Page___currentPage___of___totalPages__2, Please_click_OK_to_continue_to_the_next_page_2, Prev2, Previous2, Previous_Page2, Question___currentQuestion___of___totalQuestions__2, Questions_you_missed_on_the_assessment_2, Retake_Exam2, Return2, Review_answer_feedback_to_learn_more_2, Score____score___2, Select_an_answer2, Submit_Answer_s_2, The_response_options_are__2, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question2, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_2, Value_must_be_greater_than_or_equal_to_02, You_passed_2, translations_default2;
var init_translations2 = __esm({
  "src/lib/locales/bg-BG/translations.json": function srcLibLocalesBgBGTranslationsJson() {
    _Select_all_that_apply_2 = "(\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0432\u0441\u0438\u0447\u043A\u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0438\u043C\u0438)";
    __000_character_limit2 = "\u041B\u0438\u043C\u0438\u0442 \u043E\u0442 1000 \u0437\u043D\u0430\u043A\u0430";
    A_score_of_at_least___passingGrade____is_required2 = "\u0418\u0437\u0438\u0441\u043A\u0432\u0430 \u0441\u0435 \u0440\u0435\u0437\u0443\u043B\u0442\u0430\u0442 \u043C\u0438\u043D\u0438\u043C\u0443\u043C {{passingGrade}}";
    Answer2 = "\u041E\u0442\u0433\u043E\u0432\u043E\u0440";
    Answer__Must_be_a_number_2 = "\u041E\u0442\u0433\u043E\u0432\u043E\u0440 (\u0422\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0447\u0438\u0441\u043B\u043E)";
    Answerssss2 = "\u041E\u0442\u0433\u043E\u0432\u043E\u0440\u0438";
    Assessment_Completed2 = "\u041E\u0446\u0435\u043D\u043A\u0430\u0442\u0430 \u0435 \u0437\u0430\u0432\u044A\u0440\u0448\u0435\u043D\u0430";
    Clear2 = "\u0418\u0437\u0447\u0438\u0441\u0442\u0432\u0430\u043D\u0435";
    Clear_Selection2 = "\u041F\u0440\u0435\u043C\u0430\u0445\u0432\u0430\u043D\u0435 \u043D\u0430 \u0438\u0437\u0431\u043E\u0440\u0430";
    Close2 = "\u0417\u0430\u0442\u0432\u0430\u0440\u044F\u043D\u0435";
    Continue2 = "\u041D\u0430\u043F\u0440\u0435\u0434";
    Finish2 = "\u0417\u0430\u0432\u044A\u0440\u0448\u0432\u0430\u043D\u0435";
    Let_s_Get_Started2 = "\u0425\u0430\u0439\u0434\u0435 \u0434\u0430 \u0437\u0430\u043F\u043E\u0447\u0432\u0430\u043C\u0435";
    Must_be_a_decimal2 = "\u0422\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0434\u0435\u0441\u0435\u0442\u0438\u0447\u043D\u043E \u0447\u0438\u0441\u043B\u043E";
    Next2 = "\u0421\u043B\u0435\u0434\u0432\u0430\u0449";
    Next_Page2 = "\u0421\u043B\u0435\u0434\u0432\u0430\u0449\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
    Number_of_Drinks2 = "\u0411\u0440\u043E\u0439 \u043D\u0430\u043F\u0438\u0442\u043A\u0438";
    OK2 = "\u041E\u041A";
    Page___currentPage___of___totalPages__2 = "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 {{currentPage}} \u043E\u0442 {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_2 = "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u041E\u041A, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435 \u043A\u044A\u043C \u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430.";
    Prev2 = "\u041F\u0440\u0435\u0434\u0438\u0448\u043D\u0430";
    Previous2 = "\u041F\u0440\u0435\u0434\u0438\u0448\u0435\u043D";
    Previous_Page2 = "\u041F\u0440\u0435\u0434\u0438\u0448\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
    Question___currentQuestion___of___totalQuestions__2 = "\u0412\u044A\u043F\u0440\u043E\u0441 {{currentQuestion}} \u043E\u0442 {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_2 = "\u0412\u044A\u043F\u0440\u043E\u0441\u0438, \u043A\u043E\u0438\u0442\u043E \u0441\u0442\u0435 \u043F\u0440\u043E\u043F\u0443\u0441\u043D\u0430\u043B\u0438 \u0432 \u043E\u0446\u0435\u043D\u043A\u0430\u0442\u0430:";
    Retake_Exam2 = "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u043F\u043E\u043B\u0430\u0433\u0430\u043D\u0435 \u043D\u0430 \u0438\u0437\u043F\u0438\u0442";
    Return2 = "\u041D\u0430\u0437\u0430\u0434";
    Review_answer_feedback_to_learn_more_2 = "\u041F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0439\u0442\u0435 \u043E\u0431\u0440\u0430\u0442\u043D\u0430\u0442\u0430 \u0432\u0440\u044A\u0437\u043A\u0430 \u0437\u0430 \u043E\u0442\u0433\u043E\u0432\u043E\u0440\u0430, \u0437\u0430 \u0434\u0430 \u043D\u0430\u0443\u0447\u0438\u0442\u0435 \u043F\u043E\u0432\u0435\u0447\u0435.";
    Score____score___2 = "\u0420\u0435\u0437\u0443\u043B\u0442\u0430\u0442: {{score}}%";
    Select_an_answer2 = "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043E\u0442\u0433\u043E\u0432\u043E\u0440";
    Submit_Answer_s_2 = "\u041F\u043E\u0434\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u043E\u0442\u0433\u043E\u0432\u043E\u0440(\u0438)";
    The_response_options_are__2 = "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u0438\u0442\u0435 \u0437\u0430 \u043E\u0442\u0433\u043E\u0432\u043E\u0440 \u0441\u0430: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question2 = "\u0417\u0430 \u0434\u0430 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0435\u0442\u0435 \u0438\u0437\u0431\u043E\u0440\u0430 \u043E\u0442 \u0434\u0430\u0434\u0435\u043D \u043E\u0442\u0433\u043E\u0432\u043E\u0440, \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0442\u0435 \u043E\u043F\u0446\u0438\u044F\u0442\u0430 \"\u041F\u0440\u0435\u043C\u0430\u0445\u0432\u0430\u043D\u0435 \u043D\u0430 \u0438\u0437\u0431\u043E\u0440\u0430\" \u0441\u043B\u0435\u0434 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u044F \u0438\u0437\u0431\u0440\u0430\u043D \u043E\u0442\u0433\u043E\u0432\u043E\u0440 \u043D\u0430 \u0432\u0441\u0435\u043A\u0438 \u043E\u0442 \u0432\u044A\u043F\u0440\u043E\u0441\u0438\u0442\u0435";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_2 = "\u0417\u0430 \u0441\u044A\u0436\u0430\u043B\u0435\u043D\u0438\u0435, \u043D\u0435 \u0438\u0437\u0434\u044A\u0440\u0436\u0430\u0445\u0442\u0435 \u0438\u0437\u043F\u0438\u0442\u0430 \u0438 \u0449\u0435 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u043F\u0440\u0435\u043C\u0438\u043D\u0435\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u043E\u0446\u0435\u043D\u044F\u0432\u0430\u043D\u0435.";
    Value_must_be_greater_than_or_equal_to_02 = "\u0421\u0442\u043E\u0439\u043D\u043E\u0441\u0442\u0442\u0430 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0435 \u043F\u043E-\u0433\u043E\u043B\u044F\u043C\u0430 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u0430 \u043D\u0430 0";
    You_passed_2 = "\u0418\u0437\u0434\u044A\u0440\u0436\u0430\u0445\u0442\u0435 \u0438\u0437\u043F\u0438\u0442\u0430!";
    translations_default2 = {
      "(Select all that apply)": _Select_all_that_apply_2,
      "1,000 character limit": __000_character_limit2,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required2,
      Answer: Answer2,
      "Answer (Must be a number)": Answer__Must_be_a_number_2,
      Answerssss: Answerssss2,
      "Assessment Completed": Assessment_Completed2,
      Clear: Clear2,
      "Clear Selection": Clear_Selection2,
      Close: Close2,
      Continue: Continue2,
      Finish: Finish2,
      "Let's Get Started": Let_s_Get_Started2,
      "Must be a decimal": Must_be_a_decimal2,
      Next: Next2,
      "Next Page": Next_Page2,
      "Number of Drinks": Number_of_Drinks2,
      OK: OK2,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__2,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_2,
      Prev: Prev2,
      Previous: Previous2,
      "Previous Page": Previous_Page2,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__2,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_2,
      "Retake Exam": Retake_Exam2,
      Return: Return2,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_2,
      "Score: {{score}}%": Score____score___2,
      "Select an answer": Select_an_answer2,
      "Submit Answer(s)": Submit_Answer_s_2,
      "The response options are: ": The_response_options_are__2,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question2,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_2,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_02,
      "You passed!": You_passed_2
    };
  }
});

// src/lib/locales/cs-CZ/translations.json
var translations_exports3 = {};
__export(translations_exports3, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_3;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit3;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required3;
  },
  Answer: function Answer() {
    return Answer3;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_3;
  },
  Answerssss: function Answerssss() {
    return Answerssss3;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed3;
  },
  Clear: function Clear() {
    return Clear3;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection3;
  },
  Close: function Close() {
    return Close3;
  },
  Continue: function Continue() {
    return Continue3;
  },
  Finish: function Finish() {
    return Finish3;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started3;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal3;
  },
  Next: function Next() {
    return Next3;
  },
  "Next Page": function NextPage() {
    return Next_Page3;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks3;
  },
  OK: function OK() {
    return OK3;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__3;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_3;
  },
  Prev: function Prev() {
    return Prev3;
  },
  Previous: function Previous() {
    return Previous3;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page3;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__3;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_3;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam3;
  },
  Return: function Return() {
    return Return3;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_3;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___3;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer3;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_3;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__3;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question3;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_3;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_03;
  },
  "You passed!": function YouPassed() {
    return You_passed_3;
  },
  "default": function _default() {
    return translations_default3;
  }
});
var _Select_all_that_apply_3, __000_character_limit3, A_score_of_at_least___passingGrade____is_required3, Answer3, Answer__Must_be_a_number_3, Answerssss3, Assessment_Completed3, Clear3, Clear_Selection3, Close3, Continue3, Finish3, Let_s_Get_Started3, Must_be_a_decimal3, Next3, Next_Page3, Number_of_Drinks3, OK3, Page___currentPage___of___totalPages__3, Please_click_OK_to_continue_to_the_next_page_3, Prev3, Previous3, Previous_Page3, Question___currentQuestion___of___totalQuestions__3, Questions_you_missed_on_the_assessment_3, Retake_Exam3, Return3, Review_answer_feedback_to_learn_more_3, Score____score___3, Select_an_answer3, Submit_Answer_s_3, The_response_options_are__3, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question3, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_3, Value_must_be_greater_than_or_equal_to_03, You_passed_3, translations_default3;
var init_translations3 = __esm({
  "src/lib/locales/cs-CZ/translations.json": function srcLibLocalesCsCZTranslationsJson() {
    _Select_all_that_apply_3 = "(Vyberte v\u0161echny platn\xE9 mo\u017Enosti.)";
    __000_character_limit3 = "Limit 1000\xA0znak\u016F";
    A_score_of_at_least___passingGrade____is_required3 = "Vy\u017Eaduje se sk\xF3re alespo\u0148 {{passingGrade}}\xA0%";
    Answer3 = "Odpov\u011B\u010F";
    Answer__Must_be_a_number_3 = "Odpov\u011B\u010F (\u010D\xEDslo)";
    Answerssss3 = "Answerssss";
    Assessment_Completed3 = "Hodnocen\xED dokon\u010Deno";
    Clear3 = "Vymazat";
    Clear_Selection3 = "Zru\u0161it v\xFDb\u011Br";
    Close3 = "Zav\u0159\xEDt";
    Continue3 = "Pokra\u010Dovat";
    Finish3 = "Dokon\u010Dit";
    Let_s_Get_Started3 = "Za\u010D\xEDn\xE1me";
    Must_be_a_decimal3 = "Mus\xED b\xFDt desetinn\xE9 \u010D\xEDslo";
    Next3 = "Dal\u0161\xED";
    Next_Page3 = "Dal\u0161\xED str\xE1nka";
    Number_of_Drinks3 = "Po\u010Det n\xE1poj\u016F";
    OK3 = "OK";
    Page___currentPage___of___totalPages__3 = "Strana {{currentPage}} z {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_3 = "Kliknut\xEDm na tla\u010D\xEDtko OK p\u0159ejdete na dal\u0161\xED str\xE1nku.";
    Prev3 = "P\u0159edchoz\xED";
    Previous3 = "P\u0159edchoz\xED";
    Previous_Page3 = "P\u0159edchoz\xED str\xE1nka";
    Question___currentQuestion___of___totalQuestions__3 = "Ot\xE1zka {{currentQuestion}} z {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_3 = "Ot\xE1zky, na\xA0kter\xE9 jste p\u0159i hodnocen\xED neodpov\u011Bd\u011Bli:";
    Retake_Exam3 = "Absolvovat zkou\u0161ku znovu";
    Return3 = "Vr\xE1tit se";
    Review_answer_feedback_to_learn_more_3 = "Chcete-li se dozv\u011Bd\u011Bt v\xEDce, seznamte se se zp\u011Btnou vazbou k\xA0odpov\u011Bd\xEDm.";
    Score____score___3 = "Sk\xF3re: {{score}}\xA0%";
    Select_an_answer3 = "Vyberte odpov\u011B\u010F";
    Submit_Answer_s_3 = "Odeslat odpov\u011B\u010F/odpov\u011Bdi";
    The_response_options_are__3 = "Mo\u017Enosti odpov\u011Bd\xED jsou: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question3 = "Chcete-li zru\u0161it v\xFDb\u011Br odpov\u011Bdi, zvolte po posledn\xEDm v\xFDb\u011Bru odpov\u011Bdi u\xA0jednotliv\xFDch ot\xE1zek mo\u017Enost Zru\u0161it v\xFDb\u011Br.";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_3 = "Hodnocen\xED jste bohu\u017Eel neabsolvovali \xFAsp\u011B\u0161n\u011B a\xA0budete ho muset opakovat.";
    Value_must_be_greater_than_or_equal_to_03 = "Hodnota mus\xED b\xFDt v\u011Bt\u0161\xED nebo rovna 0";
    You_passed_3 = "Absolvovali jste \xFAsp\u011B\u0161n\u011B!";
    translations_default3 = {
      "(Select all that apply)": _Select_all_that_apply_3,
      "1,000 character limit": __000_character_limit3,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required3,
      Answer: Answer3,
      "Answer (Must be a number)": Answer__Must_be_a_number_3,
      Answerssss: Answerssss3,
      "Assessment Completed": Assessment_Completed3,
      Clear: Clear3,
      "Clear Selection": Clear_Selection3,
      Close: Close3,
      Continue: Continue3,
      Finish: Finish3,
      "Let's Get Started": Let_s_Get_Started3,
      "Must be a decimal": Must_be_a_decimal3,
      Next: Next3,
      "Next Page": Next_Page3,
      "Number of Drinks": Number_of_Drinks3,
      OK: OK3,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__3,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_3,
      Prev: Prev3,
      Previous: Previous3,
      "Previous Page": Previous_Page3,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__3,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_3,
      "Retake Exam": Retake_Exam3,
      Return: Return3,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_3,
      "Score: {{score}}%": Score____score___3,
      "Select an answer": Select_an_answer3,
      "Submit Answer(s)": Submit_Answer_s_3,
      "The response options are: ": The_response_options_are__3,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question3,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_3,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_03,
      "You passed!": You_passed_3
    };
  }
});

// src/lib/locales/da-DK/translations.json
var translations_exports4 = {};
__export(translations_exports4, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_4;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit4;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required4;
  },
  Answer: function Answer() {
    return Answer4;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_4;
  },
  Answerssss: function Answerssss() {
    return Answerssss4;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed4;
  },
  Clear: function Clear() {
    return Clear4;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection4;
  },
  Close: function Close() {
    return Close4;
  },
  Continue: function Continue() {
    return Continue4;
  },
  Finish: function Finish() {
    return Finish4;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started4;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal4;
  },
  Next: function Next() {
    return Next4;
  },
  "Next Page": function NextPage() {
    return Next_Page4;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks4;
  },
  OK: function OK() {
    return OK4;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__4;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_4;
  },
  Prev: function Prev() {
    return Prev4;
  },
  Previous: function Previous() {
    return Previous4;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page4;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__4;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_4;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam4;
  },
  Return: function Return() {
    return Return4;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_4;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___4;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer4;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_4;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__4;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question4;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_4;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_04;
  },
  "You passed!": function YouPassed() {
    return You_passed_4;
  },
  "default": function _default() {
    return translations_default4;
  }
});
var _Select_all_that_apply_4, __000_character_limit4, A_score_of_at_least___passingGrade____is_required4, Answer4, Answer__Must_be_a_number_4, Answerssss4, Assessment_Completed4, Clear4, Clear_Selection4, Close4, Continue4, Finish4, Let_s_Get_Started4, Must_be_a_decimal4, Next4, Next_Page4, Number_of_Drinks4, OK4, Page___currentPage___of___totalPages__4, Please_click_OK_to_continue_to_the_next_page_4, Prev4, Previous4, Previous_Page4, Question___currentQuestion___of___totalQuestions__4, Questions_you_missed_on_the_assessment_4, Retake_Exam4, Return4, Review_answer_feedback_to_learn_more_4, Score____score___4, Select_an_answer4, Submit_Answer_s_4, The_response_options_are__4, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question4, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_4, Value_must_be_greater_than_or_equal_to_04, You_passed_4, translations_default4;
var init_translations4 = __esm({
  "src/lib/locales/da-DK/translations.json": function srcLibLocalesDaDKTranslationsJson() {
    _Select_all_that_apply_4 = "(V\xE6lg alle, der passer)";
    __000_character_limit4 = "Maks. 1.000 tegn";
    A_score_of_at_least___passingGrade____is_required4 = "Der kr\xE6ves en score p\xE5 mindst {{passingGrade}} %";
    Answer4 = "Svar";
    Answer__Must_be_a_number_4 = "Svar (skal v\xE6re et tal)";
    Answerssss4 = "Svar";
    Assessment_Completed4 = "Vurdering afsluttet";
    Clear4 = "Ryd";
    Clear_Selection4 = "Ryd markering";
    Close4 = "Luk";
    Continue4 = "Forts\xE6t";
    Finish4 = "Afslut";
    Let_s_Get_Started4 = "Lad os komme i gang";
    Must_be_a_decimal4 = "Skal v\xE6re en decimal";
    Next4 = "N\xE6ste";
    Next_Page4 = "N\xE6ste side";
    Number_of_Drinks4 = "Antal drinks";
    OK4 = "OK";
    Page___currentPage___of___totalPages__4 = "Side {{currentPage}} af {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_4 = "Klik p\xE5 OK for at forts\xE6tte til n\xE6ste side.";
    Prev4 = "Forrige";
    Previous4 = "Tidligere";
    Previous_Page4 = "Forrige side";
    Question___currentQuestion___of___totalQuestions__4 = "Sp\xF8rgsm\xE5l {{currentQuestion}} af {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_4 = "Sp\xF8rgsm\xE5l, du har sprunget over ved vurderingen:";
    Retake_Exam4 = "G\xE5 op til eksamen igen";
    Return4 = "Vend tilbage";
    Review_answer_feedback_to_learn_more_4 = "Gennemg\xE5 svar-feedback for at l\xE6re mere.";
    Score____score___4 = "Score: {{score}} %";
    Select_an_answer4 = "V\xE6lg et svar";
    Submit_Answer_s_4 = "Indsend svar";
    The_response_options_are__4 = "Svarmulighederne er: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question4 = "For at frav\xE6lge et svar skal du bruge indstillingen Ryd valg efter det sidste svarvalg for hvert sp\xF8rgsm\xE5l";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_4 = "Desv\xE6rre har du ikke best\xE5et og bliver n\xF8dt til at tage pr\xF8ven igen.";
    Value_must_be_greater_than_or_equal_to_04 = "V\xE6rdien skal v\xE6re st\xF8rre end eller lig med 0";
    You_passed_4 = "Du bestod!";
    translations_default4 = {
      "(Select all that apply)": _Select_all_that_apply_4,
      "1,000 character limit": __000_character_limit4,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required4,
      Answer: Answer4,
      "Answer (Must be a number)": Answer__Must_be_a_number_4,
      Answerssss: Answerssss4,
      "Assessment Completed": Assessment_Completed4,
      Clear: Clear4,
      "Clear Selection": Clear_Selection4,
      Close: Close4,
      Continue: Continue4,
      Finish: Finish4,
      "Let's Get Started": Let_s_Get_Started4,
      "Must be a decimal": Must_be_a_decimal4,
      Next: Next4,
      "Next Page": Next_Page4,
      "Number of Drinks": Number_of_Drinks4,
      OK: OK4,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__4,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_4,
      Prev: Prev4,
      Previous: Previous4,
      "Previous Page": Previous_Page4,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__4,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_4,
      "Retake Exam": Retake_Exam4,
      Return: Return4,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_4,
      "Score: {{score}}%": Score____score___4,
      "Select an answer": Select_an_answer4,
      "Submit Answer(s)": Submit_Answer_s_4,
      "The response options are: ": The_response_options_are__4,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question4,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_4,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_04,
      "You passed!": You_passed_4
    };
  }
});

// src/lib/locales/de/translations.json
var translations_exports5 = {};
__export(translations_exports5, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_5;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit5;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required5;
  },
  Answer: function Answer() {
    return Answer5;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_5;
  },
  Answerssss: function Answerssss() {
    return Answerssss5;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed5;
  },
  Clear: function Clear() {
    return Clear5;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection5;
  },
  Close: function Close() {
    return Close5;
  },
  Continue: function Continue() {
    return Continue5;
  },
  Finish: function Finish() {
    return Finish5;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started5;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal5;
  },
  Next: function Next() {
    return Next5;
  },
  "Next Page": function NextPage() {
    return Next_Page5;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks5;
  },
  OK: function OK() {
    return OK5;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__5;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_5;
  },
  Prev: function Prev() {
    return Prev5;
  },
  Previous: function Previous() {
    return Previous5;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page5;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__5;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_5;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam5;
  },
  Return: function Return() {
    return Return5;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_5;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___5;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer5;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_5;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__5;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question5;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_5;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_05;
  },
  "You passed!": function YouPassed() {
    return You_passed_5;
  },
  "default": function _default() {
    return translations_default5;
  }
});
var _Select_all_that_apply_5, __000_character_limit5, A_score_of_at_least___passingGrade____is_required5, Answer5, Answer__Must_be_a_number_5, Answerssss5, Assessment_Completed5, Clear5, Clear_Selection5, Close5, Continue5, Finish5, Let_s_Get_Started5, Must_be_a_decimal5, Next5, Next_Page5, Number_of_Drinks5, OK5, Page___currentPage___of___totalPages__5, Please_click_OK_to_continue_to_the_next_page_5, Prev5, Previous5, Previous_Page5, Question___currentQuestion___of___totalQuestions__5, Questions_you_missed_on_the_assessment_5, Retake_Exam5, Return5, Review_answer_feedback_to_learn_more_5, Score____score___5, Select_an_answer5, Submit_Answer_s_5, The_response_options_are__5, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question5, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_5, Value_must_be_greater_than_or_equal_to_05, You_passed_5, translations_default5;
var init_translations5 = __esm({
  "src/lib/locales/de/translations.json": function srcLibLocalesDeTranslationsJson() {
    _Select_all_that_apply_5 = "(Bitte alle zutreffenden ausw\xE4hlen)";
    __000_character_limit5 = "Maximal 1.000\xA0Zeichen";
    A_score_of_at_least___passingGrade____is_required5 = "Eine Punktzahl von mindestens {{passingGrade}}\xA0% ist erforderlich";
    Answer5 = "Antwort";
    Answer__Must_be_a_number_5 = "Antwort (muss eine Zahl sein)";
    Answerssss5 = "Antworten";
    Assessment_Completed5 = "Bewertung abgeschlossen";
    Clear5 = "Auswahl aufheben";
    Clear_Selection5 = "Auswahl l\xF6schen";
    Close5 = "Schlie\xDFen";
    Continue5 = "Weiter";
    Finish5 = "Fertig stellen";
    Let_s_Get_Started5 = "Erste Schritte";
    Must_be_a_decimal5 = "Antwort muss eine Dezimalzahl sein";
    Next5 = "N\xE4chste";
    Next_Page5 = "N\xE4chste Seite";
    Number_of_Drinks5 = "Anzahl der Getr\xE4nke";
    OK5 = "OK";
    Page___currentPage___of___totalPages__5 = "Seite\xA0{{currentPage}} von {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_5 = "Bitte klicken Sie auf \u201EOK\u201C, um zur n\xE4chsten Seite zu gelangen.";
    Prev5 = "Vorherige";
    Previous5 = "Zur\xFCck";
    Previous_Page5 = "Vorherige Seite";
    Question___currentQuestion___of___totalQuestions__5 = "Frage\xA0{{currentQuestion}} von {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_5 = "Fragen, die Sie bei der Bewertung \xFCbersprungen haben:";
    Retake_Exam5 = "Pr\xFCfung wiederholen";
    Return5 = "Zur\xFCck";
    Review_answer_feedback_to_learn_more_5 = "Feedback anzeigen";
    Score____score___5 = "Punktzahl: {{score}}\xA0%";
    Select_an_answer5 = "W\xE4hlen Sie eine Antwort aus";
    Submit_Answer_s_5 = "Antwort(en) senden";
    The_response_options_are__5 = "Die Antwortm\xF6glichkeiten sind: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question5 = "Um die Auswahl einer Antwort aufzuheben, verwenden Sie die Option \u201EAuswahl l\xF6schen\u201C nach der letzten Antwortm\xF6glichkeit f\xFCr jede Frage.";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_5 = "Leider haben Sie nicht bestanden und m\xFCssen die Bewertung wiederholen.";
    Value_must_be_greater_than_or_equal_to_05 = "Wert muss gr\xF6\xDFer oder gleich 0 sein";
    You_passed_5 = "Sie haben bestanden!";
    translations_default5 = {
      "(Select all that apply)": _Select_all_that_apply_5,
      "1,000 character limit": __000_character_limit5,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required5,
      Answer: Answer5,
      "Answer (Must be a number)": Answer__Must_be_a_number_5,
      Answerssss: Answerssss5,
      "Assessment Completed": Assessment_Completed5,
      Clear: Clear5,
      "Clear Selection": Clear_Selection5,
      Close: Close5,
      Continue: Continue5,
      Finish: Finish5,
      "Let's Get Started": Let_s_Get_Started5,
      "Must be a decimal": Must_be_a_decimal5,
      Next: Next5,
      "Next Page": Next_Page5,
      "Number of Drinks": Number_of_Drinks5,
      OK: OK5,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__5,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_5,
      Prev: Prev5,
      Previous: Previous5,
      "Previous Page": Previous_Page5,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__5,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_5,
      "Retake Exam": Retake_Exam5,
      Return: Return5,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_5,
      "Score: {{score}}%": Score____score___5,
      "Select an answer": Select_an_answer5,
      "Submit Answer(s)": Submit_Answer_s_5,
      "The response options are: ": The_response_options_are__5,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question5,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_5,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_05,
      "You passed!": You_passed_5
    };
  }
});

// src/lib/locales/el-GR/translations.json
var translations_exports6 = {};
__export(translations_exports6, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_6;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit6;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required6;
  },
  Answer: function Answer() {
    return Answer6;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_6;
  },
  Answerssss: function Answerssss() {
    return Answerssss6;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed6;
  },
  Clear: function Clear() {
    return Clear6;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection6;
  },
  Close: function Close() {
    return Close6;
  },
  Continue: function Continue() {
    return Continue6;
  },
  Finish: function Finish() {
    return Finish6;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started6;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal6;
  },
  Next: function Next() {
    return Next6;
  },
  "Next Page": function NextPage() {
    return Next_Page6;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks6;
  },
  OK: function OK() {
    return OK6;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__6;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_6;
  },
  Prev: function Prev() {
    return Prev6;
  },
  Previous: function Previous() {
    return Previous6;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page6;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__6;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_6;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam6;
  },
  Return: function Return() {
    return Return6;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_6;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___6;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer6;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_6;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__6;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question6;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_6;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_06;
  },
  "You passed!": function YouPassed() {
    return You_passed_6;
  },
  "default": function _default() {
    return translations_default6;
  }
});
var _Select_all_that_apply_6, __000_character_limit6, A_score_of_at_least___passingGrade____is_required6, Answer6, Answer__Must_be_a_number_6, Answerssss6, Assessment_Completed6, Clear6, Clear_Selection6, Close6, Continue6, Finish6, Let_s_Get_Started6, Must_be_a_decimal6, Next6, Next_Page6, Number_of_Drinks6, OK6, Page___currentPage___of___totalPages__6, Please_click_OK_to_continue_to_the_next_page_6, Prev6, Previous6, Previous_Page6, Question___currentQuestion___of___totalQuestions__6, Questions_you_missed_on_the_assessment_6, Retake_Exam6, Return6, Review_answer_feedback_to_learn_more_6, Score____score___6, Select_an_answer6, Submit_Answer_s_6, The_response_options_are__6, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question6, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_6, Value_must_be_greater_than_or_equal_to_06, You_passed_6, translations_default6;
var init_translations6 = __esm({
  "src/lib/locales/el-GR/translations.json": function srcLibLocalesElGRTranslationsJson() {
    _Select_all_that_apply_6 = "(\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03CC\u03BB\u03B1 \u03CC\u03C3\u03B1 \u03B9\u03C3\u03C7\u03CD\u03BF\u03C5\u03BD)";
    __000_character_limit6 = "\u038C\u03C1\u03B9\u03BF 1.000 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03C9\u03BD";
    A_score_of_at_least___passingGrade____is_required6 = "\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD {{passingGrade}}%";
    Answer6 = "\u0391\u03C0\u03AC\u03BD\u03C4\u03B7\u03C3\u03B7";
    Answer__Must_be_a_number_6 = "\u0391\u03C0\u03AC\u03BD\u03C4\u03B7\u03C3\u03B7 (\u03A0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2)";
    Answerssss6 = "\u0391\u03C0\u03B1\u03BD\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2";
    Assessment_Completed6 = "\u0397 \u03B1\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5";
    Clear6 = "\u0391\u03C0\u03B1\u03BB\u03BF\u03B9\u03C6\u03AE";
    Clear_Selection6 = "\u0391\u03C0\u03B1\u03BB\u03BF\u03B9\u03C6\u03AE \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE\u03C2";
    Close6 = "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF";
    Continue6 = "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1";
    Finish6 = "\u039F\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7";
    Let_s_Get_Started6 = "\u0391\u03C2 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5";
    Must_be_a_decimal6 = "\u03A0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B5\u03BA\u03B1\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2";
    Next6 = "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF";
    Next_Page6 = "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1";
    Number_of_Drinks6 = "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C0\u03BF\u03C4\u03CE\u03BD";
    OK6 = "\u039F\u039A";
    Page___currentPage___of___totalPages__6 = "\u03A3\u03B5\u03BB\u03AF\u03B4\u03B1 {{currentPage}} \u03B1\u03C0\u03CC {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_6 = "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF OK \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03B7\u03BD \u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1.";
    Prev6 = "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF";
    Previous6 = "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF";
    Previous_Page6 = "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1";
    Question___currentQuestion___of___totalQuestions__6 = "\u0395\u03C1\u03CE\u03C4\u03B7\u03C3\u03B7 {{currentQuestion}} \u03B1\u03C0\u03CC {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_6 = "\u0395\u03C1\u03C9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2 \u03C3\u03C4\u03B9\u03C2 \u03BF\u03C0\u03BF\u03AF\u03B5\u03C2 \u03B4\u03B5\u03BD \u03B1\u03C0\u03B1\u03BD\u03C4\u03AE\u03C3\u03B1\u03C4\u03B5 \u03C3\u03C9\u03C3\u03C4\u03AC \u03C3\u03C4\u03B7\u03BD \u03B1\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7:";
    Retake_Exam6 = "\u0395\u03C0\u03B1\u03BD\u03AC\u03BB\u03B7\u03C8\u03B7 \u03B5\u03BE\u03AD\u03C4\u03B1\u03C3\u03B7\u03C2";
    Return6 = "\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE";
    Review_answer_feedback_to_learn_more_6 = "\u0395\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03C4\u03B1 \u03C3\u03C7\u03CC\u03BB\u03B9\u03B1 \u03C3\u03C4\u03B9\u03C2 \u03B1\u03C0\u03B1\u03BD\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BC\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1.";
    Score____score___6 = "\u0392\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1: {{score}}%";
    Select_an_answer6 = "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03B1\u03C0\u03AC\u03BD\u03C4\u03B7\u03C3\u03B7";
    Submit_Answer_s_6 = "\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE \u03B1\u03C0\u03AC\u03BD\u03C4\u03B7\u03C3\u03B7\u03C2/\u03B1\u03C0\u03B1\u03BD\u03C4\u03AE\u03C3\u03B5\u03C9\u03BD";
    The_response_options_are__6 = "\u039F\u03B9 \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2 \u03B1\u03C0\u03AC\u03BD\u03C4\u03B7\u03C3\u03B7\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question6 = "\u0393\u03B9\u03B1 \u03BD\u03B1 \u03B1\u03C0\u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03C4\u03B5 \u03BC\u03AF\u03B1 \u03B1\u03C0\u03AC\u03BD\u03C4\u03B7\u03C3\u03B7, \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u0391\u03C0\u03B1\u03BB\u03BF\u03B9\u03C6\u03AE \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE\u03C2 \u03BC\u03B5\u03C4\u03AC \u03C4\u03B7\u03BD \u03C4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1 \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03B1\u03C0\u03AC\u03BD\u03C4\u03B7\u03C3\u03B7\u03C2 \u03B3\u03B9\u03B1 \u03BA\u03AC\u03B8\u03B5 \u03B5\u03C1\u03CE\u03C4\u03B7\u03C3\u03B7";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_6 = "\u0394\u03C5\u03C3\u03C4\u03C5\u03C7\u03CE\u03C2, \u03B4\u03B5\u03BD \u03C4\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C6\u03AD\u03C1\u03B1\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03B8\u03B1 \u03C7\u03C1\u03B5\u03B9\u03B1\u03C3\u03C4\u03B5\u03AF \u03BD\u03B1 \u03B5\u03C0\u03B1\u03BD\u03B1\u03BB\u03AC\u03B2\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B1\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7.";
    Value_must_be_greater_than_or_equal_to_06 = "\u0397 \u03C4\u03B9\u03BC\u03AE \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B5\u03B3\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B7 \u03B1\u03C0\u03CC \u03AE \u03AF\u03C3\u03B7 \u03BC\u03B5 0";
    You_passed_6 = "\u03A0\u03B5\u03C1\u03AC\u03C3\u03B1\u03C4\u03B5!";
    translations_default6 = {
      "(Select all that apply)": _Select_all_that_apply_6,
      "1,000 character limit": __000_character_limit6,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required6,
      Answer: Answer6,
      "Answer (Must be a number)": Answer__Must_be_a_number_6,
      Answerssss: Answerssss6,
      "Assessment Completed": Assessment_Completed6,
      Clear: Clear6,
      "Clear Selection": Clear_Selection6,
      Close: Close6,
      Continue: Continue6,
      Finish: Finish6,
      "Let's Get Started": Let_s_Get_Started6,
      "Must be a decimal": Must_be_a_decimal6,
      Next: Next6,
      "Next Page": Next_Page6,
      "Number of Drinks": Number_of_Drinks6,
      OK: OK6,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__6,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_6,
      Prev: Prev6,
      Previous: Previous6,
      "Previous Page": Previous_Page6,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__6,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_6,
      "Retake Exam": Retake_Exam6,
      Return: Return6,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_6,
      "Score: {{score}}%": Score____score___6,
      "Select an answer": Select_an_answer6,
      "Submit Answer(s)": Submit_Answer_s_6,
      "The response options are: ": The_response_options_are__6,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question6,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_6,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_06,
      "You passed!": You_passed_6
    };
  }
});

// src/lib/locales/en/translations.json
var translations_exports7 = {};
__export(translations_exports7, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_7;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit7;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required7;
  },
  Answer: function Answer() {
    return Answer7;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_7;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed7;
  },
  Clear: function Clear() {
    return Clear7;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection7;
  },
  Close: function Close() {
    return Close7;
  },
  Continue: function Continue() {
    return Continue7;
  },
  Finish: function Finish() {
    return Finish7;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started7;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal7;
  },
  Next: function Next() {
    return Next7;
  },
  "Next Page": function NextPage() {
    return Next_Page7;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks7;
  },
  OK: function OK() {
    return OK7;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__7;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_7;
  },
  Prev: function Prev() {
    return Prev7;
  },
  Previous: function Previous() {
    return Previous7;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page7;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__7;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_7;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam7;
  },
  Return: function Return() {
    return Return7;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_7;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___7;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer7;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_7;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__7;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question7;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_7;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_07;
  },
  "You passed!": function YouPassed() {
    return You_passed_7;
  },
  "default": function _default() {
    return translations_default7;
  }
});
var _Select_all_that_apply_7, __000_character_limit7, A_score_of_at_least___passingGrade____is_required7, Answer7, Answer__Must_be_a_number_7, Assessment_Completed7, Clear7, Clear_Selection7, Close7, Continue7, Finish7, Let_s_Get_Started7, Must_be_a_decimal7, Next7, Next_Page7, Number_of_Drinks7, OK7, Page___currentPage___of___totalPages__7, Please_click_OK_to_continue_to_the_next_page_7, Prev7, Previous7, Previous_Page7, Question___currentQuestion___of___totalQuestions__7, Questions_you_missed_on_the_assessment_7, Retake_Exam7, Return7, Review_answer_feedback_to_learn_more_7, Score____score___7, Select_an_answer7, Submit_Answer_s_7, The_response_options_are__7, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question7, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_7, Value_must_be_greater_than_or_equal_to_07, You_passed_7, translations_default7;
var init_translations7 = __esm({
  "src/lib/locales/en/translations.json": function srcLibLocalesEnTranslationsJson() {
    _Select_all_that_apply_7 = "(Select all that apply)";
    __000_character_limit7 = "1,000 character limit";
    A_score_of_at_least___passingGrade____is_required7 = "A score of at least {{passingGrade}}% is required";
    Answer7 = "Answer";
    Answer__Must_be_a_number_7 = "Answer (Must be a number)";
    Assessment_Completed7 = "Assessment Completed";
    Clear7 = "Clear";
    Clear_Selection7 = "Clear Selection";
    Close7 = "Close";
    Continue7 = "Continue";
    Finish7 = "Finish";
    Let_s_Get_Started7 = "Let's Get Started";
    Must_be_a_decimal7 = "Must be a decimal";
    Next7 = "Next";
    Next_Page7 = "Next Page";
    Number_of_Drinks7 = "Number of Drinks";
    OK7 = "OK";
    Page___currentPage___of___totalPages__7 = "Page {{currentPage}} of {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_7 = "Please click OK to continue to the next page.";
    Prev7 = "Prev";
    Previous7 = "Previous";
    Previous_Page7 = "Previous Page";
    Question___currentQuestion___of___totalQuestions__7 = "Question {{currentQuestion}} of {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_7 = "Questions you missed on the assessment:";
    Retake_Exam7 = "Retake Exam";
    Return7 = "Return";
    Review_answer_feedback_to_learn_more_7 = "Review answer feedback to learn more.";
    Score____score___7 = "Score: {{score}}%";
    Select_an_answer7 = "Select an answer";
    Submit_Answer_s_7 = "Submit Answer(s)";
    The_response_options_are__7 = "The response options are: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question7 = "To deselect an answer, use the Clear Selection option after the last answer choice for each question";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_7 = "Unfortunately, you did not pass and will need to retake the assessment.";
    Value_must_be_greater_than_or_equal_to_07 = "Value must be greater than or equal to 0";
    You_passed_7 = "You passed!";
    translations_default7 = {
      "(Select all that apply)": _Select_all_that_apply_7,
      "1,000 character limit": __000_character_limit7,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required7,
      Answer: Answer7,
      "Answer (Must be a number)": Answer__Must_be_a_number_7,
      "Assessment Completed": Assessment_Completed7,
      Clear: Clear7,
      "Clear Selection": Clear_Selection7,
      Close: Close7,
      Continue: Continue7,
      Finish: Finish7,
      "Let's Get Started": Let_s_Get_Started7,
      "Must be a decimal": Must_be_a_decimal7,
      Next: Next7,
      "Next Page": Next_Page7,
      "Number of Drinks": Number_of_Drinks7,
      OK: OK7,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__7,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_7,
      Prev: Prev7,
      Previous: Previous7,
      "Previous Page": Previous_Page7,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__7,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_7,
      "Retake Exam": Retake_Exam7,
      Return: Return7,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_7,
      "Score: {{score}}%": Score____score___7,
      "Select an answer": Select_an_answer7,
      "Submit Answer(s)": Submit_Answer_s_7,
      "The response options are: ": The_response_options_are__7,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question7,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_7,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_07,
      "You passed!": You_passed_7
    };
  }
});

// src/lib/locales/en-GB/translations.json
var translations_exports8 = {};
__export(translations_exports8, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_8;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit8;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required8;
  },
  Answer: function Answer() {
    return Answer8;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_8;
  },
  Answerssss: function Answerssss() {
    return Answerssss7;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed8;
  },
  Clear: function Clear() {
    return Clear8;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection8;
  },
  Close: function Close() {
    return Close8;
  },
  Continue: function Continue() {
    return Continue8;
  },
  Finish: function Finish() {
    return Finish8;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started8;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal8;
  },
  Next: function Next() {
    return Next8;
  },
  "Next Page": function NextPage() {
    return Next_Page8;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks8;
  },
  OK: function OK() {
    return OK8;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__8;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_8;
  },
  Prev: function Prev() {
    return Prev8;
  },
  Previous: function Previous() {
    return Previous8;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page8;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__8;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_8;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam8;
  },
  Return: function Return() {
    return Return8;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_8;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___8;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer8;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_8;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__8;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question8;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_8;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_08;
  },
  "You passed!": function YouPassed() {
    return You_passed_8;
  },
  "default": function _default() {
    return translations_default8;
  }
});
var _Select_all_that_apply_8, __000_character_limit8, A_score_of_at_least___passingGrade____is_required8, Answer8, Answer__Must_be_a_number_8, Answerssss7, Assessment_Completed8, Clear8, Clear_Selection8, Close8, Continue8, Finish8, Let_s_Get_Started8, Must_be_a_decimal8, Next8, Next_Page8, Number_of_Drinks8, OK8, Page___currentPage___of___totalPages__8, Please_click_OK_to_continue_to_the_next_page_8, Prev8, Previous8, Previous_Page8, Question___currentQuestion___of___totalQuestions__8, Questions_you_missed_on_the_assessment_8, Retake_Exam8, Return8, Review_answer_feedback_to_learn_more_8, Score____score___8, Select_an_answer8, Submit_Answer_s_8, The_response_options_are__8, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question8, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_8, Value_must_be_greater_than_or_equal_to_08, You_passed_8, translations_default8;
var init_translations8 = __esm({
  "src/lib/locales/en-GB/translations.json": function srcLibLocalesEnGBTranslationsJson() {
    _Select_all_that_apply_8 = "(Select all that apply)";
    __000_character_limit8 = "1,000 character limit";
    A_score_of_at_least___passingGrade____is_required8 = "A score of at least {{passingGrade}}% is required";
    Answer8 = "Answer";
    Answer__Must_be_a_number_8 = "Answer (Must be a number)";
    Answerssss7 = "Answers";
    Assessment_Completed8 = "Assessment Completed";
    Clear8 = "Clear";
    Clear_Selection8 = "Clear Selection";
    Close8 = "Close";
    Continue8 = "Continue";
    Finish8 = "Finish";
    Let_s_Get_Started8 = "Let's Get Started";
    Must_be_a_decimal8 = "Must be a decimal";
    Next8 = "Next";
    Next_Page8 = "Next Page";
    Number_of_Drinks8 = "Number of Drinks";
    OK8 = "OK";
    Page___currentPage___of___totalPages__8 = "Page {{currentPage}} of {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_8 = "Please click OK to continue to the next page.";
    Prev8 = "Prev";
    Previous8 = "Previous";
    Previous_Page8 = "Previous Page";
    Question___currentQuestion___of___totalQuestions__8 = "Question {{currentQuestion}} of {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_8 = "Questions you missed on the assessment:";
    Retake_Exam8 = "Retake Exam";
    Return8 = "Return";
    Review_answer_feedback_to_learn_more_8 = "Review answer feedback to learn more.";
    Score____score___8 = "Score: {{score}}%";
    Select_an_answer8 = "Select an answer";
    Submit_Answer_s_8 = "Submit Answer(s)";
    The_response_options_are__8 = "The response options are: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question8 = "To deselect an answer, use the Clear Selection option after the last answer choice for each question";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_8 = "Unfortunately, you did not pass and will need to retake the assessment.";
    Value_must_be_greater_than_or_equal_to_08 = "Value must be greater than or equal to 0";
    You_passed_8 = "You passed!";
    translations_default8 = {
      "(Select all that apply)": _Select_all_that_apply_8,
      "1,000 character limit": __000_character_limit8,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required8,
      Answer: Answer8,
      "Answer (Must be a number)": Answer__Must_be_a_number_8,
      Answerssss: Answerssss7,
      "Assessment Completed": Assessment_Completed8,
      Clear: Clear8,
      "Clear Selection": Clear_Selection8,
      Close: Close8,
      Continue: Continue8,
      Finish: Finish8,
      "Let's Get Started": Let_s_Get_Started8,
      "Must be a decimal": Must_be_a_decimal8,
      Next: Next8,
      "Next Page": Next_Page8,
      "Number of Drinks": Number_of_Drinks8,
      OK: OK8,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__8,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_8,
      Prev: Prev8,
      Previous: Previous8,
      "Previous Page": Previous_Page8,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__8,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_8,
      "Retake Exam": Retake_Exam8,
      Return: Return8,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_8,
      "Score: {{score}}%": Score____score___8,
      "Select an answer": Select_an_answer8,
      "Submit Answer(s)": Submit_Answer_s_8,
      "The response options are: ": The_response_options_are__8,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question8,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_8,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_08,
      "You passed!": You_passed_8
    };
  }
});

// src/lib/locales/en-US/translations.json
var translations_exports9 = {};
__export(translations_exports9, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_9;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit9;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required9;
  },
  Answer: function Answer() {
    return Answer9;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_9;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed9;
  },
  Clear: function Clear() {
    return Clear9;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection9;
  },
  Close: function Close() {
    return Close9;
  },
  Continue: function Continue() {
    return Continue9;
  },
  Finish: function Finish() {
    return Finish9;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started9;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal9;
  },
  Next: function Next() {
    return Next9;
  },
  "Next Page": function NextPage() {
    return Next_Page9;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks9;
  },
  OK: function OK() {
    return OK9;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__9;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_9;
  },
  Prev: function Prev() {
    return Prev9;
  },
  Previous: function Previous() {
    return Previous9;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page9;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__9;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_9;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam9;
  },
  Return: function Return() {
    return Return9;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_9;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___9;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer9;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_9;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__9;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question9;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_9;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_09;
  },
  "You passed!": function YouPassed() {
    return You_passed_9;
  },
  "default": function _default() {
    return translations_default9;
  }
});
var _Select_all_that_apply_9, __000_character_limit9, A_score_of_at_least___passingGrade____is_required9, Answer9, Answer__Must_be_a_number_9, Assessment_Completed9, Clear9, Clear_Selection9, Close9, Continue9, Finish9, Let_s_Get_Started9, Must_be_a_decimal9, Next9, Next_Page9, Number_of_Drinks9, OK9, Page___currentPage___of___totalPages__9, Please_click_OK_to_continue_to_the_next_page_9, Prev9, Previous9, Previous_Page9, Question___currentQuestion___of___totalQuestions__9, Questions_you_missed_on_the_assessment_9, Retake_Exam9, Return9, Review_answer_feedback_to_learn_more_9, Score____score___9, Select_an_answer9, Submit_Answer_s_9, The_response_options_are__9, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question9, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_9, Value_must_be_greater_than_or_equal_to_09, You_passed_9, translations_default9;
var init_translations9 = __esm({
  "src/lib/locales/en-US/translations.json": function srcLibLocalesEnUSTranslationsJson() {
    _Select_all_that_apply_9 = "(Select all that apply)";
    __000_character_limit9 = "1,000 character limit";
    A_score_of_at_least___passingGrade____is_required9 = "A score of at least {{passingGrade}}% is required";
    Answer9 = "Answer";
    Answer__Must_be_a_number_9 = "Answer (Must be a number)";
    Assessment_Completed9 = "Assessment Completed";
    Clear9 = "Clear";
    Clear_Selection9 = "Clear Selection";
    Close9 = "Close";
    Continue9 = "Continue";
    Finish9 = "Finish";
    Let_s_Get_Started9 = "Let's Get Started";
    Must_be_a_decimal9 = "Must be a decimal";
    Next9 = "Next";
    Next_Page9 = "Next Page";
    Number_of_Drinks9 = "Number of Drinks";
    OK9 = "OK";
    Page___currentPage___of___totalPages__9 = "Page {{currentPage}} of {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_9 = "Please click OK to continue to the next page.";
    Prev9 = "Prev";
    Previous9 = "Previous";
    Previous_Page9 = "Previous Page";
    Question___currentQuestion___of___totalQuestions__9 = "Question {{currentQuestion}} of {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_9 = "Questions you missed on the assessment:";
    Retake_Exam9 = "Retake Exam";
    Return9 = "Return";
    Review_answer_feedback_to_learn_more_9 = "Review answer feedback to learn more.";
    Score____score___9 = "Score: {{score}}%";
    Select_an_answer9 = "Select an answer";
    Submit_Answer_s_9 = "Submit Answer(s)";
    The_response_options_are__9 = "The response options are: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question9 = "To deselect an answer, use the Clear Selection option after the last answer choice for each question";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_9 = "Unfortunately, you did not pass and will need to retake the assessment.";
    Value_must_be_greater_than_or_equal_to_09 = "Value must be greater than or equal to 0";
    You_passed_9 = "You passed!";
    translations_default9 = {
      "(Select all that apply)": _Select_all_that_apply_9,
      "1,000 character limit": __000_character_limit9,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required9,
      Answer: Answer9,
      "Answer (Must be a number)": Answer__Must_be_a_number_9,
      "Assessment Completed": Assessment_Completed9,
      Clear: Clear9,
      "Clear Selection": Clear_Selection9,
      Close: Close9,
      Continue: Continue9,
      Finish: Finish9,
      "Let's Get Started": Let_s_Get_Started9,
      "Must be a decimal": Must_be_a_decimal9,
      Next: Next9,
      "Next Page": Next_Page9,
      "Number of Drinks": Number_of_Drinks9,
      OK: OK9,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__9,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_9,
      Prev: Prev9,
      Previous: Previous9,
      "Previous Page": Previous_Page9,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__9,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_9,
      "Retake Exam": Retake_Exam9,
      Return: Return9,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_9,
      "Score: {{score}}%": Score____score___9,
      "Select an answer": Select_an_answer9,
      "Submit Answer(s)": Submit_Answer_s_9,
      "The response options are: ": The_response_options_are__9,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question9,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_9,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_09,
      "You passed!": You_passed_9
    };
  }
});

// src/lib/locales/es/translations.json
var translations_exports10 = {};
__export(translations_exports10, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_10;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit10;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required10;
  },
  Answer: function Answer() {
    return Answer10;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_10;
  },
  Answerssss: function Answerssss() {
    return Answerssss8;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed10;
  },
  Clear: function Clear() {
    return Clear10;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection10;
  },
  Close: function Close() {
    return Close10;
  },
  Continue: function Continue() {
    return Continue10;
  },
  Finish: function Finish() {
    return Finish10;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started10;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal10;
  },
  Next: function Next() {
    return Next10;
  },
  "Next Page": function NextPage() {
    return Next_Page10;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks10;
  },
  OK: function OK() {
    return OK10;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__10;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_10;
  },
  Prev: function Prev() {
    return Prev10;
  },
  Previous: function Previous() {
    return Previous10;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page10;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__10;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_10;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam10;
  },
  Return: function Return() {
    return Return10;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_10;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___10;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer10;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_10;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__10;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question10;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_10;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_010;
  },
  "You passed!": function YouPassed() {
    return You_passed_10;
  },
  "default": function _default() {
    return translations_default10;
  }
});
var _Select_all_that_apply_10, __000_character_limit10, A_score_of_at_least___passingGrade____is_required10, Answer10, Answer__Must_be_a_number_10, Answerssss8, Assessment_Completed10, Clear10, Clear_Selection10, Close10, Continue10, Finish10, Let_s_Get_Started10, Must_be_a_decimal10, Next10, Next_Page10, Number_of_Drinks10, OK10, Page___currentPage___of___totalPages__10, Please_click_OK_to_continue_to_the_next_page_10, Prev10, Previous10, Previous_Page10, Question___currentQuestion___of___totalQuestions__10, Questions_you_missed_on_the_assessment_10, Retake_Exam10, Return10, Review_answer_feedback_to_learn_more_10, Score____score___10, Select_an_answer10, Submit_Answer_s_10, The_response_options_are__10, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question10, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_10, Value_must_be_greater_than_or_equal_to_010, You_passed_10, translations_default10;
var init_translations10 = __esm({
  "src/lib/locales/es/translations.json": function srcLibLocalesEsTranslationsJson() {
    _Select_all_that_apply_10 = "(Seleccione todas las que correspondan)";
    __000_character_limit10 = "L\xEDmite de 1000 caracteres";
    A_score_of_at_least___passingGrade____is_required10 = "Se necesita una puntuaci\xF3n m\xEDnima de {{passingGrade}}\xA0%";
    Answer10 = "Respuesta";
    Answer__Must_be_a_number_10 = "Respuesta (debe ser un n\xFAmero)";
    Answerssss8 = "Respuestas";
    Assessment_Completed10 = "Evaluaci\xF3n completada";
    Clear10 = "Borrar";
    Clear_Selection10 = "Cancelar selecci\xF3n";
    Close10 = "Cerrar";
    Continue10 = "Continuar";
    Finish10 = "Finalizar";
    Let_s_Get_Started10 = "Empezar";
    Must_be_a_decimal10 = "Debe ser un decimal";
    Next10 = "Siguiente";
    Next_Page10 = "P\xE1gina siguiente";
    Number_of_Drinks10 = "N\xFAmero de bebidas";
    OK10 = "Aceptar";
    Page___currentPage___of___totalPages__10 = "P\xE1gina {{currentPage}} de {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_10 = "Haga clic en Aceptar para avanzar a la p\xE1gina siguiente.";
    Prev10 = "Anterior";
    Previous10 = "Anterior";
    Previous_Page10 = "P\xE1gina anterior";
    Question___currentQuestion___of___totalQuestions__10 = "Pregunta {{currentQuestion}} de {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_10 = "Preguntas que respondi\xF3 de forma incorrecta en la evaluaci\xF3n:";
    Retake_Exam10 = "Volver a hacer el examen";
    Return10 = "Volver";
    Review_answer_feedback_to_learn_more_10 = "Revisar los comentarios a las respuestas para obtener m\xE1s informaci\xF3n.";
    Score____score___10 = "Puntuaci\xF3n: {{score}}\xA0%";
    Select_an_answer10 = "Seleccionar una respuesta";
    Submit_Answer_s_10 = "Enviar respuesta(s)";
    The_response_options_are__10 = "Las opciones de respuesta son las siguientes: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question10 = "Para cancelar la selecci\xF3n de una respuesta, utilice la opci\xF3n Cancelar selecci\xF3n que se muestra despu\xE9s de la \xFAltima opci\xF3n de respuesta para cada pregunta";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_10 = "Lamentamos comunicarle que no ha aprobado y debe volver a hacer la evaluaci\xF3n.";
    Value_must_be_greater_than_or_equal_to_010 = "El valor debe ser mayor o igual a 0";
    You_passed_10 = "\xA1Ha aprobado!";
    translations_default10 = {
      "(Select all that apply)": _Select_all_that_apply_10,
      "1,000 character limit": __000_character_limit10,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required10,
      Answer: Answer10,
      "Answer (Must be a number)": Answer__Must_be_a_number_10,
      Answerssss: Answerssss8,
      "Assessment Completed": Assessment_Completed10,
      Clear: Clear10,
      "Clear Selection": Clear_Selection10,
      Close: Close10,
      Continue: Continue10,
      Finish: Finish10,
      "Let's Get Started": Let_s_Get_Started10,
      "Must be a decimal": Must_be_a_decimal10,
      Next: Next10,
      "Next Page": Next_Page10,
      "Number of Drinks": Number_of_Drinks10,
      OK: OK10,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__10,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_10,
      Prev: Prev10,
      Previous: Previous10,
      "Previous Page": Previous_Page10,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__10,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_10,
      "Retake Exam": Retake_Exam10,
      Return: Return10,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_10,
      "Score: {{score}}%": Score____score___10,
      "Select an answer": Select_an_answer10,
      "Submit Answer(s)": Submit_Answer_s_10,
      "The response options are: ": The_response_options_are__10,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question10,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_10,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_010,
      "You passed!": You_passed_10
    };
  }
});

// src/lib/locales/es-ES/translations.json
var translations_exports11 = {};
__export(translations_exports11, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_11;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit11;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required11;
  },
  Answer: function Answer() {
    return Answer11;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_11;
  },
  Answerssss: function Answerssss() {
    return Answerssss9;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed11;
  },
  Clear: function Clear() {
    return Clear11;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection11;
  },
  Close: function Close() {
    return Close11;
  },
  Continue: function Continue() {
    return Continue11;
  },
  Finish: function Finish() {
    return Finish11;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started11;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal11;
  },
  Next: function Next() {
    return Next11;
  },
  "Next Page": function NextPage() {
    return Next_Page11;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks11;
  },
  OK: function OK() {
    return OK11;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__11;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_11;
  },
  Prev: function Prev() {
    return Prev11;
  },
  Previous: function Previous() {
    return Previous11;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page11;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__11;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_11;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam11;
  },
  Return: function Return() {
    return Return11;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_11;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___11;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer11;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_11;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__11;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question11;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_11;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_011;
  },
  "You passed!": function YouPassed() {
    return You_passed_11;
  },
  "default": function _default() {
    return translations_default11;
  }
});
var _Select_all_that_apply_11, __000_character_limit11, A_score_of_at_least___passingGrade____is_required11, Answer11, Answer__Must_be_a_number_11, Answerssss9, Assessment_Completed11, Clear11, Clear_Selection11, Close11, Continue11, Finish11, Let_s_Get_Started11, Must_be_a_decimal11, Next11, Next_Page11, Number_of_Drinks11, OK11, Page___currentPage___of___totalPages__11, Please_click_OK_to_continue_to_the_next_page_11, Prev11, Previous11, Previous_Page11, Question___currentQuestion___of___totalQuestions__11, Questions_you_missed_on_the_assessment_11, Retake_Exam11, Return11, Review_answer_feedback_to_learn_more_11, Score____score___11, Select_an_answer11, Submit_Answer_s_11, The_response_options_are__11, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question11, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_11, Value_must_be_greater_than_or_equal_to_011, You_passed_11, translations_default11;
var init_translations11 = __esm({
  "src/lib/locales/es-ES/translations.json": function srcLibLocalesEsESTranslationsJson() {
    _Select_all_that_apply_11 = "(Seleccione todas las aplicables)";
    __000_character_limit11 = "L\xEDmite de 1000 caracteres";
    A_score_of_at_least___passingGrade____is_required11 = "Se necesita una puntuaci\xF3n m\xEDnima de {{passingGrade}}\xA0%";
    Answer11 = "Respuesta";
    Answer__Must_be_a_number_11 = "Respuesta (debe ser un n\xFAmero)";
    Answerssss9 = "Respuestas";
    Assessment_Completed11 = "Evaluaci\xF3n completada";
    Clear11 = "Borrar";
    Clear_Selection11 = "Cancelar selecci\xF3n";
    Close11 = "Cerrar";
    Continue11 = "Continuar";
    Finish11 = "Terminar";
    Let_s_Get_Started11 = "Empezar";
    Must_be_a_decimal11 = "Debe ser un decimal";
    Next11 = "Siguiente";
    Next_Page11 = "P\xE1gina siguiente";
    Number_of_Drinks11 = "N\xFAmero de bebidas";
    OK11 = "OK";
    Page___currentPage___of___totalPages__11 = "P\xE1gina {{currentPage}} de {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_11 = "Haga clic en OK para pasar a la p\xE1gina siguiente.";
    Prev11 = "Prev";
    Previous11 = "Anterior";
    Previous_Page11 = "P\xE1gina anterior";
    Question___currentQuestion___of___totalQuestions__11 = "Pregunta {{currentQuestion}} de {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_11 = "Preguntas que respondi\xF3 de forma incorrecta en la evaluaci\xF3n:";
    Retake_Exam11 = "Volver a hacer el examen";
    Return11 = "Volver";
    Review_answer_feedback_to_learn_more_11 = "Revisar los comentarios a las respuestas para obtener m\xE1s informaci\xF3n.";
    Score____score___11 = "Puntuaci\xF3n: {{score}}\xA0%";
    Select_an_answer11 = "Seleccionar una respuesta";
    Submit_Answer_s_11 = "Enviar respuesta(s)";
    The_response_options_are__11 = "Las opciones de respuesta son: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question11 = "Para cancelar la selecci\xF3n de una respuesta, utilice la opci\xF3n Cancelar selecci\xF3n que se muestra despu\xE9s de la \xFAltima opci\xF3n de respuesta para cada pregunta";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_11 = "Lamentamos comunicarle que no ha aprobado y debe volver a hacer la evaluaci\xF3n.";
    Value_must_be_greater_than_or_equal_to_011 = "El valor debe ser mayor o igual a 0";
    You_passed_11 = "\xA1Ha aprobado!";
    translations_default11 = {
      "(Select all that apply)": _Select_all_that_apply_11,
      "1,000 character limit": __000_character_limit11,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required11,
      Answer: Answer11,
      "Answer (Must be a number)": Answer__Must_be_a_number_11,
      Answerssss: Answerssss9,
      "Assessment Completed": Assessment_Completed11,
      Clear: Clear11,
      "Clear Selection": Clear_Selection11,
      Close: Close11,
      Continue: Continue11,
      Finish: Finish11,
      "Let's Get Started": Let_s_Get_Started11,
      "Must be a decimal": Must_be_a_decimal11,
      Next: Next11,
      "Next Page": Next_Page11,
      "Number of Drinks": Number_of_Drinks11,
      OK: OK11,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__11,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_11,
      Prev: Prev11,
      Previous: Previous11,
      "Previous Page": Previous_Page11,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__11,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_11,
      "Retake Exam": Retake_Exam11,
      Return: Return11,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_11,
      "Score: {{score}}%": Score____score___11,
      "Select an answer": Select_an_answer11,
      "Submit Answer(s)": Submit_Answer_s_11,
      "The response options are: ": The_response_options_are__11,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question11,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_11,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_011,
      "You passed!": You_passed_11
    };
  }
});

// src/lib/locales/fi-FI/translations.json
var translations_exports12 = {};
__export(translations_exports12, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_12;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit12;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required12;
  },
  Answer: function Answer() {
    return Answer12;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_12;
  },
  Answerssss: function Answerssss() {
    return Answerssss10;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed12;
  },
  Clear: function Clear() {
    return Clear12;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection12;
  },
  Close: function Close() {
    return Close12;
  },
  Continue: function Continue() {
    return Continue12;
  },
  Finish: function Finish() {
    return Finish12;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started12;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal12;
  },
  Next: function Next() {
    return Next12;
  },
  "Next Page": function NextPage() {
    return Next_Page12;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks12;
  },
  OK: function OK() {
    return OK12;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__12;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_12;
  },
  Prev: function Prev() {
    return Prev12;
  },
  Previous: function Previous() {
    return Previous12;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page12;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__12;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_12;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam12;
  },
  Return: function Return() {
    return Return12;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_12;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___12;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer12;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_12;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__12;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question12;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_12;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_012;
  },
  "You passed!": function YouPassed() {
    return You_passed_12;
  },
  "default": function _default() {
    return translations_default12;
  }
});
var _Select_all_that_apply_12, __000_character_limit12, A_score_of_at_least___passingGrade____is_required12, Answer12, Answer__Must_be_a_number_12, Answerssss10, Assessment_Completed12, Clear12, Clear_Selection12, Close12, Continue12, Finish12, Let_s_Get_Started12, Must_be_a_decimal12, Next12, Next_Page12, Number_of_Drinks12, OK12, Page___currentPage___of___totalPages__12, Please_click_OK_to_continue_to_the_next_page_12, Prev12, Previous12, Previous_Page12, Question___currentQuestion___of___totalQuestions__12, Questions_you_missed_on_the_assessment_12, Retake_Exam12, Return12, Review_answer_feedback_to_learn_more_12, Score____score___12, Select_an_answer12, Submit_Answer_s_12, The_response_options_are__12, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question12, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_12, Value_must_be_greater_than_or_equal_to_012, You_passed_12, translations_default12;
var init_translations12 = __esm({
  "src/lib/locales/fi-FI/translations.json": function srcLibLocalesFiFITranslationsJson() {
    _Select_all_that_apply_12 = "(Valitse kaikki sopivat)";
    __000_character_limit12 = "Enimm\xE4ismerkkim\xE4\xE4r\xE4 1\xA0000";
    A_score_of_at_least___passingGrade____is_required12 = "Vaadittu pistem\xE4\xE4r\xE4 on v\xE4hint\xE4\xE4n {{passingGrade}} %";
    Answer12 = "Vastaus";
    Answer__Must_be_a_number_12 = "Vastaus (on oltava numero)";
    Answerssss10 = "Vastaukset";
    Assessment_Completed12 = "Arviointi suoritettu";
    Clear12 = "Tyhjenn\xE4";
    Clear_Selection12 = "Tyhjenn\xE4 valinta";
    Close12 = "Sulje";
    Continue12 = "Jatka";
    Finish12 = "Lopeta";
    Let_s_Get_Started12 = "Aloitetaan";
    Must_be_a_decimal12 = "On oltava desimaali";
    Next12 = "Seuraava";
    Next_Page12 = "Seuraava sivu";
    Number_of_Drinks12 = "Juomien m\xE4\xE4r\xE4";
    OK12 = "OK";
    Page___currentPage___of___totalPages__12 = "Sivu {{currentPage}}/{{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_12 = "Jatka seuraavalle sivulle napsauttamalla OK.";
    Prev12 = "Edellinen";
    Previous12 = "Edellinen";
    Previous_Page12 = "Edellinen sivu";
    Question___currentQuestion___of___totalQuestions__12 = "Kysymys {{currentQuestion}}/{{totalQuestions}}";
    Questions_you_missed_on_the_assessment_12 = "Kysymykset, jotka j\xE4tit arvioinnin ulkopuolelle:";
    Retake_Exam12 = "Uusi koe";
    Return12 = "Takaisin";
    Review_answer_feedback_to_learn_more_12 = "Lue lis\xE4\xE4 vastauspalautteesta.";
    Score____score___12 = "Pisteet: {{score}} %";
    Select_an_answer12 = "Valitse vastaus";
    Submit_Answer_s_12 = "L\xE4het\xE4 vastaus";
    The_response_options_are__12 = "Vastausvaihtoehdot: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question12 = "Jos haluat poistaa vastauksen valinnan, valitse Tyhjenn\xE4 valinta kunkin kysymyksen viimeisen vastausvaihtoehdon j\xE4lkeen.";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_12 = "Valitettavasti et p\xE4\xE4ssyt l\xE4pi ja sinun on suoritettava arviointi uudelleen.";
    Value_must_be_greater_than_or_equal_to_012 = "Arvon on oltava v\xE4hint\xE4\xE4n 0";
    You_passed_12 = "P\xE4\xE4sit l\xE4pi!";
    translations_default12 = {
      "(Select all that apply)": _Select_all_that_apply_12,
      "1,000 character limit": __000_character_limit12,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required12,
      Answer: Answer12,
      "Answer (Must be a number)": Answer__Must_be_a_number_12,
      Answerssss: Answerssss10,
      "Assessment Completed": Assessment_Completed12,
      Clear: Clear12,
      "Clear Selection": Clear_Selection12,
      Close: Close12,
      Continue: Continue12,
      Finish: Finish12,
      "Let's Get Started": Let_s_Get_Started12,
      "Must be a decimal": Must_be_a_decimal12,
      Next: Next12,
      "Next Page": Next_Page12,
      "Number of Drinks": Number_of_Drinks12,
      OK: OK12,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__12,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_12,
      Prev: Prev12,
      Previous: Previous12,
      "Previous Page": Previous_Page12,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__12,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_12,
      "Retake Exam": Retake_Exam12,
      Return: Return12,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_12,
      "Score: {{score}}%": Score____score___12,
      "Select an answer": Select_an_answer12,
      "Submit Answer(s)": Submit_Answer_s_12,
      "The response options are: ": The_response_options_are__12,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question12,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_12,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_012,
      "You passed!": You_passed_12
    };
  }
});

// src/lib/locales/fr-CA/translations.json
var translations_exports13 = {};
__export(translations_exports13, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_13;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit13;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required13;
  },
  Answer: function Answer() {
    return Answer13;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_13;
  },
  Answerssss: function Answerssss() {
    return Answerssss11;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed13;
  },
  Clear: function Clear() {
    return Clear13;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection13;
  },
  Close: function Close() {
    return Close13;
  },
  Continue: function Continue() {
    return Continue13;
  },
  Finish: function Finish() {
    return Finish13;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started13;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal13;
  },
  Next: function Next() {
    return Next13;
  },
  "Next Page": function NextPage() {
    return Next_Page13;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks13;
  },
  OK: function OK() {
    return OK13;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__13;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_13;
  },
  Prev: function Prev() {
    return Prev13;
  },
  Previous: function Previous() {
    return Previous13;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page13;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__13;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_13;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam13;
  },
  Return: function Return() {
    return Return13;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_13;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___13;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer13;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_13;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__13;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question13;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_13;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_013;
  },
  "You passed!": function YouPassed() {
    return You_passed_13;
  },
  "default": function _default() {
    return translations_default13;
  }
});
var _Select_all_that_apply_13, __000_character_limit13, A_score_of_at_least___passingGrade____is_required13, Answer13, Answer__Must_be_a_number_13, Answerssss11, Assessment_Completed13, Clear13, Clear_Selection13, Close13, Continue13, Finish13, Let_s_Get_Started13, Must_be_a_decimal13, Next13, Next_Page13, Number_of_Drinks13, OK13, Page___currentPage___of___totalPages__13, Please_click_OK_to_continue_to_the_next_page_13, Prev13, Previous13, Previous_Page13, Question___currentQuestion___of___totalQuestions__13, Questions_you_missed_on_the_assessment_13, Retake_Exam13, Return13, Review_answer_feedback_to_learn_more_13, Score____score___13, Select_an_answer13, Submit_Answer_s_13, The_response_options_are__13, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question13, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_13, Value_must_be_greater_than_or_equal_to_013, You_passed_13, translations_default13;
var init_translations13 = __esm({
  "src/lib/locales/fr-CA/translations.json": function srcLibLocalesFrCATranslationsJson() {
    _Select_all_that_apply_13 = "(S\xE9lectionnez toutes les r\xE9ponses qui s'appliquent)";
    __000_character_limit13 = "1\xA0000\xA0caract\xE8res maximum";
    A_score_of_at_least___passingGrade____is_required13 = "Une note minimale de {{passingGrade}}\xA0% est requise";
    Answer13 = "R\xE9ponse";
    Answer__Must_be_a_number_13 = "R\xE9ponse (doit \xEAtre un nombre)";
    Answerssss11 = "R\xE9ponses";
    Assessment_Completed13 = "\xC9valuation termin\xE9e";
    Clear13 = "Effacer";
    Clear_Selection13 = "Effacer la s\xE9lection";
    Close13 = "Fermer";
    Continue13 = "Continuer";
    Finish13 = "Terminer";
    Let_s_Get_Started13 = "Commen\xE7ons!";
    Must_be_a_decimal13 = "Doit \xEAtre un nombre d\xE9cimal";
    Next13 = "Prochain";
    Next_Page13 = "Page suivante";
    Number_of_Drinks13 = "Nombre de consommations";
    OK13 = "OK";
    Page___currentPage___of___totalPages__13 = "Page {{currentPage}} sur {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_13 = "Veuillez cliquer sur OK pour acc\xE9der \xE0 la page suivante.";
    Prev13 = "Pr\xE9c.";
    Previous13 = "Pr\xE9c\xE9dent";
    Previous_Page13 = "Page pr\xE9c\xE9dente";
    Question___currentQuestion___of___totalQuestions__13 = "Question {{currentQuestion}} sur {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_13 = "Les questions que vous avez manqu\xE9es lors de l'\xE9valuation\xA0:";
    Retake_Exam13 = "Repasser l'examen";
    Return13 = "Retour";
    Review_answer_feedback_to_learn_more_13 = "Pour en savoir plus, consultez les commentaires li\xE9s aux r\xE9ponses.";
    Score____score___13 = "Note\xA0: {{score}}\xA0%";
    Select_an_answer13 = "S\xE9lectionnez une r\xE9ponse";
    Submit_Answer_s_13 = "Envoyer la ou les r\xE9ponses";
    The_response_options_are__13 = "Voici les diff\xE9rentes possibilit\xE9s de r\xE9ponse\xA0: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question13 = "Pour d\xE9s\xE9lectionner une r\xE9ponse, cliquez sur l'option \xAB\xA0Effacer la s\xE9lection\xA0\xBB apr\xE8s votre dernier choix de r\xE9ponse effectu\xE9 pour chaque question.";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_13 = "Malheureusement, vous avez \xE9chou\xE9 \xE0 l'examen et devrez le repasser.";
    Value_must_be_greater_than_or_equal_to_013 = "La valeur doit \xEAtre sup\xE9rieure ou \xE9gale \xE0\xA00";
    You_passed_13 = "Vous avez r\xE9ussi!";
    translations_default13 = {
      "(Select all that apply)": _Select_all_that_apply_13,
      "1,000 character limit": __000_character_limit13,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required13,
      Answer: Answer13,
      "Answer (Must be a number)": Answer__Must_be_a_number_13,
      Answerssss: Answerssss11,
      "Assessment Completed": Assessment_Completed13,
      Clear: Clear13,
      "Clear Selection": Clear_Selection13,
      Close: Close13,
      Continue: Continue13,
      Finish: Finish13,
      "Let's Get Started": Let_s_Get_Started13,
      "Must be a decimal": Must_be_a_decimal13,
      Next: Next13,
      "Next Page": Next_Page13,
      "Number of Drinks": Number_of_Drinks13,
      OK: OK13,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__13,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_13,
      Prev: Prev13,
      Previous: Previous13,
      "Previous Page": Previous_Page13,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__13,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_13,
      "Retake Exam": Retake_Exam13,
      Return: Return13,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_13,
      "Score: {{score}}%": Score____score___13,
      "Select an answer": Select_an_answer13,
      "Submit Answer(s)": Submit_Answer_s_13,
      "The response options are: ": The_response_options_are__13,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question13,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_13,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_013,
      "You passed!": You_passed_13
    };
  }
});

// src/lib/locales/fr-FR/translations.json
var translations_exports14 = {};
__export(translations_exports14, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_14;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit14;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required14;
  },
  Answer: function Answer() {
    return Answer14;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_14;
  },
  Answerssss: function Answerssss() {
    return Answerssss12;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed14;
  },
  Clear: function Clear() {
    return Clear14;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection14;
  },
  Close: function Close() {
    return Close14;
  },
  Continue: function Continue() {
    return Continue14;
  },
  Finish: function Finish() {
    return Finish14;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started14;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal14;
  },
  Next: function Next() {
    return Next14;
  },
  "Next Page": function NextPage() {
    return Next_Page14;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks14;
  },
  OK: function OK() {
    return OK14;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__14;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_14;
  },
  Prev: function Prev() {
    return Prev14;
  },
  Previous: function Previous() {
    return Previous14;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page14;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__14;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_14;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam14;
  },
  Return: function Return() {
    return Return14;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_14;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___14;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer14;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_14;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__14;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question14;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_14;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_014;
  },
  "You passed!": function YouPassed() {
    return You_passed_14;
  },
  "default": function _default() {
    return translations_default14;
  }
});
var _Select_all_that_apply_14, __000_character_limit14, A_score_of_at_least___passingGrade____is_required14, Answer14, Answer__Must_be_a_number_14, Answerssss12, Assessment_Completed14, Clear14, Clear_Selection14, Close14, Continue14, Finish14, Let_s_Get_Started14, Must_be_a_decimal14, Next14, Next_Page14, Number_of_Drinks14, OK14, Page___currentPage___of___totalPages__14, Please_click_OK_to_continue_to_the_next_page_14, Prev14, Previous14, Previous_Page14, Question___currentQuestion___of___totalQuestions__14, Questions_you_missed_on_the_assessment_14, Retake_Exam14, Return14, Review_answer_feedback_to_learn_more_14, Score____score___14, Select_an_answer14, Submit_Answer_s_14, The_response_options_are__14, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question14, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_14, Value_must_be_greater_than_or_equal_to_014, You_passed_14, translations_default14;
var init_translations14 = __esm({
  "src/lib/locales/fr-FR/translations.json": function srcLibLocalesFrFRTranslationsJson() {
    _Select_all_that_apply_14 = "(S\xE9lectionnez toutes les propositions pertinentes)";
    __000_character_limit14 = "1\xA0000\xA0caract\xE8res maximum";
    A_score_of_at_least___passingGrade____is_required14 = "Une note minimale de {{passingGrade}}\xA0% est requise";
    Answer14 = "R\xE9ponse";
    Answer__Must_be_a_number_14 = "R\xE9ponse (doit \xEAtre un chiffre)";
    Answerssss12 = "R\xE9ponses";
    Assessment_Completed14 = "\xC9valuation termin\xE9e";
    Clear14 = "Effacer";
    Clear_Selection14 = "Effacer la s\xE9lection";
    Close14 = "Fermer";
    Continue14 = "Continuer";
    Finish14 = "Termin\xE9";
    Let_s_Get_Started14 = "Commen\xE7ons\xA0!";
    Must_be_a_decimal14 = "Doit \xEAtre un nombre d\xE9cimal";
    Next14 = "Suivant";
    Next_Page14 = "Page suivante";
    Number_of_Drinks14 = "Nombre de boissons";
    OK14 = "OK";
    Page___currentPage___of___totalPages__14 = "Page {{currentPage}} sur {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_14 = "Veuillez cliquer sur OK pour acc\xE9der \xE0 la page suivante.";
    Prev14 = "Pr\xE9c.";
    Previous14 = "Pr\xE9c\xE9dent";
    Previous_Page14 = "Page pr\xE9c\xE9dente";
    Question___currentQuestion___of___totalQuestions__14 = "Question {{currentQuestion}} sur {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_14 = "Les questions que vous avez manqu\xE9es lors de l'\xE9valuation\xA0:";
    Retake_Exam14 = "Repasser l'examen";
    Return14 = "Retour";
    Review_answer_feedback_to_learn_more_14 = "Pour en savoir plus, consultez les commentaires li\xE9s aux r\xE9ponses.";
    Score____score___14 = "Note\xA0: {{score}}\xA0%";
    Select_an_answer14 = "S\xE9lectionnez une r\xE9ponse";
    Submit_Answer_s_14 = "Envoyer la ou les r\xE9ponses";
    The_response_options_are__14 = "Voici les diff\xE9rentes possibilit\xE9s de r\xE9ponse\xA0: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question14 = "Pour d\xE9s\xE9lectionner une r\xE9ponse, cliquez sur l'option \xAB\xA0Effacer la s\xE9lection\xA0\xBB apr\xE8s votre dernier choix de r\xE9ponse effectu\xE9 pour chaque question.";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_14 = "Malheureusement, vous avez \xE9chou\xE9 \xE0 l'examen et devrez le repasser.";
    Value_must_be_greater_than_or_equal_to_014 = "La valeur doit \xEAtre sup\xE9rieure ou \xE9gale \xE0\xA00";
    You_passed_14 = "Vous avez r\xE9ussi\xA0!";
    translations_default14 = {
      "(Select all that apply)": _Select_all_that_apply_14,
      "1,000 character limit": __000_character_limit14,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required14,
      Answer: Answer14,
      "Answer (Must be a number)": Answer__Must_be_a_number_14,
      Answerssss: Answerssss12,
      "Assessment Completed": Assessment_Completed14,
      Clear: Clear14,
      "Clear Selection": Clear_Selection14,
      Close: Close14,
      Continue: Continue14,
      Finish: Finish14,
      "Let's Get Started": Let_s_Get_Started14,
      "Must be a decimal": Must_be_a_decimal14,
      Next: Next14,
      "Next Page": Next_Page14,
      "Number of Drinks": Number_of_Drinks14,
      OK: OK14,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__14,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_14,
      Prev: Prev14,
      Previous: Previous14,
      "Previous Page": Previous_Page14,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__14,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_14,
      "Retake Exam": Retake_Exam14,
      Return: Return14,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_14,
      "Score: {{score}}%": Score____score___14,
      "Select an answer": Select_an_answer14,
      "Submit Answer(s)": Submit_Answer_s_14,
      "The response options are: ": The_response_options_are__14,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question14,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_14,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_014,
      "You passed!": You_passed_14
    };
  }
});

// src/lib/locales/he-IL/translations.json
var translations_exports15 = {};
__export(translations_exports15, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_15;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit15;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required15;
  },
  Answer: function Answer() {
    return Answer15;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_15;
  },
  Answerssss: function Answerssss() {
    return Answerssss13;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed15;
  },
  Clear: function Clear() {
    return Clear15;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection15;
  },
  Close: function Close() {
    return Close15;
  },
  Continue: function Continue() {
    return Continue15;
  },
  Finish: function Finish() {
    return Finish15;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started15;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal15;
  },
  Next: function Next() {
    return Next15;
  },
  "Next Page": function NextPage() {
    return Next_Page15;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks15;
  },
  OK: function OK() {
    return OK15;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__15;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_15;
  },
  Prev: function Prev() {
    return Prev15;
  },
  Previous: function Previous() {
    return Previous15;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page15;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__15;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_15;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam15;
  },
  Return: function Return() {
    return Return15;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_15;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___15;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer15;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_15;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__15;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question15;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_15;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_015;
  },
  "You passed!": function YouPassed() {
    return You_passed_15;
  },
  "default": function _default() {
    return translations_default15;
  }
});
var _Select_all_that_apply_15, __000_character_limit15, A_score_of_at_least___passingGrade____is_required15, Answer15, Answer__Must_be_a_number_15, Answerssss13, Assessment_Completed15, Clear15, Clear_Selection15, Close15, Continue15, Finish15, Let_s_Get_Started15, Must_be_a_decimal15, Next15, Next_Page15, Number_of_Drinks15, OK15, Page___currentPage___of___totalPages__15, Please_click_OK_to_continue_to_the_next_page_15, Prev15, Previous15, Previous_Page15, Question___currentQuestion___of___totalQuestions__15, Questions_you_missed_on_the_assessment_15, Retake_Exam15, Return15, Review_answer_feedback_to_learn_more_15, Score____score___15, Select_an_answer15, Submit_Answer_s_15, The_response_options_are__15, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question15, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_15, Value_must_be_greater_than_or_equal_to_015, You_passed_15, translations_default15;
var init_translations15 = __esm({
  "src/lib/locales/he-IL/translations.json": function srcLibLocalesHeILTranslationsJson() {
    _Select_all_that_apply_15 = "(\u05D1\u05D7\u05E8 \u05DB\u05DC \u05DE\u05D4 \u05E9\u05DE\u05EA\u05D0\u05D9\u05DD)";
    __000_character_limit15 = "\u05DE\u05D2\u05D1\u05DC\u05D4 \u05E9\u05DC 1,000 \u05EA\u05D5\u05D5\u05D9\u05DD";
    A_score_of_at_least___passingGrade____is_required15 = "\u05E0\u05D3\u05E8\u05E9 \u05E6\u05D9\u05D5\u05DF {{passingGrade}}% \u05DC\u05E4\u05D7\u05D5\u05EA";
    Answer15 = "\u05EA\u05E9\u05D5\u05D1\u05D4";
    Answer__Must_be_a_number_15 = "\u05EA\u05E9\u05D5\u05D1\u05D4 (\u05DE\u05E1\u05E4\u05E8 \u05D1\u05DC\u05D1\u05D3)";
    Answerssss13 = "\u05EA\u05E9\u05D5\u05D1\u05D5\u05EA";
    Assessment_Completed15 = "\u05D4\u05D4\u05E2\u05E8\u05DB\u05D4 \u05D4\u05D5\u05E9\u05DC\u05DE\u05D4";
    Clear15 = "\u05E0\u05E7\u05D4";
    Clear_Selection15 = "\u05E0\u05E7\u05D4 \u05D1\u05D7\u05D9\u05E8\u05D4";
    Close15 = "\u05E1\u05D2\u05D5\u05E8";
    Continue15 = "\u05D4\u05DE\u05E9\u05DA";
    Finish15 = "\u05E1\u05D9\u05D5\u05DD";
    Let_s_Get_Started15 = "\u05D4\u05D1\u05D4 \u05E0\u05EA\u05D7\u05D9\u05DC";
    Must_be_a_decimal15 = "\u05E2\u05E8\u05DA \u05E2\u05E9\u05E8\u05D5\u05E0\u05D9 \u05D1\u05DC\u05D1\u05D3";
    Next15 = "\u05D4\u05D1\u05D0";
    Next_Page15 = "\u05D4\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D1\u05D0";
    Number_of_Drinks15 = "\u05DE\u05E1\u05E4\u05E8 \u05DE\u05E9\u05E7\u05D0\u05D5\u05EA";
    OK15 = "OK";
    Page___currentPage___of___totalPages__15 = "\u05E2\u05DE\u05D5\u05D3 {{currentPage}} \u05DE\u05EA\u05D5\u05DA {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_15 = "\u05DC\u05D7\u05E5 \u05E2\u05DC '\u05D0\u05D9\u05E9\u05D5\u05E8' (OK) \u05DB\u05D3\u05D9 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA \u05DC\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D1\u05D0.";
    Prev15 = "\u05D4\u05E7\u05D5\u05D3\u05DD";
    Previous15 = "\u05D4\u05E7\u05D5\u05D3\u05DD";
    Previous_Page15 = "\u05E2\u05DE\u05D5\u05D3 \u05E7\u05D5\u05D3\u05DD";
    Question___currentQuestion___of___totalQuestions__15 = "\u05E9\u05D0\u05DC\u05D4 {{currentQuestion}} \u05DE\u05EA\u05D5\u05DA {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_15 = "\u05E9\u05D0\u05DC\u05D5\u05EA \u05E9\u05D4\u05D7\u05DE\u05E6\u05EA \u05D1\u05D4\u05E2\u05E8\u05DB\u05D4:";
    Retake_Exam15 = "\u05D1\u05D7\u05D9\u05E0\u05D4 \u05D7\u05D5\u05D6\u05E8\u05EA";
    Return15 = "\u05D7\u05D6\u05E8\u05D4";
    Review_answer_feedback_to_learn_more_15 = "\u05DE\u05D9\u05D3\u05E2 \u05E0\u05D5\u05E1\u05E3 \u05D1\u05DE\u05E9\u05D5\u05D1 \u05E2\u05DC \u05D4\u05EA\u05E9\u05D5\u05D1\u05D5\u05EA.";
    Score____score___15 = "\u05E6\u05D9\u05D5\u05DF: {{score}}%";
    Select_an_answer15 = "\u05D1\u05D7\u05E8 \u05EA\u05E9\u05D5\u05D1\u05D4";
    Submit_Answer_s_15 = "\u05E9\u05DC\u05D7 \u05EA\u05E9\u05D5\u05D1\u05D5\u05EA";
    The_response_options_are__15 = "\u05EA\u05E9\u05D5\u05D1\u05D5\u05EA \u05DC\u05D1\u05D7\u05D9\u05E8\u05D4: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question15 = "\u05DC\u05D1\u05D9\u05D8\u05D5\u05DC \u05D4\u05D1\u05D7\u05D9\u05E8\u05D4 \u05D1\u05EA\u05E9\u05D5\u05D1\u05D4, \u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D0\u05E4\u05E9\u05E8\u05D5\u05EA '\u05E0\u05E7\u05D4 \u05D1\u05D7\u05D9\u05E8\u05D4', \u05D0\u05D7\u05E8\u05D9 \u05D4\u05EA\u05E9\u05D5\u05D1\u05D4 \u05D4\u05D0\u05D7\u05E8\u05D5\u05E0\u05D4 \u05DC\u05D1\u05D7\u05D9\u05E8\u05D4 \u05D1\u05DB\u05DC \u05E9\u05D0\u05DC\u05D4";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_15 = "\u05DC\u05E6\u05E2\u05E8\u05E0\u05D5, \u05DC\u05D0 \u05E2\u05D1\u05E8\u05EA, \u05D5\u05EA\u05E6\u05D8\u05E8\u05DA \u05DC\u05D1\u05E6\u05E2 \u05E9\u05D5\u05D1 \u05D0\u05EA \u05D4\u05D4\u05E2\u05E8\u05DB\u05D4.";
    Value_must_be_greater_than_or_equal_to_015 = "\u05D4\u05E2\u05E8\u05DA \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05D2\u05D3\u05D5\u05DC \u05DE-0 \u05D0\u05D5 \u05E9\u05D5\u05D5\u05D4 \u05DC\u05D5";
    You_passed_15 = "\u05E2\u05D1\u05E8\u05EA!";
    translations_default15 = {
      "(Select all that apply)": _Select_all_that_apply_15,
      "1,000 character limit": __000_character_limit15,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required15,
      Answer: Answer15,
      "Answer (Must be a number)": Answer__Must_be_a_number_15,
      Answerssss: Answerssss13,
      "Assessment Completed": Assessment_Completed15,
      Clear: Clear15,
      "Clear Selection": Clear_Selection15,
      Close: Close15,
      Continue: Continue15,
      Finish: Finish15,
      "Let's Get Started": Let_s_Get_Started15,
      "Must be a decimal": Must_be_a_decimal15,
      Next: Next15,
      "Next Page": Next_Page15,
      "Number of Drinks": Number_of_Drinks15,
      OK: OK15,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__15,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_15,
      Prev: Prev15,
      Previous: Previous15,
      "Previous Page": Previous_Page15,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__15,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_15,
      "Retake Exam": Retake_Exam15,
      Return: Return15,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_15,
      "Score: {{score}}%": Score____score___15,
      "Select an answer": Select_an_answer15,
      "Submit Answer(s)": Submit_Answer_s_15,
      "The response options are: ": The_response_options_are__15,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question15,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_15,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_015,
      "You passed!": You_passed_15
    };
  }
});

// src/lib/locales/hi-IN/translations.json
var translations_exports16 = {};
__export(translations_exports16, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_16;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit16;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required16;
  },
  Answer: function Answer() {
    return Answer16;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_16;
  },
  Answerssss: function Answerssss() {
    return Answerssss14;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed16;
  },
  Clear: function Clear() {
    return Clear16;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection16;
  },
  Close: function Close() {
    return Close16;
  },
  Continue: function Continue() {
    return Continue16;
  },
  Finish: function Finish() {
    return Finish16;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started16;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal16;
  },
  Next: function Next() {
    return Next16;
  },
  "Next Page": function NextPage() {
    return Next_Page16;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks16;
  },
  OK: function OK() {
    return OK16;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__16;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_16;
  },
  Prev: function Prev() {
    return Prev16;
  },
  Previous: function Previous() {
    return Previous16;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page16;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__16;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_16;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam16;
  },
  Return: function Return() {
    return Return16;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_16;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___16;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer16;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_16;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__16;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question16;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_16;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_016;
  },
  "You passed!": function YouPassed() {
    return You_passed_16;
  },
  "default": function _default() {
    return translations_default16;
  }
});
var _Select_all_that_apply_16, __000_character_limit16, A_score_of_at_least___passingGrade____is_required16, Answer16, Answer__Must_be_a_number_16, Answerssss14, Assessment_Completed16, Clear16, Clear_Selection16, Close16, Continue16, Finish16, Let_s_Get_Started16, Must_be_a_decimal16, Next16, Next_Page16, Number_of_Drinks16, OK16, Page___currentPage___of___totalPages__16, Please_click_OK_to_continue_to_the_next_page_16, Prev16, Previous16, Previous_Page16, Question___currentQuestion___of___totalQuestions__16, Questions_you_missed_on_the_assessment_16, Retake_Exam16, Return16, Review_answer_feedback_to_learn_more_16, Score____score___16, Select_an_answer16, Submit_Answer_s_16, The_response_options_are__16, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question16, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_16, Value_must_be_greater_than_or_equal_to_016, You_passed_16, translations_default16;
var init_translations16 = __esm({
  "src/lib/locales/hi-IN/translations.json": function srcLibLocalesHiINTranslationsJson() {
    _Select_all_that_apply_16 = "(\u0935\u0947 \u0938\u092D\u0940 \u091A\u0941\u0928\u0947\u0902 \u091C\u094B \u0932\u093E\u0917\u0942 \u0939\u094B\u0902)";
    __000_character_limit16 = "1,000 \u0915\u0948\u0930\u0947\u0915\u094D\u091F\u0930 \u0938\u0940\u092E\u093E";
    A_score_of_at_least___passingGrade____is_required16 = "\u0915\u092E \u0938\u0947 \u0915\u092E {{passingGrade}}% \u0915\u093E \u0938\u094D\u0915\u094B\u0930 \u0906\u0935\u0936\u094D\u092F\u0915 \u0939\u0948";
    Answer16 = "\u0909\u0924\u094D\u0924\u0930";
    Answer__Must_be_a_number_16 = "\u0909\u0924\u094D\u0924\u0930 (\u0915\u094B\u0908 \u0938\u0902\u0916\u094D\u092F\u093E \u0939\u094B\u0928\u0940 \u091A\u093E\u0939\u093F\u090F)";
    Answerssss14 = "\u0909\u0924\u094D\u0924\u0930";
    Assessment_Completed16 = "\u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928 \u092A\u0942\u0930\u093E \u0939\u0941\u0906";
    Clear16 = "\u092E\u093F\u091F\u093E\u090F\u0902";
    Clear_Selection16 = "\u0938\u0932\u0947\u0915\u094D\u0936\u0928 \u092E\u093F\u091F\u093E\u090F\u0902";
    Close16 = "\u092C\u0902\u0926 \u0915\u0930\u0947\u0902";
    Continue16 = "\u091C\u093E\u0930\u0940 \u0930\u0916\u0947\u0902";
    Finish16 = "\u092A\u0942\u0930\u093E \u0915\u0930\u0947\u0902";
    Let_s_Get_Started16 = "\u0906\u0907\u090F \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902";
    Must_be_a_decimal16 = "\u0926\u0936\u092E\u0932\u0935 \u0905\u0935\u0936\u094D\u092F \u0939\u094B\u0928\u093E \u091A\u093E\u0939\u093F\u090F";
    Next16 = "\u0905\u0917\u0932\u093E";
    Next_Page16 = "\u0905\u0917\u0932\u093E \u092A\u0947\u091C";
    Number_of_Drinks16 = "\u092A\u0947\u092F \u0915\u0940 \u0938\u0902\u0916\u094D\u092F\u093E";
    OK16 = "\u0913\u0915\u0947";
    Page___currentPage___of___totalPages__16 = "\u0915\u0941\u0932 {{totalPages}} \u092E\u0947\u0902 \u0938\u0947 \u092A\u0947\u091C {{currentPage}}";
    Please_click_OK_to_continue_to_the_next_page_16 = "\u0905\u0917\u0932\u0947 \u092A\u0947\u091C \u092A\u0930 \u091C\u093E\u0930\u0940 \u0930\u0916\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0915\u0943\u092A\u092F\u093E '\u0913\u0915\u0947' \u0915\u094B \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902.";
    Prev16 = "\u092A\u093F\u091B\u0932\u093E";
    Previous16 = "\u092A\u093F\u091B\u0932\u093E";
    Previous_Page16 = "\u092A\u093F\u091B\u0932\u093E \u092A\u0947\u091C";
    Question___currentQuestion___of___totalQuestions__16 = "\u0915\u0941\u0932 {{totalQuestions}} \u092E\u0947\u0902 \u0938\u0947 \u0938\u0935\u093E\u0932 {{currentQuestion}}";
    Questions_you_missed_on_the_assessment_16 = "\u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928 \u092E\u0947\u0902 \u0906\u092A\u0915\u0947 \u091B\u0942\u091F\u0947 \u0938\u0935\u093E\u0932:";
    Retake_Exam16 = "\u092A\u0930\u0940\u0915\u094D\u0937\u093E \u0926\u0941\u092C\u093E\u0930\u093E \u0926\u0947\u0902";
    Return16 = "\u0935\u093E\u092A\u0938 \u0932\u094C\u091F\u0947\u0902";
    Review_answer_feedback_to_learn_more_16 = "\u0905\u0927\u093F\u0915 \u091C\u093E\u0928\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0909\u0924\u094D\u0924\u0930 \u092B\u0940\u0921\u092C\u0948\u0915 \u0915\u094B \u0926\u0947\u0916\u0947\u0902.";
    Score____score___16 = "\u0938\u094D\u0915\u094B\u0930: {{score}}%";
    Select_an_answer16 = "\u091C\u0935\u093E\u092C \u091A\u0941\u0928\u0947\u0902";
    Submit_Answer_s_16 = "\u091C\u0935\u093E\u092C \u0938\u092C\u092E\u093F\u091F \u0915\u0930\u0947\u0902";
    The_response_options_are__16 = "\u092A\u094D\u0930\u0924\u093F\u0915\u094D\u0930\u093F\u092F\u093E \u0935\u093F\u0915\u0932\u094D\u092A \u092F\u0947 \u0939\u0948\u0902: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question16 = "\u0915\u093F\u0938\u0940 \u0909\u0924\u094D\u0924\u0930 \u0938\u0947 \u0938\u0932\u0947\u0915\u094D\u0936\u0928 \u0939\u091F\u093E\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F, \u0939\u0930 \u092A\u094D\u0930\u0936\u094D\u0928 \u0915\u0947 \u0905\u0902\u0924\u093F\u092E \u0909\u0924\u094D\u0924\u0930 \u0935\u093F\u0915\u0932\u094D\u092A \u0915\u0947 \u092C\u093E\u0926 \u0926\u093F\u090F '\u0938\u0932\u0947\u0915\u094D\u0936\u0928 \u092E\u093F\u091F\u093E\u090F\u0902' \u0935\u093F\u0915\u0932\u094D\u092A \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0947\u0902";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_16 = "\u0916\u0947\u0926 \u0939\u0948 \u0915\u093F, \u0906\u092A \u092A\u093E\u0938 \u0928\u0939\u0940\u0902 \u0939\u094B \u092A\u093E\u090F \u0914\u0930 \u0906\u092A\u0915\u094B \u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928 \u092E\u0947\u0902 \u092B\u093F\u0930 \u0938\u0947 \u0936\u093E\u092E\u093F\u0932 \u0939\u094B\u0928\u093E \u0939\u094B\u0917\u093E.";
    Value_must_be_greater_than_or_equal_to_016 = "\u092E\u093E\u0928 0 \u0938\u0947 \u0905\u0927\u093F\u0915 \u092F\u093E \u0909\u0938\u0915\u0947 \u092C\u0930\u093E\u092C\u0930 \u0939\u094B\u0928\u093E \u091A\u093E\u0939\u093F\u090F";
    You_passed_16 = "\u0906\u092A \u092A\u093E\u0938 \u0939\u094B \u0917\u090F!";
    translations_default16 = {
      "(Select all that apply)": _Select_all_that_apply_16,
      "1,000 character limit": __000_character_limit16,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required16,
      Answer: Answer16,
      "Answer (Must be a number)": Answer__Must_be_a_number_16,
      Answerssss: Answerssss14,
      "Assessment Completed": Assessment_Completed16,
      Clear: Clear16,
      "Clear Selection": Clear_Selection16,
      Close: Close16,
      Continue: Continue16,
      Finish: Finish16,
      "Let's Get Started": Let_s_Get_Started16,
      "Must be a decimal": Must_be_a_decimal16,
      Next: Next16,
      "Next Page": Next_Page16,
      "Number of Drinks": Number_of_Drinks16,
      OK: OK16,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__16,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_16,
      Prev: Prev16,
      Previous: Previous16,
      "Previous Page": Previous_Page16,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__16,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_16,
      "Retake Exam": Retake_Exam16,
      Return: Return16,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_16,
      "Score: {{score}}%": Score____score___16,
      "Select an answer": Select_an_answer16,
      "Submit Answer(s)": Submit_Answer_s_16,
      "The response options are: ": The_response_options_are__16,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question16,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_16,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_016,
      "You passed!": You_passed_16
    };
  }
});

// src/lib/locales/hu-HU/translations.json
var translations_exports17 = {};
__export(translations_exports17, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_17;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit17;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required17;
  },
  Answer: function Answer() {
    return Answer17;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_17;
  },
  Answerssss: function Answerssss() {
    return Answerssss15;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed17;
  },
  Clear: function Clear() {
    return Clear17;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection17;
  },
  Close: function Close() {
    return Close17;
  },
  Continue: function Continue() {
    return Continue17;
  },
  Finish: function Finish() {
    return Finish17;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started17;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal17;
  },
  Next: function Next() {
    return Next17;
  },
  "Next Page": function NextPage() {
    return Next_Page17;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks17;
  },
  OK: function OK() {
    return OK17;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__17;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_17;
  },
  Prev: function Prev() {
    return Prev17;
  },
  Previous: function Previous() {
    return Previous17;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page17;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__17;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_17;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam17;
  },
  Return: function Return() {
    return Return17;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_17;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___17;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer17;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_17;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__17;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question17;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_17;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_017;
  },
  "You passed!": function YouPassed() {
    return You_passed_17;
  },
  "default": function _default() {
    return translations_default17;
  }
});
var _Select_all_that_apply_17, __000_character_limit17, A_score_of_at_least___passingGrade____is_required17, Answer17, Answer__Must_be_a_number_17, Answerssss15, Assessment_Completed17, Clear17, Clear_Selection17, Close17, Continue17, Finish17, Let_s_Get_Started17, Must_be_a_decimal17, Next17, Next_Page17, Number_of_Drinks17, OK17, Page___currentPage___of___totalPages__17, Please_click_OK_to_continue_to_the_next_page_17, Prev17, Previous17, Previous_Page17, Question___currentQuestion___of___totalQuestions__17, Questions_you_missed_on_the_assessment_17, Retake_Exam17, Return17, Review_answer_feedback_to_learn_more_17, Score____score___17, Select_an_answer17, Submit_Answer_s_17, The_response_options_are__17, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question17, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_17, Value_must_be_greater_than_or_equal_to_017, You_passed_17, translations_default17;
var init_translations17 = __esm({
  "src/lib/locales/hu-HU/translations.json": function srcLibLocalesHuHUTranslationsJson() {
    _Select_all_that_apply_17 = "(V\xE1lassza ki az \xF6sszes vonatkoz\xF3t)";
    __000_character_limit17 = "1000 karakter korl\xE1t";
    A_score_of_at_least___passingGrade____is_required17 = "Legal\xE1bb {{passingGrade}}%-os pontsz\xE1m sz\xFCks\xE9ges";
    Answer17 = "V\xE1lasz";
    Answer__Must_be_a_number_17 = "V\xE1lasz (sz\xE1mnak kell lennie)";
    Answerssss15 = "V\xE1laszok";
    Assessment_Completed17 = "\xC9rt\xE9kel\xE9s befejezve";
    Clear17 = "T\xF6rl\xE9s";
    Clear_Selection17 = "Kijel\xF6l\xE9s t\xF6rl\xE9se";
    Close17 = "Bez\xE1r\xE1s";
    Continue17 = "Folytat\xE1s";
    Finish17 = "Befejez\xE9s";
    Let_s_Get_Started17 = "Els\u0151 l\xE9p\xE9sek";
    Must_be_a_decimal17 = "Tizedes sz\xE1mnak kell lennie";
    Next17 = "K\xF6vetkez\u0151";
    Next_Page17 = "K\xF6vetkez\u0151 oldal";
    Number_of_Drinks17 = "Italok sz\xE1ma";
    OK17 = "OK";
    Page___currentPage___of___totalPages__17 = "{{currentPage}} / {{totalPages}} oldal";
    Please_click_OK_to_continue_to_the_next_page_17 = "K\xE9rj\xFCk, kattintson az OK gombra a k\xF6vetkez\u0151 oldalra l\xE9p\xE9shez.";
    Prev17 = "El\u0151z\u0151";
    Previous17 = "El\u0151z\u0151";
    Previous_Page17 = "El\u0151z\u0151 oldal";
    Question___currentQuestion___of___totalQuestions__17 = "{{currentQuestion}} / {{totalQuestions}} k\xE9rd\xE9s";
    Questions_you_missed_on_the_assessment_17 = "Az \xE9rt\xE9kel\xE9s sor\xE1n elmulasztott k\xE9rd\xE9sek:";
    Retake_Exam17 = "Vizsga megism\xE9tl\xE9se";
    Return17 = "Visszat\xE9r\xE9s";
    Review_answer_feedback_to_learn_more_17 = "Tekintse meg a v\xE1lasz visszajelz\xE9st a tov\xE1bbi r\xE9szletek\xE9rt.";
    Score____score___17 = "Pontsz\xE1m: {{score}}%";
    Select_an_answer17 = "V\xE1lasz kiv\xE1laszt\xE1sa";
    Submit_Answer_s_17 = "V\xE1lasz(ok) bek\xFCld\xE9se";
    The_response_options_are__17 = "A v\xE1laszlehet\u0151s\xE9gek a k\xF6vetkez\u0151k: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question17 = "A v\xE1lasz kijel\xF6l\xE9s\xE9nek megsz\xFCntet\xE9s\xE9hez haszn\xE1lja a Kijel\xF6l\xE9s t\xF6rl\xE9se opci\xF3t az egyes k\xE9rd\xE9sek utols\xF3 v\xE1laszlehet\u0151s\xE9ge ut\xE1n.";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_17 = "Sajnos nem felelt meg, ez\xE9rt \xFAjra el kell v\xE9geznie az \xE9rt\xE9kel\xE9st.";
    Value_must_be_greater_than_or_equal_to_017 = "Az \xE9rt\xE9knek legal\xE1bb 0-nak kell lennie";
    You_passed_17 = "Megfelelt!";
    translations_default17 = {
      "(Select all that apply)": _Select_all_that_apply_17,
      "1,000 character limit": __000_character_limit17,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required17,
      Answer: Answer17,
      "Answer (Must be a number)": Answer__Must_be_a_number_17,
      Answerssss: Answerssss15,
      "Assessment Completed": Assessment_Completed17,
      Clear: Clear17,
      "Clear Selection": Clear_Selection17,
      Close: Close17,
      Continue: Continue17,
      Finish: Finish17,
      "Let's Get Started": Let_s_Get_Started17,
      "Must be a decimal": Must_be_a_decimal17,
      Next: Next17,
      "Next Page": Next_Page17,
      "Number of Drinks": Number_of_Drinks17,
      OK: OK17,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__17,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_17,
      Prev: Prev17,
      Previous: Previous17,
      "Previous Page": Previous_Page17,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__17,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_17,
      "Retake Exam": Retake_Exam17,
      Return: Return17,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_17,
      "Score: {{score}}%": Score____score___17,
      "Select an answer": Select_an_answer17,
      "Submit Answer(s)": Submit_Answer_s_17,
      "The response options are: ": The_response_options_are__17,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question17,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_17,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_017,
      "You passed!": You_passed_17
    };
  }
});

// src/lib/locales/id-ID/translations.json
var translations_exports18 = {};
__export(translations_exports18, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_18;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit18;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required18;
  },
  Answer: function Answer() {
    return Answer18;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_18;
  },
  Answerssss: function Answerssss() {
    return Answerssss16;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed18;
  },
  Clear: function Clear() {
    return Clear18;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection18;
  },
  Close: function Close() {
    return Close18;
  },
  Continue: function Continue() {
    return Continue18;
  },
  Finish: function Finish() {
    return Finish18;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started18;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal18;
  },
  Next: function Next() {
    return Next18;
  },
  "Next Page": function NextPage() {
    return Next_Page18;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks18;
  },
  OK: function OK() {
    return OK18;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__18;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_18;
  },
  Prev: function Prev() {
    return Prev18;
  },
  Previous: function Previous() {
    return Previous18;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page18;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__18;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_18;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam18;
  },
  Return: function Return() {
    return Return18;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_18;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___18;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer18;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_18;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__18;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question18;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_18;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_018;
  },
  "You passed!": function YouPassed() {
    return You_passed_18;
  },
  "default": function _default() {
    return translations_default18;
  }
});
var _Select_all_that_apply_18, __000_character_limit18, A_score_of_at_least___passingGrade____is_required18, Answer18, Answer__Must_be_a_number_18, Answerssss16, Assessment_Completed18, Clear18, Clear_Selection18, Close18, Continue18, Finish18, Let_s_Get_Started18, Must_be_a_decimal18, Next18, Next_Page18, Number_of_Drinks18, OK18, Page___currentPage___of___totalPages__18, Please_click_OK_to_continue_to_the_next_page_18, Prev18, Previous18, Previous_Page18, Question___currentQuestion___of___totalQuestions__18, Questions_you_missed_on_the_assessment_18, Retake_Exam18, Return18, Review_answer_feedback_to_learn_more_18, Score____score___18, Select_an_answer18, Submit_Answer_s_18, The_response_options_are__18, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question18, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_18, Value_must_be_greater_than_or_equal_to_018, You_passed_18, translations_default18;
var init_translations18 = __esm({
  "src/lib/locales/id-ID/translations.json": function srcLibLocalesIdIDTranslationsJson() {
    _Select_all_that_apply_18 = "(Pilih semua yang sesuai)";
    __000_character_limit18 = "1.000 batas karakter";
    A_score_of_at_least___passingGrade____is_required18 = "Diperlukan skor minimal {{passingGrade}}%";
    Answer18 = "Jawab";
    Answer__Must_be_a_number_18 = "Jawab (Harus berupa angka)";
    Answerssss16 = "Jawaban";
    Assessment_Completed18 = "Penilaian Selesai";
    Clear18 = "Bersihkan";
    Clear_Selection18 = "Hapus Pilihan";
    Close18 = "Tutup";
    Continue18 = "Lanjutkan";
    Finish18 = "Selesai";
    Let_s_Get_Started18 = "Ayo Mulai";
    Must_be_a_decimal18 = "Harus berupa desimal";
    Next18 = "Berikutnya";
    Next_Page18 = "Halaman Berikutnya";
    Number_of_Drinks18 = "Jumlah Minuman";
    OK18 = "OKE";
    Page___currentPage___of___totalPages__18 = "Halaman {{currentPage}} dari {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_18 = "Silakan klik OK untuk melanjutkan ke halaman berikutnya.";
    Prev18 = "Sebelumnya";
    Previous18 = "Sebelumnya";
    Previous_Page18 = "Halaman Sebelumnya";
    Question___currentQuestion___of___totalQuestions__18 = "Pertanyaan {{currentQuestion}} dari {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_18 = "Pertanyaan yang Anda lewatkan pada penilaian:";
    Retake_Exam18 = "Lakukan Kembali Ujian";
    Return18 = "Kembali";
    Review_answer_feedback_to_learn_more_18 = "Tinjau umpan balik jawaban untuk mempelajari selengkapnya.";
    Score____score___18 = "Skor: {{score}}%";
    Select_an_answer18 = "Pilih sebuah jawaban";
    Submit_Answer_s_18 = "Kirim Jawaban";
    The_response_options_are__18 = "Pilihan responsnya adalah: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question18 = "Untuk membatalkan pilihan jawaban, gunakan opsi Hapus Pilihan setelah pilihan jawaban terakhir untuk setiap pertanyaan";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_18 = "Sayangnya, Anda tidak lulus dan harus mengulang penilaian.";
    Value_must_be_greater_than_or_equal_to_018 = "Nilai harus lebih besar dari atau sama dengan 0";
    You_passed_18 = "Anda lulus!";
    translations_default18 = {
      "(Select all that apply)": _Select_all_that_apply_18,
      "1,000 character limit": __000_character_limit18,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required18,
      Answer: Answer18,
      "Answer (Must be a number)": Answer__Must_be_a_number_18,
      Answerssss: Answerssss16,
      "Assessment Completed": Assessment_Completed18,
      Clear: Clear18,
      "Clear Selection": Clear_Selection18,
      Close: Close18,
      Continue: Continue18,
      Finish: Finish18,
      "Let's Get Started": Let_s_Get_Started18,
      "Must be a decimal": Must_be_a_decimal18,
      Next: Next18,
      "Next Page": Next_Page18,
      "Number of Drinks": Number_of_Drinks18,
      OK: OK18,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__18,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_18,
      Prev: Prev18,
      Previous: Previous18,
      "Previous Page": Previous_Page18,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__18,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_18,
      "Retake Exam": Retake_Exam18,
      Return: Return18,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_18,
      "Score: {{score}}%": Score____score___18,
      "Select an answer": Select_an_answer18,
      "Submit Answer(s)": Submit_Answer_s_18,
      "The response options are: ": The_response_options_are__18,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question18,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_18,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_018,
      "You passed!": You_passed_18
    };
  }
});

// src/lib/locales/it/translations.json
var translations_exports19 = {};
__export(translations_exports19, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_19;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit19;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required19;
  },
  Answer: function Answer() {
    return Answer19;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_19;
  },
  Answerssss: function Answerssss() {
    return Answerssss17;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed19;
  },
  Clear: function Clear() {
    return Clear19;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection19;
  },
  Close: function Close() {
    return Close19;
  },
  Continue: function Continue() {
    return Continue19;
  },
  Finish: function Finish() {
    return Finish19;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started19;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal19;
  },
  Next: function Next() {
    return Next19;
  },
  "Next Page": function NextPage() {
    return Next_Page19;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks19;
  },
  OK: function OK() {
    return OK19;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__19;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_19;
  },
  Prev: function Prev() {
    return Prev19;
  },
  Previous: function Previous() {
    return Previous19;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page19;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__19;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_19;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam19;
  },
  Return: function Return() {
    return Return19;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_19;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___19;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer19;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_19;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__19;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question19;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_19;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_019;
  },
  "You passed!": function YouPassed() {
    return You_passed_19;
  },
  "default": function _default() {
    return translations_default19;
  }
});
var _Select_all_that_apply_19, __000_character_limit19, A_score_of_at_least___passingGrade____is_required19, Answer19, Answer__Must_be_a_number_19, Answerssss17, Assessment_Completed19, Clear19, Clear_Selection19, Close19, Continue19, Finish19, Let_s_Get_Started19, Must_be_a_decimal19, Next19, Next_Page19, Number_of_Drinks19, OK19, Page___currentPage___of___totalPages__19, Please_click_OK_to_continue_to_the_next_page_19, Prev19, Previous19, Previous_Page19, Question___currentQuestion___of___totalQuestions__19, Questions_you_missed_on_the_assessment_19, Retake_Exam19, Return19, Review_answer_feedback_to_learn_more_19, Score____score___19, Select_an_answer19, Submit_Answer_s_19, The_response_options_are__19, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question19, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_19, Value_must_be_greater_than_or_equal_to_019, You_passed_19, translations_default19;
var init_translations19 = __esm({
  "src/lib/locales/it/translations.json": function srcLibLocalesItTranslationsJson() {
    _Select_all_that_apply_19 = "(Seleziona tutte le risposte applicabili)";
    __000_character_limit19 = "Limite di 1.000 caratteri";
    A_score_of_at_least___passingGrade____is_required19 = "\xC8 richiesto un punteggio di almeno il {{passingGrade}}%";
    Answer19 = "Risposta";
    Answer__Must_be_a_number_19 = "Risposta (deve essere un numero)";
    Answerssss17 = "Risposte";
    Assessment_Completed19 = "Valutazione completata";
    Clear19 = "Cancella";
    Clear_Selection19 = "Cancella selezione";
    Close19 = "Chiudi";
    Continue19 = "Continua";
    Finish19 = "Termina";
    Let_s_Get_Started19 = "Iniziamo";
    Must_be_a_decimal19 = "Deve essere decimale";
    Next19 = "Successivo";
    Next_Page19 = "Pagina successiva";
    Number_of_Drinks19 = "Numero bevute";
    OK19 = "OK";
    Page___currentPage___of___totalPages__19 = "Pagina {{currentPage}} di {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_19 = "Fai clic su OK per passare alla pagina successiva.";
    Prev19 = "Precedente";
    Previous19 = "Precedente";
    Previous_Page19 = "Pagina precedente";
    Question___currentQuestion___of___totalQuestions__19 = "Domanda {{currentQuestion}} di {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_19 = "Domande che hai saltato durante la valutazione:";
    Retake_Exam19 = "Riprova l'esame";
    Return19 = "Torna";
    Review_answer_feedback_to_learn_more_19 = "Controlla le risposte per saperne di pi\xF9.";
    Score____score___19 = "Punteggio: {{score}}%";
    Select_an_answer19 = "Seleziona una risposta";
    Submit_Answer_s_19 = "Invia risposta";
    The_response_options_are__19 = "Le possibili risposte sono: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question19 = "Per deselezionare una risposta, utilizza l'opzione Cancella selezione dopo l'ultima opzione di risposta relativa a ciascuna domanda";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_19 = "Sfortunatamente, non hai superato la valutazione e dovrai ripeterla.";
    Value_must_be_greater_than_or_equal_to_019 = "Il valore deve essere maggiore o uguale a 0";
    You_passed_19 = "Hai superato la valutazione.";
    translations_default19 = {
      "(Select all that apply)": _Select_all_that_apply_19,
      "1,000 character limit": __000_character_limit19,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required19,
      Answer: Answer19,
      "Answer (Must be a number)": Answer__Must_be_a_number_19,
      Answerssss: Answerssss17,
      "Assessment Completed": Assessment_Completed19,
      Clear: Clear19,
      "Clear Selection": Clear_Selection19,
      Close: Close19,
      Continue: Continue19,
      Finish: Finish19,
      "Let's Get Started": Let_s_Get_Started19,
      "Must be a decimal": Must_be_a_decimal19,
      Next: Next19,
      "Next Page": Next_Page19,
      "Number of Drinks": Number_of_Drinks19,
      OK: OK19,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__19,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_19,
      Prev: Prev19,
      Previous: Previous19,
      "Previous Page": Previous_Page19,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__19,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_19,
      "Retake Exam": Retake_Exam19,
      Return: Return19,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_19,
      "Score: {{score}}%": Score____score___19,
      "Select an answer": Select_an_answer19,
      "Submit Answer(s)": Submit_Answer_s_19,
      "The response options are: ": The_response_options_are__19,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question19,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_19,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_019,
      "You passed!": You_passed_19
    };
  }
});

// src/lib/locales/ja/translations.json
var translations_exports20 = {};
__export(translations_exports20, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_20;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit20;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required20;
  },
  Answer: function Answer() {
    return Answer20;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_20;
  },
  Answerssss: function Answerssss() {
    return Answerssss18;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed20;
  },
  Clear: function Clear() {
    return Clear20;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection20;
  },
  Close: function Close() {
    return Close20;
  },
  Continue: function Continue() {
    return Continue20;
  },
  Finish: function Finish() {
    return Finish20;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started20;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal20;
  },
  Next: function Next() {
    return Next20;
  },
  "Next Page": function NextPage() {
    return Next_Page20;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks20;
  },
  OK: function OK() {
    return OK20;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__20;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_20;
  },
  Prev: function Prev() {
    return Prev20;
  },
  Previous: function Previous() {
    return Previous20;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page20;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__20;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_20;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam20;
  },
  Return: function Return() {
    return Return20;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_20;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___20;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer20;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_20;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__20;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question20;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_20;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_020;
  },
  "You passed!": function YouPassed() {
    return You_passed_20;
  },
  "default": function _default() {
    return translations_default20;
  }
});
var _Select_all_that_apply_20, __000_character_limit20, A_score_of_at_least___passingGrade____is_required20, Answer20, Answer__Must_be_a_number_20, Answerssss18, Assessment_Completed20, Clear20, Clear_Selection20, Close20, Continue20, Finish20, Let_s_Get_Started20, Must_be_a_decimal20, Next20, Next_Page20, Number_of_Drinks20, OK20, Page___currentPage___of___totalPages__20, Please_click_OK_to_continue_to_the_next_page_20, Prev20, Previous20, Previous_Page20, Question___currentQuestion___of___totalQuestions__20, Questions_you_missed_on_the_assessment_20, Retake_Exam20, Return20, Review_answer_feedback_to_learn_more_20, Score____score___20, Select_an_answer20, Submit_Answer_s_20, The_response_options_are__20, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question20, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_20, Value_must_be_greater_than_or_equal_to_020, You_passed_20, translations_default20;
var init_translations20 = __esm({
  "src/lib/locales/ja/translations.json": function srcLibLocalesJaTranslationsJson() {
    _Select_all_that_apply_20 = "(\u5F53\u3066\u306F\u307E\u308B\u3082\u306E\u3092\u3059\u3079\u3066\u3092\u9078\u629E\u3059\u308B)";
    __000_character_limit20 = "\u4E0A\u96501,000\u5B57";
    A_score_of_at_least___passingGrade____is_required20 = "\u5C11\u306A\u304F\u3068\u3082 {{passingGrade}}% \u306E\u30B9\u30B3\u30A2\u304C\u5FC5\u8981\u3067\u3059";
    Answer20 = "\u56DE\u7B54";
    Answer__Must_be_a_number_20 = "\u56DE\u7B54\uFF08\u6570\u5024\u3067\u56DE\u7B54\u3057\u3066\u304F\u3060\u3055\u3044\uFF09";
    Answerssss18 = "\u56DE\u7B54";
    Assessment_Completed20 = "\u8A55\u4FA1\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F";
    Clear20 = "\u30AF\u30EA\u30A2";
    Clear_Selection20 = "\u9078\u629E\u5185\u5BB9\u3092\u30AF\u30EA\u30A2";
    Close20 = "\u9589\u3058\u308B";
    Continue20 = "\u7D9A\u884C\u3059\u308B";
    Finish20 = "\u5B8C\u4E86";
    Let_s_Get_Started20 = "\u59CB\u3081\u307E\u3057\u3087\u3046";
    Must_be_a_decimal20 = "10\u9032\u6570\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059";
    Next20 = "\u6B21\u3078";
    Next_Page20 = "\u6B21\u306E\u30DA\u30FC\u30B8";
    Number_of_Drinks20 = "\u30C9\u30EA\u30F3\u30AF\u306E\u6570";
    OK20 = "OK";
    Page___currentPage___of___totalPages__20 = "\u30DA\u30FC\u30B8{{currentPage}}/{{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_20 = "[OK] \u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u6B21\u306E\u30DA\u30FC\u30B8\u306B\u9032\u307F\u307E\u3059\u3002";
    Prev20 = "\u524D\u3078";
    Previous20 = "\u524D";
    Previous_Page20 = "\u524D\u30DA\u30FC\u30B8";
    Question___currentQuestion___of___totalQuestions__20 = "\u8CEA\u554F{{currentQuestion}}/{{totalQuestions}}";
    Questions_you_missed_on_the_assessment_20 = "\u8A55\u4FA1\u3067\u898B\u9003\u3057\u305F\u8CEA\u554F :";
    Retake_Exam20 = "\u8A66\u9A13\u3092\u518D\u53D7\u9A13";
    Return20 = "\u623B\u308B";
    Review_answer_feedback_to_learn_more_20 = "\u8A73\u7D30\u306B\u3064\u3044\u3066\u306F\u56DE\u7B54\u306E\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002";
    Score____score___20 = "\u30B9\u30B3\u30A2 : {{score}}%";
    Select_an_answer20 = "\u56DE\u7B54\u3092\u9078\u629E";
    Submit_Answer_s_20 = "\u56DE\u7B54\u3092\u63D0\u51FA";
    The_response_options_are__20 = "\u5FDC\u7B54\u30AA\u30D7\u30B7\u30E7\u30F3 : ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question20 = "\u56DE\u7B54\u306E\u9078\u629E\u3092\u89E3\u9664\u3059\u308B\u306B\u306F\u3001\u5404\u8CEA\u554F\u306E\u6700\u5F8C\u306E\u56DE\u7B54\u30AA\u30D7\u30B7\u30E7\u30F3\u306E\u5F8C\u306B [\u9078\u629E\u5185\u5BB9\u3092\u30AF\u30EA\u30A2] \u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_20 = "\u6B8B\u5FF5\u306A\u304C\u3089\u3001\u4E0D\u5408\u683C\u306E\u305F\u3081\u8A55\u4FA1\u3092\u518D\u53D7\u9A13\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002";
    Value_must_be_greater_than_or_equal_to_020 = "\u5024\u306F0\u4EE5\u4E0A\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059";
    You_passed_20 = "\u5408\u683C\u3057\u307E\u3057\u305F\uFF01";
    translations_default20 = {
      "(Select all that apply)": _Select_all_that_apply_20,
      "1,000 character limit": __000_character_limit20,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required20,
      Answer: Answer20,
      "Answer (Must be a number)": Answer__Must_be_a_number_20,
      Answerssss: Answerssss18,
      "Assessment Completed": Assessment_Completed20,
      Clear: Clear20,
      "Clear Selection": Clear_Selection20,
      Close: Close20,
      Continue: Continue20,
      Finish: Finish20,
      "Let's Get Started": Let_s_Get_Started20,
      "Must be a decimal": Must_be_a_decimal20,
      Next: Next20,
      "Next Page": Next_Page20,
      "Number of Drinks": Number_of_Drinks20,
      OK: OK20,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__20,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_20,
      Prev: Prev20,
      Previous: Previous20,
      "Previous Page": Previous_Page20,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__20,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_20,
      "Retake Exam": Retake_Exam20,
      Return: Return20,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_20,
      "Score: {{score}}%": Score____score___20,
      "Select an answer": Select_an_answer20,
      "Submit Answer(s)": Submit_Answer_s_20,
      "The response options are: ": The_response_options_are__20,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question20,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_20,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_020,
      "You passed!": You_passed_20
    };
  }
});

// src/lib/locales/km-KH/translations.json
var translations_exports21 = {};
__export(translations_exports21, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_21;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit21;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required21;
  },
  Answer: function Answer() {
    return Answer21;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_21;
  },
  Answerssss: function Answerssss() {
    return Answerssss19;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed21;
  },
  Clear: function Clear() {
    return Clear21;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection21;
  },
  Close: function Close() {
    return Close21;
  },
  Continue: function Continue() {
    return Continue21;
  },
  Finish: function Finish() {
    return Finish21;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started21;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal21;
  },
  Next: function Next() {
    return Next21;
  },
  "Next Page": function NextPage() {
    return Next_Page21;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks21;
  },
  OK: function OK() {
    return OK21;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__21;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_21;
  },
  Prev: function Prev() {
    return Prev21;
  },
  Previous: function Previous() {
    return Previous21;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page21;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__21;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_21;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam21;
  },
  Return: function Return() {
    return Return21;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_21;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___21;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer21;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_21;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__21;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question21;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_21;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_021;
  },
  "You passed!": function YouPassed() {
    return You_passed_21;
  },
  "default": function _default() {
    return translations_default21;
  }
});
var _Select_all_that_apply_21, __000_character_limit21, A_score_of_at_least___passingGrade____is_required21, Answer21, Answer__Must_be_a_number_21, Answerssss19, Assessment_Completed21, Clear21, Clear_Selection21, Close21, Continue21, Finish21, Let_s_Get_Started21, Must_be_a_decimal21, Next21, Next_Page21, Number_of_Drinks21, OK21, Page___currentPage___of___totalPages__21, Please_click_OK_to_continue_to_the_next_page_21, Prev21, Previous21, Previous_Page21, Question___currentQuestion___of___totalQuestions__21, Questions_you_missed_on_the_assessment_21, Retake_Exam21, Return21, Review_answer_feedback_to_learn_more_21, Score____score___21, Select_an_answer21, Submit_Answer_s_21, The_response_options_are__21, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question21, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_21, Value_must_be_greater_than_or_equal_to_021, You_passed_21, translations_default21;
var init_translations21 = __esm({
  "src/lib/locales/km-KH/translations.json": function srcLibLocalesKmKHTranslationsJson() {
    _Select_all_that_apply_21 = "(\u1787\u17D2\u179A\u17BE\u179F\u179A\u17BE\u179F\u1791\u17B6\u17C6\u1784\u17A2\u179F\u17CB\u178A\u17C2\u179B\u17A2\u1793\u17BB\u179C\u178F\u17D2\u178F)";
    __000_character_limit21 = "\u1780\u17C6\u178E\u178F\u17CB\u178F\u17BD\u17A2\u1780\u17D2\u179F\u179A\u178F\u17D2\u179A\u17B9\u1798 1,000 \u178F\u17BD\u17A2\u1780\u17D2\u179F\u179A";
    A_score_of_at_least___passingGrade____is_required21 = "\u1796\u17B7\u1793\u17D2\u1791\u17BB\u1799\u17C9\u17B6\u1784\u17A0\u17C4\u1785\u178E\u17B6\u179F\u17CB {{passingGrade}}% \u178F\u17D2\u179A\u17BC\u179C\u1794\u17B6\u1793\u1791\u17B6\u1798\u1791\u17B6\u179A";
    Answer21 = "\u1785\u1798\u17D2\u179B\u17BE\u1799";
    Answer__Must_be_a_number_21 = "\u1785\u1798\u17D2\u179B\u17BE\u1799 (\u178F\u17D2\u179A\u17BC\u179C\u178F\u17C2\u1787\u17B6\u1785\u17C6\u1793\u17BD\u1793)";
    Answerssss19 = "\u1785\u1798\u17D2\u179B\u17BE\u1799";
    Assessment_Completed21 = "\u1780\u17B6\u179A\u179C\u17B6\u1799\u178F\u1798\u17D2\u179B\u17C3\u1794\u17B6\u1793\u1794\u1789\u17D2\u1785\u1794\u17CB";
    Clear21 = "\u179B\u17BB\u1794";
    Clear_Selection21 = "\u179B\u17BB\u1794\u1785\u17C4\u179B\u1780\u17B6\u179A\u1787\u17D2\u179A\u17BE\u179F\u179A\u17BE\u179F";
    Close21 = "\u1794\u17B7\u1791";
    Continue21 = "\u1794\u1793\u17D2\u178F";
    Finish21 = "\u1785\u1794\u17CB";
    Let_s_Get_Started21 = "\u178F\u17C4\u17C7\u1785\u17B6\u1794\u17CB\u1795\u17D2\u178F\u17BE\u1798";
    Must_be_a_decimal21 = "\u178F\u17D2\u179A\u17BC\u179C\u178F\u17C2\u1787\u17B6\u1785\u17C6\u1793\u17BD\u1793\u1791\u179F\u1797\u17B6\u1782";
    Next21 = "\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB";
    Next_Page21 = "\u1791\u17C6\u1796\u17D0\u179A\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB";
    Number_of_Drinks21 = "\u1785\u17C6\u1793\u17BD\u1793\u1797\u17C1\u179F\u1787\u17D2\u1787\u17C8";
    OK21 = "\u1799\u179B\u17CB\u1796\u17D2\u179A\u1798";
    Page___currentPage___of___totalPages__21 = "\u1791\u17C6\u1796\u17D0\u179A {{currentPage}} \u1793\u17C3 {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_21 = "\u179F\u17BC\u1798\u1785\u17BB\u1785 OK (\u1799\u179B\u17CB\u1796\u17D2\u179A\u1798) \u178A\u17BE\u1798\u17D2\u1794\u17B8\u1794\u1793\u17D2\u178F\u1791\u17C5\u1791\u17C6\u1796\u17D0\u179A\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB\u17D4";
    Prev21 = "\u1798\u17BB\u1793";
    Previous21 = "\u1796\u17B8\u1798\u17BB\u1793";
    Previous_Page21 = "\u1791\u17C6\u1796\u17D0\u179A\u1798\u17BB\u1793";
    Question___currentQuestion___of___totalQuestions__21 = "\u179F\u17C6\u178E\u17BD\u179A\u1791\u17B8 {{currentQuestion}} \u1793\u17C3 {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_21 = "\u179F\u17C6\u178E\u17BD\u179A\u178A\u17C2\u179B\u17A2\u17D2\u1793\u1780\u1781\u1780\u1781\u17B6\u1793\u1780\u17D2\u1793\u17BB\u1784\u1780\u17B6\u179A\u179C\u17B6\u1799\u178F\u1798\u17D2\u179B\u17C3\u17D6";
    Retake_Exam21 = "\u1794\u17D2\u179A\u17A1\u1784\u17A1\u17BE\u1784\u179C\u17B7\u1789";
    Return21 = "\u178F\u17D2\u179A\u17A1\u1794\u17CB\u1798\u1780\u179C\u17B7\u1789";
    Review_answer_feedback_to_learn_more_21 = "\u1796\u17B7\u1793\u17B7\u178F\u17D2\u1799\u1798\u17BE\u179B\u1798\u178F\u17B7\u1780\u17C2\u179B\u1798\u17D2\u17A2 \u178A\u17BE\u1798\u17D2\u1794\u17B8\u179F\u17D2\u179C\u17C2\u1784\u1799\u179B\u17CB\u1794\u1793\u17D2\u1790\u17C2\u1798\u17D4";
    Score____score___21 = "\u1796\u17B7\u1793\u17D2\u1791\u17BB\u17D6 {{score}}%";
    Select_an_answer21 = "\u1787\u17D2\u179A\u17BE\u179F\u179A\u17BE\u179F\u1785\u1798\u17D2\u179B\u17BE\u1799";
    Submit_Answer_s_21 = "\u1794\u1789\u17D2\u1787\u17BC\u1793\u1785\u1798\u17D2\u179B\u17BE\u1799";
    The_response_options_are__21 = "\u1787\u1798\u17D2\u179A\u17BE\u179F\u1786\u17D2\u179B\u17BE\u1799\u178F\u1794\u1782\u17BA\u17D6 ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question21 = "\u178A\u17BE\u1798\u17D2\u1794\u17B8\u178A\u1780\u1780\u17B6\u179A\u1787\u17D2\u179A\u17BE\u179F\u179A\u17BE\u179F\u1785\u1798\u17D2\u179B\u17BE\u1799 \u179F\u17BC\u1798\u1794\u17D2\u179A\u17BE\u1787\u1798\u17D2\u179A\u17BE\u179F Clear Selection (\u1787\u1798\u17D2\u179A\u17C7\u1780\u17B6\u179A\u1787\u17D2\u179A\u17BE\u179F\u179A\u17BE\u179F) \u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB\u1796\u17B8\u1787\u1798\u17D2\u179A\u17BE\u179F\u1785\u1798\u17D2\u179B\u17BE\u1799\u1785\u17BB\u1784\u1780\u17D2\u179A\u17C4\u1799\u179F\u1798\u17D2\u179A\u17B6\u1794\u17CB\u179F\u17C6\u178E\u17BD\u179A\u1793\u17B8\u1798\u17BD\u1799\u17D7";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_21 = "\u1787\u17B6\u17A2\u1780\u17BB\u179F\u179B \u17A2\u17D2\u1793\u1780\u1798\u17B7\u1793\u1794\u17B6\u1793\u1787\u17B6\u1794\u17CB\u1791\u17C1 \u17A0\u17BE\u1799\u1793\u17B9\u1784\u178F\u17D2\u179A\u17BC\u179C\u1792\u17D2\u179C\u17BE\u1780\u17B6\u179A\u179C\u17B6\u1799\u178F\u1798\u17D2\u179B\u17C3\u17A1\u17BE\u1784\u179C\u17B7\u1789\u17D4";
    Value_must_be_greater_than_or_equal_to_021 = "\u178F\u1798\u17D2\u179B\u17C3\u178F\u17D2\u179A\u17BC\u179C\u178F\u17C2\u1792\u17C6\u1787\u17B6\u1784 \u17AC\u179F\u17D2\u1798\u17BE 0";
    You_passed_21 = "\u17A2\u17D2\u1793\u1780\u1794\u17B6\u1793\u1787\u17B6\u1794\u17CB\u17A0\u17BE\u1799!";
    translations_default21 = {
      "(Select all that apply)": _Select_all_that_apply_21,
      "1,000 character limit": __000_character_limit21,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required21,
      Answer: Answer21,
      "Answer (Must be a number)": Answer__Must_be_a_number_21,
      Answerssss: Answerssss19,
      "Assessment Completed": Assessment_Completed21,
      Clear: Clear21,
      "Clear Selection": Clear_Selection21,
      Close: Close21,
      Continue: Continue21,
      Finish: Finish21,
      "Let's Get Started": Let_s_Get_Started21,
      "Must be a decimal": Must_be_a_decimal21,
      Next: Next21,
      "Next Page": Next_Page21,
      "Number of Drinks": Number_of_Drinks21,
      OK: OK21,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__21,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_21,
      Prev: Prev21,
      Previous: Previous21,
      "Previous Page": Previous_Page21,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__21,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_21,
      "Retake Exam": Retake_Exam21,
      Return: Return21,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_21,
      "Score: {{score}}%": Score____score___21,
      "Select an answer": Select_an_answer21,
      "Submit Answer(s)": Submit_Answer_s_21,
      "The response options are: ": The_response_options_are__21,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question21,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_21,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_021,
      "You passed!": You_passed_21
    };
  }
});

// src/lib/locales/ko/translations.json
var translations_exports22 = {};
__export(translations_exports22, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_22;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit22;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required22;
  },
  Answer: function Answer() {
    return Answer22;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_22;
  },
  Answerssss: function Answerssss() {
    return Answerssss20;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed22;
  },
  Clear: function Clear() {
    return Clear22;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection22;
  },
  Close: function Close() {
    return Close22;
  },
  Continue: function Continue() {
    return Continue22;
  },
  Finish: function Finish() {
    return Finish22;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started22;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal22;
  },
  Next: function Next() {
    return Next22;
  },
  "Next Page": function NextPage() {
    return Next_Page22;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks22;
  },
  OK: function OK() {
    return OK22;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__22;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_22;
  },
  Prev: function Prev() {
    return Prev22;
  },
  Previous: function Previous() {
    return Previous22;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page22;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__22;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_22;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam22;
  },
  Return: function Return() {
    return Return22;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_22;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___22;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer22;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_22;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__22;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question22;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_22;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_022;
  },
  "You passed!": function YouPassed() {
    return You_passed_22;
  },
  "default": function _default() {
    return translations_default22;
  }
});
var _Select_all_that_apply_22, __000_character_limit22, A_score_of_at_least___passingGrade____is_required22, Answer22, Answer__Must_be_a_number_22, Answerssss20, Assessment_Completed22, Clear22, Clear_Selection22, Close22, Continue22, Finish22, Let_s_Get_Started22, Must_be_a_decimal22, Next22, Next_Page22, Number_of_Drinks22, OK22, Page___currentPage___of___totalPages__22, Please_click_OK_to_continue_to_the_next_page_22, Prev22, Previous22, Previous_Page22, Question___currentQuestion___of___totalQuestions__22, Questions_you_missed_on_the_assessment_22, Retake_Exam22, Return22, Review_answer_feedback_to_learn_more_22, Score____score___22, Select_an_answer22, Submit_Answer_s_22, The_response_options_are__22, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question22, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_22, Value_must_be_greater_than_or_equal_to_022, You_passed_22, translations_default22;
var init_translations22 = __esm({
  "src/lib/locales/ko/translations.json": function srcLibLocalesKoTranslationsJson() {
    _Select_all_that_apply_22 = "(\uD574\uB2F9 \uC0AC\uD56D\uC744 \uBAA8\uB450 \uC120\uD0DD)";
    __000_character_limit22 = "\uCD5C\uB300 1,000\uC790";
    A_score_of_at_least___passingGrade____is_required22 = "\uC810\uC218\uAC00 {{passingGrade}}\uC810 \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4.";
    Answer22 = "\uB2F5\uBCC0";
    Answer__Must_be_a_number_22 = "\uB2F5\uBCC0(\uC22B\uC790\uC5EC\uC57C \uD568)";
    Answerssss20 = "\uB2F5\uBCC0";
    Assessment_Completed22 = "\uD3C9\uAC00 \uC644\uB8CC";
    Clear22 = "\uC9C0\uC6B0\uAE30";
    Clear_Selection22 = "\uC120\uD0DD \uC9C0\uC6B0\uAE30";
    Close22 = "\uB2EB\uAE30";
    Continue22 = "\uACC4\uC18D";
    Finish22 = "\uC885\uB8CC";
    Let_s_Get_Started22 = "\uC2DC\uC791\uD558\uAE30";
    Must_be_a_decimal22 = "\uC18C\uC218\uC5EC\uC57C \uD568";
    Next22 = "\uB2E4\uC74C";
    Next_Page22 = "\uB2E4\uC74C \uD398\uC774\uC9C0";
    Number_of_Drinks22 = "\uC74C\uB8CC\uC758 \uC218";
    OK22 = "\uD655\uC778";
    Page___currentPage___of___totalPages__22 = "{{currentPage}}/{{totalPages}}\uD398\uC774\uC9C0";
    Please_click_OK_to_continue_to_the_next_page_22 = "'\uD655\uC778'\uC744 \uD074\uB9AD\uD558\uC5EC \uB2E4\uC74C \uD398\uC774\uC9C0\uB85C \uC9C4\uD589\uD558\uC138\uC694.";
    Prev22 = "\uC774\uC804";
    Previous22 = "\uC774\uC804";
    Previous_Page22 = "\uC774\uC804 \uD398\uC774\uC9C0";
    Question___currentQuestion___of___totalQuestions__22 = "\uC9C8\uBB38 {{currentQuestion}}/{{totalQuestions}}\uAC1C";
    Questions_you_missed_on_the_assessment_22 = "\uD3C9\uAC00\uC5D0\uC11C \uD2C0\uB9B0 \uC9C8\uBB38:";
    Retake_Exam22 = "\uC2DC\uD5D8 \uC7AC\uC751\uC2DC";
    Return22 = "\uB3CC\uC544\uAC00\uAE30";
    Review_answer_feedback_to_learn_more_22 = "\uC790\uC138\uD788 \uC54C\uC544\uBCF4\uB824\uBA74 \uB2F5\uBCC0\uC5D0 \uB300\uD55C \uC758\uACAC\uC744 \uD655\uC778\uD558\uC138\uC694.";
    Score____score___22 = "\uC810\uC218: {{score}}%";
    Select_an_answer22 = "\uC815\uB2F5\uC744 \uC120\uD0DD\uD558\uC138\uC694";
    Submit_Answer_s_22 = "\uB2F5\uBCC0 \uC81C\uCD9C:";
    The_response_options_are__22 = "\uC751\uB2F5 \uC635\uC158\uC740 \uB2E4\uC74C\uACFC \uAC19\uC2B5\uB2C8\uB2E4. ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question22 = "\uC751\uB2F5\uC744 \uC120\uD0DD \uCDE8\uC18C\uD558\uB824\uBA74 \uAC01 \uC9C8\uBB38\uC758 \uB9C8\uC9C0\uB9C9 \uC751\uB2F5 \uC120\uD0DD\uC9C0 \uB4A4\uC5D0 \uC788\uB294 '\uC120\uD0DD \uCDE8\uC18C' \uC635\uC158\uC744 \uC0AC\uC6A9\uD558\uC138\uC694.";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_22 = "\uD1B5\uACFC\uD558\uC9C0 \uBABB\uD588\uC73C\uBBC0\uB85C \uC2DC\uD5D8\uC744 \uB2E4\uC2DC \uBCF4\uC154\uC57C \uD569\uB2C8\uB2E4.";
    Value_must_be_greater_than_or_equal_to_022 = "\uAC12\uC774 0 \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4";
    You_passed_22 = "\uD569\uACA9\uC785\uB2C8\uB2E4!";
    translations_default22 = {
      "(Select all that apply)": _Select_all_that_apply_22,
      "1,000 character limit": __000_character_limit22,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required22,
      Answer: Answer22,
      "Answer (Must be a number)": Answer__Must_be_a_number_22,
      Answerssss: Answerssss20,
      "Assessment Completed": Assessment_Completed22,
      Clear: Clear22,
      "Clear Selection": Clear_Selection22,
      Close: Close22,
      Continue: Continue22,
      Finish: Finish22,
      "Let's Get Started": Let_s_Get_Started22,
      "Must be a decimal": Must_be_a_decimal22,
      Next: Next22,
      "Next Page": Next_Page22,
      "Number of Drinks": Number_of_Drinks22,
      OK: OK22,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__22,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_22,
      Prev: Prev22,
      Previous: Previous22,
      "Previous Page": Previous_Page22,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__22,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_22,
      "Retake Exam": Retake_Exam22,
      Return: Return22,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_22,
      "Score: {{score}}%": Score____score___22,
      "Select an answer": Select_an_answer22,
      "Submit Answer(s)": Submit_Answer_s_22,
      "The response options are: ": The_response_options_are__22,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question22,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_22,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_022,
      "You passed!": You_passed_22
    };
  }
});

// src/lib/locales/ms-MY/translations.json
var translations_exports23 = {};
__export(translations_exports23, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_23;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit23;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required23;
  },
  Answer: function Answer() {
    return Answer23;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_23;
  },
  Answerssss: function Answerssss() {
    return Answerssss21;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed23;
  },
  Clear: function Clear() {
    return Clear23;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection23;
  },
  Close: function Close() {
    return Close23;
  },
  Continue: function Continue() {
    return Continue23;
  },
  Finish: function Finish() {
    return Finish23;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started23;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal23;
  },
  Next: function Next() {
    return Next23;
  },
  "Next Page": function NextPage() {
    return Next_Page23;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks23;
  },
  OK: function OK() {
    return OK23;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__23;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_23;
  },
  Prev: function Prev() {
    return Prev23;
  },
  Previous: function Previous() {
    return Previous23;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page23;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__23;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_23;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam23;
  },
  Return: function Return() {
    return Return23;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_23;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___23;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer23;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_23;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__23;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question23;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_23;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_023;
  },
  "You passed!": function YouPassed() {
    return You_passed_23;
  },
  "default": function _default() {
    return translations_default23;
  }
});
var _Select_all_that_apply_23, __000_character_limit23, A_score_of_at_least___passingGrade____is_required23, Answer23, Answer__Must_be_a_number_23, Answerssss21, Assessment_Completed23, Clear23, Clear_Selection23, Close23, Continue23, Finish23, Let_s_Get_Started23, Must_be_a_decimal23, Next23, Next_Page23, Number_of_Drinks23, OK23, Page___currentPage___of___totalPages__23, Please_click_OK_to_continue_to_the_next_page_23, Prev23, Previous23, Previous_Page23, Question___currentQuestion___of___totalQuestions__23, Questions_you_missed_on_the_assessment_23, Retake_Exam23, Return23, Review_answer_feedback_to_learn_more_23, Score____score___23, Select_an_answer23, Submit_Answer_s_23, The_response_options_are__23, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question23, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_23, Value_must_be_greater_than_or_equal_to_023, You_passed_23, translations_default23;
var init_translations23 = __esm({
  "src/lib/locales/ms-MY/translations.json": function srcLibLocalesMsMYTranslationsJson() {
    _Select_all_that_apply_23 = "(Pilih semua yang berkenaan)";
    __000_character_limit23 = "Had 1,000 aksara";
    A_score_of_at_least___passingGrade____is_required23 = "Skor minimum {{passingGrade}}%s diperlukan";
    Answer23 = "Jawapan";
    Answer__Must_be_a_number_23 = "Jawapan (Mesti nombor)";
    Answerssss21 = "Jawapan";
    Assessment_Completed23 = "Penilaian Dilengkapkan";
    Clear23 = "Kosongkan";
    Clear_Selection23 = "Kosongkan Pilihan";
    Close23 = "Tutup";
    Continue23 = "Teruskan";
    Finish23 = "Selesai";
    Let_s_Get_Started23 = "Mari Mulakan";
    Must_be_a_decimal23 = "Mesti perpuluhan";
    Next23 = "Seterusnya";
    Next_Page23 = "Halaman Seterusnya";
    Number_of_Drinks23 = "Bilangan Minuman";
    OK23 = "OK";
    Page___currentPage___of___totalPages__23 = "Halaman {{currentPage}} daripada {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_23 = "Sila klik OK untuk meneruskan ke halaman seterusnya.";
    Prev23 = "Sebelumnya";
    Previous23 = "Sebelumnya";
    Previous_Page23 = "Halaman Sebelumnya";
    Question___currentQuestion___of___totalQuestions__23 = "Soalan {{currentQuestion}} daripada {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_23 = "Soalan yang anda tertinggal dalam penilaian:";
    Retake_Exam23 = "Ambil Semula Peperiksaan";
    Return23 = "Kembali";
    Review_answer_feedback_to_learn_more_23 = "Semak maklum balas jawapan untuk mengetahui lebih lanjut.";
    Score____score___23 = "Skor: {{score}}%";
    Select_an_answer23 = "Pilih jawapan";
    Submit_Answer_s_23 = "Serahkan Jawapan";
    The_response_options_are__23 = "Pilihan respons: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question23 = "Untuk membatalkan pilihan jawapan, gunakan pilihan Kosongkan Pilihan selepas pilihan jawapan terakhir bagi setiap soalan";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_23 = "Maaf, anda tidak lulus dan perlu ambil semula penilaian.";
    Value_must_be_greater_than_or_equal_to_023 = "Nilai mestilah lebih besar atau sama dengan 0";
    You_passed_23 = "Anda lulus!";
    translations_default23 = {
      "(Select all that apply)": _Select_all_that_apply_23,
      "1,000 character limit": __000_character_limit23,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required23,
      Answer: Answer23,
      "Answer (Must be a number)": Answer__Must_be_a_number_23,
      Answerssss: Answerssss21,
      "Assessment Completed": Assessment_Completed23,
      Clear: Clear23,
      "Clear Selection": Clear_Selection23,
      Close: Close23,
      Continue: Continue23,
      Finish: Finish23,
      "Let's Get Started": Let_s_Get_Started23,
      "Must be a decimal": Must_be_a_decimal23,
      Next: Next23,
      "Next Page": Next_Page23,
      "Number of Drinks": Number_of_Drinks23,
      OK: OK23,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__23,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_23,
      Prev: Prev23,
      Previous: Previous23,
      "Previous Page": Previous_Page23,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__23,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_23,
      "Retake Exam": Retake_Exam23,
      Return: Return23,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_23,
      "Score: {{score}}%": Score____score___23,
      "Select an answer": Select_an_answer23,
      "Submit Answer(s)": Submit_Answer_s_23,
      "The response options are: ": The_response_options_are__23,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question23,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_23,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_023,
      "You passed!": You_passed_23
    };
  }
});

// src/lib/locales/my-MM/translations.json
var translations_exports24 = {};
__export(translations_exports24, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_24;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit24;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required24;
  },
  Answer: function Answer() {
    return Answer24;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_24;
  },
  Answerssss: function Answerssss() {
    return Answerssss22;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed24;
  },
  Clear: function Clear() {
    return Clear24;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection24;
  },
  Close: function Close() {
    return Close24;
  },
  Continue: function Continue() {
    return Continue24;
  },
  Finish: function Finish() {
    return Finish24;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started24;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal24;
  },
  Next: function Next() {
    return Next24;
  },
  "Next Page": function NextPage() {
    return Next_Page24;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks24;
  },
  OK: function OK() {
    return OK24;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__24;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_24;
  },
  Prev: function Prev() {
    return Prev24;
  },
  Previous: function Previous() {
    return Previous24;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page24;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__24;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_24;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam24;
  },
  Return: function Return() {
    return Return24;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_24;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___24;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer24;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_24;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__24;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question24;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_24;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_024;
  },
  "You passed!": function YouPassed() {
    return You_passed_24;
  },
  "default": function _default() {
    return translations_default24;
  }
});
var _Select_all_that_apply_24, __000_character_limit24, A_score_of_at_least___passingGrade____is_required24, Answer24, Answer__Must_be_a_number_24, Answerssss22, Assessment_Completed24, Clear24, Clear_Selection24, Close24, Continue24, Finish24, Let_s_Get_Started24, Must_be_a_decimal24, Next24, Next_Page24, Number_of_Drinks24, OK24, Page___currentPage___of___totalPages__24, Please_click_OK_to_continue_to_the_next_page_24, Prev24, Previous24, Previous_Page24, Question___currentQuestion___of___totalQuestions__24, Questions_you_missed_on_the_assessment_24, Retake_Exam24, Return24, Review_answer_feedback_to_learn_more_24, Score____score___24, Select_an_answer24, Submit_Answer_s_24, The_response_options_are__24, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question24, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_24, Value_must_be_greater_than_or_equal_to_024, You_passed_24, translations_default24;
var init_translations24 = __esm({
  "src/lib/locales/my-MM/translations.json": function srcLibLocalesMyMMTranslationsJson() {
    _Select_all_that_apply_24 = "(\u101E\u1000\u103A\u1006\u102D\u102F\u1004\u103A\u101E\u100A\u103A\u1019\u103B\u102C\u1038\u1021\u102C\u1038\u101C\u102F\u1036\u1038\u1000\u102D\u102F \u101B\u103D\u1031\u1038\u1001\u103B\u101A\u103A\u1015\u102B)";
    __000_character_limit24 = "\u1005\u102C\u101C\u102F\u1036\u1038\u101B\u1031 \u1000\u1014\u1037\u103A\u101E\u1010\u103A\u1001\u103B\u1000\u103A \u1041,\u1040\u1040\u1040";
    A_score_of_at_least___passingGrade____is_required24 = "\u1021\u1014\u100A\u103A\u1038\u1006\u102F\u1036\u1038\u101B\u1019\u103E\u1010\u103A {{passingGrade}}% \u101C\u102D\u102F\u1021\u1015\u103A\u101E\u100A\u103A";
    Answer24 = "\u1021\u1016\u103C\u1031";
    Answer__Must_be_a_number_24 = "\u1021\u1016\u103C\u1031 (\u1002\u100F\u1014\u103A\u1038\u1010\u1005\u103A\u1001\u102F \u1016\u103C\u1005\u103A\u101B\u1019\u100A\u103A)";
    Answerssss22 = "\u1021\u1016\u103C\u1031\u1019\u103B\u102C\u1038";
    Assessment_Completed24 = "\u1021\u1000\u1032\u1016\u103C\u1010\u103A\u1019\u103E\u102F \u1015\u103C\u102E\u1038\u1005\u102E\u1038\u101E\u103D\u102C\u1038\u1015\u103C\u102E";
    Clear24 = "\u1016\u101A\u103A\u101B\u103E\u102C\u1038\u101B\u1014\u103A";
    Clear_Selection24 = "\u101B\u103D\u1031\u1038\u1001\u103B\u101A\u103A\u1019\u103E\u102F\u1000\u102D\u102F \u101B\u103E\u1004\u103A\u1038\u101B\u1014\u103A";
    Close24 = "\u1015\u102D\u1010\u103A\u101B\u1014\u103A";
    Continue24 = "\u101B\u103E\u1031\u1037\u1006\u1000\u103A\u101B\u1014\u103A";
    Finish24 = "\u1021\u1015\u103C\u102E\u1038\u101E\u1010\u103A\u101B\u1014\u103A";
    Let_s_Get_Started24 = "\u1005\u101C\u102D\u102F\u1000\u103A\u1000\u103C\u1005\u102D\u102F\u1037";
    Must_be_a_decimal24 = "\u1012\u101E\u1019\u1000\u102D\u1014\u103A\u1038 \u1016\u103C\u1005\u103A\u101B\u1019\u100A\u103A";
    Next24 = "\u1014\u1031\u102C\u1000\u103A";
    Next_Page24 = "\u1014\u1031\u102C\u1000\u103A\u1005\u102C\u1019\u103B\u1000\u103A\u1014\u103E\u102C";
    Number_of_Drinks24 = "\u101E\u1031\u102C\u1000\u103A\u1005\u101B\u102C\u1021\u101B\u1031\u1021\u1010\u103D\u1000\u103A";
    OK24 = "\u101F\u102F\u1010\u103A\u1015\u102B\u1015\u103C\u102E";
    Page___currentPage___of___totalPages__24 = "\u1005\u102C\u1019\u103B\u1000\u103A\u1014\u103E\u102C {{totalPages}} \u1021\u1014\u1000\u103A {{currentPage}}";
    Please_click_OK_to_continue_to_the_next_page_24 = "\u1014\u1031\u102C\u1000\u103A\u1005\u102C\u1019\u103B\u1000\u103A\u1014\u103E\u102C\u101E\u102D\u102F\u1037 \u1006\u1000\u103A\u101C\u1000\u103A\u101E\u103D\u102C\u1038\u101B\u1014\u103A \u1000\u103B\u1031\u1038\u1007\u1030\u1038\u1015\u103C\u102F\u104D \u1021\u102D\u102F\u1000\u1031\u1000\u102D\u102F \u1014\u103E\u102D\u1015\u103A\u1015\u102B\u104B";
    Prev24 = "\u1021\u1000\u103C\u102D\u102F";
    Previous24 = "\u101A\u1001\u1004\u103A";
    Previous_Page24 = "\u101A\u1001\u1004\u103A\u1005\u102C\u1019\u103B\u1000\u103A\u1014\u103E\u102C";
    Question___currentQuestion___of___totalQuestions__24 = "\u1019\u1031\u1038\u1001\u103D\u1014\u103A\u1038 {{totalQuestions}} \u1021\u1014\u1000\u103A {{currentQuestion}}";
    Questions_you_missed_on_the_assessment_24 = "\u1021\u1000\u1032\u1016\u103C\u1010\u103A\u1019\u103E\u102F\u1010\u103D\u1004\u103A \u101E\u1004\u103A\u1019\u1016\u103C\u1031\u101C\u102D\u102F\u1000\u103A\u1019\u102D\u101E\u1031\u102C \u1019\u1031\u1038\u1001\u103D\u1014\u103A\u1038\u1019\u103B\u102C\u1038-";
    Retake_Exam24 = "\u1005\u102C\u1019\u1031\u1038\u1015\u103D\u1032\u1015\u103C\u1014\u103A\u1016\u103C\u1031\u1019\u100A\u103A";
    Return24 = "\u1015\u103C\u1014\u103A\u101C\u102C\u1019\u100A\u103A";
    Review_answer_feedback_to_learn_more_24 = "\u1015\u102D\u102F\u1019\u102D\u102F\u101C\u1031\u1037\u101C\u102C\u101B\u1014\u103A \u1021\u1016\u103C\u1031\u1010\u102F\u1036\u1037\u1015\u103C\u1014\u103A\u1001\u103B\u1000\u103A\u1000\u102D\u102F \u1015\u103C\u1014\u103A\u101C\u100A\u103A\u101E\u102F\u1036\u1038\u101E\u1015\u103A\u1015\u102B\u104B";
    Score____score___24 = "\u1021\u1019\u103E\u1010\u103A\u2013 {{score}}%";
    Select_an_answer24 = "\u1021\u1016\u103C\u1031\u1010\u1005\u103A\u1001\u102F\u1000\u102D\u102F \u101B\u103D\u1031\u1038\u1001\u103B\u101A\u103A\u1015\u102B";
    Submit_Answer_s_24 = "\u1021\u1016\u103C\u1031(\u1019\u103B\u102C\u1038) \u1015\u1031\u1038\u1015\u102D\u102F\u1037\u1019\u100A\u103A";
    The_response_options_are__24 = "\u1010\u102F\u1036\u1037\u1015\u103C\u1014\u103A\u1019\u103E\u102F\u1006\u102D\u102F\u1004\u103A\u101B\u102C \u101B\u103D\u1031\u1038\u1001\u103B\u101A\u103A\u1005\u101B\u102C\u1019\u103B\u102C\u1038\u1019\u103E\u102C- ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question24 = "\u1021\u1016\u103C\u1031\u1010\u1005\u103A\u1001\u102F\u1021\u102C\u1038 \u101B\u103D\u1031\u1038\u1001\u103B\u101A\u103A\u1001\u103C\u1004\u103A\u1038\u1019\u103E \u1016\u103C\u102F\u1010\u103A\u101B\u1014\u103A\u104A \u1019\u1031\u1038\u1001\u103D\u1014\u103A\u1038\u1010\u1005\u103A\u1001\u102F\u1005\u102E\u1021\u1010\u103D\u1000\u103A \u1014\u1031\u102C\u1000\u103A\u1006\u102F\u1036\u1038\u1021\u1016\u103C\u1031\u1000\u102D\u102F \u101B\u103D\u1031\u1038\u1001\u103B\u101A\u103A\u1015\u103C\u102E\u1038\u1014\u1031\u102C\u1000\u103A \u101B\u103D\u1031\u1038\u1001\u103B\u101A\u103A\u1019\u103E\u102F\u1021\u102C\u1038 \u101B\u103E\u1004\u103A\u1038\u101C\u1004\u103A\u1038\u1019\u100A\u103A \u101B\u103D\u1031\u1038\u1001\u103B\u101A\u103A\u1005\u101B\u102C\u1000\u102D\u102F \u1021\u101E\u102F\u1036\u1038\u1015\u103C\u102F\u1015\u102B\u104B";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_24 = "\u1000\u1036\u1019\u1000\u1031\u102C\u1004\u103A\u1038\u1005\u103D\u102C\u1015\u1032\u104A \u101E\u1004\u103A\u1019\u1021\u1031\u102C\u1004\u103A\u1019\u103C\u1004\u103A\u1001\u1032\u1037\u101E\u1016\u103C\u1004\u1037\u103A \u1021\u1000\u1032\u1016\u103C\u1010\u103A\u1019\u103E\u102F\u1000\u102D\u102F \u1015\u103C\u1014\u103A\u101C\u100A\u103A\u1016\u103C\u1031\u1006\u102D\u102F\u101B\u1014\u103A \u101C\u102D\u102F\u1021\u1015\u103A\u1015\u102B\u101E\u100A\u103A\u104B";
    Value_must_be_greater_than_or_equal_to_024 = "\u1010\u1014\u103A\u1016\u102D\u102F\u1038\u101E\u100A\u103A 0 \u1011\u1000\u103A\u1000\u103C\u102E\u1038\u101B\u1019\u100A\u103A \u101E\u102D\u102F\u1037\u1019\u101F\u102F\u1010\u103A \u1010\u1030\u100A\u102E\u101B\u1015\u102B\u1019\u100A\u103A\u104B";
    You_passed_24 = "\u101E\u1004\u103A\u1021\u1031\u102C\u1004\u103A\u1019\u103C\u1004\u103A\u101E\u103D\u102C\u1038\u1015\u103C\u102E\u104B";
    translations_default24 = {
      "(Select all that apply)": _Select_all_that_apply_24,
      "1,000 character limit": __000_character_limit24,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required24,
      Answer: Answer24,
      "Answer (Must be a number)": Answer__Must_be_a_number_24,
      Answerssss: Answerssss22,
      "Assessment Completed": Assessment_Completed24,
      Clear: Clear24,
      "Clear Selection": Clear_Selection24,
      Close: Close24,
      Continue: Continue24,
      Finish: Finish24,
      "Let's Get Started": Let_s_Get_Started24,
      "Must be a decimal": Must_be_a_decimal24,
      Next: Next24,
      "Next Page": Next_Page24,
      "Number of Drinks": Number_of_Drinks24,
      OK: OK24,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__24,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_24,
      Prev: Prev24,
      Previous: Previous24,
      "Previous Page": Previous_Page24,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__24,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_24,
      "Retake Exam": Retake_Exam24,
      Return: Return24,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_24,
      "Score: {{score}}%": Score____score___24,
      "Select an answer": Select_an_answer24,
      "Submit Answer(s)": Submit_Answer_s_24,
      "The response options are: ": The_response_options_are__24,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question24,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_24,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_024,
      "You passed!": You_passed_24
    };
  }
});

// src/lib/locales/nl-NL/translations.json
var translations_exports25 = {};
__export(translations_exports25, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_25;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit25;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required25;
  },
  Answer: function Answer() {
    return Answer25;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_25;
  },
  Answerssss: function Answerssss() {
    return Answerssss23;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed25;
  },
  Clear: function Clear() {
    return Clear25;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection25;
  },
  Close: function Close() {
    return Close25;
  },
  Continue: function Continue() {
    return Continue25;
  },
  Finish: function Finish() {
    return Finish25;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started25;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal25;
  },
  Next: function Next() {
    return Next25;
  },
  "Next Page": function NextPage() {
    return Next_Page25;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks25;
  },
  OK: function OK() {
    return OK25;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__25;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_25;
  },
  Prev: function Prev() {
    return Prev25;
  },
  Previous: function Previous() {
    return Previous25;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page25;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__25;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_25;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam25;
  },
  Return: function Return() {
    return Return25;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_25;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___25;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer25;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_25;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__25;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question25;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_25;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_025;
  },
  "You passed!": function YouPassed() {
    return You_passed_25;
  },
  "default": function _default() {
    return translations_default25;
  }
});
var _Select_all_that_apply_25, __000_character_limit25, A_score_of_at_least___passingGrade____is_required25, Answer25, Answer__Must_be_a_number_25, Answerssss23, Assessment_Completed25, Clear25, Clear_Selection25, Close25, Continue25, Finish25, Let_s_Get_Started25, Must_be_a_decimal25, Next25, Next_Page25, Number_of_Drinks25, OK25, Page___currentPage___of___totalPages__25, Please_click_OK_to_continue_to_the_next_page_25, Prev25, Previous25, Previous_Page25, Question___currentQuestion___of___totalQuestions__25, Questions_you_missed_on_the_assessment_25, Retake_Exam25, Return25, Review_answer_feedback_to_learn_more_25, Score____score___25, Select_an_answer25, Submit_Answer_s_25, The_response_options_are__25, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question25, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_25, Value_must_be_greater_than_or_equal_to_025, You_passed_25, translations_default25;
var init_translations25 = __esm({
  "src/lib/locales/nl-NL/translations.json": function srcLibLocalesNlNLTranslationsJson() {
    _Select_all_that_apply_25 = "(selecteer alles wat van toepassing is)";
    __000_character_limit25 = "Maximaal 1000 tekens";
    A_score_of_at_least___passingGrade____is_required25 = "Je moet een minimale score van {{passingGrade}}% halen";
    Answer25 = "Antwoord";
    Answer__Must_be_a_number_25 = "Antwoord (moet een getal zijn)";
    Answerssss23 = "Antwoorden";
    Assessment_Completed25 = "Toets voltooid";
    Clear25 = "Wissen";
    Clear_Selection25 = "Selectie wissen";
    Close25 = "Sluiten";
    Continue25 = "Doorgaan";
    Finish25 = "Voltooien";
    Let_s_Get_Started25 = "Laten we beginnen";
    Must_be_a_decimal25 = "Moet een decimaal zijn";
    Next25 = "Volgende";
    Next_Page25 = "Volgende pagina";
    Number_of_Drinks25 = "Aantal drankjes";
    OK25 = "OK";
    Page___currentPage___of___totalPages__25 = "Pagina {{currentPage}} van {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_25 = "Klik op 'OK' om door te gaan naar de volgende pagina.";
    Prev25 = "Vorige";
    Previous25 = "Vorige";
    Previous_Page25 = "Vorige pagina";
    Question___currentQuestion___of___totalQuestions__25 = "Vraag {{currentQuestion}} van {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_25 = "Vragen die je fout had op de toets:";
    Retake_Exam25 = "Toets opnieuw maken";
    Return25 = "Terug";
    Review_answer_feedback_to_learn_more_25 = "Antwoordfeedback bekijken om meer te leren.";
    Score____score___25 = "Score: {{score}}%";
    Select_an_answer25 = "Selecteer een antwoord";
    Submit_Answer_s_25 = "Antwoord(en) indienen";
    The_response_options_are__25 = "De antwoordopties zijn: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question25 = "Gebruik de knop 'Selectie wissen' na de laatste antwoordoptie bij elke vraag om een antwoord te deselecteren.";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_25 = "Helaas heb je geen voldoende gehaald en moet je de toets opnieuw maken.";
    Value_must_be_greater_than_or_equal_to_025 = "Waarde moet groter dan of gelijk aan 0 zijn";
    You_passed_25 = "Je bent geslaagd!";
    translations_default25 = {
      "(Select all that apply)": _Select_all_that_apply_25,
      "1,000 character limit": __000_character_limit25,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required25,
      Answer: Answer25,
      "Answer (Must be a number)": Answer__Must_be_a_number_25,
      Answerssss: Answerssss23,
      "Assessment Completed": Assessment_Completed25,
      Clear: Clear25,
      "Clear Selection": Clear_Selection25,
      Close: Close25,
      Continue: Continue25,
      Finish: Finish25,
      "Let's Get Started": Let_s_Get_Started25,
      "Must be a decimal": Must_be_a_decimal25,
      Next: Next25,
      "Next Page": Next_Page25,
      "Number of Drinks": Number_of_Drinks25,
      OK: OK25,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__25,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_25,
      Prev: Prev25,
      Previous: Previous25,
      "Previous Page": Previous_Page25,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__25,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_25,
      "Retake Exam": Retake_Exam25,
      Return: Return25,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_25,
      "Score: {{score}}%": Score____score___25,
      "Select an answer": Select_an_answer25,
      "Submit Answer(s)": Submit_Answer_s_25,
      "The response options are: ": The_response_options_are__25,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question25,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_25,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_025,
      "You passed!": You_passed_25
    };
  }
});

// src/lib/locales/pl-PL/translations.json
var translations_exports26 = {};
__export(translations_exports26, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_26;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit26;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required26;
  },
  Answer: function Answer() {
    return Answer26;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_26;
  },
  Answerssss: function Answerssss() {
    return Answerssss24;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed26;
  },
  Clear: function Clear() {
    return Clear26;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection26;
  },
  Close: function Close() {
    return Close26;
  },
  Continue: function Continue() {
    return Continue26;
  },
  Finish: function Finish() {
    return Finish26;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started26;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal26;
  },
  Next: function Next() {
    return Next26;
  },
  "Next Page": function NextPage() {
    return Next_Page26;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks26;
  },
  OK: function OK() {
    return OK26;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__26;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_26;
  },
  Prev: function Prev() {
    return Prev26;
  },
  Previous: function Previous() {
    return Previous26;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page26;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__26;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_26;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam26;
  },
  Return: function Return() {
    return Return26;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_26;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___26;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer26;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_26;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__26;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question26;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_26;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_026;
  },
  "You passed!": function YouPassed() {
    return You_passed_26;
  },
  "default": function _default() {
    return translations_default26;
  }
});
var _Select_all_that_apply_26, __000_character_limit26, A_score_of_at_least___passingGrade____is_required26, Answer26, Answer__Must_be_a_number_26, Answerssss24, Assessment_Completed26, Clear26, Clear_Selection26, Close26, Continue26, Finish26, Let_s_Get_Started26, Must_be_a_decimal26, Next26, Next_Page26, Number_of_Drinks26, OK26, Page___currentPage___of___totalPages__26, Please_click_OK_to_continue_to_the_next_page_26, Prev26, Previous26, Previous_Page26, Question___currentQuestion___of___totalQuestions__26, Questions_you_missed_on_the_assessment_26, Retake_Exam26, Return26, Review_answer_feedback_to_learn_more_26, Score____score___26, Select_an_answer26, Submit_Answer_s_26, The_response_options_are__26, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question26, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_26, Value_must_be_greater_than_or_equal_to_026, You_passed_26, translations_default26;
var init_translations26 = __esm({
  "src/lib/locales/pl-PL/translations.json": function srcLibLocalesPlPLTranslationsJson() {
    _Select_all_that_apply_26 = "(Wybierz wszystkie elementy maj\u0105ce zastosowanie)";
    __000_character_limit26 = "Limit 1000 znak\xF3w";
    A_score_of_at_least___passingGrade____is_required26 = "Wymagany jest wynik co najmniej {{passingGrade}}%";
    Answer26 = "Odpowied\u017A";
    Answer__Must_be_a_number_26 = "Odpowied\u017A (wymagana liczba)";
    Answerssss24 = "Odpowiedzi";
    Assessment_Completed26 = "Ocena uko\u0144czona";
    Clear26 = "Wyczy\u015B\u0107";
    Clear_Selection26 = "Anuluj zaznaczenie";
    Close26 = "Zamknij";
    Continue26 = "Kontynuuj";
    Finish26 = "Koniec";
    Let_s_Get_Started26 = "Zaczynajmy";
    Must_be_a_decimal26 = "Jest wymagana warto\u015B\u0107 dziesi\u0119tna";
    Next26 = "Nast\u0119pne";
    Next_Page26 = "Nast\u0119pna strona";
    Number_of_Drinks26 = "Liczba drink\xF3w";
    OK26 = "OK";
    Page___currentPage___of___totalPages__26 = "Strona {{currentPage}} z {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_26 = "Kliknij przycisk OK, aby przej\u015B\u0107 do nast\u0119pnej strony.";
    Prev26 = "Poprzednie";
    Previous26 = "Poprzednie";
    Previous_Page26 = "Poprzednia strona";
    Question___currentQuestion___of___totalQuestions__26 = "Pytanie {{currentQuestion}} z {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_26 = "Pytania pomini\u0119te w ocenie:";
    Retake_Exam26 = "Powt\xF3rz egzamin";
    Return26 = "Powr\xF3t";
    Review_answer_feedback_to_learn_more_26 = "Przejrzyj opinie dotycz\u0105ce odpowiedzi, aby dowiedzie\u0107 si\u0119 wi\u0119cej.";
    Score____score___26 = "Wynik: {{score}}%";
    Select_an_answer26 = "Wybierz odpowied\u017A";
    Submit_Answer_s_26 = "Prze\u015Blij odpowiedzi";
    The_response_options_are__26 = "Dost\u0119pne opcje odpowiedzi: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question26 = "Aby anulowa\u0107 zaznaczenie odpowied\u017A, skorzystaj z opcji Anuluj zaznaczenie poni\u017Cej ostatniej odpowiedzi na ka\u017Cde pytanie";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_26 = "Niestety wynik jest negatywny, co wymaga ponownego przeprowadzenia oceny.";
    Value_must_be_greater_than_or_equal_to_026 = "Warto\u015B\u0107 musi by\u0107 wi\u0119ksza ni\u017C lub r\xF3wna 0";
    You_passed_26 = "Zaliczono!";
    translations_default26 = {
      "(Select all that apply)": _Select_all_that_apply_26,
      "1,000 character limit": __000_character_limit26,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required26,
      Answer: Answer26,
      "Answer (Must be a number)": Answer__Must_be_a_number_26,
      Answerssss: Answerssss24,
      "Assessment Completed": Assessment_Completed26,
      Clear: Clear26,
      "Clear Selection": Clear_Selection26,
      Close: Close26,
      Continue: Continue26,
      Finish: Finish26,
      "Let's Get Started": Let_s_Get_Started26,
      "Must be a decimal": Must_be_a_decimal26,
      Next: Next26,
      "Next Page": Next_Page26,
      "Number of Drinks": Number_of_Drinks26,
      OK: OK26,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__26,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_26,
      Prev: Prev26,
      Previous: Previous26,
      "Previous Page": Previous_Page26,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__26,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_26,
      "Retake Exam": Retake_Exam26,
      Return: Return26,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_26,
      "Score: {{score}}%": Score____score___26,
      "Select an answer": Select_an_answer26,
      "Submit Answer(s)": Submit_Answer_s_26,
      "The response options are: ": The_response_options_are__26,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question26,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_26,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_026,
      "You passed!": You_passed_26
    };
  }
});

// src/lib/locales/pt-BR/translations.json
var translations_exports27 = {};
__export(translations_exports27, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_27;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit27;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required27;
  },
  Answer: function Answer() {
    return Answer27;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_27;
  },
  Answerssss: function Answerssss() {
    return Answerssss25;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed27;
  },
  Clear: function Clear() {
    return Clear27;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection27;
  },
  Close: function Close() {
    return Close27;
  },
  Continue: function Continue() {
    return Continue27;
  },
  Finish: function Finish() {
    return Finish27;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started27;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal27;
  },
  Next: function Next() {
    return Next27;
  },
  "Next Page": function NextPage() {
    return Next_Page27;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks27;
  },
  OK: function OK() {
    return OK27;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__27;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_27;
  },
  Prev: function Prev() {
    return Prev27;
  },
  Previous: function Previous() {
    return Previous27;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page27;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__27;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_27;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam27;
  },
  Return: function Return() {
    return Return27;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_27;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___27;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer27;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_27;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__27;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question27;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_27;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_027;
  },
  "You passed!": function YouPassed() {
    return You_passed_27;
  },
  "default": function _default() {
    return translations_default27;
  }
});
var _Select_all_that_apply_27, __000_character_limit27, A_score_of_at_least___passingGrade____is_required27, Answer27, Answer__Must_be_a_number_27, Answerssss25, Assessment_Completed27, Clear27, Clear_Selection27, Close27, Continue27, Finish27, Let_s_Get_Started27, Must_be_a_decimal27, Next27, Next_Page27, Number_of_Drinks27, OK27, Page___currentPage___of___totalPages__27, Please_click_OK_to_continue_to_the_next_page_27, Prev27, Previous27, Previous_Page27, Question___currentQuestion___of___totalQuestions__27, Questions_you_missed_on_the_assessment_27, Retake_Exam27, Return27, Review_answer_feedback_to_learn_more_27, Score____score___27, Select_an_answer27, Submit_Answer_s_27, The_response_options_are__27, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question27, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_27, Value_must_be_greater_than_or_equal_to_027, You_passed_27, translations_default27;
var init_translations27 = __esm({
  "src/lib/locales/pt-BR/translations.json": function srcLibLocalesPtBRTranslationsJson() {
    _Select_all_that_apply_27 = "(Selecione todas as op\xE7\xF5es aplic\xE1veis)";
    __000_character_limit27 = "Limite de 1.000 caracteres";
    A_score_of_at_least___passingGrade____is_required27 = "\xC9 necess\xE1ria uma pontua\xE7\xE3o de pelo menos {{passingGrade}}%";
    Answer27 = "Resposta";
    Answer__Must_be_a_number_27 = "Resposta (deve ser um n\xFAmero)";
    Answerssss25 = "Respostas";
    Assessment_Completed27 = "Avalia\xE7\xE3o conclu\xEDda";
    Clear27 = "Limpar";
    Clear_Selection27 = "Limpar sele\xE7\xE3o";
    Close27 = "Fechar";
    Continue27 = "Continuar";
    Finish27 = "Terminar";
    Let_s_Get_Started27 = "Vamos come\xE7ar";
    Must_be_a_decimal27 = "Deve ser um n\xFAmero decimal";
    Next27 = "Pr\xF3ximo";
    Next_Page27 = "Pr\xF3xima p\xE1gina";
    Number_of_Drinks27 = "N\xFAmero de bebidas";
    OK27 = "OK";
    Page___currentPage___of___totalPages__27 = "P\xE1gina {{currentPage}} de {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_27 = "Clique em OK para passar para a pr\xF3xima p\xE1gina.";
    Prev27 = "Anterior";
    Previous27 = "Anterior";
    Previous_Page27 = "P\xE1gina anterior";
    Question___currentQuestion___of___totalQuestions__27 = "Pergunta {{currentQuestion}} de {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_27 = "Perguntas que voc\xEA errou na avalia\xE7\xE3o:";
    Retake_Exam27 = "Refazer exame";
    Return27 = "Voltar";
    Review_answer_feedback_to_learn_more_27 = "Revise os coment\xE1rios das respostas para saber mais.";
    Score____score___27 = "Pontua\xE7\xE3o: {{score}}";
    Select_an_answer27 = "Selecione uma resposta";
    Submit_Answer_s_27 = "Enviar resposta(s)";
    The_response_options_are__27 = "As op\xE7\xF5es de resposta s\xE3o: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question27 = 'Para desmarcar uma resposta, use a op\xE7\xE3o "Limpar sele\xE7\xE3o" depois da \xFAltima op\xE7\xE3o de resposta de cada pergunta';
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_27 = "Voc\xEA n\xE3o passou e precisar\xE1 refazer a avalia\xE7\xE3o.";
    Value_must_be_greater_than_or_equal_to_027 = "O valor deve ser maior ou igual a 0";
    You_passed_27 = "Voc\xEA passou!";
    translations_default27 = {
      "(Select all that apply)": _Select_all_that_apply_27,
      "1,000 character limit": __000_character_limit27,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required27,
      Answer: Answer27,
      "Answer (Must be a number)": Answer__Must_be_a_number_27,
      Answerssss: Answerssss25,
      "Assessment Completed": Assessment_Completed27,
      Clear: Clear27,
      "Clear Selection": Clear_Selection27,
      Close: Close27,
      Continue: Continue27,
      Finish: Finish27,
      "Let's Get Started": Let_s_Get_Started27,
      "Must be a decimal": Must_be_a_decimal27,
      Next: Next27,
      "Next Page": Next_Page27,
      "Number of Drinks": Number_of_Drinks27,
      OK: OK27,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__27,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_27,
      Prev: Prev27,
      Previous: Previous27,
      "Previous Page": Previous_Page27,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__27,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_27,
      "Retake Exam": Retake_Exam27,
      Return: Return27,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_27,
      "Score: {{score}}%": Score____score___27,
      "Select an answer": Select_an_answer27,
      "Submit Answer(s)": Submit_Answer_s_27,
      "The response options are: ": The_response_options_are__27,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question27,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_27,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_027,
      "You passed!": You_passed_27
    };
  }
});

// src/lib/locales/ro-RO/translations.json
var translations_exports28 = {};
__export(translations_exports28, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_28;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit28;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required28;
  },
  Answer: function Answer() {
    return Answer28;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_28;
  },
  Answerssss: function Answerssss() {
    return Answerssss26;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed28;
  },
  Clear: function Clear() {
    return Clear28;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection28;
  },
  Close: function Close() {
    return Close28;
  },
  Continue: function Continue() {
    return Continue28;
  },
  Finish: function Finish() {
    return Finish28;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started28;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal28;
  },
  Next: function Next() {
    return Next28;
  },
  "Next Page": function NextPage() {
    return Next_Page28;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks28;
  },
  OK: function OK() {
    return OK28;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__28;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_28;
  },
  Prev: function Prev() {
    return Prev28;
  },
  Previous: function Previous() {
    return Previous28;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page28;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__28;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_28;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam28;
  },
  Return: function Return() {
    return Return28;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_28;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___28;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer28;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_28;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__28;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question28;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_28;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_028;
  },
  "You passed!": function YouPassed() {
    return You_passed_28;
  },
  "default": function _default() {
    return translations_default28;
  }
});
var _Select_all_that_apply_28, __000_character_limit28, A_score_of_at_least___passingGrade____is_required28, Answer28, Answer__Must_be_a_number_28, Answerssss26, Assessment_Completed28, Clear28, Clear_Selection28, Close28, Continue28, Finish28, Let_s_Get_Started28, Must_be_a_decimal28, Next28, Next_Page28, Number_of_Drinks28, OK28, Page___currentPage___of___totalPages__28, Please_click_OK_to_continue_to_the_next_page_28, Prev28, Previous28, Previous_Page28, Question___currentQuestion___of___totalQuestions__28, Questions_you_missed_on_the_assessment_28, Retake_Exam28, Return28, Review_answer_feedback_to_learn_more_28, Score____score___28, Select_an_answer28, Submit_Answer_s_28, The_response_options_are__28, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question28, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_28, Value_must_be_greater_than_or_equal_to_028, You_passed_28, translations_default28;
var init_translations28 = __esm({
  "src/lib/locales/ro-RO/translations.json": function srcLibLocalesRoROTranslationsJson() {
    _Select_all_that_apply_28 = "(Selecta\u021Bi tot ceea ce se aplic\u0103)";
    __000_character_limit28 = "Limit\u0103 de 1000 de caractere";
    A_score_of_at_least___passingGrade____is_required28 = "Este necesar un punctaj de cel pu\u021Bin {{passingGrade}}%";
    Answer28 = "R\u0103spuns";
    Answer__Must_be_a_number_28 = "R\u0103spuns (trebuie s\u0103 fie un num\u0103r)";
    Answerssss26 = "R\u0103spunsuri";
    Assessment_Completed28 = "Evaluare finalizat\u0103";
    Clear28 = "\u0218terge\u021Bi";
    Clear_Selection28 = "\u0218terge\u021Bi selec\u021Bia";
    Close28 = "\xCEnchide\u021Bi";
    Continue28 = "Continua\u021Bi";
    Finish28 = "Finaliza\u021Bi";
    Let_s_Get_Started28 = "S\u0103 \xEEncepem";
    Must_be_a_decimal28 = "Trebuie s\u0103 fie o zecimal\u0103";
    Next28 = "Urm\u0103torul";
    Next_Page28 = "Pagina urm\u0103toare";
    Number_of_Drinks28 = "Num\u0103r de b\u0103uturi";
    OK28 = "OK";
    Page___currentPage___of___totalPages__28 = "Pagina {{currentPage}} din {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_28 = "Face\u021Bi clic pe OK pentru a continua la pagina urm\u0103toare.";
    Prev28 = "Anterior";
    Previous28 = "Anteriorul";
    Previous_Page28 = "Pagina anterioar\u0103";
    Question___currentQuestion___of___totalQuestions__28 = "\xCEntrebarea {{currentQuestion}} din {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_28 = "\xCEntreb\u0103ri pe care le-a\u021Bi omis la evaluare:";
    Retake_Exam28 = "Parcurge\u021Bi din nou examinarea";
    Return28 = "Reveni\u021Bi";
    Review_answer_feedback_to_learn_more_28 = "Pentru a afla mai multe, revizui\u021Bi feedbackul aferent r\u0103spunsului.";
    Score____score___28 = "Punctaj: {{score}}%";
    Select_an_answer28 = "Selecta\u021Bi un r\u0103spuns";
    Submit_Answer_s_28 = "Transmite\u021Bi r\u0103spunsul/r\u0103spunsurile";
    The_response_options_are__28 = "Op\u021Biunile de r\u0103spuns sunt: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question28 = "Pentru a deselecta un r\u0103spuns, folosi\u021Bi op\u021Biunea \u201E\u0218terge\u021Bi selec\u021Bia\u201D dup\u0103 ultima op\u021Biune de r\u0103spuns pentru fiecare \xEEntrebare";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_28 = "Din p\u0103cate, nu a\u021Bi finalizat cu succes \u0219i va trebui s\u0103 parcurge\u021Bi din nou evaluarea.";
    Value_must_be_greater_than_or_equal_to_028 = "Valoarea trebuie s\u0103 fie mai mare sau egal\u0103 cu 0";
    You_passed_28 = "A\u021Bi finalizat cu succes!";
    translations_default28 = {
      "(Select all that apply)": _Select_all_that_apply_28,
      "1,000 character limit": __000_character_limit28,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required28,
      Answer: Answer28,
      "Answer (Must be a number)": Answer__Must_be_a_number_28,
      Answerssss: Answerssss26,
      "Assessment Completed": Assessment_Completed28,
      Clear: Clear28,
      "Clear Selection": Clear_Selection28,
      Close: Close28,
      Continue: Continue28,
      Finish: Finish28,
      "Let's Get Started": Let_s_Get_Started28,
      "Must be a decimal": Must_be_a_decimal28,
      Next: Next28,
      "Next Page": Next_Page28,
      "Number of Drinks": Number_of_Drinks28,
      OK: OK28,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__28,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_28,
      Prev: Prev28,
      Previous: Previous28,
      "Previous Page": Previous_Page28,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__28,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_28,
      "Retake Exam": Retake_Exam28,
      Return: Return28,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_28,
      "Score: {{score}}%": Score____score___28,
      "Select an answer": Select_an_answer28,
      "Submit Answer(s)": Submit_Answer_s_28,
      "The response options are: ": The_response_options_are__28,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question28,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_28,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_028,
      "You passed!": You_passed_28
    };
  }
});

// src/lib/locales/ru/translations.json
var translations_exports29 = {};
__export(translations_exports29, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_29;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit29;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required29;
  },
  Answer: function Answer() {
    return Answer29;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_29;
  },
  Answerssss: function Answerssss() {
    return Answerssss27;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed29;
  },
  Clear: function Clear() {
    return Clear29;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection29;
  },
  Close: function Close() {
    return Close29;
  },
  Continue: function Continue() {
    return Continue29;
  },
  Finish: function Finish() {
    return Finish29;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started29;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal29;
  },
  Next: function Next() {
    return Next29;
  },
  "Next Page": function NextPage() {
    return Next_Page29;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks29;
  },
  OK: function OK() {
    return OK29;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__29;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_29;
  },
  Prev: function Prev() {
    return Prev29;
  },
  Previous: function Previous() {
    return Previous29;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page29;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__29;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_29;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam29;
  },
  Return: function Return() {
    return Return29;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_29;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___29;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer29;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_29;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__29;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question29;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_29;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_029;
  },
  "You passed!": function YouPassed() {
    return You_passed_29;
  },
  "default": function _default() {
    return translations_default29;
  }
});
var _Select_all_that_apply_29, __000_character_limit29, A_score_of_at_least___passingGrade____is_required29, Answer29, Answer__Must_be_a_number_29, Answerssss27, Assessment_Completed29, Clear29, Clear_Selection29, Close29, Continue29, Finish29, Let_s_Get_Started29, Must_be_a_decimal29, Next29, Next_Page29, Number_of_Drinks29, OK29, Page___currentPage___of___totalPages__29, Please_click_OK_to_continue_to_the_next_page_29, Prev29, Previous29, Previous_Page29, Question___currentQuestion___of___totalQuestions__29, Questions_you_missed_on_the_assessment_29, Retake_Exam29, Return29, Review_answer_feedback_to_learn_more_29, Score____score___29, Select_an_answer29, Submit_Answer_s_29, The_response_options_are__29, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question29, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_29, Value_must_be_greater_than_or_equal_to_029, You_passed_29, translations_default29;
var init_translations29 = __esm({
  "src/lib/locales/ru/translations.json": function srcLibLocalesRuTranslationsJson() {
    _Select_all_that_apply_29 = "(\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0441\u0435 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u0435 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u044B)";
    __000_character_limit29 = "\u041D\u0435 \u0431\u043E\u043B\u0435\u0435 1000 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432";
    A_score_of_at_least___passingGrade____is_required29 = "\u041F\u043E\u0440\u043E\u0433\u043E\u0432\u044B\u0439 \u043C\u0438\u043D\u0438\u043C\u0443\u043C: {{passingGrade}}%";
    Answer29 = "\u041E\u0442\u0432\u0435\u0442";
    Answer__Must_be_a_number_29 = "\u041E\u0442\u0432\u0435\u0442 (\u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0447\u0438\u0441\u043B\u043E\u043C)";
    Answerssss27 = "\u041E\u0442\u0432\u0435\u0442\u044B";
    Assessment_Completed29 = "\u0422\u0435\u0441\u0442 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D";
    Clear29 = "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C";
    Clear_Selection29 = "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043E\u0442\u0432\u0435\u0442";
    Close29 = "\u0417\u0430\u043A\u0440\u044B\u0442\u044C";
    Continue29 = "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C";
    Finish29 = "\u0413\u043E\u0442\u043E\u0432\u043E";
    Let_s_Get_Started29 = "\u0414\u0430\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u0438\u0441\u0442\u0443\u043F\u0438\u043C!";
    Must_be_a_decimal29 = "\u0414\u043E\u043F\u0443\u0441\u043A\u0430\u044E\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u0435\u0441\u044F\u0442\u0438\u0447\u043D\u044B\u0435 \u0447\u0438\u0441\u043B\u0430";
    Next29 = "\u0414\u0430\u043B\u0435\u0435";
    Next_Page29 = "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
    Number_of_Drinks29 = "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043D\u0430\u043F\u0438\u0442\u043A\u043E\u0432";
    OK29 = "OK";
    Page___currentPage___of___totalPages__29 = "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 {{currentPage}} \u0438\u0437 {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_29 = "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \xABOK\xBB, \u0447\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.";
    Prev29 = "\u041D\u0430\u0437\u0430\u0434";
    Previous29 = "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439";
    Previous_Page29 = "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
    Question___currentQuestion___of___totalQuestions__29 = "\u0412\u043E\u043F\u0440\u043E\u0441 {{currentQuestion}} \u0438\u0437 {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_29 = "\u041F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B:";
    Retake_Exam29 = "\u041F\u0435\u0440\u0435\u0441\u0434\u0430\u0442\u044C \u044D\u043A\u0437\u0430\u043C\u0435\u043D";
    Return29 = "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F";
    Review_answer_feedback_to_learn_more_29 = "\u0418\u0449\u0438\u0442\u0435 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0432 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u044F\u0445 \u043A \u043E\u0442\u0432\u0435\u0442\u0443.";
    Score____score___29 = "\u041E\u0446\u0435\u043D\u043A\u0430: {{score}}%";
    Select_an_answer29 = "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043E\u0442\u0432\u0435\u0442";
    Submit_Answer_s_29 = "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043E\u0442\u0432\u0435\u0442\u044B";
    The_response_options_are__29 = "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u043E\u0442\u0432\u0435\u0442\u0430: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question29 = "\u0427\u0442\u043E\u0431\u044B \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u044B\u0431\u043E\u0440, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043E\u043F\u0446\u0438\u044E \xAB\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043E\u0442\u0432\u0435\u0442\xBB \u043F\u043E\u0434 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430\u043C\u0438 \u043E\u0442\u0432\u0435\u0442\u043E\u0432.";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_29 = "\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u0432\u044B \u043D\u0430\u0431\u0440\u0430\u043B\u0438 \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u043C\u0430\u043B\u043E \u0431\u0430\u043B\u043B\u043E\u0432 \u0438 \u0432\u0430\u043C \u043F\u0440\u0438\u0434\u0435\u0442\u0441\u044F \u043F\u0440\u043E\u0439\u0442\u0438 \u0442\u0435\u0441\u0442 \u0437\u0430\u043D\u043E\u0432\u043E.";
    Value_must_be_greater_than_or_equal_to_029 = "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E 0";
    You_passed_29 = "\u0422\u0435\u0441\u0442 \u043F\u0440\u043E\u0439\u0434\u0435\u043D \u0443\u0441\u043F\u0435\u0448\u043D\u043E!";
    translations_default29 = {
      "(Select all that apply)": _Select_all_that_apply_29,
      "1,000 character limit": __000_character_limit29,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required29,
      Answer: Answer29,
      "Answer (Must be a number)": Answer__Must_be_a_number_29,
      Answerssss: Answerssss27,
      "Assessment Completed": Assessment_Completed29,
      Clear: Clear29,
      "Clear Selection": Clear_Selection29,
      Close: Close29,
      Continue: Continue29,
      Finish: Finish29,
      "Let's Get Started": Let_s_Get_Started29,
      "Must be a decimal": Must_be_a_decimal29,
      Next: Next29,
      "Next Page": Next_Page29,
      "Number of Drinks": Number_of_Drinks29,
      OK: OK29,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__29,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_29,
      Prev: Prev29,
      Previous: Previous29,
      "Previous Page": Previous_Page29,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__29,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_29,
      "Retake Exam": Retake_Exam29,
      Return: Return29,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_29,
      "Score: {{score}}%": Score____score___29,
      "Select an answer": Select_an_answer29,
      "Submit Answer(s)": Submit_Answer_s_29,
      "The response options are: ": The_response_options_are__29,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question29,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_29,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_029,
      "You passed!": You_passed_29
    };
  }
});

// src/lib/locales/sk-SK/translations.json
var translations_exports30 = {};
__export(translations_exports30, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_30;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit30;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required30;
  },
  Answer: function Answer() {
    return Answer30;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_30;
  },
  Answerssss: function Answerssss() {
    return Answerssss28;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed30;
  },
  Clear: function Clear() {
    return Clear30;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection30;
  },
  Close: function Close() {
    return Close30;
  },
  Continue: function Continue() {
    return Continue30;
  },
  Finish: function Finish() {
    return Finish30;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started30;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal30;
  },
  Next: function Next() {
    return Next30;
  },
  "Next Page": function NextPage() {
    return Next_Page30;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks30;
  },
  OK: function OK() {
    return OK30;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__30;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_30;
  },
  Prev: function Prev() {
    return Prev30;
  },
  Previous: function Previous() {
    return Previous30;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page30;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__30;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_30;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam30;
  },
  Return: function Return() {
    return Return30;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_30;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___30;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer30;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_30;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__30;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question30;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_30;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_030;
  },
  "You passed!": function YouPassed() {
    return You_passed_30;
  },
  "default": function _default() {
    return translations_default30;
  }
});
var _Select_all_that_apply_30, __000_character_limit30, A_score_of_at_least___passingGrade____is_required30, Answer30, Answer__Must_be_a_number_30, Answerssss28, Assessment_Completed30, Clear30, Clear_Selection30, Close30, Continue30, Finish30, Let_s_Get_Started30, Must_be_a_decimal30, Next30, Next_Page30, Number_of_Drinks30, OK30, Page___currentPage___of___totalPages__30, Please_click_OK_to_continue_to_the_next_page_30, Prev30, Previous30, Previous_Page30, Question___currentQuestion___of___totalQuestions__30, Questions_you_missed_on_the_assessment_30, Retake_Exam30, Return30, Review_answer_feedback_to_learn_more_30, Score____score___30, Select_an_answer30, Submit_Answer_s_30, The_response_options_are__30, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question30, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_30, Value_must_be_greater_than_or_equal_to_030, You_passed_30, translations_default30;
var init_translations30 = __esm({
  "src/lib/locales/sk-SK/translations.json": function srcLibLocalesSkSKTranslationsJson() {
    _Select_all_that_apply_30 = "(Vyberte v\u0161etky vyhovuj\xFAce mo\u017Enosti.)";
    __000_character_limit30 = "Limit 1\xA0000 znakov";
    A_score_of_at_least___passingGrade____is_required30 = "Vy\u017Eaduje sa sk\xF3re aspo\u0148 {{passingGrade}}\xA0%.";
    Answer30 = "Odpove\u010F";
    Answer__Must_be_a_number_30 = "Odpove\u010F (mus\xED by\u0165 \u010D\xEDslo)";
    Answerssss28 = "Odpovede";
    Assessment_Completed30 = "Hodnotenie dokon\u010Den\xE9";
    Clear30 = "Vymaza\u0165";
    Clear_Selection30 = "Vymaza\u0165 v\xFDber";
    Close30 = "Zatvori\u0165";
    Continue30 = "Pokra\u010Dova\u0165";
    Finish30 = "Dokon\u010Di\u0165";
    Let_s_Get_Started30 = "Za\u010Dnime";
    Must_be_a_decimal30 = "Mus\xED by\u0165 desatinn\xE9 \u010D\xEDslo";
    Next30 = "\u010Eal\u0161ie";
    Next_Page30 = "\u010Eal\u0161ia str\xE1nka";
    Number_of_Drinks30 = "Po\u010Det n\xE1pojov";
    OK30 = "OK";
    Page___currentPage___of___totalPages__30 = "Strana {{currentPage}} z {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_30 = "Kliknut\xEDm na tla\u010Didlo OK pokra\u010Dujte na \u010Fal\u0161iu str\xE1nku.";
    Prev30 = "Predch\xE1dzaj\xFAce";
    Previous30 = "Predch\xE1dzaj\xFAce";
    Previous_Page30 = "Predch\xE1dzaj\xFAca str\xE1nka";
    Question___currentQuestion___of___totalQuestions__30 = "Ot\xE1zka {{currentQuestion}} z {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_30 = "Ot\xE1zky, ktor\xE9 ste pri hodnoten\xED vynechali:";
    Retake_Exam30 = "Zopakova\u0165 sk\xFA\u0161ku";
    Return30 = "Sp\xE4\u0165";
    Review_answer_feedback_to_learn_more_30 = "Ak sa chcete dozvedie\u0165 viac, pre\u010D\xEDtajte si sp\xE4tn\xFA v\xE4zbu k odpovedi.";
    Score____score___30 = "Sk\xF3re: {{score}}\xA0%";
    Select_an_answer30 = "Vyberte odpove\u010F";
    Submit_Answer_s_30 = "Odosla\u0165 odpove\u010F (odpovede)";
    The_response_options_are__30 = "Mo\u017Enosti odpovede s\xFA: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question30 = "Ak chcete zru\u0161i\u0165 v\xFDber odpovede, pou\u017Eite mo\u017Enos\u0165 Vymaza\u0165 v\xFDber za posledn\xFDm v\xFDberom odpovede pre jednotliv\xE9 ot\xE1zky.";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_30 = "Na sk\xFA\u0161ke ste, \u017Eia\u013E, neuspeli a budete ju musie\u0165 absolvova\u0165 znova.";
    Value_must_be_greater_than_or_equal_to_030 = "Hodnota mus\xED by\u0165 v\xE4\u010D\u0161ia alebo rovn\xE1 0.";
    You_passed_30 = "Uspeli ste!";
    translations_default30 = {
      "(Select all that apply)": _Select_all_that_apply_30,
      "1,000 character limit": __000_character_limit30,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required30,
      Answer: Answer30,
      "Answer (Must be a number)": Answer__Must_be_a_number_30,
      Answerssss: Answerssss28,
      "Assessment Completed": Assessment_Completed30,
      Clear: Clear30,
      "Clear Selection": Clear_Selection30,
      Close: Close30,
      Continue: Continue30,
      Finish: Finish30,
      "Let's Get Started": Let_s_Get_Started30,
      "Must be a decimal": Must_be_a_decimal30,
      Next: Next30,
      "Next Page": Next_Page30,
      "Number of Drinks": Number_of_Drinks30,
      OK: OK30,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__30,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_30,
      Prev: Prev30,
      Previous: Previous30,
      "Previous Page": Previous_Page30,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__30,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_30,
      "Retake Exam": Retake_Exam30,
      Return: Return30,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_30,
      "Score: {{score}}%": Score____score___30,
      "Select an answer": Select_an_answer30,
      "Submit Answer(s)": Submit_Answer_s_30,
      "The response options are: ": The_response_options_are__30,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question30,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_30,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_030,
      "You passed!": You_passed_30
    };
  }
});

// src/lib/locales/sl-SI/translations.json
var translations_exports31 = {};
__export(translations_exports31, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_31;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit31;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required31;
  },
  Answer: function Answer() {
    return Answer31;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_31;
  },
  Answerssss: function Answerssss() {
    return Answerssss29;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed31;
  },
  Clear: function Clear() {
    return Clear31;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection31;
  },
  Close: function Close() {
    return Close31;
  },
  Continue: function Continue() {
    return Continue31;
  },
  Finish: function Finish() {
    return Finish31;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started31;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal31;
  },
  Next: function Next() {
    return Next31;
  },
  "Next Page": function NextPage() {
    return Next_Page31;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks31;
  },
  OK: function OK() {
    return OK31;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__31;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_31;
  },
  Prev: function Prev() {
    return Prev31;
  },
  Previous: function Previous() {
    return Previous31;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page31;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__31;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_31;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam31;
  },
  Return: function Return() {
    return Return31;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_31;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___31;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer31;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_31;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__31;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question31;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_31;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_031;
  },
  "You passed!": function YouPassed() {
    return You_passed_31;
  },
  "default": function _default() {
    return translations_default31;
  }
});
var _Select_all_that_apply_31, __000_character_limit31, A_score_of_at_least___passingGrade____is_required31, Answer31, Answer__Must_be_a_number_31, Answerssss29, Assessment_Completed31, Clear31, Clear_Selection31, Close31, Continue31, Finish31, Let_s_Get_Started31, Must_be_a_decimal31, Next31, Next_Page31, Number_of_Drinks31, OK31, Page___currentPage___of___totalPages__31, Please_click_OK_to_continue_to_the_next_page_31, Prev31, Previous31, Previous_Page31, Question___currentQuestion___of___totalQuestions__31, Questions_you_missed_on_the_assessment_31, Retake_Exam31, Return31, Review_answer_feedback_to_learn_more_31, Score____score___31, Select_an_answer31, Submit_Answer_s_31, The_response_options_are__31, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question31, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_31, Value_must_be_greater_than_or_equal_to_031, You_passed_31, translations_default31;
var init_translations31 = __esm({
  "src/lib/locales/sl-SI/translations.json": function srcLibLocalesSlSITranslationsJson() {
    _Select_all_that_apply_31 = "(Izberite vse, ki veljajo)";
    __000_character_limit31 = "Omejitev 1000 znakov";
    A_score_of_at_least___passingGrade____is_required31 = "Zahtevan je rezultat vsaj {{passingGrade}} %";
    Answer31 = "Odgovor";
    Answer__Must_be_a_number_31 = "Odgovor (mora biti \u0161tevilka)";
    Answerssss29 = "Answer";
    Assessment_Completed31 = "Preizkus znanja zaklju\u010Den";
    Clear31 = "Po\u010Disti";
    Clear_Selection31 = "Po\u010Disti izbor";
    Close31 = "Zapri";
    Continue31 = "Nadaljuj";
    Finish31 = "Kon\u010Daj";
    Let_s_Get_Started31 = "Za\u010Dnimo";
    Must_be_a_decimal31 = "Mora biti decimalka";
    Next31 = "Naslednji";
    Next_Page31 = "Naslednja stran";
    Number_of_Drinks31 = "\u0160tevilo pija\u010D";
    OK31 = "V redu";
    Page___currentPage___of___totalPages__31 = "Stran {{currentPage}} od {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_31 = "Kliknite V redu za nadaljevanje na naslednjo stran.";
    Prev31 = "Pred.";
    Previous31 = "Prej\u0161nji";
    Previous_Page31 = "Prej\u0161nja stran";
    Question___currentQuestion___of___totalQuestions__31 = "Vpra\u0161anje {{currentQuestion}} od {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_31 = "Vpra\u0161anja, ki ste jih spregledali v preizkusu znanja:";
    Retake_Exam31 = "Ponovite izpit";
    Return31 = "Nazaj";
    Review_answer_feedback_to_learn_more_31 = "\u010Ce \u017Eelite izvedeti ve\u010D, preglejte povratne informacije k odgovorom.";
    Score____score___31 = "Rezultat: {{score}} %";
    Select_an_answer31 = "Izberite odgovor";
    Submit_Answer_s_31 = "Po\u0161lji odgovor(e)";
    The_response_options_are__31 = "Mo\u017Enosti za odgovor so: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question31 = "\u010Ce \u017Eelite preklicati izbor odgovora, uporabite mo\u017Enost Po\u010Disti izbor po izbiri zadnjega odgovora za vsako vpra\u0161anje";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_31 = "\u017Dal preizkusa znanja niste uspe\u0161no opravili in ga boste morali ponovno opravljati.";
    Value_must_be_greater_than_or_equal_to_031 = "Vrednost mora biti ve\u010Dja kot ali enaka 0";
    You_passed_31 = "Uspe\u0161no opravljeno!";
    translations_default31 = {
      "(Select all that apply)": _Select_all_that_apply_31,
      "1,000 character limit": __000_character_limit31,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required31,
      Answer: Answer31,
      "Answer (Must be a number)": Answer__Must_be_a_number_31,
      Answerssss: Answerssss29,
      "Assessment Completed": Assessment_Completed31,
      Clear: Clear31,
      "Clear Selection": Clear_Selection31,
      Close: Close31,
      Continue: Continue31,
      Finish: Finish31,
      "Let's Get Started": Let_s_Get_Started31,
      "Must be a decimal": Must_be_a_decimal31,
      Next: Next31,
      "Next Page": Next_Page31,
      "Number of Drinks": Number_of_Drinks31,
      OK: OK31,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__31,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_31,
      Prev: Prev31,
      Previous: Previous31,
      "Previous Page": Previous_Page31,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__31,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_31,
      "Retake Exam": Retake_Exam31,
      Return: Return31,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_31,
      "Score: {{score}}%": Score____score___31,
      "Select an answer": Select_an_answer31,
      "Submit Answer(s)": Submit_Answer_s_31,
      "The response options are: ": The_response_options_are__31,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question31,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_31,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_031,
      "You passed!": You_passed_31
    };
  }
});

// src/lib/locales/sr-RS/translations.json
var translations_exports32 = {};
__export(translations_exports32, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_32;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit32;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required32;
  },
  Answer: function Answer() {
    return Answer32;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_32;
  },
  Answerssss: function Answerssss() {
    return Answerssss30;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed32;
  },
  Clear: function Clear() {
    return Clear32;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection32;
  },
  Close: function Close() {
    return Close32;
  },
  Continue: function Continue() {
    return Continue32;
  },
  Finish: function Finish() {
    return Finish32;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started32;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal32;
  },
  Next: function Next() {
    return Next32;
  },
  "Next Page": function NextPage() {
    return Next_Page32;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks32;
  },
  OK: function OK() {
    return OK32;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__32;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_32;
  },
  Prev: function Prev() {
    return Prev32;
  },
  Previous: function Previous() {
    return Previous32;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page32;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__32;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_32;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam32;
  },
  Return: function Return() {
    return Return32;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_32;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___32;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer32;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_32;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__32;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question32;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_32;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_032;
  },
  "You passed!": function YouPassed() {
    return You_passed_32;
  },
  "default": function _default() {
    return translations_default32;
  }
});
var _Select_all_that_apply_32, __000_character_limit32, A_score_of_at_least___passingGrade____is_required32, Answer32, Answer__Must_be_a_number_32, Answerssss30, Assessment_Completed32, Clear32, Clear_Selection32, Close32, Continue32, Finish32, Let_s_Get_Started32, Must_be_a_decimal32, Next32, Next_Page32, Number_of_Drinks32, OK32, Page___currentPage___of___totalPages__32, Please_click_OK_to_continue_to_the_next_page_32, Prev32, Previous32, Previous_Page32, Question___currentQuestion___of___totalQuestions__32, Questions_you_missed_on_the_assessment_32, Retake_Exam32, Return32, Review_answer_feedback_to_learn_more_32, Score____score___32, Select_an_answer32, Submit_Answer_s_32, The_response_options_are__32, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question32, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_32, Value_must_be_greater_than_or_equal_to_032, You_passed_32, translations_default32;
var init_translations32 = __esm({
  "src/lib/locales/sr-RS/translations.json": function srcLibLocalesSrRSTranslationsJson() {
    _Select_all_that_apply_32 = "(Izaberite sve \u0161to je primenljivo)";
    __000_character_limit32 = "Ograni\u010Denje od 1.000 znakova";
    A_score_of_at_least___passingGrade____is_required32 = "Obavezan je rezultat od najmanje {{passingGrade}}%";
    Answer32 = "Odgovor";
    Answer__Must_be_a_number_32 = "Odgovor (mora da bude broj)";
    Answerssss30 = "Odgovori";
    Assessment_Completed32 = "Procena je dovr\u0161ena";
    Clear32 = "Obri\u0161i";
    Clear_Selection32 = "Obri\u0161i izbor";
    Close32 = "Zatvori";
    Continue32 = "Nastavi";
    Finish32 = "Zavr\u0161i";
    Let_s_Get_Started32 = "Hajde da po\u010Dnemo";
    Must_be_a_decimal32 = "Mora da bude decimalni broj";
    Next32 = "Slede\u0107e";
    Next_Page32 = "Slede\u0107a strana";
    Number_of_Drinks32 = "Broj pi\u0107a";
    OK32 = "OK";
    Page___currentPage___of___totalPages__32 = "Stranica {{currentPage}} od {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_32 = "Kliknite na dugme \u201EU redu\u201C da biste nastavili ka slede\u0107oj stranici.";
    Prev32 = "Prethodna";
    Previous32 = "Prethodno";
    Previous_Page32 = "Prethodna strana";
    Question___currentQuestion___of___totalQuestions__32 = "Pitanje {{currentQuestion}} od {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_32 = "Pitanja koja ste propustili na proceni:";
    Retake_Exam32 = "Ponovno polaganje ispita";
    Return32 = "Povratak";
    Review_answer_feedback_to_learn_more_32 = "Da biste saznali vi\u0161e, pregledajte povratne informacije o odgovorima.";
    Score____score___32 = "Ocena: {{score}}%";
    Select_an_answer32 = "Izaberite odgovor";
    Submit_Answer_s_32 = "Prosledi odgovore";
    The_response_options_are__32 = "Opcije odgovora su: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question32 = "Da biste poni\u0161tili izbor odgovora, kliknite na opciju \u201EObri\u0161i izbor\u201D nakon poslednjeg izbora odgovora za svako pitanje";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_32 = "Na\u017Ealost, niste polo\u017Eili i mora\u0107ete ponovo da pola\u017Eete procenu.";
    Value_must_be_greater_than_or_equal_to_032 = "Vrednost mora biti ve\u0107a od 0 ili jednaka tom broju";
    You_passed_32 = "Polo\u017Eili ste!";
    translations_default32 = {
      "(Select all that apply)": _Select_all_that_apply_32,
      "1,000 character limit": __000_character_limit32,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required32,
      Answer: Answer32,
      "Answer (Must be a number)": Answer__Must_be_a_number_32,
      Answerssss: Answerssss30,
      "Assessment Completed": Assessment_Completed32,
      Clear: Clear32,
      "Clear Selection": Clear_Selection32,
      Close: Close32,
      Continue: Continue32,
      Finish: Finish32,
      "Let's Get Started": Let_s_Get_Started32,
      "Must be a decimal": Must_be_a_decimal32,
      Next: Next32,
      "Next Page": Next_Page32,
      "Number of Drinks": Number_of_Drinks32,
      OK: OK32,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__32,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_32,
      Prev: Prev32,
      Previous: Previous32,
      "Previous Page": Previous_Page32,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__32,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_32,
      "Retake Exam": Retake_Exam32,
      Return: Return32,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_32,
      "Score: {{score}}%": Score____score___32,
      "Select an answer": Select_an_answer32,
      "Submit Answer(s)": Submit_Answer_s_32,
      "The response options are: ": The_response_options_are__32,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question32,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_32,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_032,
      "You passed!": You_passed_32
    };
  }
});

// src/lib/locales/sv-SE/translations.json
var translations_exports33 = {};
__export(translations_exports33, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_33;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit33;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required33;
  },
  Answer: function Answer() {
    return Answer33;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_33;
  },
  Answerssss: function Answerssss() {
    return Answerssss31;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed33;
  },
  Clear: function Clear() {
    return Clear33;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection33;
  },
  Close: function Close() {
    return Close33;
  },
  Continue: function Continue() {
    return Continue33;
  },
  Finish: function Finish() {
    return Finish33;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started33;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal33;
  },
  Next: function Next() {
    return Next33;
  },
  "Next Page": function NextPage() {
    return Next_Page33;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks33;
  },
  OK: function OK() {
    return OK33;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__33;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_33;
  },
  Prev: function Prev() {
    return Prev33;
  },
  Previous: function Previous() {
    return Previous33;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page33;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__33;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_33;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam33;
  },
  Return: function Return() {
    return Return33;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_33;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___33;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer33;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_33;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__33;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question33;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_33;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_033;
  },
  "You passed!": function YouPassed() {
    return You_passed_33;
  },
  "default": function _default() {
    return translations_default33;
  }
});
var _Select_all_that_apply_33, __000_character_limit33, A_score_of_at_least___passingGrade____is_required33, Answer33, Answer__Must_be_a_number_33, Answerssss31, Assessment_Completed33, Clear33, Clear_Selection33, Close33, Continue33, Finish33, Let_s_Get_Started33, Must_be_a_decimal33, Next33, Next_Page33, Number_of_Drinks33, OK33, Page___currentPage___of___totalPages__33, Please_click_OK_to_continue_to_the_next_page_33, Prev33, Previous33, Previous_Page33, Question___currentQuestion___of___totalQuestions__33, Questions_you_missed_on_the_assessment_33, Retake_Exam33, Return33, Review_answer_feedback_to_learn_more_33, Score____score___33, Select_an_answer33, Submit_Answer_s_33, The_response_options_are__33, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question33, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_33, Value_must_be_greater_than_or_equal_to_033, You_passed_33, translations_default33;
var init_translations33 = __esm({
  "src/lib/locales/sv-SE/translations.json": function srcLibLocalesSvSETranslationsJson() {
    _Select_all_that_apply_33 = "(V\xE4lj alla alternativ som st\xE4mmer)";
    __000_character_limit33 = "H\xF6gst 1\xA0000 tecken";
    A_score_of_at_least___passingGrade____is_required33 = "En po\xE4ng p\xE5 minst {{passingGrade}}\xA0% kr\xE4vs";
    Answer33 = "Svar";
    Answer__Must_be_a_number_33 = "Svar (m\xE5ste vara en siffra)";
    Answerssss31 = "Svar";
    Assessment_Completed33 = "Utv\xE4rdering slutf\xF6rd";
    Clear33 = "Rensa";
    Clear_Selection33 = "Rensa val";
    Close33 = "St\xE4ng";
    Continue33 = "Forts\xE4tt";
    Finish33 = "Avsluta";
    Let_s_Get_Started33 = "Vi s\xE4tter ig\xE5ng";
    Must_be_a_decimal33 = "M\xE5ste vara ett decimaltal";
    Next33 = "N\xE4sta";
    Next_Page33 = "N\xE4sta sida";
    Number_of_Drinks33 = "Antal drycker";
    OK33 = "OK";
    Page___currentPage___of___totalPages__33 = "Sida {{currentPage}} av {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_33 = "Klicka p\xE5 OK f\xF6r att forts\xE4tta till n\xE4sta sida.";
    Prev33 = "F\xF6reg\xE5ende";
    Previous33 = "F\xF6reg\xE5ende";
    Previous_Page33 = "F\xF6reg\xE5ende sida";
    Question___currentQuestion___of___totalQuestions__33 = "Fr\xE5ga {{currentQuestion}} av {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_33 = "Fr\xE5gor som du missade i utv\xE4rderingen:";
    Retake_Exam33 = "G\xF6r om prov";
    Return33 = "Tillbaka";
    Review_answer_feedback_to_learn_more_33 = "Granska svarsfeedback f\xF6r mer information.";
    Score____score___33 = "Po\xE4ng: {{score}}%";
    Select_an_answer33 = "V\xE4lj ett svar";
    Submit_Answer_s_33 = "Skicka svar";
    The_response_options_are__33 = "Svarsalternativen \xE4r: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question33 = "F\xF6r att avmarkera ett svar, anv\xE4nd alternativet Rensa val efter det sista svarsalternativet f\xF6r varje fr\xE5ga";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_33 = "Tyv\xE4rr klarade du inte utv\xE4rderingen och m\xE5ste g\xF6ra om den.";
    Value_must_be_greater_than_or_equal_to_033 = "V\xE4rdet m\xE5ste vara st\xF6rre eller lika med 0";
    You_passed_33 = "Du klarade det!";
    translations_default33 = {
      "(Select all that apply)": _Select_all_that_apply_33,
      "1,000 character limit": __000_character_limit33,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required33,
      Answer: Answer33,
      "Answer (Must be a number)": Answer__Must_be_a_number_33,
      Answerssss: Answerssss31,
      "Assessment Completed": Assessment_Completed33,
      Clear: Clear33,
      "Clear Selection": Clear_Selection33,
      Close: Close33,
      Continue: Continue33,
      Finish: Finish33,
      "Let's Get Started": Let_s_Get_Started33,
      "Must be a decimal": Must_be_a_decimal33,
      Next: Next33,
      "Next Page": Next_Page33,
      "Number of Drinks": Number_of_Drinks33,
      OK: OK33,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__33,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_33,
      Prev: Prev33,
      Previous: Previous33,
      "Previous Page": Previous_Page33,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__33,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_33,
      "Retake Exam": Retake_Exam33,
      Return: Return33,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_33,
      "Score: {{score}}%": Score____score___33,
      "Select an answer": Select_an_answer33,
      "Submit Answer(s)": Submit_Answer_s_33,
      "The response options are: ": The_response_options_are__33,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question33,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_33,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_033,
      "You passed!": You_passed_33
    };
  }
});

// src/lib/locales/th-TH/translations.json
var translations_exports34 = {};
__export(translations_exports34, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_34;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit34;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required34;
  },
  Answer: function Answer() {
    return Answer34;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_34;
  },
  Answerssss: function Answerssss() {
    return Answerssss32;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed34;
  },
  Clear: function Clear() {
    return Clear34;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection34;
  },
  Close: function Close() {
    return Close34;
  },
  Continue: function Continue() {
    return Continue34;
  },
  Finish: function Finish() {
    return Finish34;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started34;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal34;
  },
  Next: function Next() {
    return Next34;
  },
  "Next Page": function NextPage() {
    return Next_Page34;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks34;
  },
  OK: function OK() {
    return OK34;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__34;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_34;
  },
  Prev: function Prev() {
    return Prev34;
  },
  Previous: function Previous() {
    return Previous34;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page34;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__34;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_34;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam34;
  },
  Return: function Return() {
    return Return34;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_34;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___34;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer34;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_34;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__34;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question34;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_34;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_034;
  },
  "You passed!": function YouPassed() {
    return You_passed_34;
  },
  "default": function _default() {
    return translations_default34;
  }
});
var _Select_all_that_apply_34, __000_character_limit34, A_score_of_at_least___passingGrade____is_required34, Answer34, Answer__Must_be_a_number_34, Answerssss32, Assessment_Completed34, Clear34, Clear_Selection34, Close34, Continue34, Finish34, Let_s_Get_Started34, Must_be_a_decimal34, Next34, Next_Page34, Number_of_Drinks34, OK34, Page___currentPage___of___totalPages__34, Please_click_OK_to_continue_to_the_next_page_34, Prev34, Previous34, Previous_Page34, Question___currentQuestion___of___totalQuestions__34, Questions_you_missed_on_the_assessment_34, Retake_Exam34, Return34, Review_answer_feedback_to_learn_more_34, Score____score___34, Select_an_answer34, Submit_Answer_s_34, The_response_options_are__34, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question34, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_34, Value_must_be_greater_than_or_equal_to_034, You_passed_34, translations_default34;
var init_translations34 = __esm({
  "src/lib/locales/th-TH/translations.json": function srcLibLocalesThTHTranslationsJson() {
    _Select_all_that_apply_34 = "(\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E14\u0E49\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E02\u0E49\u0E2D)";
    __000_character_limit34 = "\u0E08\u0E33\u0E01\u0E31\u0E14\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19 1,000 \u0E15\u0E31\u0E27";
    A_score_of_at_least___passingGrade____is_required34 = "\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E14\u0E49\u0E04\u0E30\u0E41\u0E19\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 {{passingGrade}}%";
    Answer34 = "\u0E04\u0E33\u0E15\u0E2D\u0E1A";
    Answer__Must_be_a_number_34 = "\u0E04\u0E33\u0E15\u0E2D\u0E1A (\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02)";
    Answerssss32 = "\u0E04\u0E4D\u0E32\u0E15\u0E2D\u0E1A";
    Assessment_Completed34 = "\u0E17\u0E33\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27";
    Clear34 = "\u0E25\u0E49\u0E32\u0E07";
    Clear_Selection34 = "\u0E25\u0E49\u0E32\u0E07\u0E01\u0E32\u0E23\u0E40\u0E25\u0E37\u0E2D\u0E01";
    Close34 = "\u0E1B\u0E34\u0E14";
    Continue34 = "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D";
    Finish34 = "\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19";
    Let_s_Get_Started34 = "\u0E21\u0E32\u0E40\u0E23\u0E34\u0E48\u0E21\u0E01\u0E31\u0E19\u0E40\u0E25\u0E22";
    Must_be_a_decimal34 = "\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E48\u0E32\u0E17\u0E28\u0E19\u0E34\u0E22\u0E21";
    Next34 = "\u0E16\u0E31\u0E14\u0E44\u0E1B";
    Next_Page34 = "\u0E2B\u0E19\u0E49\u0E32\u0E16\u0E31\u0E14\u0E44\u0E1B";
    Number_of_Drinks34 = "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E14\u0E37\u0E48\u0E21";
    OK34 = "\u0E15\u0E01\u0E25\u0E07";
    Page___currentPage___of___totalPages__34 = "\u0E2B\u0E19\u0E49\u0E32 {{currentPage}} \u0E08\u0E32\u0E01 {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_34 = "\u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01 \"\u0E15\u0E01\u0E25\u0E07\" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E16\u0E31\u0E14\u0E44\u0E1B";
    Prev34 = "\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32";
    Previous34 = "\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32";
    Previous_Page34 = "\u0E2B\u0E19\u0E49\u0E32\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32";
    Question___currentQuestion___of___totalQuestions__34 = "\u0E04\u0E4D\u0E32\u0E16\u0E32\u0E21\u0E17\u0E35\u0E48 {{currentQuestion}} \u0E08\u0E32\u0E01 {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_34 = "\u0E04\u0E33\u0E16\u0E32\u0E21\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E15\u0E2D\u0E1A\u0E43\u0E19\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19:";
    Retake_Exam34 = "\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E21\u0E48";
    Return34 = "\u0E01\u0E25\u0E31\u0E1A";
    Review_answer_feedback_to_learn_more_34 = "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E04\u0E33\u0E15\u0E2D\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21";
    Score____score___34 = "\u0E04\u0E30\u0E41\u0E19\u0E19: {{score}} %";
    Select_an_answer34 = "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E04\u0E33\u0E15\u0E2D\u0E1A";
    Submit_Answer_s_34 = "\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E15\u0E2D\u0E1A";
    The_response_options_are__34 = "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E32\u0E23\u0E15\u0E2D\u0E1A\u0E01\u0E25\u0E31\u0E1A\u0E21\u0E35\u0E14\u0E31\u0E07\u0E19\u0E35\u0E49 ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question34 = "\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E33\u0E15\u0E2D\u0E1A \u0E43\u0E2B\u0E49\u0E43\u0E0A\u0E49\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01 \"\u0E25\u0E49\u0E32\u0E07\u0E01\u0E32\u0E23\u0E40\u0E25\u0E37\u0E2D\u0E01\" \u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E33\u0E15\u0E2D\u0E1A\u0E2A\u0E38\u0E14\u0E17\u0E49\u0E32\u0E22\u0E02\u0E2D\u0E07\u0E41\u0E15\u0E48\u0E25\u0E30\u0E04\u0E33\u0E16\u0E32\u0E21";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_34 = "\u0E02\u0E2D\u0E2D\u0E20\u0E31\u0E22 \u0E04\u0E38\u0E13\u0E2A\u0E2D\u0E1A\u0E44\u0E21\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E41\u0E25\u0E30\u0E08\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E33\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E43\u0E2B\u0E21\u0E48";
    Value_must_be_greater_than_or_equal_to_034 = "\u0E04\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A 0";
    You_passed_34 = "\u0E04\u0E38\u0E13\u0E2A\u0E2D\u0E1A\u0E1C\u0E48\u0E32\u0E19\u0E41\u0E25\u0E49\u0E27!";
    translations_default34 = {
      "(Select all that apply)": _Select_all_that_apply_34,
      "1,000 character limit": __000_character_limit34,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required34,
      Answer: Answer34,
      "Answer (Must be a number)": Answer__Must_be_a_number_34,
      Answerssss: Answerssss32,
      "Assessment Completed": Assessment_Completed34,
      Clear: Clear34,
      "Clear Selection": Clear_Selection34,
      Close: Close34,
      Continue: Continue34,
      Finish: Finish34,
      "Let's Get Started": Let_s_Get_Started34,
      "Must be a decimal": Must_be_a_decimal34,
      Next: Next34,
      "Next Page": Next_Page34,
      "Number of Drinks": Number_of_Drinks34,
      OK: OK34,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__34,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_34,
      Prev: Prev34,
      Previous: Previous34,
      "Previous Page": Previous_Page34,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__34,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_34,
      "Retake Exam": Retake_Exam34,
      Return: Return34,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_34,
      "Score: {{score}}%": Score____score___34,
      "Select an answer": Select_an_answer34,
      "Submit Answer(s)": Submit_Answer_s_34,
      "The response options are: ": The_response_options_are__34,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question34,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_34,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_034,
      "You passed!": You_passed_34
    };
  }
});

// src/lib/locales/tl-PH/translations.json
var translations_exports35 = {};
__export(translations_exports35, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_35;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit35;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required35;
  },
  Answer: function Answer() {
    return Answer35;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_35;
  },
  Answerssss: function Answerssss() {
    return Answerssss33;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed35;
  },
  Clear: function Clear() {
    return Clear35;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection35;
  },
  Close: function Close() {
    return Close35;
  },
  Continue: function Continue() {
    return Continue35;
  },
  Finish: function Finish() {
    return Finish35;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started35;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal35;
  },
  Next: function Next() {
    return Next35;
  },
  "Next Page": function NextPage() {
    return Next_Page35;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks35;
  },
  OK: function OK() {
    return OK35;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__35;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_35;
  },
  Prev: function Prev() {
    return Prev35;
  },
  Previous: function Previous() {
    return Previous35;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page35;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__35;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_35;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam35;
  },
  Return: function Return() {
    return Return35;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_35;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___35;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer35;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_35;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__35;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question35;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_35;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_035;
  },
  "You passed!": function YouPassed() {
    return You_passed_35;
  },
  "default": function _default() {
    return translations_default35;
  }
});
var _Select_all_that_apply_35, __000_character_limit35, A_score_of_at_least___passingGrade____is_required35, Answer35, Answer__Must_be_a_number_35, Answerssss33, Assessment_Completed35, Clear35, Clear_Selection35, Close35, Continue35, Finish35, Let_s_Get_Started35, Must_be_a_decimal35, Next35, Next_Page35, Number_of_Drinks35, OK35, Page___currentPage___of___totalPages__35, Please_click_OK_to_continue_to_the_next_page_35, Prev35, Previous35, Previous_Page35, Question___currentQuestion___of___totalQuestions__35, Questions_you_missed_on_the_assessment_35, Retake_Exam35, Return35, Review_answer_feedback_to_learn_more_35, Score____score___35, Select_an_answer35, Submit_Answer_s_35, The_response_options_are__35, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question35, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_35, Value_must_be_greater_than_or_equal_to_035, You_passed_35, translations_default35;
var init_translations35 = __esm({
  "src/lib/locales/tl-PH/translations.json": function srcLibLocalesTlPHTranslationsJson() {
    _Select_all_that_apply_35 = "(Piliin ang lahat ng naaangkop)";
    __000_character_limit35 = "1,000 ang limitasyon ng character";
    A_score_of_at_least___passingGrade____is_required35 = "Kinakailangan ang iskor na hindi bababa sa {{passingGrade}}%";
    Answer35 = "Sagot";
    Answer__Must_be_a_number_35 = "Sagot (Dapat numero)";
    Answerssss33 = "Mga Sagot";
    Assessment_Completed35 = "Natapos na ang Pag-aseso";
    Clear35 = "I-clear";
    Clear_Selection35 = "I-clear ang Mapagpipilian";
    Close35 = "Isara";
    Continue35 = "Magpatuloy";
    Finish35 = "Tapos na";
    Let_s_Get_Started35 = "Magsimula Na Tayo";
    Must_be_a_decimal35 = "Dapat decimal";
    Next35 = "Susunod";
    Next_Page35 = "Susunod na Page";
    Number_of_Drinks35 = "Bilang ng Maiinom";
    OK35 = "OK";
    Page___currentPage___of___totalPages__35 = "Pahina {{currentPage}} ng {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_35 = "I-click ang OK para magpatuloy sa susunod na page.";
    Prev35 = "Nakaraan";
    Previous35 = "Nakaraan";
    Previous_Page35 = "Nakaraang Page";
    Question___currentQuestion___of___totalQuestions__35 = "Tanong {{currentQuestion}} ng {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_35 = "Mga Tanong na hindi mo nasagutan sa pag-aseso:";
    Retake_Exam35 = "Muling Mag-exam";
    Return35 = "Bumalik";
    Review_answer_feedback_to_learn_more_35 = "Suriin ang sagot sa feedback para matuto pa.";
    Score____score___35 = "Iskor: {{score}}%";
    Select_an_answer35 = "Pumili ng sagot";
    Submit_Answer_s_35 = "Isumite ang (mga) Sagot";
    The_response_options_are__35 = "Ang mga opsyon sa pagsagot: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question35 = "Para alisin sa pagkakapili ang sagot, gamitin ang opsyon na I-clear ang Mapagpipilian matapos ang huling piniling sagot para sa bawat tanong";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_35 = "Sa kasamaang-palad, hindi ka nakapasa at kailangan mong sagutang muli ang pag-aseso.";
    Value_must_be_greater_than_or_equal_to_035 = "Dapat mas mataas sa o katumbas ng 0 ang value";
    You_passed_35 = "Nakapasa ka!";
    translations_default35 = {
      "(Select all that apply)": _Select_all_that_apply_35,
      "1,000 character limit": __000_character_limit35,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required35,
      Answer: Answer35,
      "Answer (Must be a number)": Answer__Must_be_a_number_35,
      Answerssss: Answerssss33,
      "Assessment Completed": Assessment_Completed35,
      Clear: Clear35,
      "Clear Selection": Clear_Selection35,
      Close: Close35,
      Continue: Continue35,
      Finish: Finish35,
      "Let's Get Started": Let_s_Get_Started35,
      "Must be a decimal": Must_be_a_decimal35,
      Next: Next35,
      "Next Page": Next_Page35,
      "Number of Drinks": Number_of_Drinks35,
      OK: OK35,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__35,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_35,
      Prev: Prev35,
      Previous: Previous35,
      "Previous Page": Previous_Page35,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__35,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_35,
      "Retake Exam": Retake_Exam35,
      Return: Return35,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_35,
      "Score: {{score}}%": Score____score___35,
      "Select an answer": Select_an_answer35,
      "Submit Answer(s)": Submit_Answer_s_35,
      "The response options are: ": The_response_options_are__35,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question35,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_35,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_035,
      "You passed!": You_passed_35
    };
  }
});

// src/lib/locales/tr-TR/translations.json
var translations_exports36 = {};
__export(translations_exports36, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_36;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit36;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required36;
  },
  Answer: function Answer() {
    return Answer36;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_36;
  },
  Answerssss: function Answerssss() {
    return Answerssss34;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed36;
  },
  Clear: function Clear() {
    return Clear36;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection36;
  },
  Close: function Close() {
    return Close36;
  },
  Continue: function Continue() {
    return Continue36;
  },
  Finish: function Finish() {
    return Finish36;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started36;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal36;
  },
  Next: function Next() {
    return Next36;
  },
  "Next Page": function NextPage() {
    return Next_Page36;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks36;
  },
  OK: function OK() {
    return OK36;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__36;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_36;
  },
  Prev: function Prev() {
    return Prev36;
  },
  Previous: function Previous() {
    return Previous36;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page36;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__36;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_36;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam36;
  },
  Return: function Return() {
    return Return36;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_36;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___36;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer36;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_36;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__36;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question36;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_36;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_036;
  },
  "You passed!": function YouPassed() {
    return You_passed_36;
  },
  "default": function _default() {
    return translations_default36;
  }
});
var _Select_all_that_apply_36, __000_character_limit36, A_score_of_at_least___passingGrade____is_required36, Answer36, Answer__Must_be_a_number_36, Answerssss34, Assessment_Completed36, Clear36, Clear_Selection36, Close36, Continue36, Finish36, Let_s_Get_Started36, Must_be_a_decimal36, Next36, Next_Page36, Number_of_Drinks36, OK36, Page___currentPage___of___totalPages__36, Please_click_OK_to_continue_to_the_next_page_36, Prev36, Previous36, Previous_Page36, Question___currentQuestion___of___totalQuestions__36, Questions_you_missed_on_the_assessment_36, Retake_Exam36, Return36, Review_answer_feedback_to_learn_more_36, Score____score___36, Select_an_answer36, Submit_Answer_s_36, The_response_options_are__36, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question36, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_36, Value_must_be_greater_than_or_equal_to_036, You_passed_36, translations_default36;
var init_translations36 = __esm({
  "src/lib/locales/tr-TR/translations.json": function srcLibLocalesTrTRTranslationsJson() {
    _Select_all_that_apply_36 = "(Ge\xE7erli olanlar\u0131n hepsini se\xE7in)";
    __000_character_limit36 = "1.000 karakter limiti";
    A_score_of_at_least___passingGrade____is_required36 = "En az %{{passingGrade}} puan al\u0131nmas\u0131 gerekir";
    Answer36 = "Cevap";
    Answer__Must_be_a_number_36 = "Cevap (Say\u0131 olmal\u0131d\u0131r)";
    Answerssss34 = "Cevaplar";
    Assessment_Completed36 = "De\u011Ferlendirme Tamamland\u0131";
    Clear36 = "Temizle";
    Clear_Selection36 = "Se\xE7imi Temizle";
    Close36 = "Kapat";
    Continue36 = "Devam";
    Finish36 = "Bitir";
    Let_s_Get_Started36 = "Hadi Ba\u015Flayal\u0131m";
    Must_be_a_decimal36 = "Ondal\u0131k say\u0131 olmal\u0131d\u0131r";
    Next36 = "Sonraki";
    Next_Page36 = "Sonraki Sayfa";
    Number_of_Drinks36 = "\u0130\xE7ecek Say\u0131s\u0131";
    OK36 = "Tamam";
    Page___currentPage___of___totalPages__36 = "Sayfa {{currentPage}} / {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_36 = "Sonraki sayfaya devam etmek i\xE7in l\xFCtfen Tamam\u2019a t\u0131klay\u0131n.";
    Prev36 = "\xD6nceki";
    Previous36 = "\xD6nceki";
    Previous_Page36 = "\xD6nceki Sayfa";
    Question___currentQuestion___of___totalQuestions__36 = "Soru {{currentQuestion}} / {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_36 = "De\u011Ferlendirmede ka\xE7\u0131rd\u0131\u011F\u0131n\u0131z sorular:";
    Retake_Exam36 = "S\u0131nava Yeniden Gir";
    Return36 = "Geri D\xF6n";
    Review_answer_feedback_to_learn_more_36 = "Daha fazla bilgi edinmek i\xE7in cevap geri bildirimini g\xF6zden ge\xE7irin.";
    Score____score___36 = "Puan: %{{score}}";
    Select_an_answer36 = "Bir cevap se\xE7in";
    Submit_Answer_s_36 = "Cevab\u0131/Cevaplar\u0131 G\xF6nder";
    The_response_options_are__36 = "Yan\u0131t se\xE7enekleri: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question36 = "Bir cevab\u0131n se\xE7imini kald\u0131rmak i\xE7in her bir sorunun son cevap se\xE7ene\u011Finden sonra Se\xE7imi Temizle se\xE7ene\u011Fini kullan\u0131n";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_36 = "Ne yaz\u0131k ki ge\xE7emediniz ve de\u011Ferlendirmeye yeniden girmeniz gerekiyor.";
    Value_must_be_greater_than_or_equal_to_036 = "De\u011Fer, 0\u2019dan b\xFCy\xFCk veya 0\u2019a e\u015Fit olmal\u0131d\u0131r";
    You_passed_36 = "Ge\xE7tiniz!";
    translations_default36 = {
      "(Select all that apply)": _Select_all_that_apply_36,
      "1,000 character limit": __000_character_limit36,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required36,
      Answer: Answer36,
      "Answer (Must be a number)": Answer__Must_be_a_number_36,
      Answerssss: Answerssss34,
      "Assessment Completed": Assessment_Completed36,
      Clear: Clear36,
      "Clear Selection": Clear_Selection36,
      Close: Close36,
      Continue: Continue36,
      Finish: Finish36,
      "Let's Get Started": Let_s_Get_Started36,
      "Must be a decimal": Must_be_a_decimal36,
      Next: Next36,
      "Next Page": Next_Page36,
      "Number of Drinks": Number_of_Drinks36,
      OK: OK36,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__36,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_36,
      Prev: Prev36,
      Previous: Previous36,
      "Previous Page": Previous_Page36,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__36,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_36,
      "Retake Exam": Retake_Exam36,
      Return: Return36,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_36,
      "Score: {{score}}%": Score____score___36,
      "Select an answer": Select_an_answer36,
      "Submit Answer(s)": Submit_Answer_s_36,
      "The response options are: ": The_response_options_are__36,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question36,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_36,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_036,
      "You passed!": You_passed_36
    };
  }
});

// src/lib/locales/uk-UA/translations.json
var translations_exports37 = {};
__export(translations_exports37, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_37;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit37;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required37;
  },
  Answer: function Answer() {
    return Answer37;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_37;
  },
  Answerssss: function Answerssss() {
    return Answerssss35;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed37;
  },
  Clear: function Clear() {
    return Clear37;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection37;
  },
  Close: function Close() {
    return Close37;
  },
  Continue: function Continue() {
    return Continue37;
  },
  Finish: function Finish() {
    return Finish37;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started37;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal37;
  },
  Next: function Next() {
    return Next37;
  },
  "Next Page": function NextPage() {
    return Next_Page37;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks37;
  },
  OK: function OK() {
    return OK37;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__37;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_37;
  },
  Prev: function Prev() {
    return Prev37;
  },
  Previous: function Previous() {
    return Previous37;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page37;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__37;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_37;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam37;
  },
  Return: function Return() {
    return Return37;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_37;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___37;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer37;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_37;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__37;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question37;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_37;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_037;
  },
  "You passed!": function YouPassed() {
    return You_passed_37;
  },
  "default": function _default() {
    return translations_default37;
  }
});
var _Select_all_that_apply_37, __000_character_limit37, A_score_of_at_least___passingGrade____is_required37, Answer37, Answer__Must_be_a_number_37, Answerssss35, Assessment_Completed37, Clear37, Clear_Selection37, Close37, Continue37, Finish37, Let_s_Get_Started37, Must_be_a_decimal37, Next37, Next_Page37, Number_of_Drinks37, OK37, Page___currentPage___of___totalPages__37, Please_click_OK_to_continue_to_the_next_page_37, Prev37, Previous37, Previous_Page37, Question___currentQuestion___of___totalQuestions__37, Questions_you_missed_on_the_assessment_37, Retake_Exam37, Return37, Review_answer_feedback_to_learn_more_37, Score____score___37, Select_an_answer37, Submit_Answer_s_37, The_response_options_are__37, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question37, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_37, Value_must_be_greater_than_or_equal_to_037, You_passed_37, translations_default37;
var init_translations37 = __esm({
  "src/lib/locales/uk-UA/translations.json": function srcLibLocalesUkUATranslationsJson() {
    _Select_all_that_apply_37 = "(\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0432\u0441\u0435, \u0449\u043E \u043F\u0456\u0434\u0445\u043E\u0434\u0438\u0442\u044C)";
    __000_character_limit37 = "\u041E\u0431\u043C\u0435\u0436\u0435\u043D\u043D\u044F 1000 \u0437\u043D\u0430\u043A\u0456\u0432";
    A_score_of_at_least___passingGrade____is_required37 = "\u041F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u0431\u0430\u043B \u043D\u0435 \u043D\u0438\u0436\u0447\u0435 {{passingGrade}}%";
    Answer37 = "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C";
    Answer__Must_be_a_number_37 = "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C (\u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0447\u0438\u0441\u043B\u043E\u043C)";
    Answerssss35 = "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456";
    Assessment_Completed37 = "\u0422\u0435\u0441\u0442 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E";
    Clear37 = "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438";
    Clear_Selection37 = "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0432\u0438\u0431\u0440\u0430\u043D\u0435";
    Close37 = "\u0417\u0430\u043A\u0440\u0438\u0442\u0438";
    Continue37 = "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438";
    Finish37 = "\u0417\u0430\u043A\u0456\u043D\u0447\u0438\u0442\u0438";
    Let_s_Get_Started37 = "\u0420\u043E\u0437\u043F\u043E\u0447\u043D\u0435\u043C\u043E!";
    Must_be_a_decimal37 = "\u041C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0434\u0435\u0441\u044F\u0442\u043A\u043E\u0432\u0438\u043C";
    Next37 = "\u0414\u0430\u043B\u0456";
    Next_Page37 = "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430";
    Number_of_Drinks37 = "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043D\u0430\u043F\u043E\u0457\u0432";
    OK37 = "\u0422\u0430\u043A";
    Page___currentPage___of___totalPages__37 = "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0430 {{currentPage}} \u0437 {{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_37 = "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \xAB\u041E\u041A\xBB, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0457 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438.";
    Prev37 = "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D.";
    Previous37 = "\u041D\u0430\u0437\u0430\u0434";
    Previous_Page37 = "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430";
    Question___currentQuestion___of___totalQuestions__37 = "\u0417\u0430\u043F\u0438\u0442\u0430\u043D\u043D\u044F {{currentQuestion}} \u0437 {{totalQuestions}}";
    Questions_you_missed_on_the_assessment_37 = "\u041F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043D\u0456 \u0432 \u0442\u0435\u0441\u0442\u0456 \u0437\u0430\u043F\u0438\u0442\u0430\u043D\u043D\u044F:";
    Retake_Exam37 = "\u0421\u043A\u043B\u0430\u0441\u0442\u0438 \u0456\u0441\u043F\u0438\u0442 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E";
    Return37 = "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044F";
    Review_answer_feedback_to_learn_more_37 = "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u044C\u0442\u0435 \u0432\u0456\u0434\u0433\u0443\u043A\u0438 \u043D\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456, \u0449\u043E\u0431 \u0434\u0456\u0437\u043D\u0430\u0442\u0438\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435.";
    Score____score___37 = "\u0411\u0430\u043B: {{score}}%";
    Select_an_answer37 = "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C";
    Submit_Answer_s_37 = "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C(-\u0456)";
    The_response_options_are__37 = "\u0412\u0430\u0440\u0456\u0430\u043D\u0442\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question37 = "\u0429\u043E\u0431 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456, \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u043E\u043F\u0446\u0456\u044E \xAB\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C\xBB, \u0440\u043E\u0437\u0442\u0430\u0448\u043E\u0432\u0430\u043D\u0443 \u043F\u0456\u0434 \u043E\u0441\u0442\u0430\u043D\u043D\u0456\u043C \u0432\u0430\u0440\u0456\u0430\u043D\u0442\u043E\u043C \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456.";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_37 = "\u041D\u0430 \u0436\u0430\u043B\u044C, \u0432\u0438 \u043D\u0435 \u0441\u043A\u043B\u0430\u043B\u0438 \u0442\u0435\u0441\u0442, \u0456 \u0432\u0430\u043C \u0434\u043E\u0432\u0435\u0434\u0435\u0442\u044C\u0441\u044F \u0441\u043A\u043B\u0430\u0434\u0430\u0442\u0438 \u0439\u043E\u0433\u043E \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E.";
    Value_must_be_greater_than_or_equal_to_037 = "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u0430\u0431\u043E \u0434\u043E\u0440\u0456\u0432\u043D\u044E\u0432\u0430\u0442\u0438 0";
    You_passed_37 = "\u0417\u0434\u0430\u043D\u043E!";
    translations_default37 = {
      "(Select all that apply)": _Select_all_that_apply_37,
      "1,000 character limit": __000_character_limit37,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required37,
      Answer: Answer37,
      "Answer (Must be a number)": Answer__Must_be_a_number_37,
      Answerssss: Answerssss35,
      "Assessment Completed": Assessment_Completed37,
      Clear: Clear37,
      "Clear Selection": Clear_Selection37,
      Close: Close37,
      Continue: Continue37,
      Finish: Finish37,
      "Let's Get Started": Let_s_Get_Started37,
      "Must be a decimal": Must_be_a_decimal37,
      Next: Next37,
      "Next Page": Next_Page37,
      "Number of Drinks": Number_of_Drinks37,
      OK: OK37,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__37,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_37,
      Prev: Prev37,
      Previous: Previous37,
      "Previous Page": Previous_Page37,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__37,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_37,
      "Retake Exam": Retake_Exam37,
      Return: Return37,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_37,
      "Score: {{score}}%": Score____score___37,
      "Select an answer": Select_an_answer37,
      "Submit Answer(s)": Submit_Answer_s_37,
      "The response options are: ": The_response_options_are__37,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question37,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_37,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_037,
      "You passed!": You_passed_37
    };
  }
});

// src/lib/locales/vi-VN/translations.json
var translations_exports38 = {};
__export(translations_exports38, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_38;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit38;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required38;
  },
  Answer: function Answer() {
    return Answer38;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_38;
  },
  Answerssss: function Answerssss() {
    return Answerssss36;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed38;
  },
  Clear: function Clear() {
    return Clear38;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection38;
  },
  Close: function Close() {
    return Close38;
  },
  Continue: function Continue() {
    return Continue38;
  },
  Finish: function Finish() {
    return Finish38;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started38;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal38;
  },
  Next: function Next() {
    return Next38;
  },
  "Next Page": function NextPage() {
    return Next_Page38;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks38;
  },
  OK: function OK() {
    return OK38;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__38;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_38;
  },
  Prev: function Prev() {
    return Prev38;
  },
  Previous: function Previous() {
    return Previous38;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page38;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__38;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_38;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam38;
  },
  Return: function Return() {
    return Return38;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_38;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___38;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer38;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_38;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__38;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question38;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_38;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_038;
  },
  "You passed!": function YouPassed() {
    return You_passed_38;
  },
  "default": function _default() {
    return translations_default38;
  }
});
var _Select_all_that_apply_38, __000_character_limit38, A_score_of_at_least___passingGrade____is_required38, Answer38, Answer__Must_be_a_number_38, Answerssss36, Assessment_Completed38, Clear38, Clear_Selection38, Close38, Continue38, Finish38, Let_s_Get_Started38, Must_be_a_decimal38, Next38, Next_Page38, Number_of_Drinks38, OK38, Page___currentPage___of___totalPages__38, Please_click_OK_to_continue_to_the_next_page_38, Prev38, Previous38, Previous_Page38, Question___currentQuestion___of___totalQuestions__38, Questions_you_missed_on_the_assessment_38, Retake_Exam38, Return38, Review_answer_feedback_to_learn_more_38, Score____score___38, Select_an_answer38, Submit_Answer_s_38, The_response_options_are__38, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question38, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_38, Value_must_be_greater_than_or_equal_to_038, You_passed_38, translations_default38;
var init_translations38 = __esm({
  "src/lib/locales/vi-VN/translations.json": function srcLibLocalesViVNTranslationsJson() {
    _Select_all_that_apply_38 = "(Ch\u1ECDn t\u1EA5t c\u1EA3 c\xE2u tr\u1EA3 l\u1EDDi \u0111\xFAng)";
    __000_character_limit38 = "Gi\u1EDBi h\u1EA1n 1.000 k\xFD t\u1EF1";
    A_score_of_at_least___passingGrade____is_required38 = "Y\xEAu c\u1EA7u \u0111i\u1EC3m t\u1ED1i thi\u1EC3u l\xE0 {{passingGrade}}%";
    Answer38 = "C\xE2u tr\u1EA3 l\u1EDDi";
    Answer__Must_be_a_number_38 = "C\xE2u tr\u1EA3 l\u1EDDi (Ph\u1EA3i l\xE0 s\u1ED1)";
    Answerssss36 = "C\xE2u tr\u1EA3 l\u1EDDi";
    Assessment_Completed38 = "\u0110\xE3 ho\xE0n th\xE0nh b\u1EA3n \u0111\xE1nh gi\xE1";
    Clear38 = "X\xF3a";
    Clear_Selection38 = "X\xF3a l\u1EF1a ch\u1ECDn";
    Close38 = "\u0110\xF3ng";
    Continue38 = "Ti\u1EBFp t\u1EE5c";
    Finish38 = "Ho\xE0n th\xE0nh";
    Let_s_Get_Started38 = "H\xE3y c\xF9ng b\u1EAFt \u0111\u1EA7u";
    Must_be_a_decimal38 = "Ph\u1EA3i l\xE0 s\u1ED1 th\u1EADp ph\xE2n";
    Next38 = "Ti\u1EBFp theo";
    Next_Page38 = "Trang m\u1EDBi";
    Number_of_Drinks38 = "S\u1ED1 \u0111\u1ED3 u\u1ED1ng";
    OK38 = "OK";
    Page___currentPage___of___totalPages__38 = "Trang {{currentPage}}/{{totalPages}}";
    Please_click_OK_to_continue_to_the_next_page_38 = "Vui l\xF2ng nh\u1EA5p v\xE0o OK \u0111\u1EC3 ti\u1EBFp t\u1EE5c \u0111\u1EBFn trang ti\u1EBFp theo.";
    Prev38 = "Tr\u01B0\u1EDBc";
    Previous38 = "Tr\u01B0\u1EDBc";
    Previous_Page38 = "Trang tr\u01B0\u1EDBc";
    Question___currentQuestion___of___totalQuestions__38 = "C\xE2u h\u1ECFi {{currentQuestion}}/{{totalQuestions}}";
    Questions_you_missed_on_the_assessment_38 = "C\xE1c c\xE2u h\u1ECFi b\u1EA1n \u0111\xE3 tr\u1EA3 l\u1EDDi sai tr\xEAn b\u1EA3n \u0111\xE1nh gi\xE1:";
    Retake_Exam38 = "Th\u1EF1c hi\u1EC7n l\u1EA1i b\xE0i ki\u1EC3m tra";
    Return38 = "Quay l\u1EA1i";
    Review_answer_feedback_to_learn_more_38 = "Xem x\xE9t ph\u1EA3n h\u1ED3i v\u1EC1 c\xE2u tr\u1EA3 l\u1EDDi \u0111\u1EC3 t\xECm hi\u1EC3u th\xEAm.";
    Score____score___38 = "\u0110i\u1EC3m: {{score}}%";
    Select_an_answer38 = "Ch\u1ECDn m\u1ED9t c\xE2u tr\u1EA3 l\u1EDDi";
    Submit_Answer_s_38 = "G\u1EEDi c\xE2u tr\u1EA3 l\u1EDDi";
    The_response_options_are__38 = "C\xE1c t\xF9y ch\u1ECDn c\xE2u tr\u1EA3 l\u1EDDi: ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question38 = "\u0110\u1EC3 b\u1ECF ch\u1ECDn c\xE2u tr\u1EA3 l\u1EDDi, h\xE3y s\u1EED d\u1EE5ng t\xF9y ch\u1ECDn X\xF3a l\u1EF1a ch\u1ECDn \u1EDF sau l\u1EF1a ch\u1ECDn c\xE2u tr\u1EA3 l\u1EDDi cu\u1ED1i c\xF9ng cho t\u1EEBng c\xE2u h\u1ECFi";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_38 = "R\u1EA5t ti\u1EBFc, b\u1EA1n kh\xF4ng \u0111\u1EA1t v\xE0 s\u1EBD c\u1EA7n th\u1EF1c hi\u1EC7n l\u1EA1i b\xE0i \u0111\xE1nh gi\xE1.";
    Value_must_be_greater_than_or_equal_to_038 = "Gi\xE1 tr\u1ECB ph\u1EA3i l\u1EDBn h\u01A1n ho\u1EB7c b\u1EB1ng 0";
    You_passed_38 = "B\u1EA1n \u0111\xE3 \u0111\u1EA1t!";
    translations_default38 = {
      "(Select all that apply)": _Select_all_that_apply_38,
      "1,000 character limit": __000_character_limit38,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required38,
      Answer: Answer38,
      "Answer (Must be a number)": Answer__Must_be_a_number_38,
      Answerssss: Answerssss36,
      "Assessment Completed": Assessment_Completed38,
      Clear: Clear38,
      "Clear Selection": Clear_Selection38,
      Close: Close38,
      Continue: Continue38,
      Finish: Finish38,
      "Let's Get Started": Let_s_Get_Started38,
      "Must be a decimal": Must_be_a_decimal38,
      Next: Next38,
      "Next Page": Next_Page38,
      "Number of Drinks": Number_of_Drinks38,
      OK: OK38,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__38,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_38,
      Prev: Prev38,
      Previous: Previous38,
      "Previous Page": Previous_Page38,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__38,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_38,
      "Retake Exam": Retake_Exam38,
      Return: Return38,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_38,
      "Score: {{score}}%": Score____score___38,
      "Select an answer": Select_an_answer38,
      "Submit Answer(s)": Submit_Answer_s_38,
      "The response options are: ": The_response_options_are__38,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question38,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_38,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_038,
      "You passed!": You_passed_38
    };
  }
});

// src/lib/locales/zh-CN/translations.json
var translations_exports39 = {};
__export(translations_exports39, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_39;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit39;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required39;
  },
  Answer: function Answer() {
    return Answer39;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_39;
  },
  Answerssss: function Answerssss() {
    return Answerssss37;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed39;
  },
  Clear: function Clear() {
    return Clear39;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection39;
  },
  Close: function Close() {
    return Close39;
  },
  Continue: function Continue() {
    return Continue39;
  },
  Finish: function Finish() {
    return Finish39;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started39;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal39;
  },
  Next: function Next() {
    return Next39;
  },
  "Next Page": function NextPage() {
    return Next_Page39;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks39;
  },
  OK: function OK() {
    return OK39;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__39;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_39;
  },
  Prev: function Prev() {
    return Prev39;
  },
  Previous: function Previous() {
    return Previous39;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page39;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__39;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_39;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam39;
  },
  Return: function Return() {
    return Return39;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_39;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___39;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer39;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_39;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__39;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question39;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_39;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_039;
  },
  "You passed!": function YouPassed() {
    return You_passed_39;
  },
  "default": function _default() {
    return translations_default39;
  }
});
var _Select_all_that_apply_39, __000_character_limit39, A_score_of_at_least___passingGrade____is_required39, Answer39, Answer__Must_be_a_number_39, Answerssss37, Assessment_Completed39, Clear39, Clear_Selection39, Close39, Continue39, Finish39, Let_s_Get_Started39, Must_be_a_decimal39, Next39, Next_Page39, Number_of_Drinks39, OK39, Page___currentPage___of___totalPages__39, Please_click_OK_to_continue_to_the_next_page_39, Prev39, Previous39, Previous_Page39, Question___currentQuestion___of___totalQuestions__39, Questions_you_missed_on_the_assessment_39, Retake_Exam39, Return39, Review_answer_feedback_to_learn_more_39, Score____score___39, Select_an_answer39, Submit_Answer_s_39, The_response_options_are__39, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question39, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_39, Value_must_be_greater_than_or_equal_to_039, You_passed_39, translations_default39;
var init_translations39 = __esm({
  "src/lib/locales/zh-CN/translations.json": function srcLibLocalesZhCNTranslationsJson() {
    _Select_all_that_apply_39 = "\uFF08\u9009\u62E9\u6240\u6709\u9002\u7528\u7684\u9009\u9879\uFF09";
    __000_character_limit39 = "\u6700\u591A 1,000 \u4E2A\u5B57\u7B26";
    A_score_of_at_least___passingGrade____is_required39 = "\u8981\u6C42\u5206\u6570\u6700\u4F4E\u4E3A {{passingGrade}}%";
    Answer39 = "\u56DE\u7B54";
    Answer__Must_be_a_number_39 = "\u56DE\u7B54\uFF08\u5FC5\u987B\u662F\u6570\u5B57\uFF09";
    Answerssss37 = "\u7B54\u6848";
    Assessment_Completed39 = "\u8BC4\u4F30\u5DF2\u5B8C\u6210";
    Clear39 = "\u6E05\u9664";
    Clear_Selection39 = "\u6E05\u7A7A\u9009\u9879";
    Close39 = "\u5173\u95ED";
    Continue39 = "\u7EE7\u7EED";
    Finish39 = "\u5B8C\u6210";
    Let_s_Get_Started39 = "\u8BA9\u6211\u4EEC\u5F00\u59CB\u5427";
    Must_be_a_decimal39 = "\u5FC5\u987B\u4E3A\u5C0F\u6570";
    Next39 = "\u4E0B\u4E00\u4E2A";
    Next_Page39 = "\u4E0B\u4E00\u9875";
    Number_of_Drinks39 = "\u996E\u6599\u6570\u91CF";
    OK39 = "\u786E\u5B9A";
    Page___currentPage___of___totalPages__39 = "\u7B2C {{currentPage}} \u9875\uFF0C\u5171 {{totalPages}} \u9875";
    Please_click_OK_to_continue_to_the_next_page_39 = "\u8BF7\u5355\u51FB\u201C\u786E\u5B9A\u201D\u7EE7\u7EED\u4E0B\u4E00\u9875\u3002";
    Prev39 = "\u4E0A\u4E00\u9875";
    Previous39 = "\u4E0A\u4E00\u4E2A";
    Previous_Page39 = "\u4E0A\u4E00\u9875";
    Question___currentQuestion___of___totalQuestions__39 = "\u95EE\u9898 {{totalQuestions}}\uFF0C\u5171 {{currentQuestion}}";
    Questions_you_missed_on_the_assessment_39 = "\u60A8\u5728\u8BC4\u4F30\u4E2D\u9519\u8FC7\u7684\u95EE\u9898\uFF1A";
    Retake_Exam39 = "\u91CD\u65B0\u8003\u8BD5";
    Return39 = "\u8FD4\u56DE";
    Review_answer_feedback_to_learn_more_39 = "\u67E5\u770B\u7B54\u6848\u53CD\u9988\u4EE5\u4E86\u89E3\u66F4\u591A\u3002";
    Score____score___39 = "\u5F97\u5206\uFF1A{{score}}%";
    Select_an_answer39 = "\u9009\u62E9\u4E00\u4E2A\u7B54\u6848";
    Submit_Answer_s_39 = "\u63D0\u4EA4\u56DE\u7B54";
    The_response_options_are__39 = "\u54CD\u5E94\u9009\u9879\u4E3A\uFF1A ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question39 = "\u8981\u53D6\u6D88\u9009\u62E9\u7B54\u6848\uFF0C\u8BF7\u5728\u6BCF\u4E2A\u95EE\u9898\u7684\u6700\u540E\u4E00\u4E2A\u7B54\u6848\u9009\u62E9\u4E4B\u540E\u4F7F\u7528\u201C\u6E05\u9664\u9009\u62E9\u201D\u9009\u9879";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_39 = "\u5F88\u62B1\u6B49\uFF0C\u60A8\u6CA1\u6709\u901A\u8FC7\uFF0C\u9700\u8981\u91CD\u65B0\u8BC4\u4F30\u3002";
    Value_must_be_greater_than_or_equal_to_039 = "\u503C\u5FC5\u987B\u5927\u4E8E\u6216\u7B49\u4E8E 0";
    You_passed_39 = "\u60A8\u5DF2\u901A\u8FC7\uFF01";
    translations_default39 = {
      "(Select all that apply)": _Select_all_that_apply_39,
      "1,000 character limit": __000_character_limit39,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required39,
      Answer: Answer39,
      "Answer (Must be a number)": Answer__Must_be_a_number_39,
      Answerssss: Answerssss37,
      "Assessment Completed": Assessment_Completed39,
      Clear: Clear39,
      "Clear Selection": Clear_Selection39,
      Close: Close39,
      Continue: Continue39,
      Finish: Finish39,
      "Let's Get Started": Let_s_Get_Started39,
      "Must be a decimal": Must_be_a_decimal39,
      Next: Next39,
      "Next Page": Next_Page39,
      "Number of Drinks": Number_of_Drinks39,
      OK: OK39,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__39,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_39,
      Prev: Prev39,
      Previous: Previous39,
      "Previous Page": Previous_Page39,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__39,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_39,
      "Retake Exam": Retake_Exam39,
      Return: Return39,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_39,
      "Score: {{score}}%": Score____score___39,
      "Select an answer": Select_an_answer39,
      "Submit Answer(s)": Submit_Answer_s_39,
      "The response options are: ": The_response_options_are__39,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question39,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_39,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_039,
      "You passed!": You_passed_39
    };
  }
});

// src/lib/locales/zh-TW/translations.json
var translations_exports40 = {};
__export(translations_exports40, {
  "(Select all that apply)": function SelectAllThatApply() {
    return _Select_all_that_apply_40;
  },
  "1,000 character limit": function characterLimit() {
    return __000_character_limit40;
  },
  "A score of at least {{passingGrade}}% is required": function AScoreOfAtLeastPassingGradeIsRequired() {
    return A_score_of_at_least___passingGrade____is_required40;
  },
  Answer: function Answer() {
    return Answer40;
  },
  "Answer (Must be a number)": function AnswerMustBeANumber() {
    return Answer__Must_be_a_number_40;
  },
  Answerssss: function Answerssss() {
    return Answerssss38;
  },
  "Assessment Completed": function AssessmentCompleted() {
    return Assessment_Completed40;
  },
  Clear: function Clear() {
    return Clear40;
  },
  "Clear Selection": function ClearSelection() {
    return Clear_Selection40;
  },
  Close: function Close() {
    return Close40;
  },
  Continue: function Continue() {
    return Continue40;
  },
  Finish: function Finish() {
    return Finish40;
  },
  "Let's Get Started": function LetSGetStarted() {
    return Let_s_Get_Started40;
  },
  "Must be a decimal": function MustBeADecimal() {
    return Must_be_a_decimal40;
  },
  Next: function Next() {
    return Next40;
  },
  "Next Page": function NextPage() {
    return Next_Page40;
  },
  "Number of Drinks": function NumberOfDrinks() {
    return Number_of_Drinks40;
  },
  OK: function OK() {
    return OK40;
  },
  "Page {{currentPage}} of {{totalPages}}": function PageCurrentPageOfTotalPages() {
    return Page___currentPage___of___totalPages__40;
  },
  "Please click OK to continue to the next page.": function PleaseClickOKToContinueToTheNextPage() {
    return Please_click_OK_to_continue_to_the_next_page_40;
  },
  Prev: function Prev() {
    return Prev40;
  },
  Previous: function Previous() {
    return Previous40;
  },
  "Previous Page": function PreviousPage() {
    return Previous_Page40;
  },
  "Question {{currentQuestion}} of {{totalQuestions}}": function QuestionCurrentQuestionOfTotalQuestions() {
    return Question___currentQuestion___of___totalQuestions__40;
  },
  "Questions you missed on the assessment:": function QuestionsYouMissedOnTheAssessment() {
    return Questions_you_missed_on_the_assessment_40;
  },
  "Retake Exam": function RetakeExam() {
    return Retake_Exam40;
  },
  Return: function Return() {
    return Return40;
  },
  "Review answer feedback to learn more.": function ReviewAnswerFeedbackToLearnMore() {
    return Review_answer_feedback_to_learn_more_40;
  },
  "Score: {{score}}%": function ScoreScore() {
    return Score____score___40;
  },
  "Select an answer": function SelectAnAnswer() {
    return Select_an_answer40;
  },
  "Submit Answer(s)": function SubmitAnswerS() {
    return Submit_Answer_s_40;
  },
  "The response options are: ": function TheResponseOptionsAre() {
    return The_response_options_are__40;
  },
  "To deselect an answer, use the Clear Selection option after the last answer choice for each question": function ToDeselectAnAnswerUseTheClearSelectionOptionAfterTheLastAnswerChoiceForEachQuestion() {
    return To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question40;
  },
  "Unfortunately, you did not pass and will need to retake the assessment.": function UnfortunatelyYouDidNotPassAndWillNeedToRetakeTheAssessment() {
    return Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_40;
  },
  "Value must be greater than or equal to 0": function ValueMustBeGreaterThanOrEqualTo0() {
    return Value_must_be_greater_than_or_equal_to_040;
  },
  "You passed!": function YouPassed() {
    return You_passed_40;
  },
  "default": function _default() {
    return translations_default40;
  }
});
var _Select_all_that_apply_40, __000_character_limit40, A_score_of_at_least___passingGrade____is_required40, Answer40, Answer__Must_be_a_number_40, Answerssss38, Assessment_Completed40, Clear40, Clear_Selection40, Close40, Continue40, Finish40, Let_s_Get_Started40, Must_be_a_decimal40, Next40, Next_Page40, Number_of_Drinks40, OK40, Page___currentPage___of___totalPages__40, Please_click_OK_to_continue_to_the_next_page_40, Prev40, Previous40, Previous_Page40, Question___currentQuestion___of___totalQuestions__40, Questions_you_missed_on_the_assessment_40, Retake_Exam40, Return40, Review_answer_feedback_to_learn_more_40, Score____score___40, Select_an_answer40, Submit_Answer_s_40, The_response_options_are__40, To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question40, Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_40, Value_must_be_greater_than_or_equal_to_040, You_passed_40, translations_default40;
var init_translations40 = __esm({
  "src/lib/locales/zh-TW/translations.json": function srcLibLocalesZhTWTranslationsJson() {
    _Select_all_that_apply_40 = "(\u8ACB\u9078\u64C7\u6240\u6709\u5408\u9069\u7684\u9805\u76EE)";
    __000_character_limit40 = "1,000 \u5B57\u5143\u9650\u5236";
    A_score_of_at_least___passingGrade____is_required40 = "\u8981\u6C42\u5206\u6578\u81F3\u5C11\u70BA {{passingGrade}}%";
    Answer40 = "\u7B54\u6848";
    Answer__Must_be_a_number_40 = "\u7B54\u6848 (\u5FC5\u9808\u70BA\u6578\u5B57)";
    Answerssss38 = "\u7B54\u6848";
    Assessment_Completed40 = "\u5DF2\u5B8C\u6210\u8A55\u4F30";
    Clear40 = "\u6E05\u9664";
    Clear_Selection40 = "\u6E05\u9664\u9078\u64C7";
    Close40 = "\u95DC\u9589";
    Continue40 = "\u7E7C\u7E8C";
    Finish40 = "\u5B8C\u6210";
    Let_s_Get_Started40 = "\u8B93\u6211\u5011\u958B\u59CB\u5427";
    Must_be_a_decimal40 = "\u5FC5\u9808\u70BA\u5341\u9032\u4F4D";
    Next40 = "\u4E0B\u4E00\u6B65";
    Next_Page40 = "\u4E0B\u4E00\u9801";
    Number_of_Drinks40 = "\u98F2\u6599\u6578\u91CF";
    OK40 = "\u78BA\u5B9A";
    Page___currentPage___of___totalPages__40 = "\u7B2C {{currentPage}} \u9801\uFF08\u5171 {{totalPages}} \u9801\uFF09";
    Please_click_OK_to_continue_to_the_next_page_40 = "\u8ACB\u6309\u4E00\u4E0B\u300C\u78BA\u5B9A\u300D\u4EE5\u7E7C\u7E8C\u524D\u5F80\u4E0B\u4E00\u9801\u3002";
    Prev40 = "\u4E0A\u4E00\u9801";
    Previous40 = "\u4E0A\u4E00\u6B65";
    Previous_Page40 = "\u4E0A\u4E00\u9801";
    Question___currentQuestion___of___totalQuestions__40 = "\u7B2C {{currentQuestion}} \u500B\u554F\u984C\uFF08\u5171 {{totalQuestions}} \u500B\uFF09";
    Questions_you_missed_on_the_assessment_40 = "\u60A8\u5728\u8A55\u4F30\u4E2D\u907A\u6F0F\u7684\u554F\u984C\uFF1A";
    Retake_Exam40 = "\u8907\u8A66";
    Return40 = "\u8FD4\u56DE";
    Review_answer_feedback_to_learn_more_40 = "\u6AA2\u95B1\u7B54\u6848\u610F\u898B\u56DE\u994B\uFF0C\u4EE5\u77AD\u89E3\u66F4\u591A\u8CC7\u8A0A\u3002";
    Score____score___40 = "\u5F97\u5206\uFF1A{{score}}%";
    Select_an_answer40 = "\u9078\u53D6\u7B54\u6848";
    Submit_Answer_s_40 = "\u63D0\u4EA4\u7B54\u6848";
    The_response_options_are__40 = "\u56DE\u61C9\u9078\u9805\u5305\u62EC\uFF1A ";
    To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question40 = "\u82E5\u8981\u53D6\u6D88\u9078\u53D6\u7B54\u6848\uFF0C\u8ACB\u5728\u6BCF\u500B\u554F\u984C\u7684\u6700\u5F8C\u4E00\u500B\u7B54\u6848\u9078\u64C7\u4E4B\u5F8C\u4F7F\u7528\u300C\u6E05\u9664\u9078\u64C7\u300D\u9078\u9805";
    Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_40 = "\u5F88\u907A\u61BE\uFF0C\u60A8\u4E26\u672A\u901A\u904E\uFF0C\u9700\u8981\u91CD\u65B0\u9032\u884C\u8A55\u4F30\u3002";
    Value_must_be_greater_than_or_equal_to_040 = "\u503C\u5FC5\u9808\u5927\u65BC\u6216\u7B49\u65BC 0";
    You_passed_40 = "\u60A8\u901A\u904E\u4E86\uFF01";
    translations_default40 = {
      "(Select all that apply)": _Select_all_that_apply_40,
      "1,000 character limit": __000_character_limit40,
      "A score of at least {{passingGrade}}% is required": A_score_of_at_least___passingGrade____is_required40,
      Answer: Answer40,
      "Answer (Must be a number)": Answer__Must_be_a_number_40,
      Answerssss: Answerssss38,
      "Assessment Completed": Assessment_Completed40,
      Clear: Clear40,
      "Clear Selection": Clear_Selection40,
      Close: Close40,
      Continue: Continue40,
      Finish: Finish40,
      "Let's Get Started": Let_s_Get_Started40,
      "Must be a decimal": Must_be_a_decimal40,
      Next: Next40,
      "Next Page": Next_Page40,
      "Number of Drinks": Number_of_Drinks40,
      OK: OK40,
      "Page {{currentPage}} of {{totalPages}}": Page___currentPage___of___totalPages__40,
      "Please click OK to continue to the next page.": Please_click_OK_to_continue_to_the_next_page_40,
      Prev: Prev40,
      Previous: Previous40,
      "Previous Page": Previous_Page40,
      "Question {{currentQuestion}} of {{totalQuestions}}": Question___currentQuestion___of___totalQuestions__40,
      "Questions you missed on the assessment:": Questions_you_missed_on_the_assessment_40,
      "Retake Exam": Retake_Exam40,
      Return: Return40,
      "Review answer feedback to learn more.": Review_answer_feedback_to_learn_more_40,
      "Score: {{score}}%": Score____score___40,
      "Select an answer": Select_an_answer40,
      "Submit Answer(s)": Submit_Answer_s_40,
      "The response options are: ": The_response_options_are__40,
      "To deselect an answer, use the Clear Selection option after the last answer choice for each question": To_deselect_an_answer__use_the_Clear_Selection_option_after_the_last_answer_choice_for_each_question40,
      "Unfortunately, you did not pass and will need to retake the assessment.": Unfortunately__you_did_not_pass_and_will_need_to_retake_the_assessment_40,
      "Value must be greater than or equal to 0": Value_must_be_greater_than_or_equal_to_040,
      "You passed!": You_passed_40
    };
  }
});

// src/lib/locale-map.ts
var locale_map_exports = {};
__export(locale_map_exports, {
  localeMap: function localeMap() {
    return _localeMap;
  }
});
var _localeMap;
var init_locale_map = __esm({
  "src/lib/locale-map.ts": function srcLibLocaleMapTs() {
    "use strict";

    init_translations();
    init_translations2();
    init_translations3();
    init_translations4();
    init_translations5();
    init_translations6();
    init_translations7();
    init_translations8();
    init_translations9();
    init_translations10();
    init_translations11();
    init_translations12();
    init_translations13();
    init_translations14();
    init_translations15();
    init_translations16();
    init_translations17();
    init_translations18();
    init_translations19();
    init_translations20();
    init_translations21();
    init_translations22();
    init_translations23();
    init_translations24();
    init_translations25();
    init_translations26();
    init_translations27();
    init_translations28();
    init_translations29();
    init_translations30();
    init_translations31();
    init_translations32();
    init_translations33();
    init_translations34();
    init_translations35();
    init_translations36();
    init_translations37();
    init_translations38();
    init_translations39();
    init_translations40();
    _localeMap = {
      "ar-AE": translations_exports,
      "bg-BG": translations_exports2,
      "cs-CZ": translations_exports3,
      "da-DK": translations_exports4,
      de: translations_exports5,
      "el-GR": translations_exports6,
      en: translations_exports7,
      "en-GB": translations_exports8,
      "en-US": translations_exports9,
      es: translations_exports10,
      "es-ES": translations_exports11,
      "fi-FI": translations_exports12,
      "fr-CA": translations_exports13,
      "fr-FR": translations_exports14,
      "he-IL": translations_exports15,
      "hi-IN": translations_exports16,
      "hu-HU": translations_exports17,
      "id-ID": translations_exports18,
      it: translations_exports19,
      ja: translations_exports20,
      "km-KH": translations_exports21,
      ko: translations_exports22,
      "ms-MY": translations_exports23,
      "my-MM": translations_exports24,
      "nl-NL": translations_exports25,
      "pl-PL": translations_exports26,
      "pt-BR": translations_exports27,
      "ro-RO": translations_exports28,
      ru: translations_exports29,
      "sk-SK": translations_exports30,
      "sl-SI": translations_exports31,
      "sr-RS": translations_exports32,
      "sv-SE": translations_exports33,
      "th-TH": translations_exports34,
      "tl-PH": translations_exports35,
      "tr-TR": translations_exports36,
      "uk-UA": translations_exports37,
      "vi-VN": translations_exports38,
      "zh-CN": translations_exports39,
      "zh-TW": translations_exports40
    };
  }
});

// src/EvaluationApp.tsx
import React31, { Component as Component11 } from "react";
import PropTypes20 from "prop-types";
import { Provider } from "react-redux";

// src/containers/EvaluationContainer.tsx
import React30, { Component as Component10 } from "react";

// src/components/Section.tsx
import PropTypes12 from "prop-types";
import React18, { useState as useState2, useEffect } from "react";

// src/components/Question.tsx
import React17, { Component as Component3 } from "react";
import PropTypes11 from "prop-types";
import { Core as Core6 } from "@everfi/reactifi";

// src/components/MultipleChoiceAnswers.tsx
import React4, { useState } from "react";

// src/components/MultipleChoiceAnswer.tsx
import React2 from "react";
import PropTypes2 from "prop-types";

// src/components/BaseMultipleAnswer.tsx
import React from "react";
import PropTypes from "prop-types";

// src/constants/actionTypes.ts
import mirrorCreator from "mirror-creator";
var constants = mirrorCreator(["NEW_RESPONSE_SET", "RESPONSE_SET_LOADED", "INTRO_COMPLETED", "SET_RESPONSE", "FINISH_RESPONSE_SET", "SET_CURRENT_SECTION", "SET_PREVIOUS_SECTION", "SHOW_FEEDBACK", "CLEAR_RESPONSE_SET_STATE", "FEEDBACK_COMPLETED", "DISABLE_CONTROLS", "ENABLE_CONTROLS", "SET_CURRENT_RESPONSE_SET", "REMOVE_ANSWER", "RESPONSE_SET_LOCAL_MODE", "SET_SPLIT_INDEX"]);
var actionTypes_default = constants;

// src/actions/responseSet.ts
import { updateEntity, setEndpointPath, setAccessToken } from "redux-json-api";
import { readLocal } from "@everfi/reactifi";
import { Util } from "@everfi/reactifi";

// src/functions/requestDataWithoutCredentials.ts
import deepmerge from "deepmerge";
function requestDataWithoutCredentials(_0) {
  return __async(this, arguments, function (endpoint) {
    var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "GET";
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var defaultOptions, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            defaultOptions = {
              method: method,
              headers: {
                "Content-Type": "application/vnd.api+json",
                Accept: "application/vnd.api+json",
                "Cache-Control": "no-cache"
              },
              mode: "cors",
              credentials: "omit"
            };
            if (token) {
              defaultOptions.headers.Authorization = "Bearer ".concat(token);
            }
            options = deepmerge(defaultOptions, options);
            _context.next = 5;
            return fetch(endpoint, options);
          case 5:
            response = _context.sent;
            _context.next = 8;
            return response.json();
          case 8:
            return _context.abrupt("return", _context.sent);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })();
  });
}

// src/actions/responseSet.ts
var baseEndPath = "api/v1";
var Storage = Util.storage;
var newResponseSet = function newResponseSet() {
  return {
    type: actionTypes_default.NEW_RESPONSE_SET
  };
};
var setResponseSetLocalMode = function setResponseSetLocalMode(assessmentData, isLocalMode) {
  return {
    type: actionTypes_default.RESPONSE_SET_LOCAL_MODE,
    assessmentData: assessmentData,
    isLocalMode: isLocalMode
  };
};
var setSplitIndexStart = function setSplitIndexStart(splitIndexStart) {
  return {
    type: actionTypes_default.SET_SPLIT_INDEX,
    splitIndexStart: splitIndexStart
  };
};
var responseSetLoaded = function responseSetLoaded(splitQuestions) {
  return {
    type: actionTypes_default.RESPONSE_SET_LOADED,
    splitQuestions: splitQuestions
  };
};
var finishResponseSet = function finishResponseSet() {
  return {
    type: actionTypes_default.FINISH_RESPONSE_SET
  };
};
var finishFeedback = function finishFeedback() {
  return {
    type: actionTypes_default.FEEDBACK_COMPLETED
  };
};
var finishSection = function finishSection(responseSet, section) {
  var evaluationId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var organizationId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var embedded = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var endpointHost = arguments.length > 5 ? arguments[5] : undefined;
  var embeddedFields = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var isLocalMode = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  return function (dispatch) {
    return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var sectionId, errorOnSubmit, unWrapResponseSet, token, response, _response, _response$data, id, access_token, newResponseSet2, currentSectionIndex;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch({
              type: actionTypes_default.DISABLE_CONTROLS
            });
            sectionId = responseSet.current_section_id ? responseSet.current_section_id + "" : section + "";
            unWrapResponseSet = Object.assign({}, responseSet.unwrap(), {
              type: (responseSet == null ? void 0 : responseSet.id) ? "response_set_sections" : "response_sets",
              id: sectionId
            });
            unWrapResponseSet.attributes.current_section_id = parseInt(unWrapResponseSet.attributes.current_section_id, 10);
            unWrapResponseSet.attributes.complete = true;
            if (!embedded) {
              _context2.next = 34;
              break;
            }
            unWrapResponseSet.attributes.evaluation_id = evaluationId;
            unWrapResponseSet.attributes.organization_id = organizationId;
            unWrapResponseSet.attributes.fields = embeddedFields;
            if (!(responseSet == null ? void 0 : responseSet.id)) {
              _context2.next = 17;
              break;
            }
            token = Storage.getItem("accessToken");
            _context2.next = 13;
            return requestDataWithoutCredentials("".concat(endpointHost, "/").concat(baseEndPath, "/form/response_sets/").concat(responseSet.id, "/response_set_sections/").concat(sectionId, "?organization_id=").concat(organizationId), token, "PATCH", {
              body: JSON.stringify({
                data: unWrapResponseSet
              })
            });
          case 13:
            response = _context2.sent;
            if (response == null ? void 0 : response.data) {
              dispatch(readLocal(response));
            } else {
              errorOnSubmit = true;
            }
            _context2.next = 32;
            break;
          case 17:
            _context2.next = 19;
            return requestDataWithoutCredentials("".concat(endpointHost, "/").concat(baseEndPath, "/form/response_sets"), null, "POST", {
              body: JSON.stringify({
                data: unWrapResponseSet
              })
            });
          case 19:
            _response = _context2.sent;
            if (!(_response && _response.data)) {
              _context2.next = 31;
              break;
            }
            _response$data = _response.data, id = _response$data.id, access_token = _response$data.relationships.access_token;
            _context2.next = 24;
            return requestDataWithoutCredentials("".concat(endpointHost, "/").concat(baseEndPath, "/form/response_sets/").concat(id, ".json?include=evaluation,sections.questions.answers,sections.matrix_parent_questions.answers&organization_id=").concat(organizationId), access_token.data.id);
          case 24:
            newResponseSet2 = _context2.sent;
            Storage.setItem("accessToken", access_token.data.id);
            dispatch(setAccessToken(access_token.data.id));
            dispatch(readLocal(newResponseSet2));
            dispatch(setCurrentResponseSet(newResponseSet2.data));
            _context2.next = 32;
            break;
          case 31:
            errorOnSubmit = true;
          case 32:
            _context2.next = 43;
            break;
          case 34:
            if (!isLocalMode) {
              _context2.next = 39;
              break;
            }
            currentSectionIndex = responseSet.sections.findIndex(function (section2) {
              return section2.id === sectionId;
            });
            dispatch(setCurrentSection(currentSectionIndex + 1));
            _context2.next = 42;
            break;
          case 39:
            dispatch(setEndpointPath("".concat(baseEndPath, "/response_sets/").concat(responseSet.id)));
            _context2.next = 42;
            return dispatch(updateEntity(unWrapResponseSet));
          case 42:
            dispatch(setPreviousSection(responseSet.current_section_id));
          case 43:
            if (!isLocalMode) {
              dispatch(setEndpointPath(baseEndPath));
            }
            dispatch({
              type: actionTypes_default.ENABLE_CONTROLS
            });
            if (!errorOnSubmit) {
              dispatch({
                type: actionTypes_default.SHOW_FEEDBACK,
                section: section
              });
            }
          case 46:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  };
};
var introCompleted = function introCompleted() {
  return {
    type: actionTypes_default.INTRO_COMPLETED
  };
};
var setCurrentSection = function setCurrentSection(section) {
  return {
    type: actionTypes_default.SET_CURRENT_SECTION,
    section: section
  };
};
var setPreviousSection = function setPreviousSection(section) {
  return {
    type: actionTypes_default.SET_PREVIOUS_SECTION,
    section: section
  };
};
var setAnswerForQuestion = function setAnswerForQuestion(questionId, answerValue, responseType, userSuppliedText) {
  return {
    type: actionTypes_default.SET_RESPONSE,
    questionId: questionId,
    answerValue: answerValue,
    responseType: responseType,
    userSuppliedText: userSuppliedText
  };
};
var deleteAnswerForQuestion = function deleteAnswerForQuestion(questionId) {
  return {
    type: actionTypes_default.REMOVE_ANSWER,
    questionId: questionId
  };
};
var setCurrentResponseSet = function setCurrentResponseSet(responseSet) {
  return {
    type: actionTypes_default.SET_CURRENT_RESPONSE_SET,
    responseSet: responseSet
  };
};

// src/components/BaseMultipleAnswer.tsx
import { Core } from "@everfi/reactifi";

// src/lib/i18n.ts
import { i18n as i18n2 } from "@everfi/reactifi";

// src/lib/locale-manager.ts
import { i18n } from "@everfi/reactifi";
var injectResource = function injectResource(lang, locale) {
  i18n.addResources(lang, "evalufi-player", locale);
};
var localeManager = {
  load: function load(lang) {
    return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var mapModule, map, locale;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return Promise.resolve().then(function () {
              return init_locale_map(), locale_map_exports;
            });
          case 3:
            mapModule = _context3.sent;
            map = mapModule.localeMap;
            locale = map[lang];
            if (locale) {
              _context3.next = 8;
              break;
            }
            return _context3.abrupt("return");
          case 8:
            injectResource(lang, locale);
            i18n.changeLanguage(lang);
            _context3.next = 15;
            break;
          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](0);
            console.error("@everfi/evalufi-player - Could not load translations dynamically", _context3.t0);
          case 15:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 12]]);
    }));
  }
};

// src/lib/i18n.ts
(function () {
  return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var currentLanguage, locale;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          currentLanguage = i18n2.language;
          if (currentLanguage) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return");
        case 3:
          _context4.prev = 3;
          _context4.next = 6;
          return import( /* webpackChunkName: "evalufi-player-locale-[request]" */"./locales/".concat(currentLanguage, "/translations.json"));
        case 6:
          locale = _context4.sent;
          injectResource(currentLanguage, locale);
          _context4.next = 13;
          break;
        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](3);
          console.error(_context4.t0);
        case 13:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[3, 10]]);
  }));
})();
var t = function t(key, options) {
  return i18n2.t(key, __spreadProps(__spreadValues({}, options), {
    ns: "evalufi-player"
  }));
};

// src/components/BaseMultipleAnswer.tsx
var BaseMultipleAnswer = /*#__PURE__*/function (_React$Component) {
  function BaseMultipleAnswer() {
    var _this;
    _classCallCheck(this, BaseMultipleAnswer);
    _this = _callSuper(this, BaseMultipleAnswer, arguments);
    _this.renderFeedbackIcon = function (answerStatus) {
      var _this$props = _this.props,
        correct_answers = _this$props.correct_answers,
        selected = _this$props.selected,
        evaluationType = _this$props.evaluationType;
      var showFeedback2 = (!!correct_answers || selected) && evaluationType === "assessment";
      if (!showFeedback2) {
        return null;
      }
      switch (answerStatus) {
        case true:
          return _this.renderIcon("circle-check");
        case false:
          return _this.renderIcon("circle-xmark");
        default:
          return null;
      }
    };
    _this.correctAnswer = function () {
      var _this$props2 = _this.props,
        correct_answers = _this$props2.correct_answers,
        incorrectAnswers = _this$props2.incorrectAnswers,
        showFeedback2 = _this$props2.showFeedback,
        answer = _this$props2.answer;
      if (correct_answers) {
        return correct_answers.includes(answer.id);
      }
      if (showFeedback2) {
        if (incorrectAnswers && !incorrectAnswers.length) {
          return true;
        } else if (incorrectAnswers && Boolean(incorrectAnswers.filter(function (ia) {
          return ia.answer.toString() === answer.id;
        }))) {
          return false;
        }
      }
      return false;
    };
    _this.renderIcon = function (iconName) {
      var iconColorMap = {
        "circle-check": "var(--udl-colors-icon-success)",
        "circle-xmark": "var(--udl-colors-icon-error)"
      };
      return /* @__PURE__ */React.createElement(Core.Icon, {
        iconName: iconName,
        color: iconColorMap[iconName],
        className: ""
      });
    };
    _this.renderFeedbackText = function (feedbackText, status) {
      var showAnswersFeedback = _this.props.showAnswersFeedback;
      if (!showAnswersFeedback) {
        return null;
      }
      return /* @__PURE__ */React.createElement("div", {
        "data-attribute": "answer-feedback-preview",
        className: "answer-feedback".concat(status ? " correct-answer-feedback" : "").concat(!feedbackText ? " no-answer-feedback" : "")
      }, feedbackText || t("No Feedback Defined"));
    };
    _this.getAnswerClass = function (answerStatus) {
      var className = "";
      if (_this.props.selected) {
        className = "selected";
        switch (answerStatus) {
          case true:
            className += " correct";
            break;
          case false:
            className += " incorrect";
            break;
          default:
            className += "";
            break;
        }
      }
      return className;
    };
    _this.handleChange = function (event, userSuppliedText) {
      var _a;
      _this.props.dispatch(setAnswerForQuestion(
      // @ts-expect-error TS(2339): Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
      _this.props.questionId,
      // @ts-expect-error TS(2339): Property 'answer' does not exist on type 'Readonly... Remove this comment to see the full error message
      event.target.checked ? _this.props.answer.id : null,
      // @ts-expect-error TS(2339): Property 'responseType' does not exist on type 'Re... Remove this comment to see the full error message
      _this.props.responseType, userSuppliedText));
      if (_this.props.onOptionChange) {
        _this.props.onOptionChange({
          questionId:
          // @ts-expect-error TS(2339): Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
          _this.props.questionId,
          answerId:
          // @ts-expect-error TS(2339): Property 'answer' does not exist on type 'Readonly... Remove this comment to see the full error message
          event.target.checked ? _this.props.answer.id : null,
          //@ts-ignore
          isCorrect: (_a = _this.props.answer.isCorrect) != null ? _a : false
        });
      }
    };
    _this.handleSelectChange = function (value) {
      _this.props.dispatch(setAnswerForQuestion(_this.props.questionId, value.id, _this.props.responseType));
    };
    return _this;
  }
  _inherits(BaseMultipleAnswer, _React$Component);
  return _createClass(BaseMultipleAnswer);
}(React.Component);
BaseMultipleAnswer.propTypes = {
  answer: PropTypes.shape({
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }),
  correct_answers: PropTypes.arrayOf(PropTypes.string),
  questionId: PropTypes.string.isRequired,
  evaluationType: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  incorrectAnswers: PropTypes.array,
  showFeedback: PropTypes.bool,
  responseType: PropTypes.string,
  onOptionChange: PropTypes.func,
  showAnswersFeedback: PropTypes.bool
};

// src/components/MultipleChoiceAnswer.tsx
import { Core as Core2 } from "@everfi/reactifi";
import { FieldGroup, FloatingLabelFormField } from "@everfi/reactifi";
var MultipleChoiceAnswer = /*#__PURE__*/function (_BaseMultipleAnswer) {
  function MultipleChoiceAnswer(props) {
    var _this2;
    _classCallCheck(this, MultipleChoiceAnswer);
    var _a;
    _this2 = _callSuper(this, MultipleChoiceAnswer, [props]);
    _this2.handleUserSuppliedTextChange = function (value) {
      _this2.setState({
        user_supplied_text: value
      });
      if (_this2.radio) {
        _this2.handleChange({
          target: _this2.radio
        }, value);
      }
    };
    _this2.renderInputType = function (customOption, label) {
      var onChangeFunc = customOption ?
      // @ts-expect-error TS(2339): Property 'user_supplied_text' does not exist on ty... Remove this comment to see the full error message
      function (evt) {
        return _this2.handleChange(evt, _this2.state.user_supplied_text);
      } : _this2.handleChange;
      var InputComponent = _this2.props.responseType === "single_selection" ? Core2.Radio : Core2.Checkbox;
      return /* @__PURE__ */React2.createElement(InputComponent, {
        name: _this2.props.questionId,
        "data-object-type": "multiple-choice-answer",
        label: label,
        id: _this2.props.answer.id,
        value: _this2.props.answer.id,
        isChecked: _this2.props.selected,
        isDisabled: _this2.props.disabled,
        onChange: onChangeFunc,
        "data-object-id": _this2.props.answer.id,
        ref: function ref(elem) {
          _this2.radio = elem;
        }
      });
    };
    _this2.renderAnswer = function () {
      var _a;
      var answer = _this2.props.answer;
      var answerStatus = _this2.correctAnswer();
      var isRadioChecked = !!((_a = _this2.radio) == null ? void 0 : _a.checked);
      return answer.collect_user_supplied_text ?
      // @ts-ignore
      /* @__PURE__ */
      React2.createElement(FieldGroup, {
        className: "row m-0 user-supplied-text"
      }, /* @__PURE__ */React2.createElement("div", {
        className: "radio col-1 ".concat(_this2.getAnswerClass(answerStatus))
      }, _this2.renderInputType(true), /* @__PURE__ */React2.createElement("i", {
        className: "input-helper"
      })), /* @__PURE__ */React2.createElement("div", {
        className: "textfield col-11"
      }, /* @__PURE__ */React2.createElement(FloatingLabelFormField, {
        name: answer.text,
        caption: answer.text,
        dataValue: _this2.state.user_supplied_text,
        onChange: _this2.handleUserSuppliedTextChange,
        valueOverride: true,
        ref: function ref(elem) {
          _this2.suppliedTextInput = elem;
        },
        required: isRadioChecked,
        disabled: !isRadioChecked,
        runValidation: !isRadioChecked
      }))) : /* @__PURE__ */React2.createElement(Core2.Layout, {
        variant: "flex",
        alignItems: "center",
        gap: "xs",
        minH: "34px"
      }, _this2.renderInputType(false, answer.text), _this2.renderFeedbackIcon(answerStatus), _this2.renderFeedbackText(answer.feedback, answerStatus));
    };
    _this2.state = {
      user_supplied_text: ((_a = props == null ? void 0 : props.response) == null ? void 0 : _a.userSuppliedText) || ""
    };
    return _this2;
  }
  _inherits(MultipleChoiceAnswer, _BaseMultipleAnswer);
  return _createClass(MultipleChoiceAnswer, [{
    key: "render",
    value: function render() {
      return this.renderAnswer();
    }
  }]);
}(BaseMultipleAnswer);
MultipleChoiceAnswer.propTypes = {
  answer: PropTypes2.shape({
    id: PropTypes2.string,
    text: PropTypes2.string
  }),
  disabled: PropTypes2.bool,
  questionId: PropTypes2.string,
  selected: PropTypes2.bool,
  responseType: PropTypes2.string
};

// src/shared/sharedcomponents/ClearSelectionButton.tsx
import { Core as Core3 } from "@everfi/reactifi";
import PropTypes3 from "prop-types";
import React3 from "react";
var ClearSelectionButton = function ClearSelectionButton(props) {
  var selectedAnswer = props.selectedAnswer,
    questionId = props.questionId,
    questionText = props.questionText,
    responseType = props.responseType,
    handleClearSelection = props.handleClearSelection,
    buttonText = props.buttonText,
    ariaLabel = props.ariaLabel;
  var formattedAriaLabel = buttonText ? buttonText : ariaLabel ? ariaLabel : "";
  return /* @__PURE__ */React3.createElement(Core3.Button, {
    variant: "link",
    onClick: function onClick() {
      return handleClearSelection(questionId, responseType);
    },
    isDisabled: !selectedAnswer,
    "aria-label": formattedAriaLabel,
    "aria-describedby": questionText,
    "data-action": "clear-selection",
    leftIcon: /* @__PURE__ */React3.createElement(Core3.Icon, {
      iconName: "circle-xmark",
      prefix: "fas"
    })
  }, buttonText);
};
ClearSelectionButton.propTypes = {
  selectedAnswer: PropTypes3.string,
  questionId: PropTypes3.string.isRequired,
  questionText: PropTypes3.string,
  responseType: PropTypes3.string,
  handleClearSelection: PropTypes3.func.isRequired,
  buttonText: PropTypes3.string.isRequired,
  ariaLabel: PropTypes3.string
};
var ClearSelectionButton_default = ClearSelectionButton;

// src/components/MultipleChoiceAnswers.tsx
import { Core as Core4 } from "@everfi/reactifi";
import { CheckboxGroup, RadioGroup, Stack } from "@chakra-ui/react";
var MultipleChoiceAnswers = function MultipleChoiceAnswers(_ref) {
  var answers = _ref.answers,
    disabled = _ref.disabled,
    dispatch = _ref.dispatch,
    evaluationType = _ref.evaluationType,
    handleClearSelection = _ref.handleClearSelection,
    incorrectAnswers = _ref.incorrectAnswers,
    question = _ref.question,
    questionId = _ref.questionId,
    response = _ref.response,
    responseType = _ref.responseType,
    selectedAnswer = _ref.selectedAnswer,
    showFeedback2 = _ref.showFeedback,
    showAnswersFeedback = _ref.showAnswersFeedback,
    onOptionChange = _ref.onOptionChange;
  var InputGroup = responseType === "single_selection" ? RadioGroup : CheckboxGroup;
  var clearSelection = function clearSelection() {
    setValue(responseType === "single_selection" ? "" : []);
    handleClearSelection();
  };
  var _useState = useState(selectedAnswer),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  return /* @__PURE__ */React4.createElement(React4.Fragment, null, /* @__PURE__ */React4.createElement(InputGroup, {
    onChange: setValue,
    value: value
  }, /* @__PURE__ */React4.createElement(Stack, {
    "data-object-type": "multiple-choice-answers",
    spacing: 0
  }, answers.map(function (answer) {
    var selectedAnswers = Array.isArray(selectedAnswer) ? selectedAnswer.includes(answer.id) : parseInt(selectedAnswer || "") === parseInt(answer.id);
    return /* @__PURE__ */React4.createElement(MultipleChoiceAnswer, {
      key: answer.id,
      answer: answer,
      correct_answers: question == null ? void 0 : question.correct_answers,
      disabled: disabled,
      dispatch: dispatch,
      evaluationType: evaluationType,
      incorrectAnswers: incorrectAnswers,
      questionId: questionId,
      response: response,
      responseType: responseType,
      selected: selectedAnswers,
      showFeedback: showFeedback2 && selectedAnswer === answer.id,
      showAnswersFeedback: showAnswersFeedback,
      onOptionChange: onOptionChange
    });
  }))), /* @__PURE__ */React4.createElement(Core4.Layout, {
    mt: "sm"
  }, /* @__PURE__ */React4.createElement(ClearSelectionButton_default, {
    buttonText: t("Clear Selection"),
    handleClearSelection: clearSelection,
    questionId: questionId,
    questionText: question == null ? void 0 : question.text,
    responseType: responseType,
    selectedAnswer: !disabled ? selectedAnswer : null
  })));
};
var MultipleChoiceAnswers_default = MultipleChoiceAnswers;

// src/components/MultipleResponseAnswers.tsx
import React5, { Component } from "react";
import PropTypes4 from "prop-types";
import { MaterialCheckbox, CheckboxGroupControl } from "@everfi/reactifi";
import { Core as Core5 } from "@everfi/reactifi";
var MultipleResponseAnswers = /*#__PURE__*/function (_Component) {
  function MultipleResponseAnswers(props) {
    var _this3;
    _classCallCheck(this, MultipleResponseAnswers);
    _this3 = _callSuper(this, MultipleResponseAnswers, [props]);
    _this3.handleChange = function (value) {
      _this3.props.dispatch(setAnswerForQuestion(_this3.props.questionId, value, _this3.props.responseType));
    };
    _this3.renderLabel = function (answer) {
      var _a;
      var _this3$props = _this3.props,
        question = _this3$props.question,
        evaluationType = _this3$props.evaluationType;
      var showFeedback2 = !!question.correct_answers && evaluationType === "assessment";
      var isCorrect = (_a = question.correct_answers) == null ? void 0 : _a.includes(answer.id);
      var iconProps = isCorrect ? {
        iconName: "circle-check",
        color: "var(--udl-colors-icon-success)"
      } : {
        iconName: "circle-xmark",
        color: "var(--udl-colors-icon-error)"
      };
      return /* @__PURE__ */React5.createElement(Core5.Layout, {
        variant: "flex",
        gap: "xs"
      }, answer.text, showFeedback2 && /* @__PURE__ */React5.createElement(Core5.Icon, __spreadProps(__spreadValues({}, iconProps), {
        className: ""
      })));
    };
    var selectedAnswer = _this3.props.selectedAnswer;
    if (selectedAnswer) {
      if (!Array.isArray(selectedAnswer)) {
        selectedAnswer = selectedAnswer.split(",");
      } else {
        selectedAnswer = selectedAnswer.map(function (answer) {
          return String(answer);
        });
      }
    }
    _this3.state = {
      selectedAnswers: selectedAnswer
    };
    return _this3;
  }
  _inherits(MultipleResponseAnswers, _Component);
  return _createClass(MultipleResponseAnswers, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */React5.createElement("div", {
        className: "ms-answers answers"
      }, /* @__PURE__ */React5.createElement("span", {
        className: "instruction-text p3"
      }, this.props.multiSelectText), /* @__PURE__ */React5.createElement(CheckboxGroupControl, {
        dataValue: this.state.selectedAnswers,
        valueList: this.props.answers,
        valueKey: "id",
        labelKey: "text",
        name: "answer",
        onChange: this.handleChange,
        selectedClassName: "selected",
        disabled: this.props.disabled,
        labelFunction: this.props.question.correct_answers && this.renderLabel,
        CheckboxComponent: MaterialCheckbox,
        id: this.props.questionId
      }));
    }
  }]);
}(Component);
MultipleResponseAnswers.propTypes = {
  answers: PropTypes4.array.isRequired,
  question: PropTypes4.shape({
    correct_answers: PropTypes4.arrayOf(PropTypes4.string)
  }),
  questionId: PropTypes4.string.isRequired,
  dispatch: PropTypes4.func.isRequired,
  // Note: The below property should be selectedAnswer and not selectedAnswers
  // because the parent sents the information inside selectedAnswer property.
  selectedAnswer: PropTypes4.string,
  responseType: PropTypes4.string,
  multiSelectText: PropTypes4.string,
  disabled: PropTypes4.bool
};
MultipleResponseAnswers.defaultProps = {
  multiSelectText: t("(Select all that apply)")
};

// src/components/TextInputAnswer.tsx
import React7 from "react";
import { FloatingLabelFormField as FloatingLabelFormField2 } from "@everfi/reactifi";

// src/components/BaseAnswer.ts
import React6 from "react";
import PropTypes5 from "prop-types";
var BaseAnswer = /*#__PURE__*/function (_React6$Component) {
  function BaseAnswer(props) {
    var _this4;
    _classCallCheck(this, BaseAnswer);
    _this4 = _callSuper(this, BaseAnswer, [props]);
    _this4.parentHandleChange = function (value) {
      _this4.props.dispatch(setAnswerForQuestion(_this4.props.questionId, value, _this4.props.responseType));
    };
    _this4.state = {
      // @ts-expect-error TS(2339): Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
      value: _this4.props.value,
      isError: false
    };
    return _this4;
  }
  _inherits(BaseAnswer, _React6$Component);
  return _createClass(BaseAnswer);
}(React6.Component);
BaseAnswer.propTypes = {
  questionId: PropTypes5.string.isRequired,
  dispatch: PropTypes5.func.isRequired,
  responseType: PropTypes5.string,
  value: PropTypes5.string
};

// src/components/TextInputAnswer.tsx
var MAX_LENGTH = 1e3;
var TextInputAnswer = /*#__PURE__*/function (_BaseAnswer) {
  function TextInputAnswer() {
    var _this5;
    _classCallCheck(this, TextInputAnswer);
    _this5 = _callSuper(this, TextInputAnswer, arguments);
    _this5.getFieldFormat = function (question) {
      if (!question.answer_format || question.answer_format === "any") {
        return null;
      }
      return question.answer_format;
    };
    _this5.handleChange = function (value) {
      if (value && value.length === MAX_LENGTH) {
        _this5.setState({
          warning: true
        });
      } else {
        _this5.setState({
          warning: false
        });
      }
      _this5.parentHandleChange(value);
    };
    return _this5;
  }
  _inherits(TextInputAnswer, _BaseAnswer);
  return _createClass(TextInputAnswer, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        question = _this$props3.question,
        disabled = _this$props3.disabled;
      var fieldFormat = this.getFieldFormat(question);
      return /* @__PURE__ */React7.createElement("div", {
        className: "text-input-answer answers"
      }, /* @__PURE__ */React7.createElement(FloatingLabelFormField2, {
        onBlur: this.handleChange,
        dataValue: this.state.value,
        as: !fieldFormat ? "textarea" : void 0,
        caption: t("Answer"),
        disabled: disabled,
        maxlength: MAX_LENGTH,
        hintText: this.state.warning && t("1,000 character limit"),
        "aria-label": question.text,
        validationType: fieldFormat
      }));
    }
  }]);
}(BaseAnswer);

// src/components/IntegerAnswer.tsx
import React9 from "react";
import { FloatingLabelFormField as FloatingLabelFormField3 } from "@everfi/reactifi";

// src/components/BaseNumericAnswer.ts
import React8 from "react";
import PropTypes6 from "prop-types";
var BaseNumericAnswer = /*#__PURE__*/function (_React8$Component) {
  function BaseNumericAnswer(props) {
    var _this6;
    _classCallCheck(this, BaseNumericAnswer);
    _this6 = _callSuper(this, BaseNumericAnswer, [props]);
    _this6.parentHandleChange = function (value) {
      if (!isNaN(Number.parseFloat(value))) {
        _this6.props.dispatch(setAnswerForQuestion(_this6.props.questionId, value, _this6.props.responseType));
      } else {
        _this6.props.dispatch(deleteAnswerForQuestion(_this6.props.questionId));
      }
    };
    _this6.state = {
      // @ts-expect-error TS(2339): Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
      value: _this6.props.value,
      isError: false
    };
    return _this6;
  }
  _inherits(BaseNumericAnswer, _React8$Component);
  return _createClass(BaseNumericAnswer);
}(React8.Component);
BaseNumericAnswer.propTypes = {
  questionId: PropTypes6.string.isRequired,
  dispatch: PropTypes6.func.isRequired,
  responseType: PropTypes6.string,
  value: PropTypes6.string
};

// src/components/IntegerAnswer.tsx
var IntegerAnswer = /*#__PURE__*/function (_BaseNumericAnswer) {
  function IntegerAnswer() {
    var _this7;
    _classCallCheck(this, IntegerAnswer);
    _this7 = _callSuper(this, IntegerAnswer, arguments);
    _this7.handleChange = function (value) {
      if (_this7.props.onlyPositive && value < 0) {
        value = 0;
      }
      _this7.setState({
        value: value
      }, function () {
        return _this7.parentHandleChange(value);
      });
    };
    return _this7;
  }
  _inherits(IntegerAnswer, _BaseNumericAnswer);
  return _createClass(IntegerAnswer, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */React9.createElement("div", {
        className: "integer-answer row"
      }, /* @__PURE__ */React9.createElement("div", {
        className: "col-6"
      }, /* @__PURE__ */React9.createElement(FloatingLabelFormField3, {
        onBlur: this.handleChange,
        dataValue: this.state.value,
        type: "number",
        caption: t("Answer (Must be a number)"),
        disabled: this.props.disabled,
        className: "integer-flff",
        min: this.props.onlyPositive ? 0 : false,
        valueOverride: true
      })));
    }
  }]);
}(BaseNumericAnswer);

// src/components/DecimalAnswer.tsx
import React10 from "react";
import PropTypes7 from "prop-types";
import { FloatingLabelFormField as FloatingLabelFormField4 } from "@everfi/reactifi";
var DecimalAnswer = /*#__PURE__*/function (_BaseAnswer2) {
  function DecimalAnswer() {
    _classCallCheck(this, DecimalAnswer);
    return _callSuper(this, DecimalAnswer, arguments);
  }
  _inherits(DecimalAnswer, _BaseAnswer2);
  return _createClass(DecimalAnswer, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */React10.createElement("div", {
        className: "decimal-answer row"
      }, /* @__PURE__ */React10.createElement("div", {
        className: "col-6"
      }, /* @__PURE__ */React10.createElement(FloatingLabelFormField4, {
        onBlur: this.parentHandleChange,
        dataValue: this.state.value,
        type: "number",
        step: this.props.decimalPlace,
        caption: t("Answer"),
        hintText: t("Must be a decimal"),
        disabled: this.props.disabled
      })));
    }
  }]);
}(BaseAnswer);
DecimalAnswer.propTypes = {
  decimalPlace: PropTypes7.number
};
DecimalAnswer.defaultProps = {
  decimalPlace: 0.01
};

// src/components/LikertAnswers.tsx
import React12 from "react";
import PropTypes8 from "prop-types";

// src/components/LikertAnswer.tsx
import React11 from "react";
import Form from "react-bootstrap/Form";
var LikertAnswer = /*#__PURE__*/function (_BaseMultipleAnswer2) {
  function LikertAnswer() {
    _classCallCheck(this, LikertAnswer);
    return _callSuper(this, LikertAnswer, arguments);
  }
  _inherits(LikertAnswer, _BaseMultipleAnswer2);
  return _createClass(LikertAnswer, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */React11.createElement("div", {
        className: "likert-answer"
      }, /* @__PURE__ */React11.createElement(Form.Check, {
        type: "radio",
        className: this.props.selected ? "selected" : "",
        "aria-label": this.props.answer.text,
        "aria-describedby": this.props.questionId
      }, /* @__PURE__ */React11.createElement(Form.Check.Label, null, /* @__PURE__ */React11.createElement(Form.Check.Input, {
        type: "radio",
        name: this.props.questionId,
        value: this.props.answer.id,
        checked: this.props.selected,
        onChange: this.handleChange,
        disabled: this.props.disabled
      }), /* @__PURE__ */React11.createElement("i", {
        className: "input-helper"
      }))), /* @__PURE__ */React11.createElement("div", {
        className: "likert-answer-label"
      }, this.props.answer.text));
    }
  }]);
}(BaseMultipleAnswer);

// src/components/LikertAnswers.tsx
var LikertAnswers = function LikertAnswers(_ref2) {
  var answers = _ref2.answers,
    questionId = _ref2.questionId,
    dispatch = _ref2.dispatch,
    selectedAnswer = _ref2.selectedAnswer,
    responseType = _ref2.responseType,
    disabled = _ref2.disabled,
    handleClearSelection = _ref2.handleClearSelection;
  return /* @__PURE__ */React12.createElement("div", null, /* @__PURE__ */React12.createElement("div", {
    className: "likert-answers-container"
  }, /* @__PURE__ */React12.createElement("div", {
    className: "likert-answers answers"
  }, answers.map(function (answer) {
    return /* @__PURE__ */React12.createElement(LikertAnswer, {
      answer: answer,
      key: answer.id,
      questionId: questionId,
      selected: selectedAnswer === answer.id,
      dispatch: dispatch,
      responseType: responseType,
      disabled: disabled
    });
  })), /* @__PURE__ */React12.createElement("div", {
    className: "likert-clear"
  }, /* @__PURE__ */React12.createElement(ClearSelectionButton_default, {
    selectedAnswer: selectedAnswer,
    questionId: questionId,
    responseType: responseType,
    handleClearSelection: handleClearSelection,
    buttonText: "Clear"
  }))));
};
LikertAnswers.propTypes = {
  answers: PropTypes8.array.isRequired,
  questionId: PropTypes8.string.isRequired,
  dispatch: PropTypes8.func.isRequired,
  selectedAnswer: PropTypes8.string,
  responseType: PropTypes8.string,
  disabled: PropTypes8.bool,
  handleClearSelection: PropTypes8.func
};
var LikertAnswers_default = LikertAnswers;

// src/components/CalendarAnswer.tsx
import React13 from "react";
import PropTypes9 from "prop-types";
import { FloatingLabelFormField as FloatingLabelFormField5 } from "@everfi/reactifi";

// src/shared/sharedfunctions/calendar.ts
import { addDays, subDays } from "date-fns";
var getCalendarDates = function getCalendarDates(calendarDuration) {
  var answers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var today = /* @__PURE__ */new Date();
  var pastAnswers = Object.keys(answers);
  if (pastAnswers.length) {
    var startDate = pastAnswers[pastAnswers.length - 1].replace(/[_]/g, "-");
    today = addDays(new Date(startDate), 1);
  }
  var dates = [];
  for (var i = 1; i < calendarDuration + 1; i++) {
    dates.unshift(subDays(today, i));
  }
  var firstDay;
  while ((firstDay = dates[0]).getDay() !== 0) {
    var previousDate = subDays(new Date(firstDay), 1);
    previousDate.disabled = true;
    dates.unshift(previousDate);
  }
  var lastDay;
  while ((lastDay = dates[dates.length - 1]).getDay() !== 6) {
    var nextDate = addDays(new Date(lastDay), 1);
    nextDate.disabled = true;
    dates.push(nextDate);
  }
  return dates;
};

// src/components/CalendarAnswer.tsx
import { format } from "date-fns";
var CalendarAnswer = /*#__PURE__*/function (_BaseAnswer3) {
  function CalendarAnswer() {
    var _this8;
    _classCallCheck(this, CalendarAnswer);
    _this8 = _callSuper(this, CalendarAnswer, arguments);
    _this8.handleChange = function (value, date, dates) {
      return __async(_this8, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var formattedDate, allValues;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              formattedDate = format(new Date(date), "yyyy_mm_dd");
              allValues = __spreadValues({}, this.state.value);
              dates.map(function (date2) {
                if (allValues[format(new Date(date2), "yyyy_mm_dd")] !== 0 && !allValues[format(new Date(date2), "yyyy_mm_dd")] && !date2.disabled) {
                  allValues[format(new Date(date2), "yyyy_mm_dd")] = null;
                }
              });
              if (allValues[formattedDate] && value === "") {
                allValues[formattedDate] = null;
              } else if (allValues[formattedDate] && value !== "") {
                allValues[formattedDate] = parseInt(value, 10);
              } else {
                allValues[formattedDate] = parseInt(value, 10);
              }
              if (Object.values(allValues).some(function (val) {
                return val < 0;
              })) {
                this.setState({
                  isError: true
                });
              } else {
                this.setState({
                  isError: false
                });
              }
              this.setState({
                value: allValues
              });
              this.parentHandleChange(allValues);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    };
    _this8.renderDates = function () {
      var dates = getCalendarDates(_this8.props.calendarDuration, _this8.state.value);
      return dates.map(function (date) {
        var formattedDate = format(new Date(date), "MMM dd (E)");
        var dateValue = format(new Date(date), "yyyy_mm_dd");
        var caption = t("Number of Drinks");
        return (
          // @ts-expect-error TS(2339): Property 'disabled' does not exist on type 'Date'.
          /* @__PURE__ */
          React13.createElement("div", {
            className: "calendar-date branded-calendar-date ".concat(date.disabled ? "disabled" : ""),
            key: formattedDate
          }, /* @__PURE__ */React13.createElement("div", {
            className: "".concat(date.disabled ? "disabled" : "", " date-header branded-date-header"),
            "aria-hidden": "true"
          }, formattedDate), !date.disabled && /* @__PURE__ */React13.createElement(FloatingLabelFormField5, {
            disabled: date.disabled || _this8.props.disabled,
            dataValue: _this8.state.value[dateValue],
            className: "calendar-flff",
            type: "number",
            min: "0",
            max: "1000",
            "aria-label": "".concat(formattedDate, " ").concat(caption),
            hideControlLabelAria: true,
            caption: caption,
            onChange: function onChange(value) {
              return _this8.handleChange(value, date, dates);
            }
          }))
        );
      });
    };
    return _this8;
  }
  _inherits(CalendarAnswer, _BaseAnswer3);
  return _createClass(CalendarAnswer, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */React13.createElement("div", {
        className: "calendar-answer answers"
      }, this.state.isError && /* @__PURE__ */React13.createElement("div", {
        className: "error"
      }, " ", t("Value must be greater than or equal to 0")), /* @__PURE__ */React13.createElement("div", {
        className: "row calendar-dates"
      }, this.renderDates()));
    }
  }]);
}(BaseAnswer);
CalendarAnswer.propTypes = __spreadProps(__spreadValues({}, BaseAnswer.propTypes), {
  calendarDuration: PropTypes9.number,
  value: PropTypes9.object,
  disabled: PropTypes9.bool
});
CalendarAnswer.defaultProps = {
  value: {}
};

// src/components/MatrixAnswers.tsx
import React15, { Component as Component2 } from "react";
import PropTypes10 from "prop-types";

// src/components/MatrixAnswer.tsx
import React14 from "react";
import { Util as Util2 } from "@everfi/reactifi";
import { Form as Form2 } from "react-bootstrap";
var MatrixAnswer = /*#__PURE__*/function (_BaseMultipleAnswer3) {
  function MatrixAnswer() {
    _classCallCheck(this, MatrixAnswer);
    return _callSuper(this, MatrixAnswer, arguments);
  }
  _inherits(MatrixAnswer, _BaseMultipleAnswer3);
  return _createClass(MatrixAnswer, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        answer = _this$props4.answer,
        disabled = _this$props4.disabled,
        selected = _this$props4.selected,
        questionId = _this$props4.questionId;
      var answerStatus = this.correctAnswer();
      var radioClasses = Util2.formatClassName([this.getAnswerClass(answerStatus), "matrix-input", "p-l-0"]);
      return /* @__PURE__ */React14.createElement("div", {
        className: "matrix-answer"
      }, this.renderFeedbackIcon(answerStatus), /* @__PURE__ */React14.createElement(Form2.Check, {
        type: "radio",
        className: radioClasses,
        disabled: disabled,
        id: "".concat(questionId, "-").concat(answer.id),
        key: questionId,
        "aria-label": answer.text,
        "aria-describedby": questionId
      }, /* @__PURE__ */React14.createElement(Form2.Check.Label, null, /* @__PURE__ */React14.createElement(Form2.Check.Input, {
        type: "radio",
        name: questionId,
        value: answer.id,
        onChange: this.handleChange,
        checked: selected
      }), /* @__PURE__ */React14.createElement("span", null, answer.text), /* @__PURE__ */React14.createElement("i", {
        className: "input-helper"
      }))));
    }
  }]);
}(BaseMultipleAnswer);

// src/components/MatrixAnswers.tsx
import { Button } from "@everfi/reactifi";
var MatrixAnswers = /*#__PURE__*/function (_Component2) {
  function MatrixAnswers() {
    var _this9;
    _classCallCheck(this, MatrixAnswers);
    _this9 = _callSuper(this, MatrixAnswers, arguments);
    _this9.renderRows = function () {
      var _this9$props = _this9.props,
        childQuestions = _this9$props.childQuestions,
        disabled = _this9$props.disabled,
        handleClearSelection = _this9$props.handleClearSelection,
        responses = _this9$props.responses,
        responseType = _this9$props.responseType;
      return childQuestions.map(function (row) {
        var selectedAnswer = responses.find(function (rs) {
          return parseInt(rs.questionId, 10) === parseInt(row.id, 10);
        });
        return /* @__PURE__ */React15.createElement("fieldset", {
          key: row.id,
          className: "row"
        }, /* @__PURE__ */React15.createElement("legend", {
          className: "sr-only"
        }, row.text), /* @__PURE__ */React15.createElement("div", {
          "aria-hidden": "true",
          className: "col-12 p-l-0"
        }, /* @__PURE__ */React15.createElement("h4", null, row.text)), /* @__PURE__ */React15.createElement("div", {
          className: "row m-b-10"
        }, /* @__PURE__ */React15.createElement("div", {
          className: "matrix-row-wrapper col-12 col-md-10 p-t-10"
        }, /* @__PURE__ */React15.createElement("div", {
          className: "matrix-row-buttons"
        }, row.answers.map(function (answer) {
          return /* @__PURE__ */React15.createElement(MatrixAnswer, {
            answer: answer,
            key: answer.id,
            questionId: row.id,
            selected: responses.find(function (rs) {
              return parseInt(rs.answerValue, 10) === parseInt(answer.id, 10) && rs.questionId === row.id;
            }),
            dispatch: _this9.props.dispatch,
            responseType: responseType,
            disabled: disabled
          });
        }))), /* @__PURE__ */React15.createElement("div", {
          className: "matrix-answers-clear col-12 col-md-2 p-t-10"
        }, (selectedAnswer == null ? void 0 : selectedAnswer.answerValue) && /* @__PURE__ */React15.createElement(Button, {
          label: t("Clear"),
          style: "link",
          className: "clear-selection",
          onClick: function onClick() {
            return handleClearSelection(row.id, responseType);
          },
          "data-action": "clear-selection",
          tabIndex: 0,
          icon: "xmark",
          "aria-label": t("Clear")
        }))));
      });
    };
    return _this9;
  }
  _inherits(MatrixAnswers, _Component2);
  return _createClass(MatrixAnswers, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */React15.createElement("div", {
        className: "matrix-question-display"
      }, /* @__PURE__ */React15.createElement("div", {
        className: "matrix-rows-container"
      }, this.props.childQuestions && this.renderRows()));
    }
  }]);
}(Component2);
MatrixAnswers.propTypes = {
  answers: PropTypes10.array,
  dispatch: PropTypes10.func,
  responseType: PropTypes10.string,
  disabled: PropTypes10.bool,
  handleClearSelection: PropTypes10.func,
  childQuestions: PropTypes10.array,
  responses: PropTypes10.array
};

// src/components/DropdownAnswer.tsx
import React16 from "react";
import { FieldGroup as FieldGroup2, FloatingLabelFormField as FloatingLabelFormField6, SelectControl } from "@everfi/reactifi";
var DropdownAnswer = /*#__PURE__*/function (_BaseMultipleAnswer4) {
  function DropdownAnswer() {
    _classCallCheck(this, DropdownAnswer);
    return _callSuper(this, DropdownAnswer, arguments);
  }
  _inherits(DropdownAnswer, _BaseMultipleAnswer4);
  return _createClass(DropdownAnswer, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */React16.createElement("div", {
        className: "dropdown-answer answers"
      }, /* @__PURE__ */React16.createElement(FieldGroup2, {
        className: "row"
      }, /* @__PURE__ */React16.createElement(FieldGroup2, {
        className: "col-6"
      }, /* @__PURE__ */React16.createElement(FloatingLabelFormField6, {
        caption: t("Select an answer"),
        dataValue: this.props.answer ? this.props.answer.id : null,
        disabled: this.props.disabled,
        name: "answers",
        onChange: this.handleSelectChange,
        required: this.props.required
      }, /* @__PURE__ */React16.createElement(SelectControl, {
        options: this.props.answers,
        valueKey: "id",
        labelKey: "text"
      })))));
    }
  }]);
}(BaseMultipleAnswer);

// src/components/Question.tsx
import { FormControl, FormLabel } from "@chakra-ui/react";
var componentTypes = {
  multiple_choice: MultipleChoiceAnswers_default,
  multiple_response: MultipleResponseAnswers,
  free_text: TextInputAnswer,
  integer: IntegerAnswer,
  decimal: DecimalAnswer,
  likert: LikertAnswers_default,
  calendar: CalendarAnswer,
  matrix: MatrixAnswers,
  drop_down: DropdownAnswer
};
var Question = /*#__PURE__*/function (_Component3) {
  function Question(props) {
    var _this10;
    _classCallCheck(this, Question);
    _this10 = _callSuper(this, Question, [props]);
    _this10.onChangeHandlerForAnswer = function (value) {
      return _this10.setState({
        answerValue: value
      });
    };
    _this10.renderFeedback = function () {
      var _this10$props = _this10.props,
        showFeedback2 = _this10$props.showFeedback,
        question = _this10$props.question;
      var selectedAnswer = _this10.getSelectedAnswer();
      var selectedAnswerFeedback, selectedAnswerIndex;
      question.answers.map(function (answer, index) {
        if (answer.id === selectedAnswer) {
          selectedAnswerFeedback = answer.feedback;
          selectedAnswerIndex = index;
        }
      });
      if (!showFeedback2 || !selectedAnswerFeedback) {
        return null;
      }
      var isCorrect = !_this10.props.incorrectAnswers.some(function (x) {
        return x.question_id == question.id;
      });
      if (_this10.props.onFeedback) {
        _this10.props.onFeedback({
          //@ts-ignore
          questionIndex: _this10.props.questionIndex,
          answerIndex: selectedAnswerIndex,
          isCorrect: isCorrect
        });
      }
      return /* @__PURE__ */React17.createElement(Core6.Layout, {
        py: "sm",
        w: "full"
      }, /* @__PURE__ */React17.createElement(Core6.Callout, {
        variant: isCorrect ? "success" : "error",
        title: "",
        description: selectedAnswerFeedback
      }));
    };
    _this10.getSelectedAnswer = function () {
      var response = _this10.props.response;
      return response && response.answerValue;
    };
    _this10.getAnswerLabels = function () {
      var question = _this10.props.question;
      if (question.display_type === "matrix") return null;
      var rtn = t("The response options are: ");
      var answerRange = "";
      question.answers.map(function (answer, index) {
        return answerRange = answerRange + answer.position + "\u2014" + answer.text + (index < question.answers.length - 1 ? " | " : "");
      });
      return /* @__PURE__ */React17.createElement("div", {
        className: "matrix-answer-label-array"
      }, rtn + answerRange);
    };
    _this10.renderRichText = function (value, className) {
      if (!value) {
        return null;
      }
      return /* @__PURE__ */React17.createElement("div", {
        className: className,
        dangerouslySetInnerHTML: {
          __html: value
        }
      });
    };
    _this10.renderAnswerComponent = function () {
      var _this10$props2 = _this10.props,
        showFeedback2 = _this10$props2.showFeedback,
        showAnswersFeedback = _this10$props2.showAnswersFeedback,
        disableControls2 = _this10$props2.disableControls,
        onClickClearSelection = _this10$props2.onClickClearSelection,
        _this10$props2$questi = _this10$props2.question,
        id = _this10$props2$questi.id,
        answers = _this10$props2$questi.answers,
        response_type = _this10$props2$questi.response_type,
        calendar_duration_days = _this10$props2$questi.calendar_duration_days,
        only_positive = _this10$props2$questi.only_positive,
        matrix_child_questions = _this10$props2$questi.matrix_child_questions;
      var AnswersComponent = componentTypes[_this10.props.question.display_type];
      var selectedAnswer = _this10.getSelectedAnswer();
      return /* @__PURE__ */React17.createElement(React17.Fragment, null, _this10.renderFeedback(), /* @__PURE__ */React17.createElement(AnswersComponent, __spreadProps(__spreadValues({}, _this10.props), {
        onChangeValue: _this10.onChangeHandlerForAnswer,
        value: selectedAnswer,
        answers: answers,
        questionId: id,
        responseType: response_type,
        selectedAnswer: selectedAnswer,
        calendarDuration: calendar_duration_days,
        onlyPositive: only_positive,
        childQuestions: matrix_child_questions,
        disabled: showFeedback2 || disableControls2,
        handleClearSelection: onClickClearSelection,
        showAnswersFeedback: showAnswersFeedback
      })));
    };
    _this10.state = {
      answerValue: ""
    };
    return _this10;
  }
  _inherits(Question, _Component3);
  return _createClass(Question, [{
    key: "render",
    value: function render() {
      var _this$props$question = this.props.question,
        id = _this$props$question.id,
        display_type = _this$props$question.display_type,
        text = _this$props$question.text,
        detail_text_rendered = _this$props$question.detail_text_rendered,
        after_text_rendered = _this$props$question.after_text_rendered;
      var isQuestionGroup = ["likert", "matrix"].includes(display_type);
      var ariaHideLegend = ["free_text"].includes(display_type);
      var isMatrix = display_type === "matrix";
      return /* @__PURE__ */React17.createElement(Core6.Layout, {
        variant: "container"
      }, isQuestionGroup ? /* @__PURE__ */React17.createElement(Core6.Layout, null, /* @__PURE__ */React17.createElement(Core6.Typography, {
        as: "h3",
        textStyle: "ui-default"
      }, text), this.renderRichText(detail_text_rendered, "m-b-25"), isMatrix && this.getAnswerLabels(), this.renderAnswerComponent(), this.renderRichText(after_text_rendered, "m-t-25")) : /* @__PURE__ */React17.createElement(FormControl, {
        as: "fieldset"
      }, /* @__PURE__ */React17.createElement(FormLabel, {
        as: "legend",
        id: id,
        "aria-hidden": ariaHideLegend
      }, /* @__PURE__ */React17.createElement(Core6.Typography, {
        textStyle: "p1",
        id: id,
        "aria-hidden": ariaHideLegend
      }, text)), this.renderRichText(detail_text_rendered, "m-b-25"), this.renderAnswerComponent(), this.renderRichText(after_text_rendered, "m-t-25")));
    }
  }]);
}(Component3);
Question.propTypes = {
  disableControls: PropTypes11.bool,
  dispatch: PropTypes11.func.isRequired,
  evaluationType: PropTypes11.string,
  incorrectAnswers: PropTypes11.array,
  onClickClearSelection: PropTypes11.func,
  onFeedback: PropTypes11.func,
  question: PropTypes11.shape({
    id: PropTypes11.string.isRequired,
    text: PropTypes11.string.isRequired,
    feedback: PropTypes11.string,
    answers: PropTypes11.array,
    display_type: PropTypes11.string,
    detail_text_rendered: PropTypes11.string,
    after_text_rendered: PropTypes11.string,
    response_type: PropTypes11.string,
    calendar_duration_days: PropTypes11.number,
    matrix_child_questions: PropTypes11.array,
    only_positive: PropTypes11.bool
  }),
  questionIndex: PropTypes11.number,
  response: PropTypes11.shape({
    questionId: PropTypes11.string.isRequired,
    answerValue: PropTypes11.oneOfType([PropTypes11.string, PropTypes11.number]).isRequired,
    responseType: PropTypes11.string.isRequired,
    feedback: PropTypes11.string,
    answerCorrect: PropTypes11.bool
  }),
  responses: PropTypes11.array,
  showFeedback: PropTypes11.bool,
  showAnswersFeedback: PropTypes11.bool
};

// src/components/Section.tsx
import { Button as Button2, MaterialCheckbox as MaterialCheckbox2 } from "@everfi/reactifi";
var Section = function Section(_ref3) {
  var disableControls2 = _ref3.disableControls,
    dispatch = _ref3.dispatch,
    evaluationType = _ref3.evaluationType,
    onClickClearSelection = _ref3.onClickClearSelection,
    questionDisplayMode = _ref3.questionDisplayMode,
    responseSet = _ref3.responseSet,
    section = _ref3.section,
    showFeedback2 = _ref3.showFeedback,
    onFeedback = _ref3.onFeedback,
    onOptionChange = _ref3.onOptionChange,
    _ref3$hideHeader = _ref3.hideHeader,
    hideHeader = _ref3$hideHeader === void 0 ? false : _ref3$hideHeader,
    _ref3$hideQuestionCon = _ref3.hideQuestionControls,
    hideQuestionControls = _ref3$hideQuestionCon === void 0 ? false : _ref3$hideQuestionCon,
    isPreview = _ref3.isPreview;
  var _useState3 = useState2(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentIndex = _useState4[0],
    setCurrentIndex = _useState4[1];
  var _useState5 = useState2(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showAnswersFeedback = _useState6[0],
    setShowAnswersFeedback = _useState6[1];
  var nextQuestion = function nextQuestion() {
    if (currentIndex < section.questions.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };
  var prevQuestion = function prevQuestion() {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  useEffect(function () {
    setCurrentIndex(0);
  }, [questionDisplayMode, section == null ? void 0 : section.id]);
  var renderQuestionPaging = function renderQuestionPaging() {
    return /* @__PURE__ */React18.createElement("div", {
      className: "paging"
    }, t("Question {{currentQuestion}} of {{totalQuestions}}", {
      currentQuestion: currentIndex + 1,
      totalQuestions: section.questions.length
    }));
  };
  var activeQuestions = section.questions.filter(function (question) {
    return question.active;
  });
  return /* @__PURE__ */React18.createElement("div", {
    className: "section-container"
  }, /* @__PURE__ */React18.createElement("div", {
    className: "section"
  }, !hideHeader && /* @__PURE__ */React18.createElement(React18.Fragment, null, /* @__PURE__ */React18.createElement("h2", {
    className: "section-title subtitle"
  }, section.title), /* @__PURE__ */React18.createElement("p", {
    className: "section-description"
  }, section.description)), /* @__PURE__ */React18.createElement("div", {
    className: "sr-only",
    "aria-label": t("To deselect an answer, use the Clear Selection option after the last answer choice for each question")
  }), isPreview && /* @__PURE__ */React18.createElement("div", {
    className: "show-feedback-container"
  }, /* @__PURE__ */React18.createElement(MaterialCheckbox2, {
    "data-attribute": "toggle-answer-feedback",
    onChange: function onChange() {
      return setShowAnswersFeedback(!showAnswersFeedback);
    }
  }, t("Show Answer Feedback"))), questionDisplayMode === "one_at_a_time" ? /* @__PURE__ */React18.createElement(React18.Fragment, null, /* @__PURE__ */React18.createElement("div", {
    className: "questions-wrapper"
  }, /* @__PURE__ */React18.createElement("div", {
    className: "questions",
    style: {
      transform: "translateX(-".concat(currentIndex * 100, "%)")
    }
  }, activeQuestions.map(function (question, index) {
    return /* @__PURE__ */React18.createElement("div", {
      className: "question ".concat(currentIndex === index ? "active" : ""),
      key: question.id
    }, /* @__PURE__ */React18.createElement(Question, {
      question: question,
      questionIndex: index,
      response: responseSet.responses.find(function (rs) {
        return rs.questionId === question.id;
      }),
      responses: responseSet.responses,
      evaluationType: evaluationType,
      showFeedback: showFeedback2,
      showAnswersFeedback: showAnswersFeedback,
      onFeedback: onFeedback,
      onOptionChange: onOptionChange,
      incorrectAnswers: responseSet.incorrect_answers && responseSet.incorrect_answers.filter(function (incorrectAnswer) {
        return incorrectAnswer.question_id.toString() === question.id;
      }),
      dispatch: dispatch,
      onClickClearSelection: onClickClearSelection,
      disableControls: disableControls2
    }));
  })), !hideQuestionControls && /* @__PURE__ */React18.createElement("div", {
    className: "question-controls"
  }, /* @__PURE__ */React18.createElement(Button2, {
    onClick: prevQuestion,
    disabled: currentIndex === 0,
    "data-action": "prev-question",
    label: t("Prev"),
    style: "secondary"
  }), /* @__PURE__ */React18.createElement("div", {
    className: "question-page"
  }, renderQuestionPaging()), /* @__PURE__ */React18.createElement(Button2, {
    disabled: currentIndex === activeQuestions.length - 1,
    onClick: nextQuestion,
    "data-action": "next-question",
    label: t("Next"),
    style: "secondary"
  })))) : /* @__PURE__ */React18.createElement("div", {
    className: "questions"
  }, activeQuestions.map(function (question, index) {
    return /* @__PURE__ */React18.createElement(Question, {
      question: question,
      questionIndex: index,
      key: question.id,
      response: responseSet.responses.find(function (rs) {
        return rs.questionId === question.id;
      }),
      responses: responseSet.responses,
      evaluationType: evaluationType,
      showFeedback: showFeedback2,
      showAnswersFeedback: showAnswersFeedback,
      incorrectAnswers: responseSet.incorrect_answers && responseSet.incorrect_answers.filter(function (incorrectAnswer) {
        return incorrectAnswer.question_id.toString() === question.id;
      }),
      dispatch: dispatch,
      onClickClearSelection: onClickClearSelection,
      disableControls: disableControls2
    });
  }))));
};
Section.propTypes = {
  disableControls: PropTypes12.bool,
  dispatch: PropTypes12.func.isRequired,
  evaluationType: PropTypes12.string,
  onClickClearSelection: PropTypes12.func,
  questionDisplayMode: PropTypes12.string,
  responseSet: PropTypes12.object.isRequired,
  section: PropTypes12.shape({
    title: PropTypes12.string.isRequired,
    description: PropTypes12.string,
    questions: PropTypes12.array.isRequired
  }),
  showFeedback: PropTypes12.bool,
  isPreview: PropTypes12.bool
};
var Section_default = Section;

// src/components/SectionNavigation.tsx
import PropTypes13 from "prop-types";
import React19, { Component as Component4 } from "react";
import Button3 from "react-bootstrap/Button";
import { FAIcon, Core as Core7 } from "@everfi/reactifi";
var SectionNavigation = /*#__PURE__*/function (_Component4) {
  function SectionNavigation() {
    var _this11;
    _classCallCheck(this, SectionNavigation);
    _this11 = _callSuper(this, SectionNavigation, arguments);
    _this11.focusOnMain = function () {
      var mainContent = document.getElementById("content-focus");
      if (mainContent) {
        mainContent.focus();
      }
    };
    _this11.finishPage = function () {
      return __async(_this11, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.props.finishPage();
            case 2:
              if (!this.props.disableControls) {
                if (this.props.containerSelector) {
                  document.querySelector(".".concat(this.props.containerSelector)).scrollTo(0, 0);
                } else {
                  window.scrollTo(0, 0);
                }
                this.focusOnMain();
              }
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    };
    _this11.changePage = function (change) {
      var newPage = _this11.props.currentPage + change;
      _this11.props.changePage(newPage);
      if (_this11.props.containerSelector) {
        document.querySelector(".".concat(_this11.props.containerSelector)).scrollTo(0, 0);
      } else {
        window.scrollTo(0, 0);
      }
      _this11.focusOnMain();
    };
    _this11.goToPreviousPage = function () {
      var previousSectionId = _this11.props.previousSectionId;
      if (previousSectionId) {
        var lastSection = _this11.props.sections.find(function (section) {
          return String(section.id) === String(previousSectionId);
        });
        _this11.props.changePage(lastSection.position - 1);
        _this11.props.changePreviousSection(null);
      } else {
        _this11.changePage(-1);
      }
    };
    _this11.renderPaging = function () {
      return /* @__PURE__ */React19.createElement("div", {
        className: "paging"
      }, t("Page {{currentPage}} of {{totalPages}}", {
        // @ts-expect-error TS(2339): Property 'currentPage' does not exist on type 'Rea... Remove this comment to see the full error message
        currentPage: _this11.props.currentPage + 1,
        // @ts-expect-error TS(2339): Property 'numberOfPages' does not exist on type 'R... Remove this comment to see the full error message
        totalPages: _this11.props.numberOfPages
      }));
    };
    _this11.renderPreviousButton = function () {
      if (_this11.props.currentPage === 0 || !_this11.props.allowChangingAnswers) {
        return /* @__PURE__ */React19.createElement("div", {
          className: "btn-spacer"
        });
      }
      var disabled = _this11.props.currentPage === 0 || _this11.props.disableControls;
      return /* @__PURE__ */React19.createElement(Core7.Button, {
        onClick: _this11.goToPreviousPage,
        isDisabled: disabled,
        variant: "secondary",
        "aria-label": t("Previous Page")
      }, /* @__PURE__ */React19.createElement(Core7.Icon, {
        iconName: "angle-left"
      }), " ", t("Previous"));
    };
    _this11.renderNextButton = function () {
      if (!_this11.props.showFeedback) {
        return _this11.renderSubmitButton();
      }
      if (_this11.props.hideNavigation) {
        return null;
      }
      if (_this11.props.currentPage === _this11.props.numberOfPages - 1) {
        return _this11.renderFinishButton();
      }
      return _this11.renderNextPageButton();
    };
    _this11.renderSubmitButton = function () {
      var disabled = !_this11.props.sectionComplete || _this11.props.disableControls;
      return /* @__PURE__ */React19.createElement(Core7.Button, {
        variant: "primary",
        "data-action-target": "assessment-btn-submit",
        onClick: function onClick() {
          return _this11.finishPage();
        },
        isDisabled: disabled,
        className: "branded",
        "data-action": "submit"
      }, _this11.props.disableControls && /* @__PURE__ */React19.createElement(Core7.Icon, {
        iconName: "spinner",
        spin: true
      }), t("Submit Answer(s)"));
    };
    _this11.renderNextPageButton = function () {
      var disabled = _this11.props.disableControls;
      return /* @__PURE__ */React19.createElement(Core7.Button, {
        onClick: _this11.props.finishFeedback,
        variant: "secondary",
        "aria-label": t("Next Page"),
        isDisabled: disabled
      }, t("Next"), " ", /* @__PURE__ */React19.createElement(FAIcon, {
        icon: "angle-right"
      }));
    };
    // @ts-expect-error TS(7030): Not all code paths return a value.
    _this11.renderFinishButton = function () {
      var disabled = _this11.props.disableControls;
      if (_this11.props.finishMethod) {
        return /* @__PURE__ */React19.createElement(Button3, {
          className: "evaluation-nav-button finish-button btn-primary-branded",
          onClick: _this11.props.finishMethod,
          disabled: disabled
        }, t("Finish"));
      }
    };
    return _this11;
  }
  _inherits(SectionNavigation, _Component4);
  return _createClass(SectionNavigation, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */React19.createElement("div", {
        className: "btn-toolbar"
      }, !this.props.hideNavigation && /* @__PURE__ */React19.createElement(React19.Fragment, null, this.renderPreviousButton(), this.renderPaging()), this.renderNextButton());
    }
  }]);
}(Component4);
SectionNavigation.propTypes = {
  allowChangingAnswers: PropTypes13.bool,
  changePage: PropTypes13.func.isRequired,
  changePreviousSection: PropTypes13.func,
  containerSelector: PropTypes13.string,
  currentPage: PropTypes13.number.isRequired,
  disableControls: PropTypes13.bool,
  finishFeedback: PropTypes13.func,
  finishMethod: PropTypes13.func,
  finishPage: PropTypes13.func.isRequired,
  numberOfPages: PropTypes13.number.isRequired,
  previousSectionId: PropTypes13.string,
  sectionComplete: PropTypes13.bool,
  sections: PropTypes13.arrayOf(PropTypes13.shape({
    id: PropTypes13.string,
    position: PropTypes13.number
  })),
  showFeedback: PropTypes13.bool,
  hideNavigation: PropTypes13.bool
};

// src/components/EvaluationIntro.tsx
import React21, { Component as Component5 } from "react";
import PropTypes14 from "prop-types";
import Button4 from "react-bootstrap/Button";

// src/styles/IntroStyles.tsx
import React20 from "react";
import { Style } from "react-style-tag";
var IntroStyles = function IntroStyles() {
  return /* @__PURE__ */React20.createElement(Style, null, "\n    .evaluation.foundry {\n      position: absolute;\n      width: 100%;\n      min-height: calc(100% - 80px);\n      padding: 40px 0;\n    }\n\n    .evaluation.foundry .section.intro-section {\n      width: 600px;\n      height: 100%;\n      margin-top: 0;\n    }\n\n    .evaluation.foundry .section.intro-section .intro-title {\n      color: #EF4923;\n      font-weight: 500;\n      margin: 0;\n      padding: 0;\n    }\n\n    .evaluation.foundry .description-text {\n      margin: 24px 0 32px 0;\n      // font-size: 16px;\n      // line-height: 1.5;\n    }\n\n    .evaluation.foundry .intro-text {\n      margin: 24px 0;\n      // font-size: 16px;\n      // line-height: 1.5;\n    }\n\n    .evaluation.foundry .intro-text > p {\n      margin-bottom: 32px;\n    }\n\n    .evaluation.foundry .intro-button-container {\n      margin: 36px 0;\n      text-align: center;\n    }\n\n    .evaluation.foundry .intro-button {\n      margin: 0;\n    }\n\n    @media only screen and (max-width : 800px) {\n      .evaluation.foundry {\n        padding: 0;\n        min-height: auto;\n      }\n\n      .evaluation.foundry .section.intro-section {\n        width: auto;\n      }\n\n      .evaluation.foundry .section.intro-section .intro-title {\n        margin-top: 20px;\n      }\n\n      .evaluation.foundry .intro-button {\n          padding: 16px 80px;\n      }\n    }\n  ");
};
var IntroStyles_default = IntroStyles;

// src/functions/getSanitizedRichText.ts
function getSanitizedRichText(richText) {
  if (!richText) {
    return "";
  }
  return richText.trim().replace(/\u21b5/g, "");
}

// src/components/EvaluationIntro.tsx
var EvaluationIntro = /*#__PURE__*/function (_Component5) {
  function EvaluationIntro() {
    var _this12;
    _classCallCheck(this, EvaluationIntro);
    _this12 = _callSuper(this, EvaluationIntro, arguments);
    _this12.shouldShowIntro = function () {
      var intro_text = _this12.props.evaluation.intro_text;
      return !!getSanitizedRichText(intro_text);
    };
    return _this12;
  }
  _inherits(EvaluationIntro, _Component5);
  return _createClass(EvaluationIntro, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.shouldShowIntro()) {
        this.props.introCompleted();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        _this$props5$evaluati = _this$props5.evaluation,
        name = _this$props5$evaluati.name,
        description = _this$props5$evaluati.description,
        intro_text = _this$props5$evaluati.intro_text,
        intro_text_rendered = _this$props5$evaluati.intro_text_rendered,
        introCompleted3 = _this$props5.introCompleted;
      if (this.shouldShowIntro()) {
        return /* @__PURE__ */React21.createElement("div", null, /* @__PURE__ */React21.createElement(IntroStyles_default, null), /* @__PURE__ */React21.createElement("div", {
          className: "section-container"
        }, /* @__PURE__ */React21.createElement("div", {
          className: "section intro-section"
        }, /* @__PURE__ */React21.createElement("h1", {
          className: "intro-title branded-header"
        }, name), description ? /* @__PURE__ */React21.createElement("p", {
          className: "p1 description-text"
        }, description) : null, intro_text_rendered && /* @__PURE__ */React21.createElement("p", {
          className: "p1 intro-text",
          dangerouslySetInnerHTML: {
            __html: intro_text_rendered
          }
        }), !intro_text_rendered && intro_text && /* @__PURE__ */React21.createElement("p", {
          className: "p1 intro-text"
        }, intro_text), /* @__PURE__ */React21.createElement("div", {
          className: "intro-button-container"
        }, /* @__PURE__ */React21.createElement(Button4, {
          className: "intro-button btn-primary-branded",
          renderAsLegacy: true,
          onClick: introCompleted3
        }, t("Let's Get Started"))))));
      } else {
        return /* @__PURE__ */React21.createElement("div", null);
      }
    }
  }]);
}(Component5);
EvaluationIntro.propTypes = {
  evaluation: PropTypes14.shape({
    // @ts-expect-error TS(2551): Property 'stirng' does not exist on type 'typeof i... Remove this comment to see the full error message
    name: PropTypes14.stirng,
    description: PropTypes14.string,
    intro_text: PropTypes14.string,
    intro_text_rendered: PropTypes14.string
  }).isRequired,
  introCompleted: PropTypes14.func.isRequired
};

// src/components/EvaluationOutro.tsx
import React22, { Component as Component6 } from "react";
import PropTypes15 from "prop-types";
import Button5 from "react-bootstrap/Button";
var EvaluationOutro = /*#__PURE__*/function (_Component6) {
  function EvaluationOutro() {
    var _this13;
    _classCallCheck(this, EvaluationOutro);
    _this13 = _callSuper(this, EvaluationOutro, arguments);
    _this13.shouldShowOutro = function () {
      var outro_text = _this13.props.evaluation.outro_text;
      return !!getSanitizedRichText(outro_text);
    };
    return _this13;
  }
  _inherits(EvaluationOutro, _Component6);
  return _createClass(EvaluationOutro, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!this.props.shouldRetryEvaluationWebhooks) {
                _context7.next = 3;
                break;
              }
              _context7.next = 3;
              return this.props.retryEvaluationWebhooks();
            case 3:
              if (!this.shouldShowOutro()) {
                this.props.outroCompleted();
              }
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        _this$props6$evaluati = _this$props6.evaluation,
        name = _this$props6$evaluati.name,
        outro_text = _this$props6$evaluati.outro_text,
        outro_text_rendered = _this$props6$evaluati.outro_text_rendered,
        outroCompleted = _this$props6.outroCompleted;
      if (this.shouldShowOutro()) {
        return /* @__PURE__ */React22.createElement("div", null, /* @__PURE__ */React22.createElement(IntroStyles_default, null), /* @__PURE__ */React22.createElement("div", {
          className: "section-container"
        }, /* @__PURE__ */React22.createElement("div", {
          className: "section intro-section"
        }, /* @__PURE__ */React22.createElement("h1", {
          className: "intro-title"
        }, name), outro_text_rendered && /* @__PURE__ */React22.createElement("p", {
          className: "p1 intro-text",
          dangerouslySetInnerHTML: {
            __html: outro_text_rendered
          }
        }), !outro_text_rendered && outro_text && /* @__PURE__ */React22.createElement("p", {
          className: "p1 intro-text"
        }, outro_text), /* @__PURE__ */React22.createElement("div", {
          className: "intro-button-container"
        }, /* @__PURE__ */React22.createElement(Button5, {
          className: "intro-button btn-primary-branded",
          renderAsLegacy: true,
          onClick: function onClick() {
            return outroCompleted();
          }
        }, t("Continue"))))));
      } else {
        return /* @__PURE__ */React22.createElement("div", null);
      }
    }
  }]);
}(Component6);
EvaluationOutro.propTypes = {
  evaluation: PropTypes15.shape({
    name: PropTypes15.string,
    outro_text: PropTypes15.string,
    outro_text_rendered: PropTypes15.string
  }).isRequired,
  retryEvaluationWebhooks: PropTypes15.func,
  shouldRetryEvaluationWebhooks: PropTypes15.bool,
  outroCompleted: PropTypes15.func.isRequired
};

// src/components/EvaluationCompleted.tsx
import React24, { Component as Component7 } from "react";
import PropTypes16 from "prop-types";
import Button6 from "react-bootstrap/Button";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";

// src/styles/CompletedStyles.tsx
import React23 from "react";
import { Style as Style2 } from "react-style-tag";
var CompletedStyles = function CompletedStyles() {
  return /* @__PURE__ */React23.createElement(Style2, null, "\n    .evaluation.foundry .section.completed-section {\n      width: 600px;\n    }\n\n    .evaluation.foundry .section.completed-section .section-title {\n      color: #EF4923;\n      border-bottom: none;\n    }\n\n    .evaluation.foundry .score {\n      //font-weight: bold;\n    }\n    .evaluation.foundry .results-message {\n      //font-size: 16px;\n    }\n\n    .evaluation.foundry .failed,\n    .evaluation.foundry .passed {\n      padding: 20px;\n      text-align: center;\n      margin-bottom: 15px;\n    }\n    .evaluation.foundry .failed {\n      background-color: #FFF4E0;\n    }\n    .evaluation.foundry .passed {\n      background-color: #F8FBF0;\n    }\n\n    .evaluation.foundry .missed-question-well {\n      border: 1px solid #969DA4;\n      padding: 12px;\n      height: 225px;\n      overflow: auto;\n    }\n    .evaluation.foundry .missed-question {\n      padding-bottom: 15px;\n    }\n\n    .evaluation.foundry .outro-text {\n      margin: 24px 0;\n      //font-size: 16px;\n    }\n\n    .evaluation.foundry .completed-section .btn-toolbar {\n      padding: 0;\n    }\n\n    @media only screen and (max-width : 800px) {\n      .evaluation.foundry .section.completed-section {\n        width: auto;\n      }\n    }\n  ");
};
var CompletedStyles_default = CompletedStyles;

// src/components/EvaluationCompleted.tsx
import { FAIcon as FAIcon2 } from "@everfi/reactifi";
var EvaluationCompleted = /*#__PURE__*/function (_Component7) {
  function EvaluationCompleted(props) {
    var _this14;
    _classCallCheck(this, EvaluationCompleted);
    _this14 = _callSuper(this, EvaluationCompleted, [props]);
    _this14.retakeEvaluation = function () {
      _this14.setState({
        canRetake: false
      });
      _this14.props.retakeEvaluation(_this14.props.evaluation.slug);
    };
    _this14.renderButtons = function (passedExam) {
      var _this14$props = _this14.props,
        afterFinished = _this14$props.afterFinished,
        retakeEvaluation = _this14$props.retakeEvaluation;
      if (passedExam || !retakeEvaluation) {
        return /* @__PURE__ */React24.createElement(ButtonToolbar, null, /* @__PURE__ */React24.createElement("div", {
          className: "btn-spacer"
        }), /* @__PURE__ */React24.createElement("div", {
          className: "paging p3"
        }), /* @__PURE__ */React24.createElement(Button6, {
          className: "finish-button btn-primary-branded",
          renderAsLegacy: true,
          variant: "primary",
          onClick: function onClick() {
            return afterFinished();
          }
        }, t("Continue")));
      } else {
        return /* @__PURE__ */React24.createElement(ButtonToolbar, null, /* @__PURE__ */React24.createElement(Button6, {
          className: "finish-button btn-secondary-branded",
          renderAsLegacy: true,
          variant: "light",
          onClick: function onClick() {
            return afterFinished();
          }
        }, /* @__PURE__ */React24.createElement(FAIcon2, {
          icon: "angle-left"
        }), " ", t("Return")), /* @__PURE__ */React24.createElement("div", {
          className: "paging p3"
        }), /* @__PURE__ */React24.createElement(Button6, {
          className: "retake-button",
          renderAsLegacy: true,
          disabled: !_this14.state.canRetake,
          onClick: _this14.retakeEvaluation
        }, t("Retake Exam")));
      }
    };
    _this14.state = {
      canRetake: true
    };
    return _this14;
  }
  _inherits(EvaluationCompleted, _Component7);
  return _createClass(EvaluationCompleted, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(this.props.shouldRetryEvaluationWebhooks && this.props.retryEvaluationWebhooks)) {
                _context8.next = 3;
                break;
              }
              _context8.next = 3;
              return this.props.retryEvaluationWebhooks();
            case 3:
              if (!this.props.evaluation.enable_results_screen && this.props.afterFinished) {
                this.props.afterFinished();
              }
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
        evaluation = _this$props7.evaluation,
        responseSet = _this$props7.responseSet;
      var passedExam = responseSet.grading_status === "passed";
      if (evaluation.enable_results_screen) {
        return /* @__PURE__ */React24.createElement("div", null, /* @__PURE__ */React24.createElement(CompletedStyles_default, null), /* @__PURE__ */React24.createElement("div", {
          className: "evaluation-header"
        }, /* @__PURE__ */React24.createElement("h1", {
          className: "evaluation-name"
        }, this.props.evaluation.name), /* @__PURE__ */React24.createElement("p", {
          className: "evaluation-description"
        }, this.props.evaluation.description)), /* @__PURE__ */React24.createElement("div", {
          className: "section-container"
        }, /* @__PURE__ */React24.createElement("div", {
          className: "section completed-section"
        }, /* @__PURE__ */React24.createElement("h1", {
          className: "section-title"
        }, t("Assessment Completed")), evaluation.type === "assessments" && /* @__PURE__ */React24.createElement("div", {
          className: "assessment-results"
        }, /* @__PURE__ */React24.createElement("div", {
          className: passedExam ? "passed" : "failed"
        }, /* @__PURE__ */React24.createElement("h3", {
          className: "score"
        }, t("Score: {{score}}%", {
          score: responseSet.grade
        })), passedExam ? /* @__PURE__ */React24.createElement("div", {
          className: "results-message"
        }, t("You passed!")) : /* @__PURE__ */React24.createElement("div", {
          className: "results-message"
        }, /* @__PURE__ */React24.createElement("div", null, t("Unfortunately, you did not pass and will need to retake the assessment.")), /* @__PURE__ */React24.createElement("div", null, t("A score of at least {{passingGrade}}% is required", {
          passingGrade: evaluation.passing_grade
        })))), responseSet.incorrect_answers && responseSet.incorrect_answers.length ? /* @__PURE__ */React24.createElement("div", {
          className: "missed-questions"
        }, /* @__PURE__ */React24.createElement("h4", null, t("Questions you missed on the assessment:")), /* @__PURE__ */React24.createElement("div", {
          className: "missed-question-well"
        }, responseSet.incorrect_answers.map(function (_ref4) {
          var question = _ref4.question;
          return /* @__PURE__ */React24.createElement("div", {
            className: "missed-question"
          }, question.text);
        }))) : null), /* @__PURE__ */React24.createElement("p", {
          className: "outro-text"
        }, evaluation.outro_text), this.renderButtons(passedExam))));
      } else {
        return /* @__PURE__ */React24.createElement("div", null);
      }
    }
  }]);
}(Component7);
EvaluationCompleted.propTypes = {
  evaluation: PropTypes16.shape({
    description: PropTypes16.string,
    // @ts-expect-error TS(2339): Property 'boolean' does not exist on type 'typeof ... Remove this comment to see the full error message
    enable_results_screen: PropTypes16["boolean"],
    name: PropTypes16.string,
    outro_text: PropTypes16.string,
    passing_grade: PropTypes16.number,
    slug: PropTypes16.string,
    type: PropTypes16.string
  }).isRequired,
  responseSet: PropTypes16.shape({
    grading_status: PropTypes16.string,
    grade: PropTypes16.number,
    incorrect_answers: PropTypes16.arrayOf(PropTypes16.shape({
      question: PropTypes16.shape({
        text: PropTypes16.string
      })
    }))
  }).isRequired,
  retakeEvaluation: PropTypes16.func,
  retryEvaluationWebhooks: PropTypes16.func,
  shouldRetryEvaluationWebhooks: PropTypes16.bool,
  afterFinished: PropTypes16.func.isRequired
};

// src/components/DisabledSection.tsx
import React25, { Component as Component8 } from "react";
import PropTypes17 from "prop-types";
import { Core as Core8 } from "@everfi/reactifi";
var DisabledSection = /*#__PURE__*/function (_Component8) {
  function DisabledSection() {
    var _this15;
    _classCallCheck(this, DisabledSection);
    _this15 = _callSuper(this, DisabledSection, arguments);
    _this15.nextSection = function () {
      return __async(_this15, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var responseSet, incompleteSection, sectionIndex, lastSection;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              responseSet = this.props.responseSet;
              incompleteSection = responseSet.sections.find(function (section) {
                return section.completed === false;
              });
              if (!incompleteSection) {
                _context9.next = 7;
                break;
              }
              sectionIndex = responseSet.sections.findIndex(function (section) {
                return section.id === incompleteSection.id;
              });
              this.props.changeSection(sectionIndex);
              _context9.next = 11;
              break;
            case 7:
              lastSection = responseSet.sections[responseSet.sections.length - 1];
              _context9.next = 10;
              return this.props.dispatch(this.props.finishSection(responseSet, lastSection.id));
            case 10:
              this.props.completeEvaluation();
            case 11:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    };
    return _this15;
  }
  _inherits(DisabledSection, _Component8);
  return _createClass(DisabledSection, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */React25.createElement("div", {
        className: "section-container disabled-section"
      }, /* @__PURE__ */React25.createElement("div", {
        className: "section row"
      }, /* @__PURE__ */React25.createElement("div", {
        className: "col-12 section-description"
      }, t("Please click OK to continue to the next page.")), /* @__PURE__ */React25.createElement("div", {
        className: "disabled-section-button"
      }, /* @__PURE__ */React25.createElement(Core8.Button, {
        onClick: this.nextSection
      }, t("OK")))));
    }
  }]);
}(Component8);
DisabledSection.propTypes = {
  changeSection: PropTypes17.func,
  completeEvaluation: PropTypes17.func,
  dispatch: PropTypes17.func,
  finishSection: PropTypes17.func,
  responseSet: PropTypes17.object.isRequired
};

// src/styles/DefaultStyles.tsx
import React26 from "react";
import { Style as Style3 } from "react-style-tag";
var foundrySecondaryHue = "#05874F";
var foundryWhite = "#FFFFFF";
var foundryGreen = "#05874F";
var foundryRed = "#D90F31";
var foundryGray20 = "#E4E9ED";
var foundryGray80 = "#25292E";
var superDuperLight = "#F5F8FA";
var DefaultStyles = function DefaultStyles() {
  return /* @__PURE__ */React26.createElement(Style3, null, "\n    .evaluation.foundry {\n       background-color: #f2f2f2;\n       color: #333;\n    }\n     .evaluation.foundry .evaluation-header {\n       background-color: ".concat(foundrySecondaryHue, ";\n    }\n     .evaluation.foundry .evaluation-header .evaluation-name {\n       margin: 0;\n       color: ").concat(foundryWhite, ";\n       padding: 16px 24px;\n       border-bottom: 1px solid;\n       border-bottom-color: ").concat(foundrySecondaryHue, ";\n    }\n     .evaluation.foundry .evaluation-header .evaluation-description {\n       display: none;\n    }\n     .evaluation.foundry .evaluation-feedback-banner {\n       background-color: #417505;\n       color: ").concat(foundryWhite, ";\n    }\n     .evaluation.foundry .evaluation-feedback-banner .feedback-info {\n       display: flex;\n       align-items: center;\n       justify-content: space-between;\n       max-width: 800px;\n       margin: 0 auto;\n       //font-size: 16px;\n       //font-weight: 600;\n    }\n     .evaluation.foundry .section-container .section {\n       max-width: 800px;\n       margin: 20px auto 0px;\n       background-color: ").concat(foundryWhite, ";\n       padding: 24px;\n       border: 1px solid ").concat(foundryGray20, ";\n       border-radius: 3px;\n    }\n    @media only screen and (max-width : 800px) {\n      .evaluation.foundry .section-container .section {\n        width: 100%;\n        margin: 0;\n        border: none;\n      }\n    }\n     .evaluation.foundry .section-container .section .section-title {\n      //font-size: 25px;\n      //font-weight: normal;\n       border-bottom: 2px solid;\n       border-color: ").concat(foundrySecondaryHue, ";\n\n       padding-top:10px;\n       padding-bottom: 15px;\n       margin-left:-24px;\n       margin-top:-24px;\n       margin-right: -24px;\n       padding-left: 24px;\n       //font-size: 26px;\n    }\n     .evaluation.foundry .section-container .section .section-description {\n      //font-size: 16px;\n       margin: 24px 0 16px 0;\n    }\n     .evaluation.foundry .question .question-text {\n      //font-size: 20px;\n       margin-bottom: 0;\n       color: ").concat(foundryGray80, ";\n    }\n     .evaluation.foundry .question .question-feedback {\n      //font-size: 16px;\n       font-style: italic;\n       margin: 16px 0 0;\n       background-color: ").concat(superDuperLight, ";\n       padding: 9px 10px;\n       border-left: 6px solid;\n       border-color: ").concat(foundrySecondaryHue, ";\n    }\n     .evaluation.foundry .question .instruction-text {\n      //font-size: 14px;\n    }\n     .evaluation.foundry .question .answers {\n      // font-size: 16px;\n    }\n    .evaluation.foundry .question .mc-answers {\n      padding-left: 20px;\n   }\n     .evaluation.foundry .question .answers .selected label {\n      //font-weight: 500;\n    }\n     .evaluation.foundry .question .answers .feedback-icon {\n       position: absolute;\n       margin-left: -1em;\n    }\n     .evaluation.foundry .question .answers .feedback-icon.zmdi-check-circle {\n       color: ").concat(foundryGreen, ";\n    }\n     .evaluation.foundry .question .answers .feedback-icon.fa-circle-check {\n       color: ").concat(foundryGreen, ";\n    }\n     .evaluation.foundry .question .answers .feedback-icon.zmdi-close-circle {\n       color: ").concat(foundryRed, ";\n    }\n     .evaluation.foundry .question .answers .feedback-icon.fa-circle-xmark {\n       color: ").concat(foundryRed, ";\n    }\n     .evaluation.foundry .btn-toolbar {\n       display: flex;\n       align-items: center;\n       max-width: 800px;\n       padding: 24px 16px;\n       margin: 0 auto;\n       flex-direction: row;\n    }\n    @media (max-width: 479px){\n      .evaluation.foundry .btn-toolbar {\n        flex-direction: column;\n     }\n     .evaluation.foundry .btn-toolbar .paging {\n       order: 1;\n       margin-bottom: 12px;\n     }\n     .evaluation.foundry .btn-toolbar .evaluation-nav-button.previous-button {\n       order: 2;\n     }\n     .evaluation.foundry .btn-toolbar .evaluation-nav-button.next-button {\n       order: 3;\n       margin-top: 12px;\n       margin-bottom: 60px;\n     }\n    }\n     .evaluation.foundry .btn-toolbar .btn-spacer {\n       width: 100px;\n    }\n     .evaluation.foundry .btn-toolbar .btn {\n       float: none;\n       min-width: 100px;\n       margin: 0;\n    }\n     .evaluation.foundry .btn-toolbar .paging {\n       color: ").concat(foundryGray80, ";\n       flex-grow: 2;\n       text-align: right;\n       margin-right: 15px;\n    }\n     .evaluation.foundry .question .answers .btn-clear-selection {\n        margin-left: 20px;\n        margin-top: 10px;\n    }\n     .evaluation.foundry .likert-answers .btn-clear-selection {\n        align-items: flex-end;\n        margin-bottom: 8px;\n    }\n     .evaluation.foundry .matrix-answer {\n        align-self: center;\n      }\n     .evaluation.foundry .matrix-parent-question {\n       display: block;\n       width: 100%;\n       padding: 0;\n       margin-top: 0;\n       margin-bottom: 18px;\n       //font-size: 19.5px;\n       //line-height: inherit;\n       color: #25292E;\n       border: 0;\n       border-bottom: 1px solid #e5e5e5;\n     }\n     .evaluation.foundry .clear-selection {\n        &.btn-link,\n        &.btn-link:focus,\n        &.btn-link:hover,\n        &.btn-link:active {\n          margin-left: 0;\n          padding-left: 0;\n          margin-top: 8px;\n        }\n      }\n      .evaluation.foundry .answers .user-supplied-text .radio {\n        float: left;\n        margin-top: 20px;\n        padding-right: 0;\n      }\n\n      .evaluation.foundry .answers .user-supplied-text .textfield {\n        float: left;\n        margin-bottom: 15px;\n        width: 50%;\n        margin-left: 0;\n        padding-left: 0;\n      }\n      .evaluation.foundry .answers .user-supplied-text .textfield .fg-float {\n        margin: 0;\n      }\n\n      .evaluation.foundry .radio, .evaluation.foundry .checkbox{\n        position: relative;\n        display: block;\n        margin: 14px 0 10px 16px;\n        // font-size: 16px;\n        &.matrix-input {\n          display: block;\n          padding-left: 30px;\n          min-height: 18px;\n        }\n        input {\n          width: 19px;\n          height: 19px;\n          cursor: pointer;\n          line-height: normal;\n          padding: 0;\n        }\n        label {\n          display: block;\n          padding-left: 5px;\n        }\n      }\n      .assessment .evaluation.foundry .radio label, .assessment .evaluation.foundry .checkbox label,\n      .survey .evaluation.foundry .radio label, .survey .evaluation.foundry .checkbox label{\n        padding-left: 30px;\n      }\n      .evaluation.foundry .question{\n        margin-bottom: 20px;\n      }\n      .evaluation.foundry .btn-toolbar .btn-secondary {\n        display: inline-block;\n        //font-weight: normal;\n        text-align: center;\n        white-space: nowrap;\n        vertical-align: middle;\n        touch-action: manipulation;\n        background-image: none;\n        border: 1px solid transparent;\n        padding: 6px 12px;\n        //font-size: 14px;\n        //line-height: 1.42857143;\n        border-radius: 4px;\n        cursor:pointer;\n        color: ").concat(foundrySecondaryHue, ";\n      }\n      .evaluation.foundry .btn:disabled{\n        cursor: not-allowed;\n        opacity: 0.77;\n      }\n      .evaluation.foundry .btn-toolbar .evaluation-nav-button {\n        outline-color: #0A92D1 !important;\n        outline-offset: 3px;\n      }\n      .error {\n        color: #D90F31;\n        //font-size: 12px;\n      }\n\n  "));
};
var DefaultStyles_default = DefaultStyles;

// src/styles/EvaluationsStyles.tsx
import React27 from "react";
import { Style as Style4 } from "react-style-tag";
var EvaluationsStyle = function EvaluationsStyle() {
  return /* @__PURE__ */React27.createElement(Style4, null, "\n      .questions-wrapper {\n        position: relative;\n        overflow: hidden;\n        width: 100%;\n        .questions {\n          display: flex;\n          transition: transform 0.3s ease;\n        }\n        .question {\n          width: 100%;\n          flex-shrink: 0;\n        }\n        .question-controls {\n          display: flex;\n          justify-content: space-between;\n        }\n      }\n      .likert-answers {\n        display: flex;\n        justify-content: space-between;\n        width: calc( 100% - 90px );\n\n        .likert-answer {\n          text-align: center;\n          min-width: 19px;\n          position: relative;\n          .radio {\n            margin-left: 0;\n            & label {\n              padding: 0px;\n              max-width: 20px;\n              margin: 0 auto;\n              position: relative;\n              margin-top: -5px;\n            }\n          }\n          .likert-answer-label {\n            width: 100px;\n          }\n        }\n      }\n\n      .likert-answers-labels {\n        display: inline-block;\n        width: calc( 100% - 90px );\n        span:first-child {\n          float: left;\n        }\n        span:last-child {\n          float: right;\n        }\n      }\n\n      .likert-radio-label {\n        position: absolute;\n        color: #666;\n        margin-top: 8px;\n        width: 100%;\n        text-align: center;\n      }\n\n      .likert-clear {\n        float: right;\n        margin-top: -36px;\n      }\n\n      .likert-answer-label-array {\n        margin-bottom: 7px;\n      }\n\n      .likert-answers-container {\n      }\n\n      .matrix-answer-label-array {\n        margin-bottom: 11px;\n        margin-top: -12px;\n      }\n\n      .matrix-question-display {\n        .row {\n          margin-left: 0;\n          margin-right: 0;\n        }\n\n        .matrix-column-labels {\n          display: flex;\n          justify-content: space-around;\n          padding-left: 0;\n          .column-label {\n            width: 90px;\n            max-width: 90px;\n            justify-content: center;\n            align-items: center;\n            text-align: center;\n          }\n        }\n        .matrix-row-buttons {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          .matrix-answer {\n            display: flex;\n            justify-content: space-around;\n            align-items: center;\n            align-self: baseline;\n            text-align: center;\n            min-width: 19px;\n            position: relative;\n            .matrix-input .form-check-label {\n              flex-direction: column;\n              > span {\n                font-size: 14px;\n                margin-top: 0.7em;\n              }\n            }\n            .matrix-input .form-check-input {\n              align-self: center;\n              margin: 0 auto;\n              &:checked {\n                background: #0d7978;\n                border-color: #0d7978;\n                &::before {\n                  content: \"\";\n                  display: block;\n                  margin: 25% auto;\n                  width: 50%;\n                  height: 50%;\n                  border-radius: 50%;\n                  background: white;\n                }\n              }\n            }\n          }\n        }\n\n        .matrix-radio-label {\n          position: absolute;\n          color: #666;\n          margin-left: 5px;\n          margin-top: 3px;\n          width: 100%;\n          text-align: center;\n        }\n\n        .matrix-rows-container {\n          .row {\n            div.legendDisplay {\n              padding: 10px 0 10px 15px;\n              border-bottom: none;\n              display: block;\n              margin-bottom: 18px;\n            }\n          }\n        }\n\n        .matrix-answers-label-container {\n          width: 100%;\n        }\n\n        .matrix-answers-labels {\n          display: inline-block;\n          width: calc( 100% - 90px );\n          span:first-child {\n            float: left;\n            margin-left: 15px;\n          }\n          span:last-child {\n            float: right;\n          }\n        }\n\n        .matrix-answers-clear {\n          display: flex;\n          align-items: center;\n        }\n      }\n\n      .calendar-dates {\n        display: flex;\n        flex-wrap: wrap;\n        margin-left: -10px;\n\n        .calendar-date {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          justify-content: center;\n          border: 1px solid #0d7978;\n          width: 105px;\n          margin: 5px 3px;\n          padding: 3px 3px;\n\n          &.disabled {\n            border: 1px solid #e1e1e1;\n          }\n\n          .date-header {\n            width: calc(100% + 6px);\n            color: white;\n            background-color: #0d7978;\n            margin-top: -3px;\n            text-align: center;\n            margin-bottom: 20px;\n            white-space: nowrap;\n\n            &.disabled {\n              background-color: #e1e1e1;\n              color: #000;\n              margin-bottom: 94px;\n            }\n          }\n          .calendar-flff {\n            margin-bottom: 10px;\n            width: 100%;\n            .fg-label {\n              left: 1px;\n              white-space: initial;\n              top: 5px;\n            }\n          }\n\n          &.calendar-date-preview {\n            width: 93px;\n          }\n        }\n      }\n      @media only screen and (max-width: 768px) {\n        .matrix-question-display {\n          .matrix-row-buttons {\n            flex-direction: column;\n\n            .matrix-answer {\n              text-align: left;\n\n              .matrix-input {\n                > .form-check-label {\n                  flex-direction: row;\n\n                  > span {\n                    margin-top: 0;\n                    margin-left: 0.5em;\n                  }\n                }\n              }\n            }\n          }\n          .row, .matrix-answers-clear {\n            padding: 0;\n          }\n          .matrix-row-wrapper {\n            padding-left: 5px;\n          }\n        }\n\n        .likert-answers-container {\n          display: flex;\n          flex-direction: column;\n        }\n\n        .likert-answers {\n          display: block;\n          width: 100%;\n\n          .likert-answer {\n            display: flex;\n            align-items: start;\n\n            .likert-answer-label {\n              margin: 0.2em 0 0.2em 0.2em;\n              width: 100%;\n              text-align: left;\n            }\n          }\n        }\n\n        .likert-clear {\n          margin: 0 0 0 -2px;\n        }\n      }\n  ");
};
var EvaluationsStyles_default = EvaluationsStyle;

// src/styles/CustomStyles.tsx
import React28 from "react";
import PropTypes18 from "prop-types";
import { Style as Style5 } from "react-style-tag";
var CustomStyles = function CustomStyles(_ref5) {
  var styles = _ref5.styles;
  if (!styles) {
    return null;
  }
  return /* @__PURE__ */React28.createElement(Style5, null, styles);
};
CustomStyles.propTypes = {
  styles: PropTypes18.string
};
var CustomStyles_default = CustomStyles;

// src/containers/EvaluationContainer.tsx
import { ProgressSpinner, JsonApiDecorator } from "@everfi/reactifi";
import { connect } from "react-redux";
import PropTypes19 from "prop-types";

// src/components/EvaluationFeedbackBanner.tsx
import React29, { Component as Component9 } from "react";
import { Core as Core9 } from "@everfi/reactifi";
var EvaluationContainer = /*#__PURE__*/function (_Component9) {
  function EvaluationContainer(props) {
    _classCallCheck(this, EvaluationContainer);
    return _callSuper(this, EvaluationContainer, [props]);
  }
  _inherits(EvaluationContainer, _Component9);
  return _createClass(EvaluationContainer, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */React29.createElement(Core9.Callout, {
        title: "",
        variant: "neutral",
        description: t("Review answer feedback to learn more.", {}),
        isClosable: true
      });
    }
  }]);
}(Component9);

// src/containers/EvaluationContainer.tsx
import { sortBy, remove } from "lodash";
var mapResponseSetToProps = function mapResponseSetToProps(props, apiStore) {
  if (apiStore.response_sets) {
    props.responseSet = apiStore.response_sets.first(["sections"]);
    if (props.responseSet.current_section_id || props.sectionToDisplay) {
      var sectionId = props.showFeedback && props.sectionToDisplay ? props.sectionToDisplay : props.responseSet.current_section_id;
      sectionId = String(sectionId);
      props.currentSection = apiStore.response_set_sections.find(sectionId, {
        questions: ["answers"],
        matrix_parent_questions: ["answers"]
      });
      if (props.currentSection) {
        props.currentSection.index = props.responseSet.sections.findIndex(function (sect) {
          return sect.id === props.currentSection.id;
        });
        if (props.currentSection.matrix_parent_questions) {
          props.currentSection.matrix_parent_questions.forEach(function (parent) {
            parent.display_type = "matrix";
            parent.matrix_child_questions = props.currentSection.questions.filter(function (question) {
              return question.matrix_question_id === Number(parent.id);
            });
          });
          var filteredQuestions = props.currentSection.questions.filter(function (question) {
            return question.matrix_question_id === null;
          });
          var allQuestions = filteredQuestions.concat(props.currentSection.matrix_parent_questions);
          props.currentSection.questions = allQuestions;
        }
        props.currentSection.questions = sortBy(props.currentSection.questions, "display_position");
      }
    }
    remove(props.responseSet.answers, function (answer) {
      return Array.isArray(answer.value) && answer.value.length === 0 || answer.value === null;
    });
    props.responseSet.responses = props.responseSet.answers.map(function (answer) {
      return {
        questionId: String(answer.question_id),
        answerValue: Object(answer.value) === answer.value ? answer.value : String(answer.value),
        responseType: String(answer.response_type),
        userSuppliedText: (answer == null ? void 0 : answer.user_supplied_text) === "undefined" ? "" : answer == null ? void 0 : answer.user_supplied_text
      };
    });
    if (props.showCompleted && props.evaluation.enable_results_screen && props.responseSet.incorrect_answers) {
      props.responseSet.incorrect_answers.forEach(function (answer) {
        answer.question = apiStore.response_set_questions.find(String(answer.question_id));
      });
    }
  }
};
var mapStateToProps = function mapStateToProps(state, currProps) {
  var apiStore = new JsonApiDecorator(state.api);
  var props = {
    afterFinished: currProps.afterFinished,
    containerSelector: currProps.containerSelector,
    disableControls: state.api.disableControls,
    dispatch: state.dispatch,
    embeddedFields: currProps.embeddedFields,
    previousSectionId: state.previousSectionId,
    retakeEvaluation: currProps.retakeEvaluation,
    sectionToDisplay: state.sectionToDisplay,
    shouldRetryEvaluationWebhooks: state.shouldRetryEvaluationWebhooks,
    showCompleted: state.showCompleted,
    showFeedback: state.showFeedback,
    showIntro: state.showIntro
  };
  props.hasSqs = false;
  if (apiStore.assessments) {
    props.evaluation = apiStore.assessments.first();
  } else if (apiStore.surveys) {
    props.evaluation = apiStore.surveys.first();
    if (props.evaluation.relationships.sqs_surveys && props.evaluation.relationships.sqs_surveys.data.length) {
      props.hasSqs = true;
    }
  } else if (apiStore.polls) {
    props.evaluation = apiStore.polls.first();
  } else if (apiStore.forms) {
    props.evaluation = apiStore.forms.first();
  } else if (apiStore.evaluations) {
    props.evaluation = apiStore.evaluations.first();
  }
  mapResponseSetToProps(props, apiStore);
  return props;
};
var EvaluationContainer2 = /*#__PURE__*/function (_Component10) {
  function EvaluationContainer2(props) {
    var _this16;
    _classCallCheck(this, EvaluationContainer2);
    _this16 = _callSuper(this, EvaluationContainer2, [props]);
    _this16.introCompleted = function () {
      _this16.props.dispatch(introCompleted());
    };
    _this16.changeSection = function (section) {
      _this16.props.dispatch(setCurrentSection(section));
    };
    _this16.changePreviousSection = function (section) {
      _this16.props.dispatch(setPreviousSection(section));
    };
    _this16.finishFeedback = function () {
      _this16.props.dispatch(finishFeedback());
    };
    _this16.isLocalMode = function () {
      var assessmentData = _this16.props.assessmentData;
      if (!assessmentData) {
        return false;
      }
      return !assessmentData.evalufi_id;
    };
    _this16.submitSection = function () {
      return __async(_this16, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.props.dispatch(finishSection(
              // @ts-expect-error TS(2339): Property 'responseSet' does not exist on type 'Rea... Remove this comment to see the full error message
              this.props.responseSet,
              // @ts-expect-error TS(2339): Property 'currentSection' does not exist on type '... Remove this comment to see the full error message
              this.props.currentSection.index,
              // @ts-expect-error TS(2339): Property 'evaluationId' does not exist on type 'Re... Remove this comment to see the full error message
              this.props.evaluationId,
              // @ts-expect-error TS(2339): Property 'organizationId' does not exist on type '... Remove this comment to see the full error message
              this.props.organizationId,
              // @ts-expect-error TS(2339): Property 'embedded' does not exist on type 'Readon... Remove this comment to see the full error message
              this.props.embedded,
              // @ts-expect-error TS(2339): Property 'endpointHost' does not exist on type 'Re... Remove this comment to see the full error message
              this.props.endpointHost,
              // @ts-expect-error TS(2339): Property 'embeddedFields' does not exist on type '... Remove this comment to see the full error message
              this.props.embeddedFields, this.isLocalMode()));
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    };
    _this16.completeEvaluation = function () {
      _this16.props.dispatch(finishResponseSet(_this16.props.responseSet));
    };
    _this16.questionIsAnswered = function (question) {
      var currentResponse = _this16.props.responseSet.answers.find(function (answer) {
        return parseInt(answer.question_id, 10) === parseInt(question.id, 10);
      });
      if (!currentResponse) {
        return false;
      }
      if (currentResponse.user_supplied_text === "undefined") {
        currentResponse.user_supplied_text = "";
      }
      if (currentResponse.response_type === "calender") {
        return Object.values(currentResponse.value).filter(Boolean).length === question.calendar_duration_days;
      } else if (currentResponse.response_type === "single_selection") {
        var currentAnswer = question.answers.find(function (answer) {
          return parseInt(answer.id, 10) === parseInt(currentResponse.value);
        });
        if (currentAnswer && currentAnswer.collect_user_supplied_text) {
          return !!currentResponse.user_supplied_text;
        }
      }
      return currentResponse.value && currentResponse.value.toString().length > 0;
    };
    _this16.handleClearSelection = function (questionId, responseType) {
      _this16.props.dispatch(setAnswerForQuestion(questionId, null, responseType));
    };
    _this16.afterFinished = function (rs) {
      return __async(_this16, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _a, responseSet, sqsId;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              responseSet = rs || this.props.responseSet;
              sqsId = (_a = responseSet.sqs_response_set) == null ? void 0 : _a.id;
              if (this.props.hasSqs && sqsId) {
                this.props.initializeResponseSet(sqsId);
              } else {
                this.props.afterFinished({
                  response_set_id: responseSet.id
                });
              }
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    };
    var onlyOneSection = _this16.props.splitQuestions === 1;
    if (!onlyOneSection) {
      _this16.state = {
        currentSection: 0
      };
      return _possibleConstructorReturn(_this16);
    }
    var toFocusSectionIndex = _this16.props.splitIndexStart - 1;
    _this16.state = {
      currentSection: toFocusSectionIndex
    };
    return _this16;
  }
  _inherits(EvaluationContainer2, _Component10);
  return _createClass(EvaluationContainer2, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.showFeedback && this.props.showFeedback) {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: "cssStyles",
    get: function get() {
      return [/* @__PURE__ */React30.createElement(DefaultStyles_default, null), /* @__PURE__ */React30.createElement(EvaluationsStyles_default, null), /* @__PURE__ */React30.createElement(CustomStyles_default, {
        styles: this.props.evaluation.css_style
      })];
    }
    // eslint-disable-next-line sonarjs/cognitive-complexity
  }, {
    key: "render",
    value: function render() {
      var _this17 = this;
      var _this$props8 = this.props,
        responseSet = _this$props8.responseSet,
        evaluation = _this$props8.evaluation,
        currentSection = _this$props8.currentSection,
        disableControls2 = _this$props8.disableControls,
        splitQuestions = _this$props8.splitQuestions,
        isPreview = _this$props8.isPreview;
      if (responseSet && evaluation) {
        if (this.props.showIntro) {
          return /* @__PURE__ */React30.createElement("div", {
            className: "evaluation foundry",
            "aria-live": "assertive"
          }, this.cssStyles, /* @__PURE__ */React30.createElement(EvaluationIntro, {
            evaluation: evaluation,
            introCompleted: this.introCompleted
          }));
        }
        if (this.props.showCompleted) {
          return /* @__PURE__ */React30.createElement("div", {
            className: "evaluation foundry",
            "aria-live": "assertive"
          }, this.cssStyles, evaluation.type === "assessments" ? /* @__PURE__ */React30.createElement(EvaluationCompleted, {
            evaluation: evaluation,
            responseSet: responseSet,
            retakeEvaluation: this.props.retakeEvaluation,
            retryEvaluationWebhooks: this.props.retryEvaluationWebhooks,
            shouldRetryEvaluationWebhooks: this.props.shouldRetryEvaluationWebhooks,
            afterFinished: this.props.afterFinished
          }) : /* @__PURE__ */React30.createElement(EvaluationOutro, {
            evaluation: evaluation,
            retryEvaluationWebhooks: this.props.retryEvaluationWebhooks,
            shouldRetryEvaluationWebhooks: this.props.shouldRetryEvaluationWebhooks,
            outroCompleted: this.afterFinished
          }));
        } else if (currentSection) {
          var onlyOneSection = splitQuestions === 1;
          var allQuestionsAnswered = currentSection.questions.every(function (question) {
            if (!question.required) {
              return true;
            }
            if (question.matrix_parent) {
              return question.matrix_child_questions.every(function (child_question) {
                return _this17.questionIsAnswered(child_question);
              });
            }
            return _this17.questionIsAnswered(question);
          });
          return /* @__PURE__ */React30.createElement("div", {
            className: "evaluation foundry",
            "aria-live": "assertive"
          }, this.cssStyles, !onlyOneSection && /* @__PURE__ */React30.createElement("div", {
            className: "evaluation-header"
          }, /* @__PURE__ */React30.createElement("h1", {
            className: "evaluation-name"
          }, evaluation.name), /* @__PURE__ */React30.createElement("p", {
            className: "evaluation-description"
          }, evaluation.description)), this.props.showFeedback && /* @__PURE__ */React30.createElement(EvaluationContainer, null), /* @__PURE__ */React30.createElement("div", null, /* @__PURE__ */React30.createElement(Section_default, {
            section: currentSection,
            showFeedback: this.props.showFeedback,
            onFeedback: this.props.onFeedback,
            onOptionChange: this.props.onOptionChange,
            dispatch: this.props.dispatch,
            evaluationType: evaluation.evaluation_type,
            questionDisplayMode: evaluation.question_display_mode,
            responseSet: responseSet,
            onClickClearSelection: this.handleClearSelection,
            disableControls: disableControls2,
            hideHeader: onlyOneSection,
            hideQuestionControls: onlyOneSection,
            isPreview: isPreview
          }), /* @__PURE__ */React30.createElement(SectionNavigation, {
            sectionComplete: allQuestionsAnswered,
            showFeedback: this.props.showFeedback,
            finishPage: this.submitSection,
            finishFeedback: this.finishFeedback,
            changePage: this.changeSection,
            numberOfPages: responseSet.sections.length,
            allowChangingAnswers: evaluation.allow_changing_answers,
            finishMethod: this.completeEvaluation,
            currentPage: currentSection.index,
            containerSelector: this.props.containerSelector,
            disableControls: disableControls2,
            sections: responseSet.sections,
            previousSectionId: this.props.previousSectionId,
            changePreviousSection: this.changePreviousSection,
            hideNavigation: onlyOneSection
          })));
        } else if (!currentSection) {
          return /* @__PURE__ */React30.createElement("div", {
            className: "evaluation foundry",
            "aria-live": "assertive"
          }, this.cssStyles, /* @__PURE__ */React30.createElement(DisabledSection, {
            changeSection: this.changeSection,
            completeEvaluation: this.completeEvaluation,
            dispatch: this.props.dispatch,
            finishSection: finishSection,
            responseSet: responseSet
          }));
        }
      }
      return /* @__PURE__ */React30.createElement("div", {
        className: "foundry"
      }, /* @__PURE__ */React30.createElement(ProgressSpinner, null));
    }
  }]);
}(Component10);
EvaluationContainer2.propTypes = {
  afterFinished: PropTypes19.func,
  containerSelector: PropTypes19.string,
  currentSection: PropTypes19.shape({
    title: PropTypes19.string.isRequired,
    index: PropTypes19.number.isRequired,
    description: PropTypes19.string,
    questions: PropTypes19.array.isRequired,
    // @ts-expect-error TS(2339): Property 'boolean' does not exist on type 'typeof ... Remove this comment to see the full error message
    active: PropTypes19["boolean"]
  }),
  disableControls: PropTypes19.bool,
  dispatch: PropTypes19.func.isRequired,
  embedded: PropTypes19.bool,
  embeddedFields: PropTypes19.object,
  endpointHost: PropTypes19.string,
  evaluation: PropTypes19.shape({
    id: PropTypes19.string.isRequired,
    name: PropTypes19.string.isRequired,
    evaluation_type: PropTypes19.string,
    description: PropTypes19.string,
    slug: PropTypes19.string,
    allow_changing_answers: PropTypes19.bool,
    type: PropTypes19.string,
    css_style: PropTypes19.string,
    relationships: PropTypes19.object,
    question_display_mode: PropTypes19.string
  }),
  evaluationId: PropTypes19.string,
  hasSqs: PropTypes19.bool,
  initializeResponseSet: PropTypes19.func,
  organizationId: PropTypes19.string,
  previousSectionId: PropTypes19.string,
  retakeEvaluation: PropTypes19.func,
  retryEvaluationWebhooks: PropTypes19.func,
  responseSet: PropTypes19.shape({
    id: PropTypes19.string.isRequired,
    answers: PropTypes19.array,
    responses: PropTypes19.array.isRequired,
    sections: PropTypes19.array.isRequired,
    status: PropTypes19.string,
    sqs_response_set: PropTypes19.object
  }),
  shouldRetryEvaluationWebhooks: PropTypes19.func,
  showCompleted: PropTypes19.bool,
  showFeedback: PropTypes19.bool,
  showIntro: PropTypes19.bool,
  // SDK specific props
  splitQuestions: PropTypes19.number,
  splitIndexStart: PropTypes19.number,
  onFeedback: PropTypes19.func,
  isPreview: PropTypes19.bool
};
var EvaluationContainer_default = connect(mapStateToProps)(EvaluationContainer2);

// src/store/EvaluationStore.ts
import thunk from "redux-thunk";
import { createStore, compose, applyMiddleware } from "redux";

// src/reducers/responseSet.ts
import { JsonApiDecorator as JsonApiDecorator2 } from "@everfi/reactifi";
import { reducer as api } from "redux-json-api";
var setResponse = function setResponse(state, action) {
  if (state.showFeedback) {
    return state;
  }
  var response = {
    questionId: action.questionId,
    answerValue: action.answerValue,
    responseType: action.responseType,
    userSuppliedText: action.userSuppliedText
  };
  var newState = Object.assign({}, state);
  var responses = newState.api.response_sets.data[0].attributes.responses;
  var answers = newState.api.response_sets.data[0].attributes.answers;
  if (answers && Array.isArray(answers)) {
    responses = answers.map(function (answer) {
      return {
        questionId: String(answer.question_id),
        responseType: answer.response_type,
        answerValue: Object(answer.value) === answer.value ? answer.value : String(answer.value),
        userSuppliedText: String(answer.user_supplied_text)
      };
    });
  }
  if (!responses) {
    responses = [response];
  } else {
    var index = responses.findIndex(function (resp) {
      return resp.questionId === action.questionId || resp.question_id === action.questionId;
    });
    if (index !== -1) {
      responses = [].concat(_toConsumableArray(responses.slice(0, index)), [response], _toConsumableArray(responses.slice(index + 1)));
    } else {
      responses = responses.concat(response);
    }
  }
  newState.api.response_sets.data[0].attributes.responses = responses;
  newState.api.response_sets.data[0].attributes.answers = responses.map(function (resp) {
    var answer = {
      question_id: resp.questionId,
      value: resp.answerValue,
      response_type: resp.responseType
    };
    if (state.isLocalMode) {
      var isIncorrect = state.api.answers.data.find(function (x) {
        return x.attributes.questionId == responses[0].questionId && x.id == responses[0].answerValue && !x.attributes.isCorrect;
      });
      if (isIncorrect) {
        newState.api.response_sets.data[0].attributes.incorrect_answers.push({
          question_id: responses[0].questionId,
          answer: responses[0].answerValue
        });
      }
    }
    if (typeof resp.userSuppliedText !== "undefined") {
      answer.user_supplied_text = resp.userSuppliedText;
    }
    return answer;
  });
  return newState;
};
var setResponseSetLocalMode2 = function setResponseSetLocalMode2(state, payload) {
  var newState = Object.assign({}, state);
  newState.api = payload.assessmentData;
  newState.isLocalMode = payload.isLocalMode;
  return newState;
};
var setSplitIndex = function setSplitIndex(state, payload) {
  var newState = Object.assign({}, state);
  newState.splitIndexStart = payload.splitIndexStart;
  return newState;
};
var responseSetLoaded2 = function responseSetLoaded2(state, action) {
  var _a;
  var newState = Object.assign({}, state);
  if (!((_a = newState.api) == null ? void 0 : _a.response_sets)) {
    return newState;
  }
  if (action.splitQuestions === 0 || action.splitQuestions === void 0) {
    if (["completed", "skipped"].includes(newState.api.response_sets.data[0].attributes.status)) {
      newState.showCompleted = true;
      newState.shouldRetryEvaluationWebhooks = true;
    } else if (!newState.api.response_sets.data[0].attributes.answers.length) {
      newState.showIntro = true;
    }
  } else {
    setCurrentSection2(newState, {
      section: newState.splitIndexStart - 1
    });
  }
  return newState;
};
var introCompleted2 = function introCompleted2(state) {
  var newState = Object.assign({}, state);
  newState.showIntro = false;
  return newState;
};
var finishResponseSet2 = function finishResponseSet2(state) {
  var finishState = Object.assign({}, state);
  finishState.api.response_sets.data[0].attributes.status = "completed";
  finishState.showCompleted = true;
  return finishState;
};
var setCurrentSection2 = function setCurrentSection2(state, action) {
  var newState = Object.assign({}, state);
  newState.showFeedback = false;
  delete newState.sectionToDisplay;
  if (newState.api.response_set_sections.data.length <= action.section || !newState.api.response_sets.data[0].attributes.answers) {
    return newState;
  }
  var currentSection = newState.api.response_set_sections.data[action.section];
  if (!currentSection) {
    return newState;
  }
  var currentSectionId = currentSection.id;
  newState.api.response_sets.data[0].attributes.current_section_id = currentSectionId;
  var questionsMap = getCurrentSectionQuestionMap(newState, action.section);
  newState.api.response_sets.data[0].attributes.responses = newState.api.response_sets.data[0].attributes.answers.map(function (answer) {
    return {
      questionId: "".concat(answer.question_id),
      answerValue: questionsMap[answer.question_id] ? void 0 : answer.value,
      responseType: answer.response_type,
      userSuppliedText: answer.user_supplied_text
    };
  });
  return newState;
};
var setPreviousSection2 = function setPreviousSection2(state, action) {
  var newState = Object.assign({}, state);
  newState.previousSectionId = action.section;
  return newState;
};
var disableControls = function disableControls(state) {
  var newState = Object.assign({}, state);
  newState.api.disableControls = true;
  return newState;
};
var enableControls = function enableControls(state) {
  var newState = Object.assign({}, state);
  newState.api.disableControls = false;
  return newState;
};
var showFeedback = function showFeedback(state, action) {
  var newState = __spreadValues({}, state);
  var _newState$api$respons = newState.api.response_sets.data[0].attributes,
    answers = _newState$api$respons.answers,
    currentSectionId = _newState$api$respons.currentSectionId,
    status = _newState$api$respons.status;
  if (answers) {
    newState.api.response_sets.data[0].attributes.responses = state.isLocalMode ? getResponsesFromAnswersLocalMode(answers, state.api) : getResponsesFromAnswers(answers);
    var responses = newState.api.response_sets.data[0].attributes.responses;
    var questionsMap = getCurrentSectionQuestionMap(newState, action.section);
    var responseWithFeedback = responses.find(function (response) {
      return questionsMap[response.questionId] && !!response.feedback;
    });
    var responseSetSectionsData = newState.api.response_set_sections.data;
    var currentSection = responseSetSectionsData[action.section];
    var isLastSection = action.section === responseSetSectionsData.length - 1;
    var responseSetCompleted = status === "completed" && !currentSectionId;
    if (responseWithFeedback && currentSection) {
      return __spreadProps(__spreadValues({}, newState), {
        showFeedback: true,
        sectionToDisplay: currentSection.id
      });
    } else if (isLastSection || responseSetCompleted) {
      return __spreadProps(__spreadValues({}, newState), {
        showCompleted: true
      });
    }
  }
  return newState;
};
var getResponsesFromAnswers = function getResponsesFromAnswers(answers) {
  return answers.map(function (answer) {
    return {
      questionId: "".concat(answer.question_id),
      answerValue: answer.value,
      responseType: answer.response_type,
      feedback: answer.feedback,
      userSuppliedText: answer.user_supplied_text
    };
  });
};
var getResponsesFromAnswersLocalMode = function getResponsesFromAnswersLocalMode(answers, api2) {
  var answersArray = api2.answers.data;
  return answers.map(function (answer) {
    var _a;
    return {
      questionId: "".concat(answer.question_id),
      answerValue: answer.value,
      responseType: answer.response_type,
      feedback: (_a = answersArray.find(function (a) {
        return a.id == answer.value;
      })) == null ? void 0 : _a.attributes.feedback,
      userSuppliedText: answer.user_supplied_text
    };
  });
};
var completeFeedback = function completeFeedback(state) {
  var newState = Object.assign({}, state);
  newState.showFeedback = false;
  delete newState.sectionToDisplay;
  return newState;
};
var getCurrentSectionQuestionMap = function getCurrentSectionQuestionMap(state, section) {
  if (state.api.response_set_sections.data.length <= section) {
    return {};
  }
  var currentSectionObject = state.api.response_set_sections.data[section];
  if (!currentSectionObject) {
    return {};
  }
  var currentSectionId = currentSectionObject.id;
  var apiStore = new JsonApiDecorator2(state.api);
  var currentSection = apiStore.response_set_sections.find(currentSectionId + "", {
    questions: ["answers"],
    matrix_parent_questions: ["answers"]
  });
  if (!currentSection) {
    return {};
  }
  return currentSection.questions.reduce(function (map, question) {
    map[question.id] = question;
    return map;
  }, {});
};
var setCurrentResponseSet2 = function setCurrentResponseSet2(state, action) {
  var newState = Object.assign({}, state);
  newState.api.response_sets.data[0] = action.responseSet;
  return newState;
};
var removeAnswer = function removeAnswer(state, action) {
  var newState = Object.assign({}, state);
  var answers = newState.api.response_sets.data[0].attributes.answers;
  if (answers) {
    var newAnswers = answers.filter(function (answer) {
      return answer.question_id !== action.questionId;
    });
    newState.api.response_sets.data[0].attributes.answers = newAnswers;
  }
  return newState;
};
var responseSetReducer = function responseSetReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var response = {};
  switch (action.type) {
    case actionTypes_default.NEW_RESPONSE_SET:
      {
        state.api = void 0;
        state.showFeedback = void 0;
        state.showIntro = void 0;
        state.showCompleted = void 0;
        break;
      }
    case actionTypes_default.SET_RESPONSE:
      {
        response = setResponse(state, action);
        break;
      }
    case actionTypes_default.REMOVE_ANSWER:
      {
        response = removeAnswer(state, action);
        break;
      }
    case actionTypes_default.RESPONSE_SET_LOADED:
      {
        response = responseSetLoaded2(state, action);
        break;
      }
    case actionTypes_default.INTRO_COMPLETED:
      {
        response = introCompleted2(state);
        break;
      }
    case actionTypes_default.FINISH_RESPONSE_SET:
      {
        response = finishResponseSet2(state);
        break;
      }
    case actionTypes_default.SET_CURRENT_SECTION:
      {
        response = setCurrentSection2(state, action);
        break;
      }
    case actionTypes_default.SET_PREVIOUS_SECTION:
      {
        response = setPreviousSection2(state, action);
        break;
      }
    case actionTypes_default.SHOW_FEEDBACK:
      {
        response = showFeedback(state, action);
        break;
      }
    case actionTypes_default.FEEDBACK_COMPLETED:
      {
        response = completeFeedback(state);
        break;
      }
    case actionTypes_default.DISABLE_CONTROLS:
      {
        response = disableControls(state);
        break;
      }
    case actionTypes_default.ENABLE_CONTROLS:
      {
        response = enableControls(state);
        break;
      }
    case actionTypes_default.SET_CURRENT_RESPONSE_SET:
      {
        response = setCurrentResponseSet2(state, action);
        break;
      }
    case actionTypes_default.RESPONSE_SET_LOCAL_MODE:
      {
        response = setResponseSetLocalMode2(state, action);
        break;
      }
    case actionTypes_default.SET_SPLIT_INDEX:
      {
        response = setSplitIndex(state, action);
        break;
      }
    default:
      response = state;
  }
  if (!state.isLocalMode) {
    state.api = api(Object.assign({}, state.api), action);
  }
  return response;
};

// src/store/EvaluationStore.ts
var defaultState = {
  responseSet: {
    responses: []
  }
};
var store = createStore(responseSetReducer, defaultState,
// @ts-expect-error TS(2345): Argument of type '(...args: any[]) => StoreEnhance... Remove this comment to see the full error message
compose(applyMiddleware(thunk), /* istanbul ignore next */
// @ts-expect-error TS(2339): Property '__REDUX_DEVTOOLS_EXTENSION__' does not e... Remove this comment to see the full error message
window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
  return f;
}));

// src/EvaluationApp.tsx
import { readLocal as readLocal2, ChakraUIProvider } from "@everfi/reactifi";
import { setEndpointHost, setEndpointPath as setEndpointPath2, setHeader, setAccessToken as setAccessToken2, readEndpoint } from "redux-json-api";
var EvaluationApp = /*#__PURE__*/function (_Component11) {
  function EvaluationApp(props) {
    var _this18;
    _classCallCheck(this, EvaluationApp);
    _this18 = _callSuper(this, EvaluationApp, [props]);
    _this18.initializeResponseSet = function (id, accessToken) {
      return __async(_this18, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this$props9, assessmentData, endpointHost, endpointPath, responseSet, splitQuestions, splitIndexStart, isLoadedBySDK, isLocalMode, host, path, responseSetId, token, formsUrl, response, newResponseSet2;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this$props9 = this.props, assessmentData = _this$props9.assessmentData, endpointHost = _this$props9.endpointHost, endpointPath = _this$props9.endpointPath, responseSet = _this$props9.responseSet, splitQuestions = _this$props9.splitQuestions, splitIndexStart = _this$props9.splitIndexStart;
              isLoadedBySDK = !!assessmentData;
              isLocalMode = isLoadedBySDK && !assessmentData.evalufi_id;
              if (!isLocalMode) {
                _context12.next = 8;
                break;
              }
              store.dispatch(newResponseSet());
              store.dispatch(setResponseSetLocalMode(assessmentData, true));
              store.dispatch(responseSetLoaded(splitQuestions));
              return _context12.abrupt("return");
            case 8:
              host = endpointHost[endpointHost.length - 1] !== "/" ? endpointHost + "/" : endpointHost;
              path = endpointPath[0] === "/" ? endpointPath.substring(1, endpointPath.length) : endpointPath;
              path = path[path.length - 1] === "/" ? path.substring(0, path.length - 1) : path;
              responseSetId = id ? id :
              // @ts-expect-error TS(2339): Property 'responseSetId' does not exist on type 'R... Remove this comment to see the full error message
              this.props.responseSetId || responseSet && responseSet.data && responseSet.data.id;
              token = accessToken || this.props.accessToken;
              store.dispatch(newResponseSet());
              store.dispatch(setEndpointHost(host));
              store.dispatch(setEndpointPath2(path));
              store.dispatch(setAccessToken2(token));
              store.dispatch(setHeader({
                "Content-Type": "application/json"
              }));
              store.dispatch(setHeader({
                "Accept-Language": this.props.language
              }));
              store.dispatch(setSplitIndexStart(splitIndexStart));
              if (!responseSetId) {
                _context12.next = 26;
                break;
              }
              _context12.next = 23;
              return store.dispatch(readEndpoint("response_sets/".concat(responseSetId, ".json?include=evaluation,sections.questions.answers,sections.matrix_parent_questions.answers")));
            case 23:
              store.dispatch(responseSetLoaded(splitQuestions));
              _context12.next = 33;
              break;
            case 26:
              formsUrl = "".concat(host).concat(path, "/forms/").concat(this.props.evaluationId, ".json?include=sections.questions.answers,sections.matrix_parent_questions.answers&organization_id=").concat(this.props.organizationId);
              _context12.next = 29;
              return requestDataWithoutCredentials(formsUrl);
            case 29:
              response = _context12.sent;
              store.dispatch(readLocal2(response));
              newResponseSet2 = {
                data: {
                  type: "response_sets",
                  attributes: {
                    current_section_id: response.data.relationships.sections.data[0].id,
                    answers: []
                  },
                  relationships: {
                    sections: response.data.relationships.sections
                  }
                },
                included: response.included.filter(function (include) {
                  return include.type === "sections";
                }).map(function (section) {
                  return Object.assign({}, section, {
                    type: "response_set_sections"
                  });
                })
              };
              store.dispatch(readLocal2(newResponseSet2));
            case 33:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
    };
    _this18.initializeResponseSet();
    return _this18;
  }
  _inherits(EvaluationApp, _Component11);
  return _createClass(EvaluationApp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props10 = this.props,
        language = _this$props10.language,
        loadLocales = _this$props10.loadLocales;
      if (!loadLocales) {
        return;
      }
      localeManager.load(language);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.responseSetId !== this.props.responseSetId) {
        this.initializeResponseSet(this.props.responseSetId, this.props.accessToken);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /* @__PURE__ */React31.createElement(Provider, {
        store: store
      }, /* @__PURE__ */React31.createElement(ChakraUIProvider, null, /* @__PURE__ */React31.createElement(EvaluationContainer_default, __spreadProps(__spreadValues({}, this.props), {
        initializeResponseSet: this.initializeResponseSet
      }))));
    }
  }]);
}(Component11);
EvaluationApp.propTypes = {
  accessToken: PropTypes20.string,
  afterFinished: PropTypes20.func,
  containerSelector: PropTypes20.string,
  embedded: PropTypes20.bool,
  embeddedFields: PropTypes20.object,
  endpointHost: PropTypes20.string,
  endpointPath: PropTypes20.string,
  evaluationId: PropTypes20.string,
  language: PropTypes20.string,
  onComplete: PropTypes20.func,
  organizationId: PropTypes20.string,
  primaryColor: PropTypes20.string,
  responseSet: PropTypes20.shape({
    data: PropTypes20.shape({
      id: PropTypes20.string
    })
  }),
  responseSetId: PropTypes20.string,
  retakeEvaluation: PropTypes20.func,
  retryEvaluationWebhooks: PropTypes20.func,
  secondaryColor: PropTypes20.string,
  // SDK specific props
  splitQuestions: PropTypes20.number,
  splitIndexStart: PropTypes20.number,
  onFeedback: PropTypes20.func,
  onOptionChange: PropTypes20.func,
  //local mode
  assessmentData: PropTypes20.object,
  loadLocales: PropTypes20.bool,
  isPreview: PropTypes20.bool
};
EvaluationApp.defaultProps = {
  language: "en",
  loadLocales: false
};

// src/index.ts
var src_default = EvaluationApp;
export { src_default as default };